/* sf-core.js v3.21.1-rc.50 — storefront-core opt-in behaviors (scoped to selected components).
 * Critical add-to-cart ships separately in sf-core-cart.js. Binds data-ds-* hooks only.
 * Generated — do not edit in the theme. */
/* 0header-nav-drawer.js */
(function () {
try {
/* 0header-nav-drawer — v2 mobile nav drawer ("D · Card grid"): open/close,
 * sheet offset, scroll lock, Back closes without navigating (Baymard
 * #1057), card → level drill-down, single-open groups, "More" fold >10.
 *
 * Filename starts with `0`: build.mjs concatenates src/behaviors/*.js
 * alphabetically into one bundle, so this forces our popstate listener to
 * register (and run) before collection-listing.js / script.collection-
 * filters.js. Must stay [a-z0-9-] — a leading `_` passes build.mjs fine but
 * build.mjs's sf-asset regex doesn't match it, so the component silently
 * ships with no drawer JS.
 *
 * Close-by-hand uses replaceState(), never history.back() — back() fires a
 * page-wide popstate that collection AJAX can't tell apart from real
 * navigation (that was the reload bug). See __dsNavDrawerPoppedOverlay.
 *
 * Coexists with header-nav.js (legacy drawer, no-ops on this markup). No
 * import/export: the build wraps this file in an IIFE.
 */

(function () {
  if (document.__dsNavDrawerBound) return;
  document.__dsNavDrawerBound = true;

  var DESKTOP_MIN = 1024;
  var MAX_CARDS = 10;
  var DIR_CLEAR_DELAY = 300;
  var HISTORY_KEY = 'dsNavDrawer';

  // The one drawer currently open: { nav, trigger }. A page has one header.
  var active = null;

  function navForTrigger(trigger) {
    var header = trigger && trigger.closest('[data-ds-header]');
    return header && header.querySelector('[data-ds-nav-drawer]');
  }

  function triggerForNav(nav) {
    var header = nav && nav.closest('[data-ds-header]');
    return header && header.querySelector('[data-ds-header-menu-button]');
  }

  function isOpen(nav) {
    return !!nav && nav.hasAttribute('data-ds-nav-drawer-open');
  }

  /* ---- Sheet position: starts at the bottom edge of the search row ------ */

  function sizeDrawer(nav) {
    if (!nav) return;
    var header = nav.closest('[data-ds-header]');
    var bar = header && header.querySelector('[data-ds-header-main-row]');
    var edge = bar || header;
    var top = edge ? edge.getBoundingClientRect().bottom : 0;
    /* Floor so a fractional edge never leaves a hairline of the page between
       the search row and the sheet. */
    top = Math.max(0, Math.min(window.innerHeight, Math.floor(top)));
    nav.style.setProperty('--ds-nav-drawer-top', top + 'px');
    nav.style.setProperty('--ds-nav-drawer-max-height', Math.max(0, Math.floor(window.innerHeight - top)) + 'px');
  }

  function sizeOpenDrawer() {
    if (active && isOpen(active.nav)) sizeDrawer(active.nav);
  }

  /* ---- Page scroll lock --------------------------------------------------- */

  function syncScrollLock() {
    var open = document.querySelector('[data-ds-nav-drawer][data-ds-nav-drawer-open]');
    document.documentElement.toggleAttribute('data-ds-nav-drawer-scroll-lock', Boolean(open));
  }

  /* ---- Levels and groups --------------------------------------------------- */

  function closeGroups(scope) {
    scope.querySelectorAll('[data-ds-nav-drawer-group-toggle][aria-expanded="true"]').forEach(function (toggle) {
      setGroup(toggle, false);
    });
  }

  function setGroup(toggle, open) {
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    var id = toggle.getAttribute('aria-controls');
    var panel = id && document.getElementById(id);
    if (panel) panel.hidden = !open;
  }

  function resetToRoot(nav) {
    nav.querySelectorAll('[data-ds-nav-drawer-level]').forEach(function (level) {
      level.hidden = true;
      level.removeAttribute('data-ds-nav-drawer-dir');
    });
    closeGroups(nav);
    nav.querySelectorAll('[data-ds-nav-drawer-scroll]').forEach(function (scroller) {
      scroller.removeAttribute('data-ds-nav-drawer-dir');
      scroller.scrollTop = 0;
    });
    var returned = nav.querySelector('[data-ds-nav-drawer-returned-to]');
    if (returned) returned.removeAttribute('data-ds-nav-drawer-returned-to');
    var open = nav.querySelector('[data-ds-nav-drawer-open-card]');
    if (open) open.removeAttribute('data-ds-nav-drawer-open-card');
  }

  // Marks the card whose level is open — "which branch am I in" while inside
  // the drawer's own UI state, separate from data-ds-nav-drawer-current (the
  // real page URL, set by Liquid). Skipped if the card is already the true
  // current page: one highlight source, not two competing ones.
  function markOpenCard(card) {
    if (card.hasAttribute('data-ds-nav-drawer-current')) return;
    card.setAttribute('data-ds-nav-drawer-open-card', '');
  }

  function openLevel(card) {
    var id = card.getAttribute('aria-controls');
    var level = id && document.getElementById(id);
    if (!level) return false;
    var nav = card.closest('[data-ds-nav-drawer]');
    // Entering a level starts with every group collapsed.
    closeGroups(nav || level);
    var scroller = level.closest('[data-ds-nav-drawer-scroll]');
    if (scroller) {
      scroller.removeAttribute('data-ds-nav-drawer-dir');
      // The level is positioned absolute, inset: 0 against this scroller — if
      // the root grid was scrolled down first, that scrollTop still offsets
      // the level's containing block, pushing it up out of view.
      scroller.scrollTop = 0;
    }
    level.setAttribute('data-ds-nav-drawer-dir', 'fwd');
    level.hidden = false;
    level.scrollTop = 0;
    markOpenCard(card);
    var back = level.querySelector('[data-ds-nav-drawer-back]');
    if (back) back.focus({ preventScroll: true });
    return true;
  }

  // Highlights the card just returned to via in-drawer Back — focus() alone
  // often isn't painted as :focus-visible after a mouse click. Skipped if
  // another card is already the true current page (convention 03: one
  // "where am I" source, not two competing highlights).
  function markReturnedTo(card) {
    var nav = card.closest('[data-ds-nav-drawer]');
    if (nav) {
      var current = nav.querySelector('[data-ds-nav-drawer-card][data-ds-nav-drawer-current]');
      if (current && current !== card) return;
      var stale = nav.querySelector('[data-ds-nav-drawer-returned-to]');
      if (stale && stale !== card) stale.removeAttribute('data-ds-nav-drawer-returned-to');
    }
    card.setAttribute('data-ds-nav-drawer-returned-to', '');
    card.addEventListener('blur', function onBlur() {
      card.removeEventListener('blur', onBlur);
      card.removeAttribute('data-ds-nav-drawer-returned-to');
    });
  }

  function closeLevel(back) {
    var level = back.closest('[data-ds-nav-drawer-level]');
    if (!level) return;
    level.hidden = true;
    level.removeAttribute('data-ds-nav-drawer-dir');
    closeGroups(level);
    // The root grid plays the "back" slide; clear it once it has run so the
    // next return can replay it.
    var scroller = level.closest('[data-ds-nav-drawer-scroll]');
    if (scroller) {
      scroller.setAttribute('data-ds-nav-drawer-dir', 'back');
      window.clearTimeout(scroller.__dsNavDrawerDirTimer);
      scroller.__dsNavDrawerDirTimer = window.setTimeout(function () {
        scroller.removeAttribute('data-ds-nav-drawer-dir');
      }, DIR_CLEAR_DELAY);
    }
    var card = level.id && document.querySelector('[data-ds-nav-drawer-card][aria-controls="' + cssEscape(level.id) + '"]');
    if (card) {
      card.removeAttribute('data-ds-nav-drawer-open-card');
      card.focus({ preventScroll: true });
      markReturnedTo(card);
    }
  }

  function cssEscape(value) {
    return window.CSS && CSS.escape ? CSS.escape(value) : String(value).replace(/["\\]/g, '\\$&');
  }

  /* ---- Open and close ------------------------------------------------------ */

  function syncTrigger(trigger, nav, open) {
    if (!trigger) return;
    if (nav.id) trigger.setAttribute('aria-controls', nav.id);
    trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    var label = trigger.getAttribute(open ? 'data-label-close' : 'data-label-open');
    if (label) trigger.setAttribute('aria-label', label);
    var iconOpen = trigger.querySelector('[data-ds-header-menu-icon-open]');
    var iconClose = trigger.querySelector('[data-ds-header-menu-icon-close]');
    if (iconOpen) iconOpen.classList.toggle('sf-hidden', open);
    if (iconClose) iconClose.classList.toggle('sf-hidden', !open);
  }

  function openDrawer(nav, trigger) {
    if (!nav) return;
    if (active && active.nav !== nav) closeDrawer({ skipHistory: true });
    trigger = trigger || triggerForNav(nav);
    resetToRoot(nav);
    sizeDrawer(nav);
    nav.setAttribute('data-ds-nav-drawer-open', '');
    syncTrigger(trigger, nav, true);
    active = { nav: nav, trigger: trigger };
    syncScrollLock();
    // A real Back press pops this; no URL change, so no navigation happens.
    try {
      var state = {};
      var current = history.state;
      if (current && typeof current === 'object') {
        for (var key in current) state[key] = current[key];
      }
      state[HISTORY_KEY] = true;
      history.pushState(state, '');
    } catch (error) {
      /* sandboxed frames can refuse pushState — the drawer still works */
    }
  }

  // options.fromPop: history entry already gone (real Back pressed).
  // options.skipHistory: leave history alone (bfcache restore, editor reload).
  // options.focusTrigger: return focus to the hamburger (Escape).
  function closeDrawer(options) {
    options = options || {};
    var nav = active && active.nav;
    var trigger = active && active.trigger;
    active = null;
    if (nav) {
      nav.removeAttribute('data-ds-nav-drawer-open');
      syncTrigger(trigger || triggerForNav(nav), nav, false);
    }
    syncScrollLock();
    // Drop the flag via replaceState, not history.back() — back() fires a
    // page-wide popstate other listeners (collection AJAX) can't tell
    // apart from real navigation.
    if (!options.fromPop && !options.skipHistory && history.state && history.state[HISTORY_KEY]) {
      try {
        var cleaned = {};
        for (var k in history.state) if (k !== HISTORY_KEY) cleaned[k] = history.state[k];
        history.replaceState(cleaned, '');
      } catch (error) {
        /* ignore */
      }
    }
    if (options.focusTrigger && trigger && trigger.isConnected) trigger.focus();
  }

  window.addEventListener('popstate', function () {
    if (!active) return;
    // Flags this pop as overlay-close, not navigation, for collection AJAX
    // listeners (theme repo) — see file header for the ordering guarantee.
    window.__dsNavDrawerPoppedOverlay = true;
    closeDrawer({ fromPop: true });
  });

  // A bfcache restore can bring the page back with the drawer still open.
  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    var stale = document.querySelector('[data-ds-nav-drawer][data-ds-nav-drawer-open]');
    if (stale) {
      active = { nav: stale, trigger: triggerForNav(stale) };
      closeDrawer({ skipHistory: true });
    }
  });

  /* ---- Fold grids longer than MAX_CARDS behind "More" --------------------- */

  function gridItems(grid) {
    return Array.prototype.filter.call(grid.querySelectorAll('[data-ds-nav-drawer-item]'), function (item) {
      return item.closest('[data-ds-nav-drawer-grid]') === grid;
    });
  }

  function moreItemFor(grid) {
    var items = grid.querySelectorAll('[data-ds-nav-drawer-more-item]');
    for (var i = 0; i < items.length; i += 1) {
      if (items[i].closest('[data-ds-nav-drawer-grid]') === grid) return items[i];
    }
    return null;
  }

  function foldGrid(grid) {
    // Once the shopper expanded this grid, keep it expanded until the section
    // re-renders (which brings fresh markup without the marker).
    if (grid.hasAttribute('data-ds-nav-drawer-expanded')) return;
    var items = gridItems(grid);
    var moreItem = moreItemFor(grid);
    var fold = items.length > MAX_CARDS && !!moreItem;
    items.forEach(function (item, index) {
      var overflow = fold && index >= MAX_CARDS;
      if (overflow) {
        item.hidden = true;
        item.setAttribute('data-ds-nav-drawer-overflow', '');
      } else if (item.hasAttribute('data-ds-nav-drawer-overflow')) {
        // Only undo what this file hid; [hidden] set by Liquid stays.
        item.hidden = false;
        item.removeAttribute('data-ds-nav-drawer-overflow');
      }
    });
    if (moreItem) {
      moreItem.hidden = !fold;
      var more = moreItem.querySelector('[data-ds-nav-drawer-more]');
      if (more) more.setAttribute('aria-expanded', 'false');
    }
  }

  function expandGrid(grid, focusFirst) {
    var revealed = [];
    gridItems(grid).forEach(function (item) {
      if (!item.hasAttribute('data-ds-nav-drawer-overflow')) return;
      item.hidden = false;
      item.removeAttribute('data-ds-nav-drawer-overflow');
      revealed.push(item);
    });
    grid.setAttribute('data-ds-nav-drawer-expanded', '');
    var moreItem = moreItemFor(grid);
    if (moreItem) {
      var more = moreItem.querySelector('[data-ds-nav-drawer-more]');
      if (more) more.setAttribute('aria-expanded', 'true');
      moreItem.hidden = true;
    }
    if (focusFirst && revealed.length) {
      var card = revealed[0].querySelector('[data-ds-nav-drawer-card]');
      if (card) card.focus({ preventScroll: false });
    }
  }

  function foldGrids(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-ds-nav-drawer-grid]').forEach(foldGrid);
  }

  /* ---- Observers: remeasure while open -------------------------------------- */

  var headerBox = typeof ResizeObserver === 'function' ? new ResizeObserver(sizeOpenDrawer) : null;

  /* Dismissing the announcement bar shortens the header while the drawer stays
     open; a size observer misses that when the bar's wrapper collapses without
     resizing the header box, so also remeasure when header children change. */
  function watchHeaders(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var headers = Array.prototype.slice.call(scope.querySelectorAll('[data-ds-header]'));
    if (scope.matches && scope.matches('[data-ds-header]')) headers.push(scope);
    headers.forEach(function (header) {
      if (header.__dsNavDrawerWatch || !header.querySelector('[data-ds-nav-drawer]')) return;
      header.__dsNavDrawerWatch = true;
      if (headerBox) headerBox.observe(header);
      if (typeof MutationObserver === 'function') {
        new MutationObserver(sizeOpenDrawer).observe(header, { childList: true, subtree: true });
      }
    });
  }

  // Safety net: if more than one card ends up marked current (menu data
  // mistake, future Liquid regression), show none rather than several — a
  // wrong single highlight is a data bug; several at once reads as broken.
  function guardSingleCurrent(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-ds-nav-drawer]').forEach(function (nav) {
      var current = nav.querySelectorAll('[data-ds-nav-drawer-card][data-ds-nav-drawer-current]');
      if (current.length > 1) {
        current.forEach(function (card) {
          card.removeAttribute('data-ds-nav-drawer-current');
          card.removeAttribute('aria-current');
        });
      }
    });
  }

  function init(root) {
    foldGrids(root);
    watchHeaders(root);
    guardSingleCurrent(root);
    // A section re-render drops the open nav from the DOM; release the lock
    // and the state that pointed at it.
    if (active && !active.nav.isConnected) {
      active = null;
    }
    syncScrollLock();
  }

  init(document);

  // A reload keeps history.state; clear a leftover flag so this page's
  // drawer (which starts closed) doesn't act on it.
  if (history.state && history.state[HISTORY_KEY]) {
    try {
      var cleaned = {};
      for (var k in history.state) if (k !== HISTORY_KEY) cleaned[k] = history.state[k];
      history.replaceState(cleaned, '');
    } catch (error) {
      /* ignore */
    }
  }

  /* ---- Delegated events --------------------------------------------------- */

  document.addEventListener('click', function (event) {
    if (!event.target.closest) return;

    // header-nav.js also sees this click (and preventDefaults it) but no-ops
    // on v2 markup; neither listener depends on running first.
    var trigger = event.target.closest('[data-ds-header-menu-button]');
    if (trigger) {
      var nav = navForTrigger(trigger);
      if (!nav) return;
      event.preventDefault();
      if (isOpen(nav)) closeDrawer();
      else openDrawer(nav, trigger);
      return;
    }

    var drawer = event.target.closest('[data-ds-nav-drawer]');
    if (!drawer) return;

    // Tap on the scrim.
    if (event.target.closest('[data-ds-nav-drawer-backdrop]')) {
      event.preventDefault();
      if (active && active.nav === drawer) closeDrawer();
      return;
    }

    // Cards with a level drill down; cards without aria-controls are links.
    var card = event.target.closest('[data-ds-nav-drawer-card][aria-controls]');
    if (card) {
      if (openLevel(card)) event.preventDefault();
      return;
    }

    var back = event.target.closest('[data-ds-nav-drawer-back]');
    if (back) {
      event.preventDefault();
      closeLevel(back);
      return;
    }

    // One open group per level.
    var toggle = event.target.closest('[data-ds-nav-drawer-group-toggle]');
    if (toggle) {
      event.preventDefault();
      var willOpen = toggle.getAttribute('aria-expanded') !== 'true';
      if (willOpen) {
        var scope = toggle.closest('[data-ds-nav-drawer-level]') || drawer;
        scope.querySelectorAll('[data-ds-nav-drawer-group-toggle][aria-expanded="true"]').forEach(function (other) {
          if (other !== toggle) setGroup(other, false);
        });
      }
      setGroup(toggle, willOpen);
      return;
    }

    // Reveal the folded cards in place.
    var more = event.target.closest('[data-ds-nav-drawer-more]');
    if (more) {
      event.preventDefault();
      var grid = more.closest('[data-ds-nav-drawer-grid]');
      if (grid) expandGrid(grid, true);
    }
  });

  // Escape, capture phase: so the region modal's own Escape handler (which may
  // close it first in bubble order) can't make this think no modal was open —
  // Escape over an open region modal closes only that modal.
  document.addEventListener(
    'keydown',
    function (event) {
      if (event.key !== 'Escape' || !active) return;
      if (document.querySelector('[data-ds-region-modal][aria-hidden="false"]')) return;
      closeDrawer({ focusTrigger: true });
    },
    true,
  );

  // iOS ignores overflow:hidden on the page for touch scrolling; block drags
  // outside the sheet (and an open region modal above it).
  document.addEventListener(
    'touchmove',
    function (event) {
      if (!document.documentElement.hasAttribute('data-ds-nav-drawer-scroll-lock')) return;
      if (event.target.closest && event.target.closest('[data-ds-nav-drawer-panel]')) return;
      if (event.target.closest && event.target.closest('[data-ds-region-modal][aria-hidden="false"]')) return;
      if (event.cancelable) event.preventDefault();
    },
    { passive: false },
  );

  window.addEventListener('resize', function () {
    if (!active) return;
    if (window.innerWidth >= DESKTOP_MIN) {
      closeDrawer();
      return;
    }
    sizeDrawer(active.nav);
  });

  window.addEventListener('scroll', sizeOpenDrawer, { passive: true });

  document.addEventListener('ds:header-announcement-dismiss', function () {
    sizeOpenDrawer();
    requestAnimationFrame(sizeOpenDrawer);
  });

  /* ---- Theme Editor --------------------------------------------------------- */

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var target = event.target;
    var nav = target && target.closest && target.closest('[data-ds-nav-drawer]');
    if (!nav) return;
    init(nav);
    if (window.innerWidth >= DESKTOP_MIN) return;
    // A folded card can't be edited while hidden — unfold its grid.
    var folded = target.closest('[data-ds-nav-drawer-overflow]') ||
      (target.querySelector && target.querySelector('[data-ds-nav-drawer-overflow]'));
    var grid = folded && folded.closest('[data-ds-nav-drawer-grid]');
    if (grid) expandGrid(grid, false);
    if (!isOpen(nav)) openDrawer(nav);
  });

  document.addEventListener('shopify:section:unload', function () {
    window.setTimeout(function () {
      if (active && !active.nav.isConnected) active = null;
      syncScrollLock();
    }, 0);
  });
})();

} catch (sfError) {
if (typeof console !== 'undefined') console.error('[sf-core] behavior "0header-nav-drawer" failed to initialise:', sfError);
}
})();

/* accordion.js */
(function () {
try {
/* accordion — expand/collapse with height animation + chevron rotation.
 * Binds [data-ds-accordion] and data-ds-accordion-{trigger,content,chevron}
 * (see snippets/ds-accordion.liquid). aria-expanded on the trigger is the state.
 * Progressive enhancement: without JS the content stays visible (open).
 *
 * Authoring rules: src/behaviors/README.md. No import/export.
 */

if (!document.__dsAccordionBound) {
  document.__dsAccordionBound = true;
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest && e.target.closest('[data-ds-accordion-trigger]');
    if (!trigger) return;
    var root = trigger.closest('[data-ds-accordion]');
    if (!root) return;
    var content = root.querySelector('[data-ds-accordion-content]');
    if (!content) return;

    var isOpen = trigger.getAttribute('aria-expanded') === 'true';
    trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');

    if (isOpen) {
      // Closing: pin the current height, then animate to 0 next frame.
      content.style.maxHeight = content.scrollHeight + 'px';
      requestAnimationFrame(function () { content.style.maxHeight = '0'; });
    } else {
      // Opening: measure real height, then animate 0 → height.
      content.style.maxHeight = 'none';
      var h = content.scrollHeight;
      content.style.maxHeight = '0';
      requestAnimationFrame(function () { content.style.maxHeight = h + 'px'; });
      content.addEventListener('transitionend', function onEnd() {
        content.style.maxHeight = 'none';
        content.removeEventListener('transitionend', onEnd);
      });
    }

    var chevron = root.querySelector('[data-ds-accordion-chevron]');
    if (chevron) chevron.classList.toggle('sf-rotate-180', !isOpen);
  });
}

} catch (sfError) {
if (typeof console !== 'undefined') console.error('[sf-core] behavior "accordion" failed to initialise:', sfError);
}
})();

/* announcement.js */
(function () {
try {
/* announcement — rotate announcement item blocks vertically.
 *
 * Pauses while shoppers hover/focus the bar and restarts after Theme Editor
 * section renders. Progressive enhancement: the first message is visible and
 * the remaining faces are inert without JS.
 *
 * No external CSS required. Animation/layout styles are applied inline.
 *
 * Authoring rules: src/behaviors/README.md. No import/export.
 */

var ANNOUNCEMENT = '[data-ds-header-announcement]';
var ANNOUNCEMENT_SLIDE = '[data-ds-announcement-slide]';
var ANNOUNCEMENT_VIEWPORT = '[data-ds-announcement-viewport]';
var ANNOUNCEMENT_TRACK = '[data-ds-announcement-track]';

function bindAnnouncement(root) {
  if (root.dataset.dsAnnouncementBound) return;
  root.dataset.dsAnnouncementBound = '1';

  var viewport = root.querySelector(ANNOUNCEMENT_VIEWPORT);
  var track = root.querySelector(ANNOUNCEMENT_TRACK);
  var slides = Array.from(root.querySelectorAll(ANNOUNCEMENT_SLIDE));

  if (!viewport || !track || !slides.length) return;

  var active = 0;
  var timer = null;
  var animating = false;

  var duration = 500;
  var interval = Number(root.dataset.dsAnnouncementInterval || 4000);

  interval = Math.max(2000, interval);

  var reduceMotion = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /*
   * Viewport
   *
   * Critical one-line layout is already present in the server-rendered markup
   * so the first paint has the same height as the hydrated state (no CLS). The
   * band height is owned by the snippet class (sf-h-8 below lg, sf-h-11 at lg —
   * 32/44px), so DON'T pin an inline height here: an inline value beats the
   * class and would force one height at every breakpoint, overflowing the band
   * and knocking the copy off-centre.
   */
  viewport.style.position = 'relative';
  viewport.style.display = 'block';
  viewport.style.overflow = 'hidden';

  /*
   * Keep the track a block box (width = viewport width). As a flex item it would
   * take min-width:auto and grow to the message's min-content width, so a long
   * nowrap message would never be clipped by the viewport — and the marquee,
   * which only scrolls when the copy overflows, would never start. Block layout
   * clamps the copy to the band width so the overflow (and the scroll) is real.
   */
  track.style.position = 'relative';
  track.style.display = 'block';
  track.style.height = '100%';

  /*
   * Initial slide state.
   */
  slides.forEach(function (slide, index) {
    slide.dataset.dsAnnouncementIndex = String(index);
    slide.dataset.state = index === 0 ? 'active' : 'idle';

    slide.style.width = '100%';
    slide.style.minWidth = '0';
    slide.style.boxSizing = 'border-box';
    slide.style.whiteSpace = 'nowrap';
    // Not clipped: the CTA's 44 tap box (data-ds-tap) reaches above and below
    // the 20px line, and Chromium hit-tests overflow-x: clip as a clip on both
    // axes. The message truncates on its own and the viewport clips the band.
    slide.style.overflow = 'visible';

    var message = slide.querySelector('[data-ds-announcement-message]');

    if (message) {
      message.style.minWidth = '0';
      message.style.overflow = 'hidden';
      message.style.textOverflow = 'ellipsis';
      message.style.whiteSpace = 'nowrap';
    }

    /*
     * Announcement items can contain message + CTA, so keep their contents
     * centered as one horizontal row.
     */
    slide.style.alignItems = 'center';
    slide.style.justifyContent = 'center';

    /*
     * Don't overwrite display if the nested block already explicitly defines
     * one. Inline-flex is needed for the usual span-based announcement item.
     */
    if (!slide.style.display) {
      slide.style.display = 'flex';
    }

    if (!reduceMotion) {
      slide.style.transition =
        'transform ' +
        duration +
        'ms cubic-bezier(.22, 1, .36, 1), opacity ' +
        duration +
        'ms cubic-bezier(.22, 1, .36, 1)';

      slide.style.willChange = 'transform, opacity';
    }

    if (index === 0) {
      slide.style.position = 'relative';
      slide.style.inset = '';
      slide.style.height = '100%';
      slide.style.transform = 'translate3d(0, 0, 0)';
      slide.style.opacity = '1';
      slide.style.pointerEvents = '';

      slide.removeAttribute('aria-hidden');
    } else {
      slide.style.position = 'absolute';
      slide.style.inset = '0';
      slide.style.transform = 'translate3d(0, 100%, 0)';
      slide.style.opacity = '0';
      slide.style.pointerEvents = 'none';

      slide.setAttribute('aria-hidden', 'true');
    }
  });

  /*
   * Marquee for messages that don't fit on one line (typically mobile).
   *
   * Instead of clipping the copy with an ellipsis ("…"), the active slide's
   * message scrolls horizontally in a continuous one-direction loop so the
   * shopper can read all of it. Skipped entirely under reduced-motion (the
   * server-rendered ellipsis stays) and when the copy already fits.
   */
  var marquee = null;

  function pauseMarquee() {
    if (marquee && marquee.anim) marquee.anim.pause();
  }

  function resumeMarquee() {
    if (marquee && marquee.anim && !reduceMotion) marquee.anim.play();
  }

  function teardownMarquee() {
    if (!marquee) return;
    try { marquee.anim.cancel(); } catch (error) { /* already gone */ }
    if (marquee.inner) marquee.inner.style.transform = '';
    marquee = null;
  }

  function setupMarquee(slide) {
    teardownMarquee();

    if (reduceMotion || !slide) return;

    var message = slide.querySelector('[data-ds-announcement-message]');
    if (!message) return;

    /*
     * Build (once) an inner "track" we can translate while the message box
     * clips. The real copy plus an aria-hidden clone ride the track with a gap
     * between them; translating by exactly one copy + gap lands the clone where
     * the original started, so looping back to 0 is seamless — a continuous
     * one-direction scroll with no visible jump-back. Once the text lives in a
     * child element the parent's text-overflow ellipsis no longer applies.
     */
    var GAP = 48;

    var track = message.querySelector('[data-ds-announcement-marquee]');
    var copy;

    if (!track) {
      track = document.createElement('span');
      track.setAttribute('data-ds-announcement-marquee', '');
      track.style.display = 'inline-flex';
      track.style.flexWrap = 'nowrap';
      track.style.alignItems = 'center';
      track.style.willChange = 'transform';

      copy = document.createElement('span');
      copy.setAttribute('data-ds-announcement-marquee-copy', '');
      copy.style.whiteSpace = 'nowrap';

      while (message.firstChild) {
        copy.appendChild(message.firstChild);
      }

      track.appendChild(copy);
      message.appendChild(track);
    } else {
      track.style.transform = '';
      copy = track.querySelector('[data-ds-announcement-marquee-copy]');
    }

    message.style.overflow = 'hidden';
    message.style.textOverflow = 'clip';
    message.style.whiteSpace = 'nowrap';

    var single = Math.ceil(copy.getBoundingClientRect().width);
    var clone = track.querySelector('[data-ds-announcement-marquee-clone]');

    /* Fits on one line — leave it centered, drop any clone, nothing to loop. */
    if (single <= message.clientWidth + 4) {
      if (clone) track.removeChild(clone);
      track.style.gap = '';
      return;
    }

    if (typeof track.animate !== 'function') return;

    /* Trailing clone makes the wrap-around seamless. */
    if (!clone) {
      clone = copy.cloneNode(true);
      clone.removeAttribute('data-ds-announcement-marquee-copy');
      clone.setAttribute('data-ds-announcement-marquee-clone', '');
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);
    }

    track.style.gap = GAP + 'px';

    var distance = single + GAP;

    /* ~55px/s constant scroll. */
    var duration = Math.max(4000, Math.round((distance / 55) * 1000));

    marquee = {
      inner: track,
      slide: slide,
      anim: track.animate(
        [
          { transform: 'translateX(0)' },
          { transform: 'translateX(-' + distance + 'px)' }
        ],
        {
          duration: duration,
          iterations: Infinity,
          easing: 'linear'
        }
      )
    };
  }

  setupMarquee(slides[active]);

  /* Web fonts can reflow the copy after first paint — re-measure once ready. */
  if (document.fonts && document.fonts.ready &&
    typeof document.fonts.ready.then === 'function') {
    document.fonts.ready.then(function () {
      setupMarquee(slides[active]);
    });
  }

  /* Re-measure when the viewport (and therefore the overflow) changes. */
  var resizeTimer = null;
  window.addEventListener('resize', function () {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(function () {
      setupMarquee(slides[active]);
    }, 150);
  });

  /* Pause the scroll while the shopper is reading (hover/focus). */
  root.addEventListener('mouseenter', pauseMarquee);
  root.addEventListener('mouseleave', resumeMarquee);
  root.addEventListener('focusin', pauseMarquee);
  root.addEventListener('focusout', function (event) {
    if (!root.contains(event.relatedTarget)) resumeMarquee();
  });

  if (slides.length < 2) return;

  function clearTimer() {
    window.clearTimeout(timer);
    timer = null;
  }

  function schedule() {
    clearTimer();

    if (!root.isConnected) return;
    if (animating) return;

    timer = window.setTimeout(flip, interval);
  }

  function completeFlip(previous, next, nextIndex) {
    /*
     * Previous slide returns to the waiting position below the viewport.
     */
    previous.dataset.state = 'idle';
    previous.style.position = 'absolute';
    previous.style.inset = '0';
    previous.style.transform = 'translate3d(0, 100%, 0)';
    previous.style.opacity = '0';
    previous.style.pointerEvents = 'none';
    previous.setAttribute('aria-hidden', 'true');

    /*
     * New active slide becomes the element defining the track's natural
     * height.
     */
    next.dataset.state = 'active';
    next.style.position = 'relative';
    next.style.inset = '';
    next.style.height = '100%';
    next.style.transform = 'translate3d(0, 0, 0)';
    next.style.opacity = '1';
    next.style.pointerEvents = '';
    next.removeAttribute('aria-hidden');

    active = nextIndex;
    animating = false;

    setupMarquee(next);

    schedule();
  }

  function flip() {
    if (!root.isConnected) return;
    if (animating) return;

    animating = true;
    clearTimer();

    var previous = slides[active];
    var nextIndex = (active + 1) % slides.length;
    var next = slides[nextIndex];

    /*
     * Reduced motion: swap immediately.
     */
    if (reduceMotion) {
      completeFlip(previous, next, nextIndex);
      return;
    }

    /*
     * Prepare the incoming slide below the viewport.
     */
    next.dataset.state = 'entering';
    next.style.position = 'absolute';
    next.style.inset = '0';
    next.style.transform = 'translate3d(0, 100%, 0)';
    next.style.opacity = '0';
    next.style.pointerEvents = 'none';
    next.removeAttribute('aria-hidden');

    /*
     * Previous remains visually active at its current position.
     */
    previous.style.position = 'relative';
    previous.style.inset = '';
    previous.style.transform = 'translate3d(0, 0, 0)';
    previous.style.opacity = '1';

    /*
     * Commit the incoming slide's starting pose before transitioning it.
     */
    next.getBoundingClientRect();

    requestAnimationFrame(function () {
      if (!root.isConnected) return;

      previous.dataset.state = 'leaving';
      next.dataset.state = 'active';

      previous.style.transform = 'translate3d(0, -100%, 0)';
      previous.style.opacity = '0';
      previous.style.pointerEvents = 'none';

      next.style.transform = 'translate3d(0, 0, 0)';
      next.style.opacity = '1';
    });

    var finished = false;

    function finish(event) {
      if (finished) return;

      /*
       * Ignore transitionend events bubbling from children and ignore opacity;
       * transform is the transition that defines completion.
       */
      if (event) {
        if (event.target !== next) return;
        if (event.propertyName !== 'transform') return;
      }

      finished = true;

      next.removeEventListener('transitionend', finish);

      completeFlip(previous, next, nextIndex);
    }

    next.addEventListener('transitionend', finish);

    /*
     * Safety fallback for browsers/layout changes that prevent transitionend
     * from firing.
     */
    window.setTimeout(function () {
      finish();
    }, duration + 100);
  }

  /*
   * Pause rotation while the shopper is interacting with the bar.
   */
  root.addEventListener('mouseenter', function () {
    clearTimer();
  });

  root.addEventListener('mouseleave', function () {
    if (!animating) schedule();
  });

  root.addEventListener('focusin', function () {
    clearTimer();
  });

  root.addEventListener('focusout', function (event) {
    if (!root.contains(event.relatedTarget) && !animating) {
      schedule();
    }
  });

  schedule();
}

function initAnnouncements(scope) {
  if (!scope) return;

  if (scope.matches && scope.matches(ANNOUNCEMENT)) {
    bindAnnouncement(scope);
  }

  if (scope.querySelectorAll) {
    scope.querySelectorAll(ANNOUNCEMENT).forEach(bindAnnouncement);
  }
}

if (!document.__dsAnnouncementBound) {
  document.__dsAnnouncementBound = true;

  var startAnnouncements = function () {
    initAnnouncements(document);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startAnnouncements);
  } else {
    startAnnouncements();
  }

  /*
   * Shopify Theme Editor: bind newly rendered sections.
   */
  document.addEventListener('shopify:section:load', function (event) {
    initAnnouncements(event.target);
  });

  /*
   * Dismiss announcement bar.
   */
  document.addEventListener('click', function (event) {
    var dismiss =
      event.target.closest &&
      event.target.closest('[data-ds-header-announcement-dismiss]');

    var root = dismiss && dismiss.closest(ANNOUNCEMENT);

    if (root) {
      root.remove();
      document.dispatchEvent(new CustomEvent('ds:header-announcement-dismiss'));
    }
  });
}
} catch (sfError) {
if (typeof console !== 'undefined') console.error('[sf-core] behavior "announcement" failed to initialise:', sfError);
}
})();

/* cart-added.js */
(function () {
try {
/* cart-added — opens the "Added to cart" dialog (ds-cart-added with modal: true)
 * after an AJAX add, filled from the line that was just added.
 *
 * Reads the ds:cart:added detail buy-buttons.js emits — the Cart AJAX API
 * response for /cart/add.js, whose first non-child line carries what to show:
 * image, product_title, options_with_values, final_line_price. No component DOM
 * is touched but this dialog's own hooks.
 *
 * The BuildYou path adds its add-ons in a second request (product-addon.js) and
 * then re-emits this event with the parent product line plus its add-on children,
 * so the dialog re-fills with the product, the add-on rows and a combined total.
 * That event lands after the BuildYou SDK bridge's own product-only event
 * (blocks/ds-product-customization-form.liquid), which forwards the SDK's format
 * and falls through to "no line" — the dialog then keeps the line its Liquid
 * rendered, the product and variant on the page, until the add-on event refines it.
 *
 * Progressive enhancement: without this script the dialog stays hidden and the
 * add still happens — buy-buttons.js already falls back to a full-page POST.
 *
 * Authoring rules: src/behaviors/README.md. No import/export.
 */

(function () {
  if (document.__dsCartAddedBound) return;
  document.__dsCartAddedBound = true;

  var lastFocus = null;

  function modal() {
    return document.querySelector('[data-ds-cart-added-modal]');
  }

  // One attribute is the whole state: src/cart-added.css animates off it.
  function isOpen(el) {
    return Boolean(el) && el.getAttribute('aria-hidden') === 'false';
  }

  // The Cart AJAX API returns the added line itself, or { items: [...] } when
  // several land at once. Take the first line that is not an add-on: a bundle add
  // sends the add-ons FIRST and the main product last (Cross-sell Bundle spec
  // §3.2), and the add-on path (product-addon.js) emits ds:cart:added for a
  // request that contains ONLY add-ons — the dialog must show the product either
  // way, never its gift box.
  function isChild(line) {
    if (!line) return false;
    var properties = line.properties;
    return Boolean(
      line.parent_relationship ||
        line.parent_line_key ||
        (properties && properties._bundle_role === 'addon')
    );
  }

  // The add-on lines of the same response. buy-buttons.js sends main + add-ons in
  // ONE /cart/add.js call, so a bundle arrives here whole and the dialog can show
  // what the shopper actually paid — the product price alone would understate it.
  function addedAddons(detail) {
    if (!detail || !Array.isArray(detail.items)) return [];
    return detail.items.filter(isChild);
  }

  function addedLine(detail) {
    if (!detail) return null;
    if (Array.isArray(detail.items)) {
      for (var i = 0; i < detail.items.length; i += 1) {
        if (!isChild(detail.items[i])) return detail.items[i];
      }
      return null;
    }
    if (isChild(detail)) return null;
    return detail.product_title || detail.title ? detail : null;
  }

  function optionLabels(line) {
    var pairs = line.options_with_values;
    if (!Array.isArray(pairs)) return [];
    return pairs
      .filter(function (pair) {
        // Shopify sends "Title / Default Title" for products with no real options.
        return pair && pair.value && pair.value !== 'Default Title';
      })
      .map(function (pair) {
        // Colour values may be "Name|swatch-file"; only the name is for shoppers.
        return { name: pair.name, value: String(pair.value).split('|')[0].trim() };
      });
  }

  /* A "Buy More Save More" value is one pack: "1 PC" or "2 PCS" (the s is
     optional). The count is how many pieces that variant sells. */
  function packCount(line) {
    var pairs = line && line.options_with_values;
    if (!Array.isArray(pairs)) return 0;
    for (var i = 0; i < pairs.length; i++) {
      var pair = pairs[i];
      if (!pair || !pair.name || pair.name.indexOf('Buy More Save More') === -1) continue;
      var parts = String(pair.value || '').trim().split(/\s+/);
      if (!parts.length || !/^\d+$/.test(parts[0])) continue;
      if (parts.length > 1 && !/^pcs?$/i.test(parts[1])) continue;
      var count = Number(parts[0]);
      if (count >= 1) return count;
    }
    return 0;
  }

  /* The /pc figure painted inside the selected pack pill ("$30.95/pc"), not
     the pack total in the price block. */
  function selectedPillPiece(count) {
    var pills = document.querySelectorAll('[data-ds-bmsm-pill][aria-current="true"]');
    for (var i = 0; i < pills.length; i++) {
      var top = pills[i].querySelector('[data-ds-bmsm-pill-top]');
      var bot = pills[i].querySelector('[data-ds-bmsm-pill-bot]');
      if (!top || !bot) continue;
      var parts = top.textContent.trim().split(/\s+/);
      if (!/^\d+$/.test(parts[0]) || Number(parts[0]) !== count) continue;
      if (parts.length > 1 && !/^pcs?$/i.test(parts[1])) continue;
      var text = bot.textContent.replace(/\s+/g, ' ').trim();
      if (text) return text;
    }
    return '';
  }

  // Shopify money fields are integer cents; the shop's format lives in Liquid, not
  // here, so render the store default and let the theme override via data-money.
  function money(cents, root) {
    var format = root.getAttribute('data-ds-cart-added-money') || '${{amount}}';
    var amount = (Number(cents) || 0) / 100;
    return format.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, amount.toFixed(2));
  }

  // A live personalization canvas snapshot, or '' if it can't be read (a
  // cross-origin-tainted canvas throws on toDataURL — never let that break fill).
  function canvasPreview(canvas, type, quality) {
    if (!canvas || typeof canvas.toDataURL !== 'function') return '';
    try {
      return canvas.toDataURL({ format: type, quality: quality }) || '';
    } catch (e) {
      return '';
    }
  }

  function eventPreview(detail) {
    // The exact frame the shopper just personalized, in priority order: a live
    // personalization canvas (buildyouCanvas, then engraver), then the SDK's
    // in-memory preview (window.BuildYou.publicPreviewUrl, usually a data: URI),
    // then whatever preview URL the event detail carried. ds:cart:added fires only
    // after the bridge's /cart.js round trip, so these are set by modal-open time.
    var win = typeof window !== 'undefined' ? window : null;
    var candidate =
      (win && win.buildyouCanvas && canvasPreview(win.buildyouCanvas, 'png', 0.7)) ||
      (win && win.engraver && canvasPreview(win.engraver.canvas, 'jpeg', 0.7)) ||
      (win && win.BuildYou && win.BuildYou.publicPreviewUrl) ||
      (detail &&
        typeof detail === 'object' &&
        (detail.previewUrl ||
          detail.previewImageUrl ||
          detail.publicPreviewUrl ||
          detail.preview_image)) ||
      '';
    if (candidate && typeof candidate === 'object') candidate = candidate.url || candidate.src || '';
    return typeof candidate === 'string' ? candidate : '';
  }

  /* Parse `_custom_groups_{n} {label}` line-item properties into an ordered
     pack list. Nova emits one property per pack carrying the pack's preview
     URL as the value; the key tail is the pack name (24-hex id → fallback to
     "Pack {n}"). Empty values are skipped, so a pack whose render hasn't
     landed yet drops out rather than painting a broken thumbnail. */
  function parsePacks(line) {
    var properties = (line && line.properties) || {};
    var hex24 = /^[a-f0-9]{24}$/i;
    var packs = [];
    Object.keys(properties).forEach(function (key) {
      if (key.indexOf('_custom_groups_') !== 0) return;
      var url = properties[key];
      if (!url) return;
      var tail = key.replace(/^_custom_groups_\d+\s*/, '').trim();
      var name = tail && !hex24.test(tail) ? tail : '';
      packs.push({ url: String(url), name: name, rawKey: key });
    });
    return packs;
  }

  function fillPacks(root, packs, image, titleText) {
    var wrap = root.querySelector('[data-ds-cart-added-pack-wrap]');
    if (!wrap) return;
    var counter = wrap.querySelector('[data-ds-cart-added-pack-counter]');
    if (!counter) return;
    var prev = counter.querySelector('[data-ds-cart-added-pack-prev]');
    var next = counter.querySelector('[data-ds-cart-added-pack-next]');
    var counterText = counter.querySelector(
      '[data-ds-cart-added-pack-counter-text]'
    );
    if (!prev || !next || !counterText) return;

    if (packs.length < 2 || !image) {
      counter.setAttribute('hidden', '');
      wrap.removeAttribute('data-ds-cart-added-pack-index');
      return;
    }

    function render(index) {
      if (index < 0) index = 0;
      if (index >= packs.length) index = packs.length - 1;
      var pack = packs[index];
      image.src = pack.url;
      image.setAttribute('data-ds-image-zoom-src', pack.url);
      if (pack.name) {
        image.alt = pack.name;
        image.setAttribute('data-ds-image-zoom-alt', pack.name);
      } else if (titleText) {
        image.alt = titleText;
        image.setAttribute('data-ds-image-zoom-alt', titleText);
      }
      counterText.textContent = (index + 1) + '/' + packs.length;
      prev.disabled = index <= 0;
      next.disabled = index >= packs.length - 1;
      wrap.setAttribute('data-ds-cart-added-pack-index', String(index));
    }

    // Rebind each open — the handler closes over the fresh packs list, so
    // reopening with a different product never fires stale chevrons.
    prev.onclick = function (e) {
      e.preventDefault();
      var i = Number(wrap.getAttribute('data-ds-cart-added-pack-index') || '0');
      render(i - 1);
    };
    next.onclick = function (e) {
      e.preventDefault();
      var i = Number(wrap.getAttribute('data-ds-cart-added-pack-index') || '0');
      render(i + 1);
    };

    counter.removeAttribute('hidden');
    render(0);
  }

  function fill(root, line, previewUrl) {
    var titleText = line.product_title || line.title || '';
    var image = root.querySelector('[data-ds-cart-added-image]');
    if (image) {
      // The thumbnail IS the personalization preview now — no separate Preview
      // button — so it carries the zoom-lightbox hooks the button used to carry.
      // BuildYou can send the already-rendered browser preview with its success
      // event. Prefer it over the persisted line-property URL: the latter points
      // at S3 and may not be available yet when the modal opens.
      var src =
        previewUrl ||
        (line.properties && line.properties['_customily-preview']) ||
        lineImage(line);
      if (src) {
        // Swapping src on an already-loaded <img> won't re-show the spinner on
        // its own — reset it so the frame goes gray/spinning again, same as a
        // fresh ds-image on the cart page (image-fallback.js hides it once more
        // on the new load/error).
        var wrap = image.closest('[data-ds-image]');
        var spinner = wrap && wrap.querySelector('[data-ds-image-loading]');
        if (spinner) spinner.hidden = false;
        delete image.dataset.dsImageRetries;
        image.src = src;
        image.alt = titleText;
        image.setAttribute('data-ds-image-zoom-src', src);
        image.setAttribute('data-ds-image-zoom-alt', titleText);
        image.setAttribute('data-ds-image-zoom-title', titleText);
        image.removeAttribute('hidden');
      } else {
        image.setAttribute('hidden', '');
      }
    }

    // Multi-Pack navigator (SF0201): overrides the single-image fallback above
    // when the line carries ≥ 2 `_custom_groups_*` properties, pointing the
    // thumbnail at pack 1 and wiring chevron prev/next.
    fillPacks(root, parsePacks(line), image, titleText);

    var title = root.querySelector('[data-ds-cart-added-title]');
    if (title && titleText) title.textContent = titleText;

    var options = root.querySelector('[data-ds-cart-added-options]');
    if (options) {
      var labels = optionLabels(line);
      options.textContent = '';
      labels.forEach(function (label) {
        /* Same two spans the Liquid draws: the label in the row's own weight,
         * the chosen value semibold navy. textContent on each, so a value that
         * came back from Shopify can never inject markup. */
        var span = document.createElement('span');
        span.appendChild(document.createTextNode(label.name + ': '));
        var value = document.createElement('span');
        value.className = 'sf-font-semibold sf-text-action-secondary';
        value.textContent = label.value;
        span.appendChild(value);
        options.appendChild(span);
      });
      if (labels.length) {
        options.removeAttribute('hidden');
      } else {
        options.setAttribute('hidden', '');
      }
    }

    var amount = root.querySelector('[data-ds-price-amount]');
    var cents = lineCents(line);
    if (amount && cents !== null) amount.textContent = money(cents, root);


    var qtyValue = Math.max(1, Number(line.quantity) || 1);
    var quantity = root.querySelector('[data-ds-cart-added-quantity]');
    if (quantity) quantity.textContent = String(qtyValue);

    /* Under the amount: "$30.95/pc" from the selected pack pill whenever the
       line is a pack, including quantity 1. "$46.90/each" only when the line
       is not a pack and more than one was added. */
    var unit = root.querySelector('[data-ds-cart-added-unit]');
    if (unit) {
      var count = packCount(line);
      var fromPill = count >= 1 ? selectedPillPiece(count) : '';
      var unitCents = Number(line.final_price);
      var showUnit = false;
      if (fromPill) {
        unit.textContent = fromPill;
        showUnit = true;
      } else if (count >= 1 && isFinite(unitCents) && unitCents > 0) {
        var piece = money(Math.round(unitCents / count), root).replace(/\s*[A-Z]{3}\s*$/, '').trim();
        unit.textContent = piece + '/pc';
        showUnit = true;
      } else if (count === 0 && qtyValue > 1 && isFinite(unitCents) && unitCents > 0) {
        unit.textContent = money(unitCents, root).replace(/\s*[A-Z]{3}\s*$/, '').trim() + '/each';
        showUnit = true;
      }
      if (showUnit) unit.removeAttribute('hidden');
      else unit.setAttribute('hidden', '');
    }

    // ponytail: Edit item hidden in this modal on request (2026-09-08) — swap
    // this block back for `fillEdit(root, line);` to restore it.
    var editLinkWrap = root.querySelector('[data-ds-cart-added-edit-link]');
    var editBuildYouWrap = root.querySelector('[data-ds-cart-added-edit-buildyou]');
    if (editLinkWrap) editLinkWrap.setAttribute('hidden', '');
    if (editBuildYouWrap) editBuildYouWrap.setAttribute('hidden', '');

    fillProperties(root, line);
  }

  function fillEdit(root, line) {
    var properties = (line && line.properties) || {};
    var isBuildYou = Boolean(
      line &&
        line.key &&
        properties['_buildyou-customization-id'] &&
        properties['_source_app'] === 'buildyou_nova'
    );
    var linkWrap = root.querySelector('[data-ds-cart-added-edit-link]');
    var link = linkWrap && linkWrap.querySelector('[data-ds-cart-added-edit]');
    var buildYouWrap = root.querySelector('[data-ds-cart-added-edit-buildyou]');

    if (isBuildYou && buildYouWrap) {
      buildYouWrap.setAttribute('data-line-key', line.key);
      buildYouWrap.setAttribute('hidden', '');
      if (linkWrap) linkWrap.setAttribute('hidden', '');
      loadBuildYouCartBundle(buildYouWrap, linkWrap);
      return;
    }

    if (buildYouWrap) {
      buildYouWrap.setAttribute('hidden', '');
      buildYouWrap.removeAttribute('data-line-key');
    }
    if (linkWrap) linkWrap.removeAttribute('hidden');
    if (link && line.url) link.setAttribute('href', line.url);
  }

  // The cart bundle scans `.by-edit-design-slot[data-line-key]` once at startup.
  // Its MutationObserver only watches #cart_line_form, which does not exist on a
  // PDP, so loading it before this modal has the real line key leaves a visible
  // but unbound button. Stamp the key above, then load the exact cart-page bundle.
  function loadBuildYouCartBundle(editControl, fallbackControl) {
    window.BuildYou = window.BuildYou || {};
    if (window.BuildYou.cartScriptState === 'ready') {
      if (editControl.dataset.byEditBound === '1') editControl.removeAttribute('hidden');
      return;
    }
    if (window.BuildYou.cartScriptState === 'loading') {
      return;
    }
    window.BuildYou.cartScriptState = 'loading';

    // Injected at build time from .env.<env> (build.mjs applyEnvUrls), the same
    // way the Liquid snippets get their BuildYou URLs: prod build → prod CDN,
    // dev build → dev CDN. No hardcoded environment here.
    var cartCssUrl = 'https://assets.buildyou.io/scripts/shopify/cart.bundle.css';
    var cartCssFallbackUrl = 'https://cdn.bestbuildyou.com/scripts/shopify/cart.bundle.css';
    var cartJsUrl = 'https://assets.buildyou.io/scripts/shopify/cart.bundle.js';
    var cartJsFallbackUrl = 'https://cdn.bestbuildyou.com/scripts/shopify/cart.bundle.js';
    var css = document.createElement('link');
    css.rel = 'stylesheet';
    css.crossOrigin = 'anonymous';
    css.onerror = function () {
      css.onerror = null;
      css.href = cartCssFallbackUrl;
    };
    css.href = cartCssUrl;
    document.head.appendChild(css);

    function appendScript(src, canRetry) {
      var script = document.createElement('script');
      script.async = true;
      script.crossOrigin = 'anonymous';
      script.onload = function () {
        window.BuildYou.cartScriptState = 'ready';
        if (editControl.dataset.byEditBound === '1') editControl.removeAttribute('hidden');
      };
      script.onerror = function () {
        if (canRetry) {
          appendScript(cartJsFallbackUrl, false);
        } else {
          window.BuildYou.cartScriptState = 'failed';
          if (fallbackControl) fallbackControl.removeAttribute('hidden');
        }
      };
      script.src = src;
      document.head.appendChild(script);
    }

    appendScript(cartJsUrl, true);
  }

  function visibleProperties(line) {
    var properties = (line && line.properties) || {};
    var optionNames = {};
    if (Array.isArray(line && line.options_with_values)) {
      line.options_with_values.forEach(function (option) {
        if (option && option.name) optionNames[option.name] = true;
      });
    }
    return Object.keys(properties).reduce(function (rows, key) {
      var value = properties[key];
      if (!value) return rows;
      if (key.charAt(0) !== '_') {
        rows.push({ name: key, value: value });
        return rows;
      }
      if (key.indexOf('_custom_') !== 0 || /\(originals?\)|\(filtered\)/.test(String(value))) {
        return rows;
      }
      var label = key.replace(/^_custom_\S+\s*/, '').trim();
      if (label && !optionNames[label]) rows.push({ name: label, value: value });
      return rows;
    }, []);
  }

  // Rebuild the plain "Label: Value" lines the static card draws — one per line,
  // the same flat style as the chosen options above (Figma 5543:37874), not the
  // boxed list the full cart line uses.
  function fillProperties(root, line) {
    var el = root.querySelector('[data-ds-cart-added-properties]');
    if (!el) return;
    // ponytail: personalization lines hidden on request (2026-09-05) — matches the
    // snippet's static override; restore `visibleProperties(line)` to bring them back.
    var rows = [];
    el.textContent = '';
    rows.forEach(function (row) {
      var span = document.createElement('span');
      span.textContent = row.name + ': ' + row.value;
      el.appendChild(span);
    });
    if (rows.length) el.removeAttribute('hidden');
    else el.setAttribute('hidden', '');
  }

  // The line total in cents, or null when the payload carries no price at all —
  // the caller then leaves whatever Liquid already rendered rather than writing 0.
  function lineCents(line) {
    var cents = line && line.final_line_price;
    if (cents === undefined || cents === null) cents = line && line.line_price;
    if (cents === undefined || cents === null) cents = line && line.final_price;
    if (cents === undefined || cents === null) return null;
    return Number(cents) || 0;
  }

  function lineImage(line) {
    var src = (line && (line.image || line.featured_image)) || '';
    if (src && src.url) src = src.url;
    return src || '';
  }

  function fillAddonRow(node, addon, root) {
    var image = node.querySelector('[data-ds-cart-addon-image]');
    var src = lineImage(addon);
    if (image) {
      if (src) {
        image.src = src;
        image.alt = '';
        image.removeAttribute('hidden');
      } else {
        image.setAttribute('hidden', '');
      }
    }

    var title = node.querySelector('[data-ds-cart-addon-title]');
    if (title) title.textContent = addon.product_title || addon.title || '';

    // Storybook pm add-on row has Quantity only — no variant line.
    var variant = node.querySelector('[data-ds-cart-addon-variant]');
    if (variant) {
      variant.textContent = '';
      variant.setAttribute('hidden', '');
    }

    var quantity = node.querySelector('[data-ds-cart-addon-quantity]');
    if (quantity) {
      var qty = Number(addon.quantity);
      if (qty > 0) {
        // Same quantity as before (was "× N"); Storybook pm label format only.
        var labelMatch = (quantity.textContent || '').match(/^(.*?:\s*)/);
        quantity.textContent = (labelMatch ? labelMatch[1] : 'Quantity: ') + qty;
        quantity.removeAttribute('hidden');
      } else {
        quantity.setAttribute('hidden', '');
      }
    }

    var price = node.querySelector('[data-ds-cart-addon-price]');
    if (price) price.textContent = money(lineCents(addon) || 0, root);

    /* Same short note as the main line: "$5.95/each" under the line total
     * once more than one was added. addon.final_price is Shopify's per-unit
     * cents, so nothing is divided here either. */
    var addonUnit = node.querySelector('[data-ds-cart-addon-unit]');
    if (addonUnit) {
      var addonQty = Number(addon.quantity) || 0;
      /* `final_price` is what Shopify's own lines carry; a line assembled by a
       * bridge (the BuildYou path builds its own) may only have the line total,
       * so divide that back out rather than dropping the note. */
      var addonUnitCents = Number(addon.final_price);
      if (!isFinite(addonUnitCents) || addonUnitCents <= 0) {
        var addonLineCents = Number(lineCents(addon));
        if (isFinite(addonLineCents) && addonQty > 0) addonUnitCents = addonLineCents / addonQty;
      }
      if (addonQty > 1 && isFinite(addonUnitCents) && addonUnitCents > 0) {
        addonUnit.textContent = money(addonUnitCents, root).replace(/\s*[A-Z]{3}\s*$/, '').trim() + '/each';
        addonUnit.removeAttribute('hidden');
      } else {
        addonUnit.setAttribute('hidden', '');
      }
    }
    return node;
  }

  // No add-ons: the whole block goes, item total included — on its own it would
  // just restate the price already shown above.
  function fillAddons(root, line, addons) {
    var block = root.querySelector('[data-ds-cart-added-addons]');
    if (!block) return;
    var list = root.querySelector('[data-ds-cart-added-addon-list]');
    var template = root.querySelector('[data-ds-cart-added-addon-template]');
    if (!addons.length || !list || !template || !template.content.firstElementChild) {
      block.setAttribute('hidden', '');
      return;
    }

    list.textContent = '';
    var total = lineCents(line) || 0;
    addons.forEach(function (addon) {
      total += lineCents(addon) || 0;
      list.appendChild(fillAddonRow(template.content.firstElementChild.cloneNode(true), addon, root));
    });

    var totalEl = root.querySelector('[data-ds-cart-added-total]');
    if (totalEl) totalEl.textContent = money(total, root);
    block.removeAttribute('hidden');
  }

  function open(detail) {
    var el = modal();
    if (!el) return;
    var line = addedLine(detail);
    if (line) fill(el, line, eventPreview(detail));
    fillAddons(el, line, addedAddons(detail));

    lastFocus = document.activeElement;
    el.setAttribute('aria-hidden', 'false');
    el.setAttribute('data-ds-page-lock', '');

    var closeBtn = el.querySelector('[data-ds-cart-added-close]');
    // Focus after paint so the dialog is on screen first.
    window.requestAnimationFrame(function () {
      if (closeBtn) closeBtn.focus({ focusVisible: false });
    });
  }

  function close() {
    var el = modal();
    if (!isOpen(el)) return;
    // Move focus OUT before hiding. aria-hidden on an ancestor of the focused
    // element is invalid — the browser warns and refuses to hide it from the
    // a11y tree — and the Edit control that triggered a close still holds focus
    // here. Blur first, then restore focus to whatever opened the dialog.
    var active = document.activeElement;
    if (active && el.contains(active) && typeof active.blur === 'function') active.blur();
    // The sheet keeps sliding out on its own — the CSS delays visibility until
    // the transition ends, so nothing here has to wait for it.
    el.setAttribute('aria-hidden', 'true');
    el.removeAttribute('data-ds-page-lock');
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    lastFocus = null;
  }

  // Buy buttons with the dialog switched off render no dialog and carry this
  // attribute instead: the add then goes straight to the cart page.
  function redirectTarget() {
    var el = document.querySelector('[data-ds-cart-added-redirect]');
    return (el && el.getAttribute('data-ds-cart-added-redirect')) || '';
  }

  document.addEventListener('ds:cart:added', function (e) {
    if (modal()) {
      open(e.detail);
      return;
    }
    var to = redirectTarget();
    if (to) window.location.assign(to);
  });

  // Edit design: the BuildYou slot opens its editor in-page, and the cart bundle
  // binds its handler on the button itself — that target-phase handler runs
  // before any bubble listener here. Close in the CAPTURE phase so the page
  // lock is lifted BEFORE the editor opens and snapshots the body styles
  // (page-lock.js reacts between this listener and the next one); otherwise it
  // saves our pinned body and restores it on close, leaving the page stuck.
  // No preventDefault — the bundle / plain link still runs.
  document.addEventListener(
    'click',
    function (e) {
      if (e.target.closest && e.target.closest('[data-ds-cart-added-edit]')) close();
    },
    true
  );

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    if (e.target.closest('[data-ds-cart-added-continue]')) {
      e.preventDefault();
      close();
      // The trigger (e.g. a quick-add card) can be far down the page — send the
      // shopper back to the top, where continued browsing normally starts.
      // page-lock.js restores the page's scroll once this handler returns, so
      // the scroll waits for it.
      window.setTimeout(function () {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 0);
      return;
    }
    if (e.target.closest('[data-ds-cart-added-close]')) {
      e.preventDefault();
      close();
      return;
    }
    // Backdrop: the overlay itself, never the dialog inside it.
    var el = modal();
    if (isOpen(el) && e.target === el) close();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (isOpen(modal())) close();
  });
})();

} catch (sfError) {
if (typeof console !== 'undefined') console.error('[sf-core] behavior "cart-added" failed to initialise:', sfError);
}
})();

/* cart-alerts.js */
(function () {
try {
/* cart-alerts — drives the state-driven notices under the cart title
 * (snippets/ds-cart-alerts.liquid): the price-update notice's dismiss button and
 * the cart-expiry countdown ticker.
 *
 * Progressive enhancement: Liquid renders both notices fully (the countdown at
 * its starting mm:ss); this only makes them interactive — the countdown ticks
 * down and swaps to the expired copy at zero, and the price-update notice can be
 * dismissed for the session. Without JS the copy still reads correctly.
 *
 * Authoring rules: src/behaviors/README.md. No import/export.
 */

var CART_ALERTS = '[data-ds-cart-alerts]';
var PRICE_UPDATE = '[data-ds-cart-price-update]';
var PRICE_UPDATE_CLOSE = '[data-ds-cart-price-update-close]';
var EXPIRY = '[data-ds-cart-expiry]';
var EXPIRY_TIME = '[data-ds-cart-expiry-time]';
var DISMISS_KEY = 'ds-cart-price-update-dismissed';

function cartAlertsPad(n) {
  return n < 10 ? '0' + n : '' + n;
}

function cartAlertsFormat(seconds) {
  var h = Math.floor(seconds / 3600);
  var m = Math.floor((seconds % 3600) / 60);
  var s = seconds % 60;
  return h > 0
    ? h + ':' + cartAlertsPad(m) + ':' + cartAlertsPad(s)
    : cartAlertsPad(m) + ':' + cartAlertsPad(s);
}

function cartAlertsInitPriceUpdate(region) {
  var pu = region.querySelector(PRICE_UPDATE);
  if (!pu) return;
  var message = pu.textContent.trim();
  try {
    if (sessionStorage.getItem(DISMISS_KEY) === message) pu.hidden = true;
  } catch (e) {}
  var close = pu.querySelector(PRICE_UPDATE_CLOSE);
  if (close) {
    close.addEventListener('click', function () {
      pu.hidden = true;
      try {
        sessionStorage.setItem(DISMISS_KEY, message);
      } catch (e) {}
    });
  }
}

function cartAlertsInitExpiry(region) {
  var exp = region.querySelector(EXPIRY);
  if (!exp) return;
  var seconds = parseInt(exp.getAttribute('data-ds-cart-expiry-seconds'), 10) || 0;
  if (seconds <= 0) return;
  var timeEl = exp.querySelector(EXPIRY_TIME);
  var expiredText = exp.getAttribute('data-ds-cart-expiry-expired') || '';
  var remaining = seconds;
  var timer = setInterval(function () {
    remaining -= 1;
    if (remaining <= 0) {
      clearInterval(timer);
      // Swap the whole row content for the expired message, keeping the tone.
      exp.textContent = '';
      var span = document.createElement('span');
      span.className = 'sf-font-medium';
      span.textContent = expiredText;
      exp.appendChild(span);
      return;
    }
    if (timeEl) timeEl.textContent = cartAlertsFormat(remaining);
  }, 1000);
}

function cartAlertsInit(region) {
  if (!region || region.__dsCartAlertsBound) return;
  region.__dsCartAlertsBound = true;
  cartAlertsInitPriceUpdate(region);
  cartAlertsInitExpiry(region);
}

function cartAlertsInitAll() {
  var regions = document.querySelectorAll(CART_ALERTS);
  for (var i = 0; i < regions.length; i++) cartAlertsInit(regions[i]);
}

if (!document.__dsCartAlertsBound) {
  document.__dsCartAlertsBound = true;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cartAlertsInitAll, { once: true });
  } else {
    cartAlertsInitAll();
  }

  // The region can also arrive after load — the theme editor re-renders a section
  // by swapping its HTML in, with no DOMContentLoaded. Watch for it so the
  // countdown starts and the dismiss button binds in that case too. (The
  // per-region guard keeps re-scans idempotent.)
  if (typeof MutationObserver === 'function') {
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
          cartAlertsInitAll();
          return;
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
}

} catch (sfError) {
if (typeof console !== 'undefined') console.error('[sf-core] behavior "cart-alerts" failed to initialise:', sfError);
}
})();

/* cart-checkout-sticky.js */
(function () {
try {
/* cart-checkout-sticky — reveal/hide the mobile sticky checkout bar.
 *
 * Binds [data-ds-cart-checkout-sticky] (snippets/ds-cart-checkout-sticky.liquid).
 * The bar starts hidden (sf-hidden). While the in-card Checkout button
 * ([data-ds-cart-checkout-anchor], in ds-cart-summary) is OFF screen, this shows
 * the bar; once that button scrolls back into view the bar hides again, so the
 * shopper never sees two checkout buttons at once. With no JS the bar never
 * shows and the in-card button still works (progressive enhancement).
 *
 * The bar is CSS-hidden from tablet-air (820) up (tablet-air:sf-hidden, never toggled here) where the
 * Order Summary is a sticky sidebar; the observer still runs there but the CSS
 * keeps the bar gone.
 *
 * It also opens/closes the Order Summary bottom sheet the bar's total expands
 * into — see bindSheet below.
 *
 * Idempotent + Theme-Editor-safe: the section can re-render, so re-scans must
 * not double-observe. Authoring rules: src/behaviors/README.md. No import/export.
 */
function cartCheckoutStickyInit(bar) {
  if (!bar || bar.dataset.dsBound) return;

  // Watch the real in-card checkout button. Scope to this bar's cart so a page
  // with more than one never crosses the wires; fall back to document.
  var scope = bar.closest('[data-ds-cart]') || document;
  var anchor = scope.querySelector('[data-ds-cart-checkout-anchor]');
  if (!anchor) return;

  bar.dataset.dsBound = '1';

  // Without IntersectionObserver, leave the bar hidden: the in-card button is
  // enough and revealing a permanent bar would be worse than none.
  if (!('IntersectionObserver' in window)) return;

  var observer = new IntersectionObserver(
    function (entries) {
      var entry = entries[0];
      if (!entry) return;
      // In view → the shopper has reached the real button; hide the bar.
      // Out of view (above or below) → show it.
      if (entry.isIntersecting) {
        bar.classList.add('sf-hidden');
      } else {
        bar.classList.remove('sf-hidden');
      }
    },
    { threshold: 0 }
  );
  observer.observe(anchor);

  bindSheet(bar, scope);
}

/* The Order Summary sheet the bar's total opens (SF0031). Plain markup behind
 * `hidden`: this flips the scrim + sheet, keeps aria-expanded honest, turns the
 * chevron over, and closes on Escape, on the scrim and on the X. The page
 * behind it is locked while it is open so the sheet is what scrolls. */
function bindSheet(bar, scope) {
  var toggle = bar.querySelector('[data-ds-cart-sticky-toggle]');
  if (!toggle) return;

  var root = scope === document ? document : scope;
  var sheet = root.querySelector('[data-ds-cart-sticky-sheet]');
  var scrim = root.querySelector('[data-ds-cart-sticky-scrim]');
  if (!sheet || !scrim) return;

  var chevron = bar.querySelector('[data-ds-cart-sticky-chevron]');

  function open() {
    sheet.hidden = false;
    scrim.hidden = false;
    toggle.setAttribute('aria-expanded', 'true');
    if (chevron) chevron.classList.add('sf-rotate-180');
    sheet.setAttribute('data-ds-page-lock', '');
    var close = sheet.querySelector('[data-ds-cart-sticky-close]');
    if (close && typeof close.focus === 'function') close.focus({ focusVisible: false });
  }

  function close() {
    sheet.hidden = true;
    scrim.hidden = true;
    toggle.setAttribute('aria-expanded', 'false');
    if (chevron) chevron.classList.remove('sf-rotate-180');
    sheet.removeAttribute('data-ds-page-lock');
    if (typeof toggle.focus === 'function') toggle.focus();
  }

  toggle.addEventListener('click', function () {
    if (sheet.hidden) open();
    else close();
  });

  scrim.addEventListener('click', close);

  sheet.addEventListener('click', function (event) {
    if (event.target.closest('[data-ds-cart-sticky-close]')) close();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && !sheet.hidden) close();
  });

  // The bar, the sheet and the scrim are CSS-hidden from tablet-air up. That
  // hides them, but the scroll lock set in open() lives on the document and
  // would stay after a resize, so the page could not scroll. Close for real
  // when the layout leaves the bar behind.
  var airValue = getComputedStyle(document.documentElement).getPropertyValue('--breakpoint-tablet-air').trim();
  var airPx = parseInt(airValue, 10) || 820;
  var air = window.matchMedia('(min-width: ' + airPx + 'px)');
  var onAir = function (event) {
    if (event.matches && !sheet.hidden) close();
  };
  if (air.addEventListener) air.addEventListener('change', onAir);
  else air.addListener(onAir);
}

function cartCheckoutStickyInitAll() {
  var bars = document.querySelectorAll('[data-ds-cart-checkout-sticky]');
  for (var i = 0; i < bars.length; i++) cartCheckoutStickyInit(bars[i]);
}

if (!document.__dsCartCheckoutStickyBound) {
  document.__dsCartCheckoutStickyBound = true;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cartCheckoutStickyInitAll, { once: true });
  } else {
    cartCheckoutStickyInitAll();
  }

  // The theme editor re-renders a section by swapping its HTML in, with no
  // DOMContentLoaded — re-scan so the bar re-binds. The per-bar guard keeps it
  // idempotent.
  if (typeof MutationObserver === 'function') {
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
          cartCheckoutStickyInitAll();
          return;
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
}

} catch (sfError) {
if (typeof console !== 'undefined') console.error('[sf-core] behavior "cart-checkout-sticky" failed to initialise:', sfError);
}
})();

/* cart-item-total.js */
(function () {
try {
/* cart-item-total — keeps a cart line's "Item total (incl. add-ons)" honest while
 * the buyer is still stepping. Pure arithmetic, no network: cart-lines.js owns
 * /cart/change.js.
 *
 * It moves the total by the DIFFERENCE against the rendered quantities, never by
 * re-adding the line, so a total the server discounted keeps its discount. A line
 * without data-ds-cart-item-total-cents is left alone.
 *
 * Authoring rules: src/behaviors/README.md. No import/export.
 */

var CART_ITEM = '[data-ds-cart-item]';
var CART_ITEM_TOTAL = '[data-ds-cart-item-total-value] [data-ds-price-amount]';
var CART_ITEM_LINE = '[data-ds-cart-item-line-price] [data-ds-price-amount]';
var CART_ITEM_EACH = '[data-ds-cart-item-each]';

function cartItemCents(el, attr) {
  var raw = el && el.getAttribute(attr);
  if (raw === null || raw === undefined || raw === '') return null;
  var value = Number(raw);
  return Number.isFinite(value) ? value : null;
}

// Blank means mid-edit, not "zero of these".
function cartItemQuantity(scope, rendered) {
  var input = scope && scope.querySelector('input[type="number"]');
  if (!input) return rendered;
  var raw = String(input.value).trim();
  if (raw === '') return rendered;
  var value = Number(raw);
  if (!Number.isFinite(value) || value < 0) return rendered;
  return value;
}

function cartItemMoney(root, cents) {
  // money_format may carry markup; this writes text, so drop the tags.
  var format = (root.getAttribute('data-ds-cart-item-money') || '${{amount}}').replace(/<[^>]*>/g, '');
  var amount = (Number(cents) || 0) / 100;
  return format.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, amount.toFixed(2));
}

// The line's own quantity: the first stepper outside any add-on row.
function cartItemMainQuantity(root, renderedQty) {
  var steppers = root.querySelectorAll('[data-ds-number-input]');
  for (var i = 0; i < steppers.length; i += 1) {
    if (!steppers[i].closest('[data-ds-cart-addon-line]')) {
      return cartItemQuantity(steppers[i], renderedQty);
    }
  }
  return renderedQty;
}

function cartItemSync(root) {
  if (!root) return;
  var unit = cartItemCents(root, 'data-ds-cart-item-price');
  var renderedQty = cartItemCents(root, 'data-ds-cart-item-quantity');
  if (renderedQty === null) renderedQty = 1;
  var mainQty = cartItemMainQuantity(root, renderedQty);

  // Purchase-row line total (unit × quantity). Moved by the stepper DIFFERENCE
  // off the rendered line total, not re-multiplied, so a per-line discount the
  // server applied is kept — the same reasoning as the add-ons total below.
  var line = root.querySelector(CART_ITEM_LINE);
  if (line && unit !== null) {
    var lineCents = cartItemCents(root, 'data-ds-cart-item-line-cents');
    if (lineCents === null) lineCents = unit * renderedQty;
    line.textContent = cartItemMoney(root, lineCents + unit * (mainQty - renderedQty));
  }
  // "$X each" is only meaningful once there is more than one; at 1 the line
  // total already IS the unit price.
  var each = root.querySelector(CART_ITEM_EACH);
  if (each) each.hidden = !(mainQty > 1);

  // Each add-on row shows its own line total (unit x quantity) with "(… each)"
  // under it; move that total by the stepper difference too, and show the each
  // note only past 1 — the same rules as the purchase row above.
  var addonRows = root.querySelectorAll('[data-ds-cart-addon-line]');
  for (var k = 0; k < addonRows.length; k += 1) {
    var rowUnit = cartItemCents(addonRows[k], 'data-ds-cart-addon-line-price');
    var rowRendered = cartItemCents(addonRows[k], 'data-ds-cart-addon-line-quantity');
    if (rowRendered === null) rowRendered = 1;
    var rowQty = cartItemQuantity(addonRows[k], rowRendered);
    var rowAmount = addonRows[k].querySelector('[data-ds-cart-addon-line-amount]');
    var rowCents = cartItemCents(addonRows[k], 'data-ds-cart-addon-line-cents');
    if (rowAmount && rowUnit !== null && rowCents !== null) {
      rowAmount.textContent = '+ ' + cartItemMoney(root, rowCents + rowUnit * (rowQty - rowRendered));
    }
    var rowEach = addonRows[k].querySelector('[data-ds-cart-addon-line-each]');
    if (rowEach) rowEach.hidden = !(rowQty > 1);
  }
  var amount = root.querySelector(CART_ITEM_TOTAL);
  var rendered = cartItemCents(root, 'data-ds-cart-item-total-cents');
  // Nothing to reason from: leave the add-ons total the caller rendered. A line
  // with no add-ons has no such row and is done after the line total above.
  if (!amount || unit === null || rendered === null) return;

  var delta = unit * (mainQty - renderedQty);
  var rows = root.querySelectorAll('[data-ds-cart-addon-line]');
  for (var j = 0; j < rows.length; j += 1) {
    var addonUnit = cartItemCents(rows[j], 'data-ds-cart-addon-line-price');
    if (addonUnit === null) continue;
    var addonRendered = cartItemCents(rows[j], 'data-ds-cart-addon-line-quantity');
    if (addonRendered === null) addonRendered = 1;
    delta += addonUnit * (cartItemQuantity(rows[j], addonRendered) - addonRendered);
  }

  amount.textContent = cartItemMoney(root, rendered + delta);
}

function cartItemTotalBusy(root, busy) {
  if (!root) return;
  var pending = Number(root.getAttribute('data-ds-cart-item-total-pending') || 0);
  pending = Math.max(0, pending + (busy ? 1 : -1));
  root.setAttribute('data-ds-cart-item-total-pending', String(pending));
  busy = pending > 0;
  var value = root.querySelector('[data-ds-cart-item-total-value]');
  var loading = root.querySelector('[data-ds-cart-item-total-loading]');
  if (value) value.hidden = busy;
  if (loading) loading.hidden = !busy;
}

if (!document.__dsCartItemTotalBound) {
  document.__dsCartItemTotalBound = true;

  // The buttons dispatch input+change on the field, so one listener covers both.
  document.addEventListener('input', function (event) {
    var field = event.target;
    if (!field || !field.closest || field.type !== 'number') return;
    cartItemSync(field.closest(CART_ITEM));
  });
  document.addEventListener('change', function (event) {
    var field = event.target;
    if (!field || !field.closest || field.type !== 'number') return;
    cartItemSync(field.closest(CART_ITEM));
  });
  document.addEventListener('ds:cart:updating', function (event) {
    var detail = event.detail || {};
    if (detail.root) cartItemTotalBusy(detail.root, !!detail.busy);
  });
}

} catch (sfError) {
if (typeof console !== 'undefined') console.error('[sf-core] behavior "cart-item-total" failed to initialise:', sfError);
}
})();

/* cart-lines.js */
(function () {
try {
/* cart-lines — the cart page's quantity and remove requests.
 *
 * A cross-sell add-on rides in the cart as its own independent Shopify line,
 * grouped with its main only by the hidden _bundle_group properties — Shopify has
 * no parent/child link between them and cascades nothing. So a quantity change
 * touches only the line it was made on (an add-on's quantity is independent of its
 * main's), but a REMOVAL of a main takes its add-ons with it: they are nested
 * under it on the page and must not be left behind as orphan lines. That cascade
 * is one atomic /cart/update.js; a single line (a main with no add-ons, or an
 * add-on removed on its own) still goes through /cart/change.js. The response is
 * the new truth, so the line's rendered quantities and total are restamped from it.
 *
 * A removal is IMMEDIATE: the line leaves the page optimistically and the
 * request goes to Shopify straight away — there is no undo window. If the
 * request fails the line is put back with the reason, so the page never lies
 * about the cart. A confirmation UI (ds-confirm-modal) can still ask first.
 *
 * Emits, alongside buy-buttons.js:
 *   ds:cart:updated  detail = the full cart
 *   ds:cart:error    detail = { description } | { error }
 *   ds:toast         detail = the error copy, when a removal fails — which here
 *                    means the request itself failed (offline, or the cart
 *                    rejected it), never \"sold out\": removing is a removal, and
 *                    inventory cannot refuse one
 *   ds:cart:removed  detail = { key, title, image } — a plain "removed" notice
 * and asks first, so a confirmation UI can take over:
 *   ds:cart:remove-request  cancelable, detail = { key, root, addon }
 * and listens for:
 *   ds:cart:remove-confirm  detail = { key }, from the confirmation UI
 *
 * Optimistic: the field keeps what the buyer set while the request is in flight
 * and rolls back to the rendered quantity if it fails.
 *
 * Authoring rules: src/behaviors/README.md. No import/export.
 */
var CART_LINE = '[data-ds-cart-item]';
var ADDON_LINE = '[data-ds-cart-addon-line]';

function cartLinesUrl(path) {
  var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
  return (root || '/') + path;
}

function cartLinesScope(el) {
  var addon = el.closest(ADDON_LINE);
  var root = el.closest(CART_LINE);
  return {
    root: root,
    addon: addon,
    el: addon || root,
    key: (addon || root) && (addon || root).getAttribute(addon ? 'data-ds-cart-addon-line-key' : 'data-ds-cart-item-key'),
    quantityAttr: addon ? 'data-ds-cart-addon-line-quantity' : 'data-ds-cart-item-quantity',
  };
}

function cartLinesRendered(scope) {
  var raw = scope.el && scope.el.getAttribute(scope.quantityAttr);
  var value = Number(raw);
  return Number.isFinite(value) ? value : 1;
}

// Requests can overlap — typing a second quantity before the first answers — so
// the line counts them. Stamping each button with its previous state instead
// loses that state on the second call and leaves the steppers disabled for good.
function cartLinesBusy(scope, busy) {
  if (!scope.root) return;
  var inFlight = Number(scope.root.getAttribute('data-ds-cart-lines-pending') || 0);
  inFlight = Math.max(0, inFlight + (busy ? 1 : -1));
  scope.root.setAttribute('data-ds-cart-lines-pending', String(inFlight));
  scope.root.setAttribute('aria-busy', inFlight ? 'true' : 'false');
  // number-input.js owns which stepper is disabled at min/max, so let it decide
  // again by re-running its own sync instead of restoring a remembered flag.
  scope.root.querySelectorAll('[data-ds-number-input] input[type="number"]').forEach(function (input) {
    var field = input.closest('[data-ds-number-input]');
    if (!field) return;
    field.querySelectorAll('button[data-ds-number-input-decrease], button[data-ds-number-input-increase]')
      .forEach(function (button) { button.disabled = !!inFlight; });
    if (!inFlight) input.dispatchEvent(new Event('input', { bubbles: true }));
  });
}

// The buyer's own value stands until the server answers; a failure puts the
// rendered one back and lets cart-item-total.js re-read it.
function cartLinesRestore(scope) {
  var input = scope.el && scope.el.querySelector('input[type="number"]');
  if (!input) return;
  input.value = String(cartLinesRendered(scope));
  input.dispatchEvent(new Event('input', { bubbles: true }));
}

// Restamp EVERY rendered line from the response, not just the one that made the
// request: `key` hashes variant + properties, not an id, so any line's key can
// come back different from what is still stamped in the DOM ("no valid id or
// line parameter" on every request after, until reload) — the response is the
// only place a current key can be read from. Order is what ties a DOM row back
// to its item: cart.items keeps its relative order for lines that still exist
// (a removal only closes the gap it leaves), and the page renders main rows and
// each one's add-on rows in that same order, so zipping DOM order against
// cart.items order re-identifies every row without needing a stored id at all.
function cartLinesApply(cart) {
  if (!cart || !Array.isArray(cart.items)) return;
  var addonsByGroup = {};
  cart.items.forEach(function (item) {
    var group = item.properties && item.properties._bundle_group;
    if (group && item.properties._bundle_role === 'addon') {
      (addonsByGroup[group] = addonsByGroup[group] || []).push(item);
    }
  });
  var mains = cart.items.filter(function (item) {
    return !item.properties || item.properties._bundle_role !== 'addon';
  });
  var mainIndex = 0;
  document.querySelectorAll(CART_LINE).forEach(function (root) {
    var item = mains[mainIndex];
    mainIndex += 1;
    if (!item) return;
    root.setAttribute('data-ds-cart-item-key', item.key);
    root.setAttribute('data-ds-cart-item-quantity', String(item.quantity));
    var lineOnly = Number(item.final_line_price || item.line_price || 0);
    root.setAttribute('data-ds-cart-item-line-cents', String(lineOnly));
    var total = lineOnly;
    var group = item.properties && item.properties._bundle_group;
    var siblings = (group && addonsByGroup[group]) || [];
    var addonIndex = 0;
    root.querySelectorAll('[data-ds-cart-addon-line-key]').forEach(function (row) {
      var child = siblings[addonIndex];
      addonIndex += 1;
      if (!child) return;
      row.setAttribute('data-ds-cart-addon-line-key', child.key);
      row.setAttribute('data-ds-cart-addon-line-quantity', String(child.quantity));
      var childLine = Number(child.final_line_price || child.line_price || 0);
      // The row's own total moves off this; left stale, the next sync snaps
      // the price back to the first-paint amount.
      row.setAttribute('data-ds-cart-addon-line-cents', String(childLine));
      total += childLine;
    });
    root.setAttribute('data-ds-cart-item-total-cents', String(total));
    var field = root.querySelector('input[type="number"]');
    if (field) field.dispatchEvent(new Event('input', { bubbles: true }));
  });
}

function cartLinesShowEmpty() {
  var form = document.querySelector('[data-ds-cart-form]');
  var live = document.querySelector('[data-ds-cart-empty-live]');
  var template = document.querySelector('[data-ds-cart-empty-template]');
  if (!live || !template || !template.content) return false;
  if (form) form.hidden = true;
  // The alert band (price-update / expiry countdown) sits in the title group
  // ABOVE the form, so hiding the form alone leaves it on an empty cart. It is a
  // filled-cart notice, so it goes with the lines. Inline display beats the
  // region's own lg:sf-flex class, which the [hidden] attribute would not.
  var alerts = document.querySelector('[data-ds-cart-alerts-region]');
  if (alerts) alerts.style.display = 'none';
  // The cross-sell band is a filled-cart surface: the empty state keeps the page
  // on its one action (Continue shopping), and a reload would not render it.
  document.querySelectorAll('[data-ds-cart-recommendations]').forEach(function (band) {
    band.hidden = true;
  });
  if (!live.firstElementChild) live.appendChild(template.content.cloneNode(true));
  live.hidden = false;
  return true;
}

function cartLinesHideEmpty() {
  var form = document.querySelector('[data-ds-cart-form]');
  var live = document.querySelector('[data-ds-cart-empty-live]');
  if (form) form.hidden = false;
  var alerts = document.querySelector('[data-ds-cart-alerts-region]');
  if (alerts) alerts.style.display = '';
  document.querySelectorAll('[data-ds-cart-recommendations]').forEach(function (band) {
    band.hidden = false;
  });
  if (!live) return;
  live.hidden = true;
  live.textContent = '';
}

// The empty Component is already templated by the section, so the last line can
// switch views in the same frame. The response confirms the cart but never needs
// a page reload just to ask Liquid for markup we already have.
function cartLinesReloadIfEmpty(cart) {
  if (!cart || Number(cart.item_count) !== 0) return false;
  cartLinesShowEmpty();
  return true;
}

// Main products only: an add-on is not a piece of its own, so it must not swell
// the heading count either (Cross-sell Bundle spec §3.3). Mirrors the section's
// server-rendered count and dsCartMainItemCount in cart-count.js.
function cartLinesPieceCount(cart) {
  if (cart && Array.isArray(cart.items)) {
    var n = 0;
    for (var i = 0; i < cart.items.length; i += 1) {
      var properties = cart.items[i].properties;
      if (!properties || properties._bundle_role !== 'addon') {
        n += Number(cart.items[i].quantity) || 0;
      }
    }
    return n;
  }
  return Number(cart && cart.item_count) || 0;
}

// The heading is "Shopping Cart (4 items)". Liquid stamps the bare heading and
// the two unit words; the count is the only part that moves. A title that still
// says "(14 items)" must not be treated as the base, or the next update appends
// a second "(5)" and the old total never leaves.
function cartLinesTitleBase(title) {
  var base = title.getAttribute('data-ds-cart-title-base');
  if (base) return base;
  base = title.textContent.replace(/\s*\(\d+(?:\s+[^\d)]+)?\)\s*$/, '').trim();
  title.setAttribute('data-ds-cart-title-base', base);
  return base;
}

function cartLinesTitleWrite(title, count) {
  var base = cartLinesTitleBase(title);
  var n = Number(count) || 0;
  var countEl = title.querySelector('[data-ds-cart-title-count]');
  title.textContent = base;
  if (n <= 0) return;
  if (!countEl) {
    countEl = document.createElement('span');
    countEl.setAttribute('data-ds-cart-title-count', '');
    countEl.className = 'sf-font-display sf-text-h5 sf-font-regular sf-text-tertiary';
  }
  var one = title.getAttribute('data-ds-cart-title-one');
  var other = title.getAttribute('data-ds-cart-title-other');
  var label = one || other ? ' (' + n + ' ' + (n === 1 ? one || other : other || one) + ')' : ' (' + n + ')';
  countEl.textContent = label;
  title.appendChild(countEl);
}

function cartLinesTitle(cart) {
  var title = document.querySelector('[data-ds-cart-title]');
  if (!title || !cart || !Array.isArray(cart.items)) return;
  cartLinesTitleWrite(title, cartLinesPieceCount(cart));
}

// Removing a main changes the visible piece count with certainty; it does not
// need Shopify to recalculate prices first. Keep the heading in step with the
// detached row while totals wait for the authoritative response.
function cartLinesTitleDelta(delta) {
  var title = document.querySelector('[data-ds-cart-title]');
  if (!title || !delta) return;
  var match = title.textContent.match(/\((\d+)(?:\s+[^\d)]+)?\)\s*$/);
  var count = Math.max(0, (match ? Number(match[1]) : 0) + delta);
  cartLinesTitleWrite(title, count);
}

function cartLinesUpdating(entry, busy) {
  document.dispatchEvent(new CustomEvent('ds:cart:updating', {
    detail: { busy: busy, root: entry && entry.parentRoot },
  }));
}

function cartLinesFinishUpdating(entry) {
  if (!entry || !entry.loading) return;
  entry.loading = false;
  cartLinesUpdating(entry, false);
}

function cartLinesPublish(cart) {
  cartLinesApply(cart);
  window.tfxCart = cart;
  document.dispatchEvent(new CustomEvent('ds:cart:updated', { detail: cart }));
  cartLinesTitle(cart);
  cartLinesReloadIfEmpty(cart);
}

// Concurrent mutations may invalidate rendered line keys. A bundle 404 only
// proves that one old key disappeared, not that its independent add-ons did.
function cartLinesCleanupBundle(entry) {
  if (!entry.group) return Promise.resolve(false);
  return fetch(cartLinesUrl('cart.js'), {
    headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
  }).then(function (res) {
    if (!res.ok) throw new Error('cart read failed');
    return res.json();
  }).then(function (cart) {
    var updates = {};
    (cart.items || []).forEach(function (item) {
      if (item.properties && item.properties._bundle_group === entry.group) updates[item.key] = 0;
    });
    if (!Object.keys(updates).length) {
      cartLinesPublish(cart);
      return true;
    }
    return fetch(cartLinesUrl('cart/update.js'), {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({ updates: updates }),
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) return false;
        cartLinesPublish(data);
        return true;
      });
    });
  }).catch(function () { return false; });
}

function cartLinesChange(scope, quantity, onDone) {
  if (!scope.key) return;
  cartLinesBusy(scope, true);
  fetch(cartLinesUrl('cart/change.js'), {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    },
    body: JSON.stringify({ id: scope.key, quantity: quantity }),
  })
    .then(function (res) {
      return res.json().then(function (data) {
        return { ok: res.ok, data: data };
      });
    })
    .then(function (result) {
      cartLinesBusy(scope, false);
      if (!result.ok) {
        cartLinesRestore(scope);
        document.dispatchEvent(new CustomEvent('ds:cart:error', { detail: result.data }));
        return;
      }
      cartLinesApply(result.data);
      window.tfxCart = result.data;
      document.dispatchEvent(new CustomEvent('ds:cart:updated', { detail: result.data }));
      cartLinesTitle(result.data);
      cartLinesReloadIfEmpty(result.data);
      if (onDone) onDone(result.data);
    })
    .catch(function (error) {
      cartLinesBusy(scope, false);
      cartLinesRestore(scope);
      document.dispatchEvent(new CustomEvent('ds:cart:error', { detail: { error: String(error) } }));
    });
}

var cartLinesInFlight = [];
var cartLinesScreenPending = 0;

function cartLinesScreenLoading(busy) {
  cartLinesScreenPending = Math.max(0, cartLinesScreenPending + (busy ? 1 : -1));
  var root = document.querySelector('[data-ds-cart]');
  var overlay = document.querySelector('[data-ds-cart-screen-loading]');
  if (root) root.setAttribute('aria-busy', cartLinesScreenPending ? 'true' : 'false');
  if (overlay) overlay.hidden = !cartLinesScreenPending;
}

function cartLinesAnnounceRemoved(entry) {
  if (!entry) return;
  entry.announced = true;
  document.dispatchEvent(new CustomEvent('ds:cart:removed', {
    detail: { key: entry.key, title: entry.title, image: entry.image },
  }));
}

function cartLinesDetach(entry) {
  entry.parent = entry.node.parentNode;
  entry.before = entry.node.nextElementSibling;
  if (entry.parent) entry.parent.removeChild(entry.node);
  if (entry.parentRoot) cartLinesSyncAddons(entry.parentRoot);
}

// SF0190 — a main line's "Add-ons Items" block and its "Item total (incl.
// add-ons)" row exist only while it has an add-on: ds-cart renders neither for
// a line without one. Removing the last add-on row by hand must drop both, or
// the card shows an empty heading a reload would not; restoring a failed
// removal brings them back.
function cartLinesSyncAddons(root) {
  var block = root.querySelector('[data-ds-cart-item-addons]');
  if (!block) return;
  var empty = !block.querySelector(ADDON_LINE);
  block.hidden = empty;
  var total = root.querySelector('[data-ds-cart-item-total]');
  if (total) total.hidden = empty;
}

// A removal that failed to commit: the line the buyer watched leave comes back,
// with its optimistic count/title decrement undone.
function cartLinesRestoreNode(entry) {
  if (!entry.parent) return;
  if (entry.before && entry.before.parentNode === entry.parent) {
    entry.parent.insertBefore(entry.node, entry.before);
  } else {
    entry.parent.appendChild(entry.node);
  }
  if (entry.parentRoot) cartLinesSyncAddons(entry.parentRoot);
  var field = entry.node.querySelector('input[type="number"]');
  if (field) field.dispatchEvent(new Event('input', { bubbles: true }));
  if (entry.mainQuantity) {
    cartLinesTitleDelta(entry.mainQuantity);
    document.dispatchEvent(new CustomEvent('ds:cart:optimistic-count', {
      detail: { delta: entry.mainQuantity },
    }));
  }
  cartLinesFinishUpdating(entry);
  if (document.querySelector(CART_LINE)) cartLinesHideEmpty();
}

// Send the removal the buyer already saw happen. A failure here is the one case
// where the line comes back — with the reason.
function cartLinesCommit(entry) {
  // One key removes through /cart/change.js; a main dragging its add-ons out with
  // it removes them all in one atomic /cart/update.js, so the cart never shows a
  // half-gone bundle.
  var keys = entry.keys && entry.keys.length ? entry.keys : [entry.key];
  var multi = keys.length > 1;
  var payload;
  if (multi) {
    var updates = {};
    keys.forEach(function (k) { updates[k] = 0; });
    payload = { updates: updates };
  } else {
    payload = { id: keys[0], quantity: 0 };
  }
  var request = {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    },
    body: JSON.stringify(payload),
  };

  // The add-on row is already gone; its parent card is what's still on
  // screen while this request is in flight, so it carries the busy state.
  if (entry.parentRoot) cartLinesBusy({ root: entry.parentRoot }, true);
  cartLinesScreenLoading(true);
  if (!entry.loading) {
    entry.loading = true;
    cartLinesUpdating(entry, true);
  }

  var operation = fetch(cartLinesUrl(multi ? 'cart/update.js' : 'cart/change.js'), request)
    .then(function (res) {
      return res.json().then(
        function (data) { return { ok: res.ok, status: res.status, data: data }; },
        function () { return { ok: res.ok, status: res.status, data: null }; }
      );
    })
    .then(function (result) {
      if (entry.parentRoot) cartLinesBusy({ root: entry.parentRoot }, false);
      cartLinesScreenLoading(false);
      if (result.ok) {
        cartLinesPublish(result.data);
        cartLinesFinishUpdating(entry);
        if (!entry.announced) cartLinesAnnounceRemoved(entry);
        return true;
      }
      // 404 means the cart no longer has that line — another tab removed it, or
      // the cart was rebuilt. The buyer wanted it gone and it is gone, so this
      // is the outcome, not a failure: leave it removed and say nothing.
      if (result.status === 404 && multi) {
        return cartLinesCleanupBundle(entry).then(function (clean) {
          if (clean) {
            cartLinesFinishUpdating(entry);
            return true;
          }
          cartLinesUncommit(entry, '');
          return false;
        });
      }
      if (result.status === 404) {
        cartLinesFinishUpdating(entry);
        return true;
      }
      cartLinesUncommit(entry, (result.data && result.data.description) || '');
      document.dispatchEvent(new CustomEvent('ds:cart:error', { detail: result.data }));
      return false;
    })
    .catch(function (error) {
      if (entry.parentRoot) cartLinesBusy({ root: entry.parentRoot }, false);
      cartLinesScreenLoading(false);
      // Offline, blocked, or a non-JSON answer: the line is still in the cart,
      // so put it back rather than leave the page lying about it.
      cartLinesUncommit(entry, '');
      document.dispatchEvent(new CustomEvent('ds:cart:error', { detail: { error: String(error) } }));
      return false;
    });
  cartLinesInFlight.push(operation);
  operation.then(function () {
    var index = cartLinesInFlight.indexOf(operation);
    if (index > -1) cartLinesInFlight.splice(index, 1);
  });
  return operation;
}

// The commit failed, so the line the buyer watched leave comes back — say why,
// or it reads as the page breaking.
function cartLinesUncommit(entry, description) {
  cartLinesRestoreNode(entry);
  var region = document.querySelector('[data-ds-toast-region]');
  if (!region) return;
  document.dispatchEvent(new CustomEvent('ds:toast', {
    detail: {
      highlight: entry.title || '',
      message: description || region.getAttribute('data-ds-toast-remove-failed') || 'could not be removed',
    },
  }));
}

function cartLinesLabel(node) {
  var title = node.querySelector('[data-ds-cart-item-title], [data-ds-cart-addon-line-title]');
  var image = node.querySelector('img[src]');
  return {
    title: title ? title.textContent.trim() : '',
    image: image ? image.getAttribute('src') : '',
  };
}

function cartLinesDrop(scope) {
  if (!scope.el || !scope.key) return;
  var label = cartLinesLabel(scope.el);
  // Removing a whole line takes its add-ons with it — they hang off it in the DOM
  // and, being property-grouped rather than Shopify parent/child, Shopify will not
  // drop them on its own. Removing an add-on on its own touches only that add-on.
  var keys = [scope.key];
  if (scope.root && !scope.addon) {
    scope.root.querySelectorAll('[data-ds-cart-addon-line-key]').forEach(function (row) {
      var childKey = row.getAttribute('data-ds-cart-addon-line-key');
      if (childKey && keys.indexOf(childKey) === -1) keys.push(childKey);
    });
  }
  // An add-on removed alone leaves its main's "Item total" row on the page with
  // a now-stale cents value — nothing else restamps it once the commit lands.
  var parentRoot = scope.addon ? scope.root : null;
  var entry = {
    key: scope.key, keys: keys, node: scope.el, parent: null, before: null,
    title: label.title, image: label.image, parentRoot: parentRoot,
    mainQuantity: scope.addon ? 0 : cartLinesRendered(scope), loading: false,
    group: scope.root && scope.root.getAttribute('data-ds-cart-item-bundle-group'),
    announced: false,
  };
  cartLinesDetach(entry);
  if (!document.querySelector(CART_LINE)) cartLinesShowEmpty();
  entry.loading = true;
  cartLinesUpdating(entry, true);
  if (entry.mainQuantity) {
    cartLinesTitleDelta(-entry.mainQuantity);
    document.dispatchEvent(new CustomEvent('ds:cart:optimistic-count', {
      detail: { delta: -entry.mainQuantity },
    }));
  }
  // Immediate: the line is already gone from the page, so send it now.
  cartLinesCommit(entry);
}

function cartLinesRemove(scope) {
  var request = new CustomEvent('ds:cart:remove-request', {
    cancelable: true,
    detail: { key: scope.key, root: scope.root, addon: scope.addon },
  });
  // A confirmation UI (ds-confirm-modal) cancels this and calls back once the
  // buyer has said yes; with nothing listening the removal goes straight through.
  if (!document.dispatchEvent(request)) return;
  cartLinesDrop(scope);
}

if (!document.__dsCartLinesBound) {
  document.__dsCartLinesBound = true;

  // change, not input: one request when the buyer settles, not per keystroke.
  document.addEventListener('change', function (event) {
    var field = event.target;
    if (!field || !field.closest || field.type !== 'number') return;
    if (!field.closest(CART_LINE)) return;
    var scope = cartLinesScope(field);
    if (cartLinesInFlight.length) return cartLinesRestore(scope);
    var quantity = Number(field.value);
    if (!Number.isFinite(quantity) || quantity < 0) return cartLinesRestore(scope);
    if (quantity === cartLinesRendered(scope)) return;
    cartLinesChange(scope, quantity);
  });

  document.addEventListener('click', function (event) {
    var trigger = event.target && event.target.closest
      ? event.target.closest('[data-ds-cart-item-remove], [data-ds-cart-addon-line-remove]')
      : null;
    if (!trigger || !trigger.closest(CART_LINE)) return;
    event.preventDefault();
    if (cartLinesInFlight.length) return;
    cartLinesRemove(cartLinesScope(trigger));
  });

  // The confirmation UI re-requests the removal it cancelled.
  document.addEventListener('ds:cart:remove-confirm', function (event) {
    var key = event.detail && event.detail.key;
    if (!key) return;
    if (cartLinesInFlight.length) return;
    var el = document.querySelector(
      '[data-ds-cart-addon-line-key="' + key + '"], [data-ds-cart-item-key="' + key + '"]',
    );
    if (!el) return;
    var scope = cartLinesScope(el.querySelector('input[type="number"]') || el);
    cartLinesDrop(scope);
  });
}

} catch (sfError) {
if (typeof console !== 'undefined') console.error('[sf-core] behavior "cart-lines" failed to initialise:', sfError);
}
})();

/* cart-pack-nav.js */
(function () {
try {
/* cart-pack-nav.js
 *
 * Multi-Pack navigator for cart line items (SF0201 / Nova feature family).
 * Each `[data-wp-pack-nav]` scope cycles through N pack previews via a prev/
 * next chevron overlay on the main image and a counter pill at the bottom.
 * Pack urls + names are serialized onto the nav as JSON data attributes.
 */
(function () {
  if (window.__wpCartPackNavLoaded) return;
  window.__wpCartPackNavLoaded = true;

  function parseJson(attr) {
    try {
      return JSON.parse(attr || '[]');
    } catch (_e) {
      return [];
    }
  }

  function activate(nav, index) {
    var urls = parseJson(nav.getAttribute('data-wp-pack-urls'));
    var names = parseJson(nav.getAttribute('data-wp-pack-names'));
    var total = urls.length;
    if (!total) return;

    if (index < 0) index = 0;
    if (index >= total) index = total - 1;

    var url = urls[index];
    var name = names[index] || '';

    nav.setAttribute('data-wp-pack-active', String(index));

    var img = nav.querySelector('[data-wp-pack-main-image]');
    if (img && url) {
      img.setAttribute('src', url);
      img.setAttribute('alt', name);
    }

    // The main-image button carries data-ds-cart-photo-index that
    // cart-photo-lightbox.js reads when opening the modal — keep it on the
    // active pack so a click on the image opens the overlay at that slide.
    var main = nav.querySelector('[data-wp-pack-main]');
    if (main) main.setAttribute('data-ds-cart-photo-index', String(index));

    var counterCurrent = nav.querySelector('[data-wp-pack-counter-current]');
    if (counterCurrent) counterCurrent.textContent = String(index + 1);
    var counterTotal = nav.querySelector('[data-wp-pack-counter-total]');
    if (counterTotal) counterTotal.textContent = String(total);

    var prev = nav.querySelector('[data-wp-pack-prev]');
    if (prev) prev.disabled = index <= 0;
    var next = nav.querySelector('[data-wp-pack-next]');
    if (next) next.disabled = index >= total - 1;
  }

  function current(nav) {
    return parseInt(nav.getAttribute('data-wp-pack-active') || '0', 10);
  }

  function onClick(e) {
    var btn = e.target.closest && e.target.closest('[data-wp-pack-prev], [data-wp-pack-next]');
    if (!btn) return;
    var nav = btn.closest('[data-wp-pack-nav]');
    if (!nav) return;
    e.preventDefault();
    e.stopPropagation();
    var delta = btn.hasAttribute('data-wp-pack-prev') ? -1 : 1;
    activate(nav, current(nav) + delta);
  }

  function initAll() {
    document.querySelectorAll('[data-wp-pack-nav]').forEach(function (nav) {
      activate(nav, current(nav));
    });
  }

  document.addEventListener('click', onClick);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }
})();

} catch (sfError) {
if (typeof console !== 'undefined') console.error('[sf-core] behavior "cart-pack-nav" failed to initialise:', sfError);
}
})();

/* cart-photo-lightbox.js */
(function () {
try {
/* cart-photo-lightbox — opens a cart line's personalization photos in the
 * gallery viewer (ds-cart-photo-lightbox). Any element with [data-ds-cart-photo]
 * carries data-ds-cart-photo-target="<overlay id>" and data-ds-cart-photo-index;
 * clicking it opens that line's overlay ON the clicked photo.
 *
 * The viewer itself — track, chevrons, counter, rail — is a plain ds-gallery, so
 * behaviors/gallery.js drives it; this behavior only opens/closes the dialog,
 * jumps it to the clicked photo (`ds:gallery:set`, instant), and retitles the
 * header to the active photo's file name as the shopper steps through. Titles
 * come off the overlay's data-ds-cart-photo-lightbox-titles JSON, so retitling
 * never has to read the gallery's slide markup.
 *
 * It owns only the dialog: open/close, portal to <body> (so a transformed/sticky
 * ancestor never traps its z-index — same reason as media-lightbox.js), scroll
 * lock, focus trap + restore. Progressive enhancement: without this script the
 * card thumbnails are plain images and nothing opens.
 *
 * Authoring rules: src/behaviors/README.md. No import/export.
 */

(function () {
  if (document.__dsCartPhotoLightboxBound) return;
  document.__dsCartPhotoLightboxBound = true;

  var lastTrigger = null;
  var titleObserver = null;

  // Portal the overlay to <body>: a cart line can sit in a stacking context
  // (transforms during row updates), which would trap a fixed overlay's
  // z-index. Drops any stale twin a section re-render left with the same id.
  function hoist(overlay) {
    if (!overlay) return overlay;
    if (overlay.id) {
      document.querySelectorAll('[data-ds-cart-photo-lightbox]').forEach(function (el) {
        if (el !== overlay && el.id === overlay.id && el.parentNode) {
          el.parentNode.removeChild(el);
        }
      });
    }
    if (overlay.parentNode !== document.body) document.body.appendChild(overlay);
    return overlay;
  }

  function hoistAll() {
    document.querySelectorAll('[data-ds-cart-photo-lightbox]').forEach(hoist);
  }

  function isOpen(overlay) {
    return !!overlay && overlay.getAttribute('aria-hidden') === 'false';
  }

  function openOverlayEl() {
    var list = document.querySelectorAll('[data-ds-cart-photo-lightbox]');
    for (var i = 0; i < list.length; i++) {
      if (isOpen(list[i])) return list[i];
    }
    return null;
  }

  function titlesFor(overlay) {
    var raw = overlay.getAttribute('data-ds-cart-photo-lightbox-titles');
    if (!raw) return [];
    try {
      var parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function setTitle(overlay, index) {
    var titleEl = overlay.querySelector('[data-ds-cart-photo-lightbox-title]');
    if (!titleEl) return;
    var titles = titlesFor(overlay);
    var name = titles[index];
    if (name) titleEl.textContent = name;
  }

  // Retitle the header whenever the gallery moves to another slide, by watching
  // its active-index attribute — no dependency on gallery.js emitting an event.
  function watchTitle(overlay, gallery) {
    if (titleObserver) titleObserver.disconnect();
    if (!gallery || typeof MutationObserver === 'undefined') return;
    titleObserver = new MutationObserver(function () {
      setTitle(overlay, Number(gallery.dataset.dsGalleryActive || 0));
    });
    titleObserver.observe(gallery, {
      attributes: true,
      attributeFilter: ['data-ds-gallery-active'],
    });
  }

  function open(trigger) {
    var id = trigger.getAttribute('data-ds-cart-photo-target');
    var overlay = id ? hoist(document.getElementById(id)) : null;
    if (!overlay) return;

    var index = Number(trigger.getAttribute('data-ds-cart-photo-index') || 0);
    lastTrigger = trigger;

    overlay.setAttribute('aria-hidden', 'false');
    overlay.setAttribute('data-ds-page-lock', '');

    // Jump the gallery straight to the clicked photo — instant, so the viewer
    // opens already on that slide instead of sliding to it.
    var gallery = overlay.querySelector('[data-ds-gallery]');
    if (gallery) {
      gallery.dispatchEvent(
        new CustomEvent('ds:gallery:set', {
          bubbles: true,
          detail: { index: index, instant: true },
        }),
      );
      watchTitle(overlay, gallery);
    }
    setTitle(overlay, index);

    var close = overlay.querySelector('[data-ds-cart-photo-lightbox-close]');
    if (close) window.requestAnimationFrame(function () { close.focus({ focusVisible: false }); });
  }

  function close(overlay) {
    if (!overlay) return;
    if (titleObserver) { titleObserver.disconnect(); titleObserver = null; }
    overlay.setAttribute('aria-hidden', 'true');
    overlay.removeAttribute('data-ds-page-lock');
    if (lastTrigger && typeof lastTrigger.focus === 'function') lastTrigger.focus();
    lastTrigger = null;
  }

  function trapTab(e, overlay) {
    var dialog = overlay.querySelector('[data-ds-cart-photo-lightbox-dialog]') || overlay;
    var focusable = Array.prototype.filter.call(
      dialog.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])',
      ),
      function (el) {
        return el.offsetParent !== null || el === document.activeElement;
      },
    );
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    } else if (!dialog.contains(document.activeElement)) {
      e.preventDefault();
      first.focus();
    }
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;

    var closeBtn = e.target.closest('[data-ds-cart-photo-lightbox-close]');
    if (closeBtn) {
      e.preventDefault();
      close(closeBtn.closest('[data-ds-cart-photo-lightbox]'));
      return;
    }

    var trigger = e.target.closest('[data-ds-cart-photo]');
    if (trigger) {
      e.preventDefault();
      open(trigger);
      return;
    }

    // Click the dimmed backdrop (the overlay itself, not its card) to close.
    var overlay = e.target.closest('[data-ds-cart-photo-lightbox]');
    if (overlay && isOpen(overlay) && e.target === overlay) close(overlay);
  });

  document.addEventListener('keydown', function (e) {
    var overlay = openOverlayEl();
    if (overlay) {
      if (e.key === 'Escape') { close(overlay); return; }
      if (e.key === 'Tab') { trapTab(e, overlay); return; }
      return;
    }
    if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
      var trigger = e.target.closest && e.target.closest('[data-ds-cart-photo]');
      if (trigger) {
        e.preventDefault();
        open(trigger);
      }
    }
  });

  // Portal up front so the first open never flashes trapped under a sibling row.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hoistAll, { once: true });
  } else {
    hoistAll();
  }
})();

} catch (sfError) {
if (typeof console !== 'undefined') console.error('[sf-core] behavior "cart-photo-lightbox" failed to initialise:', sfError);
}
})();

/* cart-popover.js */
(function () {
try {
/* cart-popover — keeps the header mini-cart honest after an AJAX cart change.
 * Pure restamp from the ds:cart:updated payload (the full cart, already fetched
 * by buy-buttons.js / cart-lines.js): no network of its own, the same contract
 * cart-summary.js has for the Order Summary.
 *
 * Open/close is NOT here. Hovering the anchor is what opens the panel and CSS
 * does that natively — src/cart-popover.css. This file only rewrites contents,
 * so without it the popover still shows what Liquid rendered on page load.
 *
 * Lines are rebuilt from the two <template>s the snippet ships, so the restamped
 * markup is the same markup Liquid renders. An add-on is nested under the product
 * it rides with, never listed on its own (Cross-sell Bundle spec §3.3).
 *
 * Authoring rules: src/behaviors/README.md. No import/export.
 */

var CART_POPOVER = '[data-ds-cart-popover]';

function cartPopoverMoney(root, cents) {
  var format = (root.getAttribute('data-ds-cart-popover-money') || '${{amount}}').replace(/<[^>]*>/g, '');
  var amount = (Number(cents) || 0) / 100;
  return format.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, amount.toFixed(2));
}

// Same test as cart-count.js: an add-on is a child line, not a piece of its own.
function cartPopoverIsAddon(item) {
  if (!item) return false;
  var properties = item.properties;
  return Boolean(item.parent_relationship || (properties && properties._bundle_role === 'addon'));
}

function cartPopoverImage(item) {
  var src = (item && item.properties && item.properties['_customily-preview']) || '';
  if (!src) src = (item && (item.image || item.featured_image)) || '';
  if (src && src.url) src = src.url;
  return src || '';
}

function cartPopoverSet(root, selector, text) {
  var el = root.querySelector(selector);
  if (el) el.textContent = text;
}

function cartPopoverToggle(el, on) {
  if (!el) return;
  el.hidden = !on;
}

function cartPopoverFillImage(node, selector, src, alt) {
  var image = node.querySelector(selector);
  if (!image) return;
  if (src) {
    image.src = src;
    image.alt = alt || '';
    image.removeAttribute('hidden');
  } else {
    image.setAttribute('hidden', '');
  }
}

function cartPopoverFillText(node, selector, text, hideWhenBlank) {
  var el = node.querySelector(selector);
  if (!el) return;
  el.textContent = text || '';
  if (!hideWhenBlank) return;
  if (text) el.removeAttribute('hidden');
  else el.setAttribute('hidden', '');
}

// "Default Title" is what Shopify sends for a product with no real options.
// Colour values may be "Name|swatch-file"; only the name is for shoppers.
function cartPopoverVariant(item) {
  var title = item.variant_title;
  if (!title || title === 'Default Title') return '';
  return String(title).split(' / ').map(function (part) {
    return part.split('|')[0].trim();
  }).join(' / ');
}

function cartPopoverAddonNode(root, addon) {
  var template = root.querySelector('[data-ds-cart-popover-addon-template]');
  if (!template || !template.content.firstElementChild) return null;
  var node = template.content.firstElementChild.cloneNode(true);
  var title = addon.product_title || addon.title || '';
  cartPopoverFillImage(node, '[data-ds-cart-addon-image]', cartPopoverImage(addon), '');
  cartPopoverFillText(node, '[data-ds-cart-addon-title]', title, false);
  var variant = cartPopoverVariant(addon);
  cartPopoverFillText(node, '[data-ds-cart-addon-variant]', variant, true);
  cartPopoverFillText(node, '[data-ds-cart-addon-price]', cartPopoverMoney(root, addon.final_line_price), false);
  return node;
}

function cartPopoverLineNode(root, item, addons) {
  var template = root.querySelector('[data-ds-cart-popover-line-template]');
  if (!template || !template.content.firstElementChild) return null;
  var node = template.content.firstElementChild.cloneNode(true);
  var title = item.product_title || item.title || '';

  cartPopoverFillImage(node, '[data-ds-cart-popover-line-image]', cartPopoverImage(item), title);
  var titleEl = node.querySelector('[data-ds-cart-popover-line-title]');
  if (titleEl) {
    titleEl.textContent = title;
    if (item.url && titleEl.tagName === 'A') titleEl.setAttribute('href', item.url);
  }
  var variant = cartPopoverVariant(item);
  cartPopoverFillText(node, '[data-ds-cart-popover-line-variant]', variant, true);
  cartPopoverFillText(node, '[data-ds-cart-popover-line-quantity]', String(Number(item.quantity) || 1), false);
  cartPopoverFillText(node, '[data-ds-cart-popover-line-price]', cartPopoverMoney(root, item.final_price), false);
  cartPopoverFillText(node, '[data-ds-cart-popover-line-total]', cartPopoverMoney(root, item.final_line_price), false);

  var list = node.querySelector('[data-ds-cart-popover-line-addons]');
  if (list) {
    list.textContent = '';
    addons.forEach(function (addon) {
      var row = cartPopoverAddonNode(root, addon);
      if (row) list.appendChild(row);
    });
    cartPopoverToggle(list, addons.length > 0);
  }
  return node;
}

// The add-ons of one main line: they share its _bundle_group, which is the only
// grouping this cart uses (the Cart AJAX API cannot set a parent_id).
function cartPopoverAddonsOf(items, item) {
  var group = item.properties && item.properties._bundle_group;
  if (!group) return [];
  return items.filter(function (candidate) {
    return (
      cartPopoverIsAddon(candidate) &&
      candidate.properties &&
      candidate.properties._bundle_group === group
    );
  });
}

function cartPopoverApply(root, cart) {
  var items = Array.isArray(cart.items) ? cart.items : [];
  var mains = items.filter(function (item) {
    return !cartPopoverIsAddon(item);
  });

  var list = root.querySelector('[data-ds-cart-popover-lines]');
  if (list) {
    list.textContent = '';
    mains.forEach(function (item) {
      var node = cartPopoverLineNode(root, item, cartPopoverAddonsOf(items, item));
      if (node) list.appendChild(node);
    });
    cartPopoverToggle(list, mains.length > 0);
  }

  var count = mains.reduce(function (total, item) {
    return total + (Number(item.quantity) || 0);
  }, 0);
  cartPopoverSet(root, '[data-ds-cart-popover-count]', '(' + count + ')');

  cartPopoverToggle(root.querySelector('[data-ds-cart-popover-empty]'), mains.length === 0);
  cartPopoverToggle(root.querySelector('[data-ds-cart-popover-footer]'), mains.length > 0);

  cartPopoverSet(root, '[data-ds-cart-popover-subtotal]', cartPopoverMoney(root, cart.items_subtotal_price));
  cartPopoverSet(root, '[data-ds-cart-popover-total]', cartPopoverMoney(root, cart.total_price));

  var discountCents = Number(cart.total_discount || 0);
  cartPopoverToggle(root.querySelector('[data-ds-cart-popover-discount-row]'), discountCents > 0);
  if (discountCents > 0) {
    cartPopoverSet(root, '[data-ds-cart-popover-discount]', '-' + cartPopoverMoney(root, discountCents));
  }
}

function cartPopoverBusy(root, busy) {
  if (!root) return;
  var pending = Number(root.getAttribute('data-ds-cart-popover-pending') || 0);
  pending = Math.max(0, pending + (busy ? 1 : -1));
  root.setAttribute('data-ds-cart-popover-pending', String(pending));
  busy = pending > 0;
  root.setAttribute('aria-busy', busy ? 'true' : 'false');
  root.querySelectorAll('[data-ds-cart-popover-subtotal], [data-ds-cart-popover-total]').forEach(function (el) {
    el.hidden = busy;
  });
  root.querySelectorAll('[data-ds-cart-popover-loading]').forEach(function (el) {
    el.hidden = !busy;
  });
  var pendingEl = root.querySelector('[data-ds-cart-popover-pending]');
  if (pendingEl) pendingEl.hidden = !busy;
  if (busy) {
    ['[data-ds-cart-popover-empty]', '[data-ds-cart-popover-lines]', '[data-ds-cart-popover-footer]']
      .forEach(function (selector) {
        var el = root.querySelector(selector);
        if (el) el.hidden = true;
      });
  }
}

if (!document.__dsCartPopoverBound) {
  document.__dsCartPopoverBound = true;

  document.addEventListener('ds:cart:updated', function (event) {
    var cart = event.detail;
    if (!cart || !Array.isArray(cart.items)) return;
    document.querySelectorAll(CART_POPOVER).forEach(function (root) {
      cartPopoverApply(root, cart);
    });
  });

  document.addEventListener('ds:cart:updating', function (event) {
    document.querySelectorAll(CART_POPOVER).forEach(function (root) {
      cartPopoverBusy(root, !!(event.detail && event.detail.busy));
    });
  });
}

} catch (sfError) {
if (typeof console !== 'undefined') console.error('[sf-core] behavior "cart-popover" failed to initialise:', sfError);
}
})();

/* cart-summary.js */
(function () {
try {
/* cart-summary — keeps the Order Summary honest after a quantity change. Pure
 * restamp from the /cart/change.js response cart-lines.js already fetched: no
 * network of its own.
 *
 * It moves Subtotal, Discount and Estimated Total (plus the mobile sticky bar
 * total/saving) to the numbers the server
 * returned, toggling the Discount and "You're saving" rows when a saving appears
 * or clears. Shipping and Tax stay estimate copy — Shopify only knows them at
 * checkout — so they are never rewritten. A summary without the *-cents anchors
 * (a bare render, Storybook) is left exactly as drawn.
 *
 * Listens for ds:cart:updated (detail = the full cart). Binds data-ds-* only.
 * Authoring rules: src/behaviors/README.md. No import/export.
 */
var CART_SUMMARY = '[data-ds-cart-summary]';

function cartSummaryMoney(root, cents) {
  var format = (root.getAttribute('data-ds-cart-summary-money') || '${{amount}}').replace(/<[^>]*>/g, '');
  var amount = (Number(cents) || 0) / 100;
  return format.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, amount.toFixed(2));
}

function cartSummarySet(root, selector, text) {
  var el = root.querySelector(selector);
  if (el) el.textContent = text;
}

function cartSummaryCount(root, count) {
  cartSummarySet(root, '[data-ds-cart-summary-count-value]', String(count));
  var word = root.querySelector('[data-ds-cart-summary-items-word]');
  if (word) {
    word.textContent = count === 1 ? word.getAttribute('data-one') : word.getAttribute('data-other');
  }
}

function cartSummaryToggle(el, on) {
  if (!el) return;
  el.hidden = !on;
  el.style.display = on ? '' : 'none';
}

function cartSummaryApply(root, cart) {
  if (!root || !cart) return;

  if (Array.isArray(cart.items)) {
    var count = cart.items.reduce(function (total, item) {
      var properties = item && item.properties;
      var addon = item && (item.parent_relationship || (properties && properties._bundle_role === 'addon'));
      return addon ? total : total + (Number(item && item.quantity) || 0);
    }, 0);
    root.setAttribute('data-ds-cart-summary-count', String(count));
    cartSummaryCount(root, count);
  }

  if (typeof cart.items_subtotal_price === 'number') {
    root.setAttribute('data-ds-cart-summary-subtotal-cents', String(cart.items_subtotal_price));
    cartSummarySet(root, '[data-ds-cart-summary-subtotal]', cartSummaryMoney(root, cart.items_subtotal_price));
  }
  if (typeof cart.total_price === 'number') {
    root.setAttribute('data-ds-cart-summary-total-cents', String(cart.total_price));
    cartSummarySet(root, '[data-ds-cart-summary-total]', cartSummaryMoney(root, cart.total_price));
  }

  var discountCents = Number(cart.total_discount || 0);
  var discountRow = root.querySelector('[data-ds-cart-summary-discount-row]');
  if (discountRow) {
    cartSummaryToggle(discountRow, discountCents > 0);
    if (discountCents > 0) {
      cartSummarySet(root, '[data-ds-cart-summary-discount]', '-' + cartSummaryMoney(root, discountCents));
    }
  }

  // Original minus charged: compare-at plus discounts, the whole saving.
  var savingCents = Number(cart.original_total_price || 0) - Number(cart.total_price || 0);
  var savingRow = root.querySelector('[data-ds-cart-summary-saving]');
  if (savingRow) {
    cartSummaryToggle(savingRow, savingCents > 0);
    if (savingCents > 0) {
      cartSummarySet(root, '[data-ds-cart-summary-saving-amount]', cartSummaryMoney(root, savingCents));
    }
  }
}


/* Sticky checkout bar total/saving sit OUTSIDE [data-ds-cart-summary] (on
 * [data-ds-cart-checkout-sticky]), so cartSummaryApply never reaches them.
 * Mirror total + saving here from the same cart payload. */
function cartSummaryApplyStickyBar(cart) {
  if (!cart) return;
  var bars = document.querySelectorAll('[data-ds-cart-checkout-sticky]');
  if (!bars.length) return;
  var formatRoot =
    document.querySelector(CART_SUMMARY + '[data-ds-cart-summary-money]') ||
    document.querySelector(CART_SUMMARY);
  if (!formatRoot) return;

  var totalText =
    typeof cart.total_price === 'number' ? cartSummaryMoney(formatRoot, cart.total_price) : '';
  var savingCents = Number(cart.original_total_price || 0) - Number(cart.total_price || 0);

  bars.forEach(function (bar) {
    if (totalText) {
      var totalEl = bar.querySelector('[data-ds-cart-summary-total]');
      if (totalEl) totalEl.textContent = totalText;
    }
    var savingRow = bar.querySelector('[data-ds-cart-summary-saving]');
    if (!savingRow) return;
    cartSummaryToggle(savingRow, savingCents > 0);
    if (savingCents > 0) {
      var amt = bar.querySelector('[data-ds-cart-summary-saving-amount]');
      if (amt) amt.textContent = cartSummaryMoney(formatRoot, savingCents);
    }
  });
}

function cartSummaryBusy(root, busy) {
  if (!root) return;
  var pending = Number(root.getAttribute('data-ds-cart-summary-pending') || 0);
  pending = Math.max(0, pending + (busy ? 1 : -1));
  root.setAttribute('data-ds-cart-summary-pending', String(pending));
  busy = pending > 0;
  root.setAttribute('aria-busy', busy ? 'true' : 'false');
  root.querySelectorAll('[data-ds-cart-summary-subtotal], [data-ds-cart-summary-total]').forEach(function (el) {
    el.hidden = busy;
  });
  root.querySelectorAll('[data-ds-cart-summary-loading]').forEach(function (el) {
    el.hidden = !busy;
  });
  if (busy) {
    root.querySelectorAll('[data-ds-cart-summary-discount-row], [data-ds-cart-summary-saving]').forEach(function (el) {
      el.hidden = true;
      el.style.display = 'none';
    });
  }
}

if (!document.__dsCartSummaryBound) {
  document.__dsCartSummaryBound = true;

  document.addEventListener('ds:cart:updated', function (event) {
    var cart = event.detail;
    if (!cart || !Array.isArray(cart.items)) return;
    document.querySelectorAll(CART_SUMMARY).forEach(function (root) {
      cartSummaryApply(root, cart);
    });
    cartSummaryApplyStickyBar(cart);
  });

  document.addEventListener('ds:cart:updating', function (event) {
    document.querySelectorAll(CART_SUMMARY).forEach(function (root) {
      cartSummaryBusy(root, !!(event.detail && event.detail.busy));
    });
  });

  document.addEventListener('ds:cart:optimistic-count', function (event) {
    var delta = Number(event.detail && event.detail.delta) || 0;
    if (!delta) return;
    document.querySelectorAll(CART_SUMMARY).forEach(function (root) {
      var count = Math.max(0, Number(root.getAttribute('data-ds-cart-summary-count') || 0) + delta);
      root.setAttribute('data-ds-cart-summary-count', String(count));
      cartSummaryCount(root, count);
    });
  });
}

} catch (sfError) {
if (typeof console !== 'undefined') console.error('[sf-core] behavior "cart-summary" failed to initialise:', sfError);
}
})();

/* checkbox.js */
(function () {
try {
/* checkbox — apply the mixed (indeterminate) state, which is a DOM property
 * with no HTML attribute. Binds [data-ds-checkbox-indeterminate] (see
 * snippets/ds-checkbox.liquid). A MutationObserver re-applies it to checkboxes
 * added after load (Theme Editor section re-render, async mounts).
 *
 * Authoring rules: src/behaviors/README.md. No import/export.
 */

function applyIndeterminate(scope) {
  scope.querySelectorAll('[data-ds-checkbox-indeterminate]').forEach(function (input) {
    input.indeterminate = true;
  });
}

if (!document.__dsCheckboxBound) {
  document.__dsCheckboxBound = true;
  var start = function () {
    applyIndeterminate(document);
    new MutationObserver(function (records) {
      records.forEach(function (record) {
        record.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) applyIndeterminate(node);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
}

} catch (sfError) {
if (typeof console !== 'undefined') console.error('[sf-core] behavior "checkbox" failed to initialise:', sfError);
}
})();

/* checkout-loading.js */
(function () {
try {
/* checkout-loading — the Checkout button's busy state, from click to navigation.
 *
 * The handover to Shopify is silent on a slow connection: nothing on screen
 * changes until the checkout document arrives, so the buyer clicks again. This
 * appends a spinner absolute to the right edge so the label stays centred,
 * sets aria-busy and swallows further clicks — whether the control is the cart
 * form's submit (name="checkout"), the ATC modal's link, or the cart popover's.
 *
 * `disabled` is deliberately NOT set: on the cart page the control is the form's
 * submitter and carries name="checkout", which a disabled button drops — and
 * cart-lines.js re-submits through it (requestSubmit(target)) after flushing a
 * deferred removal. Pointer-events + a click guard block the double-submit
 * without touching what gets posted.
 *
 * The state normally ends with the page going away, and is restored on the
 * paths where it cannot: a cart error, bfcache restore, and a safety timeout
 * for the handovers that quietly never happen.
 *
 * Authoring rules: src/behaviors/README.md. No import/export.
 */
var CHECKOUT_LOADING = '[data-ds-cart-checkout], [data-ds-cart-popover-checkout], [name="checkout"]';

// Match the button's own icon size. The start icon, when there is one, states
// it outright through its `sf-h-icon-*` class; without one there is nothing on
// the button that names its icon step, so fall back to md (20px), what
// ds-button draws everywhere except its s step.
function checkoutLoadingIconSize(el) {
  var icon = el.querySelector(':scope > svg[data-ds-icon]');
  var match = icon && /(?:^|\s)sf-h-icon-([a-z]+)(?:\s|$)/.exec(icon.getAttribute('class') || '');
  return match ? match[1] : 'md';
}

function checkoutLoadingIcon(el) {
  var size = checkoutLoadingIconSize(el);
  var span = document.createElement('span');
  // Absolute to the right edge so the Checkout label stays centred.
  span.className = 'sf-absolute sf-right-3 sf-animate-spin sf-inline-flex';
  span.setAttribute('data-ds-checkout-loading-spinner', '');
  span.innerHTML =
    '<svg class="sf-h-icon-' + size + ' sf-w-icon-' + size + ' sf-shrink-0" viewBox="0 0 24 24"' +
    ' fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"' +
    ' stroke-linejoin="round" aria-hidden="true" focusable="false" data-ds-icon="spinner">' +
    '<path d="M12 3a9 9 0 1 0 9 9" /></svg>';
  return span;
}

// Nothing here is certain to navigate: a click may be cancelled downstream, or
// the cart may answer without a toast. The timer is the last resort that hands
// the button back rather than leaving it busy forever.
var CHECKOUT_LOADING_TIMEOUT = 15000;

function checkoutLoadingArmTimeout(el) {
  clearTimeout(el.__dsCheckoutLoadingTimer);
  el.__dsCheckoutLoadingTimer = setTimeout(function () {
    checkoutLoadingStop(el);
  }, CHECKOUT_LOADING_TIMEOUT);
}

function checkoutLoadingStart(el) {
  if (!el || el.hasAttribute('data-ds-checkout-loading')) return;
  el.setAttribute('data-ds-checkout-loading', '');
  el.setAttribute('aria-busy', 'true');
  el.classList.add('sf-pointer-events-none', 'sf-relative');
  // Absolute spinner at the right edge. Dim the label; hide any existing end
  // icon so only the spinner shows.
  var label = el.querySelector(':scope > span');
  if (label) label.classList.add('sf-opacity-70');
  var icon = el.querySelector(':scope > svg[data-ds-icon]');
  if (icon) icon.setAttribute('hidden', '');
  el.appendChild(checkoutLoadingIcon(el));
  checkoutLoadingArmTimeout(el);
}

function checkoutLoadingStop(el) {
  if (!el || !el.hasAttribute('data-ds-checkout-loading')) return;
  clearTimeout(el.__dsCheckoutLoadingTimer);
  el.__dsCheckoutLoadingTimer = null;
  el.removeAttribute('data-ds-checkout-loading');
  el.setAttribute('aria-busy', 'false');
  el.classList.remove('sf-pointer-events-none', 'sf-relative');
  var spinner = el.querySelector('[data-ds-checkout-loading-spinner]');
  if (spinner && spinner.parentNode) spinner.parentNode.removeChild(spinner);
  var label = el.querySelector(':scope > span.sf-opacity-70');
  if (label) label.classList.remove('sf-opacity-70');
  var icon = el.querySelector(':scope > svg[data-ds-icon]');
  if (icon) icon.removeAttribute('hidden');
}

function checkoutLoadingStopAll() {
  document.querySelectorAll('[data-ds-checkout-loading]').forEach(checkoutLoadingStop);
}

if (!document.__dsCheckoutLoadingBound) {
  document.__dsCheckoutLoadingBound = true;

  // Some storefronts run a search/analytics app (Searchanise was the one caught)
  // that binds a delegated click on the cart form's Checkout button to record a
  // conversion: it preventDefaults the buyer's first click, fires its beacon, then
  // re-fires the click synthetically — and a synthetic click never submits the
  // form, so the handover silently never happens and the buyer has to click a
  // second time (the app also stamps the button, so the second click gets through).
  // Beat it in the CAPTURE phase, which always runs before a delegated bubble
  // handler: on the first real click, start the busy state and submit the cart
  // form ourselves, then stop the event so the app can't swallow it. Scoped to the
  // form's name="checkout" submit; the popover/modal checkout links are plain
  // navigations and fall through to the handler below.
  document.addEventListener('click', function (event) {
    var el = event.target && event.target.closest ? event.target.closest('[name="checkout"]') : null;
    if (!el) return;
    var form = el.form || (el.closest && el.closest('form'));
    if (!form) return;
    if (el.hasAttribute('data-ds-checkout-loading')) {
      event.preventDefault();
      return;
    }
    if (event.defaultPrevented) return;
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    // Ours is the only submission — cancel the native one so the form is not
    // posted twice, and stop the app's bubble handler from ever seeing the click.
    event.preventDefault();
    event.stopPropagation();
    checkoutLoadingStart(el);
    if (form.requestSubmit) form.requestSubmit(el);
    else form.submit();
  }, true);

  document.addEventListener('click', function (event) {
    var el = event.target && event.target.closest ? event.target.closest(CHECKOUT_LOADING) : null;
    if (!el) return;
    // Already handed over — this click must not post the cart form again.
    if (el.hasAttribute('data-ds-checkout-loading')) {
      event.preventDefault();
      return;
    }
    // Neither of these hands over to checkout: a cancelled click goes nowhere,
    // and a middle/modified click opens a tab while this page stays put.
    if (event.defaultPrevented) return;
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    checkoutLoadingStart(el);
  });

  document.addEventListener('ds:cart:error', checkoutLoadingStopAll);
  // A failed commit reports itself only through the toast on one path, and
  // nothing else raises one while a checkout is in flight.
  document.addEventListener('ds:toast', checkoutLoadingStopAll);

  // Back from checkout: bfcache restores the DOM it was frozen with.
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) checkoutLoadingStopAll();
  });
}

} catch (sfError) {
if (typeof console !== 'undefined') console.error('[sf-core] behavior "checkout-loading" failed to initialise:', sfError);
}
})();

/* collapsible.js */
(function () {
try {
/* collapsible — clamp long content with a Show more / Show less toggle.
 * Binds [data-ds-collapsible] and data-ds-collapsible-{viewport,toggle}
 * (see snippets/ds-collapsible.liquid). The snippet ships fully expanded with
 * the toggle hidden; on init we measure the viewport against its clamp height
 * and, only when it overflows, collapse it and reveal the toggle. Content that
 * already fits loses the toggle entirely. Without this JS the content stays
 * visible in full — nothing hides behind a control that cannot open.
 *
 * Authoring rules: src/behaviors/README.md. No import/export.
 */

function bindCollapsible(el) {
  if (el.dataset.dsCollapsibleBound) return;
  var viewport = el.querySelector('[data-ds-collapsible-viewport]');
  var toggle = el.querySelector('[data-ds-collapsible-toggle]');
  if (!viewport || !toggle) return;
  el.dataset.dsCollapsibleBound = '1';

  // Measure against the clamp: collapse, read whether content is taller than
  // the capped viewport, then keep it collapsed (with the toggle) only if so.
  el.setAttribute('data-collapsed', 'true');
  var overflows = viewport.scrollHeight - viewport.clientHeight > 1;
  if (!overflows) {
    el.removeAttribute('data-collapsed');
    return;
  }
  toggle.hidden = false;
  toggle.setAttribute('aria-expanded', 'false');
}

function initCollapsibles(scope) {
  (scope || document).querySelectorAll('[data-ds-collapsible]').forEach(bindCollapsible);
}

function animateCollapsible(el, viewport, collapsed) {
  var version = (el.__dsCollapsibleMotion || 0) + 1;
  el.__dsCollapsibleMotion = version;

  if (viewport.__dsCollapsibleEnd) {
    viewport.removeEventListener('transitionend', viewport.__dsCollapsibleEnd);
  }

  // Start from the height that is actually painted. This also makes a second
  // click during a running transition reverse smoothly from its current point.
  var from = viewport.getBoundingClientRect().height;
  var clamp = parseFloat(getComputedStyle(viewport).getPropertyValue('--collapse-max-height'));
  var to = collapsed ? Math.min(viewport.scrollHeight, clamp) : viewport.scrollHeight;

  viewport.style.maxHeight = from + 'px';
  el.setAttribute('data-collapsed', collapsed ? 'true' : 'false');
  // Commit the start length before scheduling the destination length. A
  // transition cannot interpolate to/from `none`, which was the original snap.
  void viewport.offsetHeight;

  var finish = function (event) {
    if (event.target !== viewport || event.propertyName !== 'max-height') return;
    if (el.__dsCollapsibleMotion !== version) return;
    viewport.style.maxHeight = '';
    viewport.removeEventListener('transitionend', finish);
    viewport.__dsCollapsibleEnd = null;
  };
  viewport.__dsCollapsibleEnd = finish;
  viewport.addEventListener('transitionend', finish);

  requestAnimationFrame(function () {
    if (el.__dsCollapsibleMotion !== version) return;
    viewport.style.maxHeight = to + 'px';
  });
}

function restoreCollapsibleItemPosition(el) {
  var target = el.closest('[data-ds-accordion]') || el;
  var rect = target.getBoundingClientRect();
  if (rect.top >= 0) return;

  var top = rect.top + window.scrollY;
  // The viewport height is already animating. A simultaneous smooth scroll
  // creates a second, competing motion and can chase a moving layout target.
  // Reposition immediately so the height transition remains the only motion.
  window.scrollTo({
    top: Math.max(0, Math.round(top)),
    behavior: 'auto',
  });
}

if (!document.__dsCollapsibleBound) {
  document.__dsCollapsibleBound = true;

  var run = function () { initCollapsibles(document); };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }
  // Theme Editor section re-render and any async-swapped section (e.g. the PDP).
  document.addEventListener('shopify:section:load', run);

  // Content injected after load (Storybook mount, lazy sections): re-scan on the
  // next frame. bindCollapsible is guarded per element, so re-runs are cheap.
  if (typeof MutationObserver !== 'undefined') {
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; run(); });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest && e.target.closest('[data-ds-collapsible-toggle]');
    if (!toggle) return;
    var el = toggle.closest('[data-ds-collapsible]');
    if (!el) return;
    var collapsed = el.getAttribute('data-collapsed') === 'true';
    animateCollapsible(el, el.querySelector('[data-ds-collapsible-viewport]'), !collapsed);
    if (!collapsed) restoreCollapsibleItemPosition(el);
    toggle.setAttribute('aria-expanded', collapsed ? 'true' : 'false');
    var next = collapsed ? toggle.getAttribute('data-label-less') : toggle.getAttribute('data-label-more');
    if (next) toggle.textContent = next;
  });
}

} catch (sfError) {
if (typeof console !== 'undefined') console.error('[sf-core] behavior "collapsible" failed to initialise:', sfError);
}
})();

/* collection-header.js */
(function () {
try {
/* collection-header — "See more" / "See less" under the collection description
 * (ds-collection-header).
 *
 * The description ships clamped to two lines and the toggle ships hidden. This
 * shows the toggle only while the text is actually cut at the current width
 * (scrollHeight beyond the clamped box), re-checked on resize, and flips the
 * clamp when it is pressed. Without JS the clamp simply holds.
 *
 * Authoring rules: src/behaviors/README.md. No import/export.
 */

(function () {
  var CLAMP = 'sf-line-clamp-2';

  function setup(root) {
    if (root.dataset.dsBound) return;
    var desc = root.querySelector('[data-ds-collection-header-desc]');
    var more = root.querySelector('[data-ds-collection-header-more]');
    if (!desc || !more) return;
    root.dataset.dsBound = '1';

    function expanded() {
      return more.getAttribute('aria-expanded') === 'true';
    }

    function check() {
      if (expanded()) return;
      var cut = desc.scrollHeight > desc.clientHeight + 1;
      more.classList.toggle('sf-hidden', !cut);
    }

    more.addEventListener('click', function () {
      var open = !expanded();
      more.setAttribute('aria-expanded', open ? 'true' : 'false');
      desc.classList.toggle(CLAMP, !open);
      more.textContent = open ? more.dataset.labelLess : more.dataset.labelMore;
      if (!open) check();
    });

    check();
    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(check).observe(desc);
    } else {
      window.addEventListener('resize', check);
    }
  }

  function init() {
    document.querySelectorAll('[data-ds-collection-header]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();

} catch (sfError) {
if (typeof console !== 'undefined') console.error('[sf-core] behavior "collection-header" failed to initialise:', sfError);
}
})();

/* collection-listing.js */
(function () {
try {
/* collection-listing — sort and paginate a ds-collection without a full page
 * load. Same flow as the tenant's collection AJAX (script.collection-filters.js,
 * CollectionAjax) it replaces:
 *
 * 1. A click on a same-page link that carries `page` or `sort_by` (the
 *    ds-pagination numbers, the ds-sort-picker options) is intercepted.
 * 2. The grid turns into the skeleton (<template data-ds-collection-skeleton>)
 *    and, for a page change, the window scrolls to the top of the listing.
 * 3. The section is fetched through the Section Rendering API
 *    (`?section_id=`), and [data-ds-collection-body] — sort, grid, pagination
 *    — is swapped for the fresh one; the URL is pushed, so Back restores it.
 * 4. Back / Forward re-load the URL in place (popstate).
 * Any failure falls back to a normal navigation to the same URL.
 *
 * After a page change the window lands on the top of the listing again once
 * the new grid is in. Focus is not moved.
 *
 * Page size from lg: the pagination spec wants 24 below lg and 96 from lg, but
 * the URL page is always the 24 one (Liquid cannot see the width). From lg the
 * body's `data-desktop-step` URL pages are drawn as one: the next pages' cards
 * are fetched and appended, and the [hidden] lg pagination row (numbers link
 * `page=1, 5, 9…`) takes over from the 24 one. Below lg the extra cards go
 * again, so the page keeps its first product across a resize.
 *
 * Progressive enhancement: without this script every link is a real
 * `?page=` / `?sort_by=` URL and the page simply reloads.
 *
 * Authoring rules: src/behaviors/README.md. No import/export.
 */

(function () {
  if (document.__dsCollectionListingBound) return;
  document.__dsCollectionListingBound = true;

  var controller = null;
  var desktop = window.matchMedia('(min-width: 1024px)');
  var expandToken = 0;

  function root() {
    return document.querySelector('[data-ds-collection][data-section-id]');
  }

  function isListingLink(link) {
    if (!link || !link.href || link.target === '_blank') return false;
    var url = new URL(link.href, window.location.origin);
    if (url.origin !== window.location.origin) return false;
    if (url.pathname !== window.location.pathname) return false;
    return url.searchParams.has('page') || url.searchParams.has('sort_by');
  }

  function showSkeleton(el) {
    var body = el.querySelector('[data-ds-collection-body]');
    var grid = body && body.querySelector('[data-ds-collection-grid]');
    var template = body && body.querySelector('template[data-ds-collection-skeleton]');
    if (grid && template) {
      var skeleton = template.content.firstElementChild.cloneNode(true);
      grid.replaceWith(skeleton);
    }
    if (body) {
      body.querySelectorAll('[data-ds-collection-pagination], [data-ds-collection-pagination-desktop]').forEach(function (pager) {
        pager.hidden = true;
      });
    }
    // The header pill hides while the grid loads (collection-header spec).
    var count = el.querySelector('[data-ds-collection-header-count]');
    if (count) count.hidden = true;
  }

  function showCount(el) {
    var count = el.querySelector('[data-ds-collection-header-count]');
    if (count) count.hidden = false;
  }

  function scrollToListing(el) {
    var top = el.getBoundingClientRect().top + window.pageYOffset - 16;
    window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
  }

  // Section Rendering returns the section, not the <head>, so the page title
  // and canonical are brought in line here. The section stamps the new page
  // number and canonical URL on [data-ds-collection-body]; the title follows
  // Shopify's own "<title> – Page N" convention around the collection name.
  function syncHead(el, body) {
    var page = parseInt(body.getAttribute('data-page'), 10) || 1;
    var canonical = body.getAttribute('data-canonical');
    var link = document.querySelector('link[rel="canonical"]');
    if (link && canonical) link.setAttribute('href', canonical);

    var heading = el.querySelector('[data-ds-collection-header] h1');
    var name = heading ? heading.textContent.trim() : '';
    var title = document.title.replace(/ \u2013 Page \d+/, '');
    if (page > 1) {
      title = name && title.indexOf(name) === 0
        ? name + ' \u2013 Page ' + page + title.slice(name.length)
        : title + ' \u2013 Page ' + page;
    }
    document.title = title;
  }

  // The scroll issued on click runs while the grid shrinks to the skeleton and
  // grows back, and on iOS the new page did not land on its top (BY-096). Once
  // the real grid is in, the listing is scrolled to again, with no animation
  // since the content is final.
  function settleOnListing(el) {
    var top = el.getBoundingClientRect().top + window.pageYOffset - 16;
    window.scrollTo({ top: Math.max(top, 0), behavior: 'auto' });
  }

  function setPager(body, wide) {
    var narrowPager = body.querySelector('[data-ds-collection-pagination]');
    var widePager = body.querySelector('[data-ds-collection-pagination-desktop]');
    if (narrowPager) narrowPager.hidden = wide;
    if (widePager) widePager.hidden = !wide;
  }

  function fetchPage(base, page, sectionId) {
    var url = new URL(base, window.location.origin);
    url.searchParams.set('page', String(page));
    url.searchParams.set('section_id', sectionId);
    return fetch(url.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.text();
      })
      .then(function (html) {
        return new DOMParser().parseFromString(html, 'text/html');
      });
  }

  // From lg: append the cards of the next URL pages so one page shows
  // `data-desktop-step` of them, then switch to the lg pagination row. A failed
  // fetch leaves the 24 page and its row as they are, which still pages right.
  function expand(el, base) {
    var body = el.querySelector('[data-ds-collection-body]');
    var grid = body && body.querySelector('[data-ds-collection-grid]');
    if (!grid || body.hasAttribute('data-ds-collection-expanded')) return;
    var step = parseInt(body.getAttribute('data-desktop-step'), 10) || 1;
    if (step < 2) return;
    var page = parseInt(body.getAttribute('data-page'), 10) || 1;
    var pages = parseInt(body.getAttribute('data-pages'), 10) || 1;
    var last = Math.min(page + step - 1, pages);

    body.setAttribute('data-ds-collection-expanded', '');
    var token = ++expandToken;
    var requests = [];
    for (var p = page + 1; p <= last; p++) requests.push(fetchPage(base, p, el.dataset.sectionId));

    Promise.all(requests)
      .then(function (docs) {
        if (token !== expandToken || !grid.isConnected) return;
        var frag = document.createDocumentFragment();
        docs.forEach(function (doc) {
          doc.querySelectorAll('[data-ds-collection-grid] > li').forEach(function (li) {
            var card = document.importNode(li, true);
            card.setAttribute('data-ds-collection-extra', '');
            frag.appendChild(card);
          });
        });
        grid.appendChild(frag);
        setPager(body, true);
      })
      .catch(function () {
        if (token === expandToken) body.removeAttribute('data-ds-collection-expanded');
      });
  }

  function collapse(el) {
    var body = el.querySelector('[data-ds-collection-body]');
    if (!body || !body.hasAttribute('data-ds-collection-expanded')) return;
    expandToken++;
    body.querySelectorAll('[data-ds-collection-extra]').forEach(function (card) {
      card.remove();
    });
    body.removeAttribute('data-ds-collection-expanded');
    setPager(body, false);
  }

  function fit(base) {
    var el = root();
    if (!el) return;
    if (desktop.matches) expand(el, base || window.location.href);
    else collapse(el);
  }

  function load(href, options) {
    var push = !options || options.push !== false;
    var paging = Boolean(options && options.paging);
    var el = root();
    if (!el) {
      window.location.href = href;
      return;
    }

    if (controller) controller.abort();
    controller = new AbortController();

    if (paging) scrollToListing(el);
    showSkeleton(el);

    var fetchUrl = new URL(href, window.location.origin);
    fetchUrl.searchParams.set('section_id', el.dataset.sectionId);

    fetch(fetchUrl.toString(), {
      signal: controller.signal,
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
    })
      .then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var next = doc.querySelector('[data-ds-collection-body]');
        var current = el.querySelector('[data-ds-collection-body]');
        if (!next || !current) throw new Error('collection body not found');
        current.replaceWith(next);
        showCount(el);
        syncHead(el, next);
        if (push) window.history.pushState({ dsCollection: true }, '', href);
        if (paging) settleOnListing(el);
        fit(href);
      })
      .catch(function (error) {
        if (error && error.name === 'AbortError') return;
        window.location.href = href;
      });
  }

  document.addEventListener('click', function (event) {
    if (event.defaultPrevented || event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var el = root();
    if (!el) return;
    var link = event.target.closest('a[href]');
    if (!link || !el.contains(link) || !isListingLink(link)) return;

    event.preventDefault();
    var paging = new URL(link.href, window.location.origin).searchParams.has('page');
    load(link.href, { paging: paging });
  });

  if (desktop.addEventListener) desktop.addEventListener('change', function () { fit(); });
  else desktop.addListener(function () { fit(); });
  document.addEventListener('shopify:section:load', function () { fit(); });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { fit(); }, { once: true });
  } else {
    fit();
  }

  window.addEventListener('popstate', function () {
    // Skip a pop that just closed the mobile nav drawer 
    if (window.__dsNavDrawerPoppedOverlay) {
      window.__dsNavDrawerPoppedOverlay = false;
      return;
    }
    if (!root()) return;
    load(window.location.href, { push: false });
  });
})();

} catch (sfError) {
if (typeof console !== 'undefined') console.error('[sf-core] behavior "collection-listing" failed to initialise:', sfError);
}
})();

/* confirm-modal.js */
(function () {
try {
/* confirm-modal — holds a destructive action until the buyer says yes.
 *
 * cart-lines.js fires a cancelable ds:cart:remove-request before it touches the
 * cart; this cancels it, fills the dialog from the line that asked, and answers
 * with ds:cart:remove-confirm when the buyer confirms. Nothing else in core
 * knows about the dialog, so a page without one removes straight away.
 *
 * Open/closed is [aria-hidden]; src/confirm-modal.css carries the motion. Focus
 * is trapped while open and returned to whatever opened it.
 *
 * Authoring rules: src/behaviors/README.md. No import/export.
 */

var CONFIRM_MODAL = '[data-ds-confirm-modal]';
var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])';

var confirmModalReturn = null;
var confirmModalKey = '';

function confirmModalEl() {
  return document.querySelector(CONFIRM_MODAL);
}

function confirmModalFill(root, line, addon) {
  var source = addon || line;
  var set = function (hook, value) {
    var el = root.querySelector(hook);
    if (el && value !== null && value !== undefined) el.textContent = value;
  };
  var title = source.querySelector('[data-ds-cart-item-title], [data-ds-cart-addon-line-title]');
  set('[data-ds-confirm-modal-product]', title ? title.textContent.trim() : '');

  // The variant line is the options list, joined between its items — joining the
  // wrapper's text instead puts the separator inside each option.
  var options = addon
    ? [addon.querySelector('[data-ds-cart-addon-line-title] + p')]
    : [].slice.call(line.querySelectorAll('[data-ds-cart-item-title] + div > *'));
  set('[data-ds-confirm-modal-variant]', options
    .filter(Boolean)
    .map(function (el) { return el.textContent.trim(); })
    .filter(Boolean)
    .join(' · '));

  var price = source.querySelector('[data-ds-price-amount], [data-ds-cart-addon-line-amount]');
  var amount = root.querySelector('[data-ds-confirm-modal-price] [data-ds-price-amount]');
  if (amount && price) amount.textContent = price.textContent.trim();

  var from = source.querySelector('img');
  var into = root.querySelector('[data-ds-confirm-modal-image]');
  if (into && from && from.getAttribute('src')) {
    into.src = from.getAttribute('src');
    into.alt = from.getAttribute('alt') || '';
    into.removeAttribute('hidden');
  } else if (into) {
    into.setAttribute('hidden', '');
  }
}

function confirmModalClose(root) {
  if (!root || root.getAttribute('aria-hidden') === 'true') return;
  root.setAttribute('aria-hidden', 'true');
  root.removeAttribute('data-ds-confirm-modal-key');
  // page-lock.js keeps the page held while another dialog (ds-cart-added) is
  // still open under this one.
  root.removeAttribute('data-ds-page-lock');
  confirmModalKey = '';
  if (confirmModalReturn && confirmModalReturn.focus) confirmModalReturn.focus();
  confirmModalReturn = null;
}

function confirmModalOpen(root, detail) {
  confirmModalKey = detail.key || '';
  root.setAttribute('data-ds-confirm-modal-key', confirmModalKey);
  if (detail.root) confirmModalFill(root, detail.root, detail.addon);

  confirmModalReturn = document.activeElement;
  root.setAttribute('aria-hidden', 'false');
  root.setAttribute('data-ds-page-lock', '');

  // The card often opens under the pointer, so a footer button would paint
  // :hover immediately. Hold hover until the pointer actually moves.
  root.setAttribute('data-ds-confirm-modal-settle', '');
  var settle = function () {
    root.removeAttribute('data-ds-confirm-modal-settle');
    window.removeEventListener('pointermove', settle);
  };
  window.addEventListener('pointermove', settle);

  // Focus the dialog, not a button. Focusing Keep/Close on open matches :focus
  // and paints the hover fill before the buyer has touched anything. Tab still
  // reaches the actions; the trap below starts from whichever control is first.
  var dialog = root.querySelector('[data-ds-confirm-modal-dialog]');
  window.requestAnimationFrame(function () {
    if (dialog && dialog.focus) dialog.focus();
  });
}

function confirmModalTrap(root, event) {
  var items = [].slice.call(root.querySelectorAll(FOCUSABLE)).filter(function (el) {
    return el.offsetParent !== null;
  });
  if (!items.length) return;
  var first = items[0];
  var last = items[items.length - 1];
  var dialog = root.querySelector('[data-ds-confirm-modal-dialog]');
  // The dialog itself is focused on open (tabindex -1, not in this list).
  // Shift+Tab from there would otherwise leave the sheet.
  if (event.shiftKey && (document.activeElement === first || document.activeElement === dialog)) {
    event.preventDefault();
    last.focus();
  } else if (!event.shiftKey && document.activeElement === last) {
    event.preventDefault();
    first.focus();
  }
}

if (!document.__dsConfirmModalBound) {
  document.__dsConfirmModalBound = true;

  document.addEventListener('ds:cart:remove-request', function (event) {
    var root = confirmModalEl();
    if (!root) return;
    event.preventDefault();
    confirmModalOpen(root, event.detail || {});
  });

  document.addEventListener('click', function (event) {
    var root = confirmModalEl();
    if (!root || root.getAttribute('aria-hidden') !== 'false') return;
    var target = event.target;
    if (!target || !target.closest) return;

    if (target.closest('[data-ds-confirm-modal-confirm]')) {
      var key = confirmModalKey;
      confirmModalClose(root);
      document.dispatchEvent(new CustomEvent('ds:cart:remove-confirm', { detail: { key: key } }));
      return;
    }
    if (target.closest('[data-ds-confirm-modal-cancel]') || target.closest('[data-ds-confirm-modal-close]')) {
      confirmModalClose(root);
      return;
    }
    // The scrim is the root itself; a click inside the card must not close it.
    if (target === root) confirmModalClose(root);
  });

  document.addEventListener('keydown', function (event) {
    var root = confirmModalEl();
    if (!root || root.getAttribute('aria-hidden') !== 'false') return;
    if (event.key === 'Escape') {
      confirmModalClose(root);
    } else if (event.key === 'Tab') {
      confirmModalTrap(root, event);
    }
  });
}

} catch (sfError) {
if (typeof console !== 'undefined') console.error('[sf-core] behavior "confirm-modal" failed to initialise:', sfError);
}
})();

/* customer-reviews.js */
(function () {
try {
/* customer-reviews — fills the homepage band's review cards from Judge.me.
 *
 * The UI is this file; the data is `WcReviewData.judgemeShopCards`
 * (product-reviews-data-judgeme.js): the shop metafields the section parked in
 * the hidden source node, handed over as plain cards ({ body, author, product,
 * href, image, rating }).
 *
 * The band's aggregate has always been real (Judge.me writes the shop average
 * and count into shop metafields, the section prints them); the CARDS used to
 * be hand-typed section blocks. Nothing is force-filled: a card is built only
 * from the parts the feed gave, and a feed that yields nothing leaves the
 * merchant's curated cards alone. The WanderCo SF API is not used here — no
 * request leaves the homepage for this band.
 *
 * Authoring rules: src/behaviors/README.md. No import/export.
 */

var ROOT = '[data-ds-customer-reviews]';

/* ds-rating stacks a filled star over a track star per slot and reveals the
 * overlay with a width utility, so re-pointing it is a class swap — no second
 * star implementation here. Same routine the PDP band uses. */
function setStars(container, score) {
  var halves = Math.max(0, Math.min(10, Math.round(score * 2)));
  container.setAttribute('data-ds-rating-value', String(score));
  container.querySelectorAll('[role="img"] > span').forEach(function (slot, index) {
    var overlay = slot.querySelector('span');
    if (!overlay) return;
    var filled = (index + 1) * 2;
    overlay.classList.remove('sf-w-full', 'sf-w-1/2', 'sf-hidden');
    if (halves >= filled) overlay.classList.add('sf-w-full');
    else if (halves === filled - 1) overlay.classList.add('sf-w-1/2');
    else overlay.classList.add('sf-hidden');
  });
}

function fillCard(node, review) {
  var quote = node.querySelector('blockquote');
  if (quote) quote.textContent = '“' + review.body + '”';

  var author = node.querySelector('cite');
  if (author) {
    if (!review.author) author.remove();
    else author.textContent = review.author;
  }

  var image = node.querySelector('img');
  if (image && review.image) {
    image.setAttribute('src', review.image);
    image.removeAttribute('srcset');
    image.setAttribute('alt', '');
  }

  var stars = node.querySelector('[data-ds-rating]');
  if (stars) setStars(stars, review.rating);

  return node;
}

/* Draw the cards. Figma's card leads with a photo and Judge.me's feed is not
 * ordered that way, so the photo-bearing ones go first. Extras stay available
 * in the scroller. */
function renderCards(root, track, template, cards) {
  cards = cards.slice().sort(function (a, b) {
    return (b.image ? 1 : 0) - (a.image ? 1 : 0);
  });
  var limit = parseInt(root.getAttribute('data-ds-customer-reviews-limit'), 10) || 8;
  track.innerHTML = '';
  cards.slice(0, limit).forEach(function (card) {
    var node = template.content.firstElementChild.cloneNode(true);
    track.appendChild(fillCard(node, card));
  });
}

function setup(root) {
  // Absent when the section already drew Judge.me's photo-gallery cards in Liquid.
  var source = root.querySelector('[data-ds-customer-reviews-source]');
  var template = root.querySelector('[data-ds-customer-reviews-template]');
  var track = root.querySelector('[data-ds-customer-reviews-track]');
  var shopCards = window.WcReviewData && window.WcReviewData.judgemeShopCards;
  if (!source || !template || !track || !shopCards) return;
  /* Nothing parsable leaves the merchant's curated cards alone — four
   * hand-picked quotes beat an empty band. */
  var cards = shopCards(source);
  if (cards.length) renderCards(root, track, template, cards);
}

function init(scope) {
  (scope || document).querySelectorAll(ROOT).forEach(function (root) {
    if (root.dataset.dsBound) return;
    root.dataset.dsBound = '1';
    setup(root);
  });
}

/* The data source (product-reviews-data-judgeme.js) is concatenated AFTER this
 * file in sf-core.js, so start once the whole bundle has run. */
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () { init(); });
} else {
  Promise.resolve().then(function () { init(); });
}

document.addEventListener('shopify:section:load', function (event) {
  init(event.target);
});

} catch (sfError) {
if (typeof console !== 'undefined') console.error('[sf-core] behavior "customer-reviews" failed to initialise:', sfError);
}
})();

/* customily-preview.js */
(function () {
try {
/* customily-preview — the PDP preview dialog Customily renders has a title
 * band and an image, and no footer. The storefront preview (PreviewModalPattern)
 * closes with Close + Add to Cart. This mounts that row into Customily's card
 * and points the two buttons at the controls Customily already handles: the
 * header X, and #customily-cart-btn.
 *
 * It also repaints a selected swatch. Customily writes
 * `border: solid #e95d2c !important` on the chosen <label>, and an inline
 * !important beats every stylesheet. BuildYou's selected tile is navy
 * (--action-secondary-default), so once that orange border is on the label
 * this sets border-color back to the token.
 *
 * Customily's markup is not a ds component. This file is the same exception as
 * src/customily.css: a skin for one third-party dialog, declared by
 * ds-product-customization-form.
 *
 * Authoring rules: src/behaviors/README.md. No import/export.
 */

(function () {
  if (document.__dsCustomilyPreviewBound) return;
  document.__dsCustomilyPreviewBound = true;

  /* Customily clones #customily-cart-btn into the preview (same id, no
     listeners) and may portal that clone ahead of the real button.
     getElementById then returns the clone, and clicking it adds nothing.
     Keep the button that still sits in the product form. */
  var pageCart = null;

  function rememberPageCart() {
    var buttons = document.querySelectorAll('[id="customily-cart-btn"]');
    for (var i = 0; i < buttons.length; i++) {
      if (!buttons[i].closest('.customily-modal-preview-only')) {
        pageCart = buttons[i];
        return;
      }
    }
  }

  function cartButton() {
    if (pageCart && pageCart.isConnected && !pageCart.closest('.customily-modal-preview-only')) {
      return pageCart;
    }
    rememberPageCart();
    if (pageCart && pageCart.isConnected) return pageCart;
    return document.getElementById('customily-cart-btn');
  }

  function labelOf(btn) {
    var text = btn ? (btn.innerText || '').replace(/\s+/g, ' ').trim() : '';
    return text || 'Add to Cart';
  }

  /* Same loading treatment as BY's preview Add to Cart: the label stays, dims,
     and a spinner sits on the right edge. The label does not change to
     "Loading...". */
  function setAdding(add, adding) {
    var label = add.querySelector('[data-ds-customily-preview-add-label]');
    var spinner = add.querySelector('[data-ds-customily-preview-add-spinner]');
    add.disabled = !!adding;
    if (adding) add.setAttribute('aria-busy', 'true');
    else add.removeAttribute('aria-busy');
    if (label) label.classList.toggle('sf-opacity-70', !!adding);
    if (spinner) {
      if (adding) spinner.removeAttribute('hidden');
      else spinner.setAttribute('hidden', '');
    }
  }

  /* The footer is mounted once and Customily reuses the same dialog. A
     successful add closes the modal while the button is still busy, so the
     next Preview opens with Add to Cart disabled. Clear that before show. */
  function resetAdding() {
    var buttons = document.querySelectorAll('[data-ds-customily-preview-add]');
    for (var i = 0; i < buttons.length; i++) setAdding(buttons[i], false);
  }

  var previewToken = 0;

  function closePreview() {
    var modal = document.querySelector('.customily-modal-preview-only');
    if (!modal) return;
    var x = modal.querySelector('.customily-close-button');
    if (x) x.click();
  }

  function cartCount() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) { return cart && cart.item_count ? cart.item_count : 0; })
      .catch(function () { return 0; });
  }

  /* #customily-bottom-wrapper is display:none. Customily's add runs after the
     export, and a visibility check then bails if we hide the button again
     in the same turn as the click. Keep it in the document, off screen,
     until the add settles. */
  function revealCart(cart) {
    var hidden = cart && cart.closest('#customily-bottom-wrapper');
    if (!hidden) return function () {};
    var prevStyle = hidden.getAttribute('style');
    hidden.style.setProperty('display', 'block', 'important');
    hidden.style.setProperty('position', 'fixed', 'important');
    hidden.style.setProperty('left', '-10000px', 'important');
    hidden.style.setProperty('top', '0', 'important');
    hidden.style.setProperty('width', 'auto', 'important');
    hidden.style.setProperty('height', 'auto', 'important');
    hidden.style.setProperty('margin', '0', 'important');
    hidden.style.setProperty('opacity', '0', 'important');
    hidden.style.setProperty('pointer-events', 'none', 'important');
    return function () {
      if (prevStyle == null) hidden.removeAttribute('style');
      else hidden.setAttribute('style', prevStyle);
    };
  }

  function watchCart(before, token, onAdded, onGiveUp) {
    var tries = 0;
    function tick() {
      if (token !== previewToken) return;
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          if (token !== previewToken) return;
          if (cart && cart.item_count > before) {
            onAdded(cart);
            return;
          }
          tries += 1;
          if (tries < 40) window.setTimeout(tick, 500);
          else onGiveUp();
        })
        .catch(function () {
          tries += 1;
          if (tries < 40) window.setTimeout(tick, 500);
          else onGiveUp();
        });
    }
    window.setTimeout(tick, 500);
  }

  function mount(modal) {
    var main = modal.querySelector('.main');
    if (!main || main.querySelector('[data-ds-customily-preview-actions]')) return;

    var actions = document.createElement('div');
    actions.setAttribute('data-ds-customily-preview-actions', '');

    var close = document.createElement('button');
    close.type = 'button';
    close.setAttribute('data-ds-customily-preview-close', '');
    close.textContent = 'Close';

    var add = document.createElement('button');
    add.type = 'button';
    add.setAttribute('data-ds-customily-preview-add', '');
    var addLabel = document.createElement('span');
    addLabel.setAttribute('data-ds-customily-preview-add-label', '');
    addLabel.textContent = labelOf(cartButton());
    var addSpinner = document.createElement('span');
    addSpinner.setAttribute('data-ds-customily-preview-add-spinner', '');
    addSpinner.setAttribute('hidden', '');
    addSpinner.innerHTML =
      '<svg class="sf-h-icon-sm sf-w-icon-sm sf-shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false" data-ds-icon="spinner"><path d="M12 3a9 9 0 1 0 9 9" /></svg>';
    add.appendChild(addLabel);
    add.appendChild(addSpinner);

    close.addEventListener('click', function () {
      var x = main.querySelector('.customily-close-button');
      if (x) x.click();
    });
    add.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      var cart = cartButton();
      if (!cart || cart.disabled || add.disabled) return;
      setAdding(add, true);
      /* Customily posts /cart/add.js itself after the export. That request
         never goes through buy-buttons, so the cart sheet and the header
         count stay put and this modal keeps covering the page. Watch the
         cart until the line lands, then open our sheet and close the modal.
         If buy-buttons does emit ds:cart:added, that wins and we only close. */
      var token = ++previewToken;
      var restore = revealCart(cart);
      var finished = false;
      function done(ok) {
        if (finished || token !== previewToken) return;
        finished = true;
        restore();
        if (!ok) setAdding(add, false);
      }
      function onAdded() {
        document.removeEventListener('ds:cart:added', onAdded);
        document.removeEventListener('ds:cart:error', onError);
        if (token !== previewToken) return;
        done(true);
        closePreview();
      }
      function onError() {
        document.removeEventListener('ds:cart:added', onAdded);
        document.removeEventListener('ds:cart:error', onError);
        if (token !== previewToken) return;
        done(false);
      }
      document.addEventListener('ds:cart:added', onAdded);
      document.addEventListener('ds:cart:error', onError);
      cartCount().then(function (before) {
        if (token !== previewToken) return;
        cart.click();
        watchCart(before, token, function (cartState) {
          if (finished || token !== previewToken) return;
          var items = cartState.items || [];
          var line = items[items.length - 1];
          done(true);
          if (line) document.dispatchEvent(new CustomEvent('ds:cart:added', { detail: line }));
          document.dispatchEvent(new CustomEvent('ds:cart:updated', { detail: cartState }));
          closePreview();
        }, function () {
          document.removeEventListener('ds:cart:added', onAdded);
          document.removeEventListener('ds:cart:error', onError);
          done(false);
        });
      });
    });

    actions.appendChild(close);
    actions.appendChild(add);
    main.appendChild(actions);
  }

  function scan() {
    var modals = document.querySelectorAll('.customily-modal-preview-only');
    for (var i = 0; i < modals.length; i++) mount(modals[i]);
  }

  /* Customily inserts the dialog after this script, and sometimes after the
     show event. Watch for the card and mount once it exists. */
  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(function () {
      queued = false;
      scan();
    });
  }

  /* Customily's selected orange. Compared without spaces so `rgb(233, 93, 44)`
     and `rgb(233,93,44)` are the same border. */
  var SELECTED_ORANGE = 'rgb(233,93,44)';

  function paintSwatches() {
    var root = document.getElementById('customily-options');
    if (!root) return;
    var navy = getComputedStyle(document.documentElement)
      .getPropertyValue('--action-secondary-default')
      .trim();
    if (!navy) return;
    var labels = root.querySelectorAll(
      '.customily-swatch label, .swatch-container label, .cl-color-picker label'
    );
    for (var i = 0; i < labels.length; i++) {
      var border = getComputedStyle(labels[i]).borderTopColor.replace(/\s+/g, '');
      if (border !== SELECTED_ORANGE) continue;
      labels[i].style.setProperty('border-color', navy, 'important');
    }
  }

  /* The orange border is already on the label when Customily inserts it, so an
     attribute-only observer never sees that first write. childList catches the
     insert. A later selection only mutates style, which the same observer
     already handled. */
  function setImportant(el, prop, value) {
    if (!el || !value) return;
    if (el.style.getPropertyPriority(prop) !== 'important') {
      el.style.setProperty(prop, value, 'important');
      return;
    }
    var current = el.style.getPropertyValue(prop);
    if (current === value || current === value + 'px') return;
    el.style.setProperty(prop, value, 'important');
  }

  var BUTTON_PROPS = ['display', 'flex', 'flex-direction', 'justify-content', 'align-items', 'width', 'max-width', 'margin-left', 'margin-right', 'text-align'];

  function clearImportant(el, props) {
    if (!el) return;
    for (var i = 0; i < props.length; i++) {
      if (el.style.getPropertyPriority(props[i]) === 'important') el.style.removeProperty(props[i]);
    }
  }

  /* Only while Customily is reading the photo (both classes). Before upload
     and after it finishes, Replace and its icon stay as Customily drew them.
     Inline overrides from the processing pass are removed, or they would keep
     hiding Replace once the classes are gone. */
  function isUploading(btn) {
    return btn.classList.contains('disabled') && btn.classList.contains('disable-pointer-events');
  }

  function restoreUploadButton(btn) {
    if (btn.hasAttribute('data-ds-processing-on')) {
      btn.removeAttribute('data-ds-processing-on');
      clearImportant(btn, BUTTON_PROPS);
      if (btn.parentElement) clearImportant(btn.parentElement, ['justify-content']);
      var file = btn.closest ? btn.closest('.customily-file-input') : null;
      if (file) clearImportant(file, ['justify-content', 'text-align']);
    }
    var label = btn.querySelector('[data-ds-customily-processing]');
    if (label) label.remove();
    /* One label only. Select Image has no icon; Replace wraps the rotate icon.
       A photo in the field means the remove control is in the DOM. Clear only
       an important display we wrote earlier, then hide the label that is not
       the current one — without that, both words stay on screen. */
    var field = btn.closest ? btn.closest('.customily-file-input') : null;
    if (!field) return;
    var hasValue = !!field.querySelector('.cl_remove-image');
    var kids = btn.children;
    for (var k = 0; k < kids.length; k++) {
      var child = kids[k];
      if (child.hasAttribute('data-ds-customily-processing')) continue;
      var cls = typeof child.className === 'string' ? child.className : '';
      if (cls.indexOf('spinner') !== -1) {
        child.removeAttribute('data-ds-processing-hidden');
        clearImportant(child, ['display', 'flex', 'margin-left', 'margin-right']);
        continue;
      }
      if (child.tagName !== 'SPAN') continue;
      if (child.style.getPropertyPriority('display') === 'important') child.style.removeProperty('display');
      var isReplace = !!child.querySelector('.cl-icon, svg');
      var shouldHide = hasValue ? !isReplace : isReplace;
      if (shouldHide) {
        if (child.style.display !== 'none') child.style.display = 'none';
      }
    }
  }

  function paintProcessing() {
    var root = document.getElementById('customily-options');
    if (!root) return;
    var css = getComputedStyle(document.documentElement);
    var fontSize = css.getPropertyValue('--font-body-sm-size').trim();
    var lineHeight = css.getPropertyValue('--font-body-sm-lh').trim();
    var gap = css.getPropertyValue('--space-2').trim();
    var buttons = root.querySelectorAll('.customily-download-button');
    for (var i = 0; i < buttons.length; i++) {
      var btn = buttons[i];
      if (!isUploading(btn)) {
        restoreUploadButton(btn);
        continue;
      }
      btn.setAttribute('data-ds-processing-on', '');
      setImportant(btn, 'display', 'inline-flex');
      setImportant(btn, 'flex', '0 0 auto');
      setImportant(btn, 'flex-direction', 'row');
      setImportant(btn, 'justify-content', 'flex-start');
      setImportant(btn, 'align-items', 'center');
      setImportant(btn, 'width', 'fit-content');
      setImportant(btn, 'max-width', '100%');
      setImportant(btn, 'margin-left', '0');
      setImportant(btn, 'margin-right', 'auto');
      setImportant(btn, 'text-align', 'left');
      var row = btn.parentElement;
      if (row) setImportant(row, 'justify-content', 'flex-start');
      var file = btn.closest ? btn.closest('.customily-file-input') : null;
      if (file) {
        setImportant(file, 'justify-content', 'flex-start');
        setImportant(file, 'text-align', 'left');
      }
      /* Do not set display on Customily's own spans. v-show keeps Select
         Image and Replace as inline style, and overwriting it leaves both
         words on screen after the upload. CSS pulls those spans out of the
         line only while the uploading classes are present. */
      var spinner = null;
      var kids = btn.children;
      for (var k = 0; k < kids.length; k++) {
        var child = kids[k];
        if (child.hasAttribute('data-ds-customily-processing')) continue;
        var cls = typeof child.className === 'string' ? child.className : '';
        if (cls.indexOf('spinner') === -1) continue;
        spinner = child;
        setImportant(child, 'flex', '0 0 auto');
        setImportant(child, 'margin-left', '0');
        if (gap) setImportant(child, 'margin-right', gap);
        child.setAttribute('data-ds-processing-hidden', '');
      }
      var label = btn.querySelector('[data-ds-customily-processing]');
      if (!label) {
        label = document.createElement('span');
        label.setAttribute('data-ds-customily-processing', '');
        label.textContent = 'Processing by AI ...';
        btn.appendChild(label);
      }
      if (spinner && spinner.nextSibling !== label) btn.insertBefore(label, spinner.nextSibling);
      setImportant(label, 'display', 'inline');
      setImportant(label, 'flex', '0 0 auto');
      setImportant(label, 'margin-left', '0px');
      setImportant(label, 'margin-right', '0px');
      setImportant(label, 'color', 'inherit');
      setImportant(label, 'font-weight', 'inherit');
      setImportant(label, 'white-space', 'nowrap');
      setImportant(label, 'text-align', 'left');
      if (fontSize) setImportant(label, 'font-size', fontSize);
      if (lineHeight) setImportant(label, 'line-height', lineHeight);
    }
  }

  var paintQueued = false;
  function schedulePaint() {
    if (paintQueued) return;
    paintQueued = true;
    window.requestAnimationFrame(function () {
      paintQueued = false;
      paintSwatches();
      paintProcessing();
    });
  }

  var swatchWatch = null;
  var swatchRoot = null;
  function watchSwatches() {
    var root = document.getElementById('customily-options');
    if (!root || !window.MutationObserver) return;
    if (swatchRoot !== root) {
      if (swatchWatch) swatchWatch.disconnect();
      swatchRoot = root;
      swatchWatch = new MutationObserver(function () {
        paintSwatches();
        schedulePaint();
      });
      swatchWatch.observe(root, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['style', 'class'],
      });
    }
    schedulePaint();
  }

  window.addEventListener('customily-preview-modal-show', function () {
    resetAdding();
    schedule();
  });
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    if (!target.closest('#customily-preview-button, .customily-preview-button')) return;
    resetAdding();
    rememberPageCart();
    schedule();
    window.setTimeout(schedule, 400);
  }, true);
  if (window.MutationObserver) {
    new MutationObserver(function () {
      schedule();
      watchSwatches();
    }).observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  }
  schedule();
  watchSwatches();
})();

} catch (sfError) {
if (typeof console !== 'undefined') console.error('[sf-core] behavior "customily-preview" failed to initialise:', sfError);
}
})();

/* delivery-breakdown.js */
(function () {
try {
/* delivery-breakdown — opens the "Delivery breakdown" dialog from the PDP's
 * "Order today and get it by" line ([data-ds-delivery-breakdown-open]).
 *
 * Every number in the dialog is server-rendered by ds-delivery-info, so this
 * only flips [aria-hidden] (src/delivery-breakdown.css carries the motion),
 * traps Tab and returns focus.
 *
 * NOT a singleton: each card renders its own dialog, because each holds its own
 * numbers. ds-product-delivery has no block limit, so a trigger resolves the
 * dialog inside ITS card and only falls back to the first in the document —
 * `document.querySelector` alone would open the first card's ETA from the
 * second card's line.
 *
 * Progressive enhancement: without this the trigger is inert and the dialog
 * stays hidden — the ETA is already printed on the card.
 *
 * Authoring rules: src/behaviors/README.md. No import/export.
 */

var DB_ROOT = '[data-ds-delivery-breakdown]';
var DB_FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])';

var dbReturn = null;

// The dialog a trigger belongs to: its own card first, the page's first one as
// the fallback for a caller that mounts the dialog outside the card.
function dbFor(trigger) {
  var card = trigger && trigger.closest && trigger.closest('[data-ds-delivery-info]');
  return (card && card.querySelector(DB_ROOT)) || document.querySelector(DB_ROOT);
}

// The one currently open — there can only be one, since opening locks the page.
function dbOpenEl() {
  var list = document.querySelectorAll(DB_ROOT);
  for (var i = 0; i < list.length; i++) {
    if (list[i].getAttribute('aria-hidden') === 'false') return list[i];
  }
  return null;
}

function dbOpen(root, trigger) {
  dbReturn = trigger || document.activeElement;
  root.setAttribute('aria-hidden', 'false');
  root.setAttribute('data-ds-page-lock', '');
  window.requestAnimationFrame(function () {
    var close = root.querySelector('[data-ds-delivery-breakdown-close]');
    if (close) close.focus({ focusVisible: false });
  });
}

function dbClose(root) {
  if (!root || root.getAttribute('aria-hidden') === 'true') return;
  root.setAttribute('aria-hidden', 'true');
  // page-lock.js keeps the page held while another dialog is still open.
  root.removeAttribute('data-ds-page-lock');
  if (dbReturn && dbReturn.focus) dbReturn.focus();
  dbReturn = null;
}

function dbTrap(root, event) {
  var items = [].slice.call(root.querySelectorAll(DB_FOCUSABLE)).filter(function (el) {
    return el.offsetParent !== null;
  });
  if (!items.length) return;
  var first = items[0];
  var last = items[items.length - 1];
  if (event.shiftKey && document.activeElement === first) {
    event.preventDefault();
    last.focus();
  } else if (!event.shiftKey && document.activeElement === last) {
    event.preventDefault();
    first.focus();
  } else if (!root.contains(document.activeElement)) {
    event.preventDefault();
    first.focus();
  }
}

if (!document.__dsDeliveryBreakdownBound) {
  document.__dsDeliveryBreakdownBound = true;

  document.addEventListener('click', function (event) {
    if (!event.target.closest) return;

    var trigger = event.target.closest('[data-ds-delivery-breakdown-open]');
    if (trigger) {
      var target = dbFor(trigger);
      if (!target) return;
      event.preventDefault();
      dbOpen(target, trigger);
      return;
    }

    var root = dbOpenEl();
    if (!root) return;
    // The scrim is the root itself; a click inside the card must not close it.
    if (event.target.closest('[data-ds-delivery-breakdown-close]') || event.target === root) {
      dbClose(root);
    }
  });

  document.addEventListener('keydown', function (event) {
    var root = dbOpenEl();
    if (!root) return;
    if (event.key === 'Escape') dbClose(root);
    else if (event.key === 'Tab') dbTrap(root, event);
  });
}

} catch (sfError) {
if (typeof console !== 'undefined') console.error('[sf-core] behavior "delivery-breakdown" failed to initialise:', sfError);
}
})();

/* gallery.js */
(function () {
try {
/* gallery — product gallery carousel: a NATIVE scroll-snap viewer plus prev/next
 * chevrons, thumbnail select, counter, and inline-video play/pause. Binds
 * [data-ds-gallery] and its data-ds-gallery-* children (see
 * snippets/ds-gallery.liquid).
 *
 * The viewer is a horizontal scroll-snap container — one slide per viewport,
 * exactly like ds-hero-slider. The finger-swipe on a phone is therefore the
 * BROWSER'S OWN native scroll (momentum, snap and all), which stays smooth even
 * inside a throttled in-app webview (Facebook/Instagram) where a hand-wired
 * JS transform-drag janks. This script only ADDS the enhancements on top of
 * that zero-JS baseline: it reads the active slide back from the scroll
 * position, moves the selection when a chevron or thumbnail is pressed (via
 * scrollTo, so swipe and click share ONE scroll position instead of fighting a
 * transform), restages the thumbnail ring + counter, and plays/pauses the
 * inline video. Progressive enhancement: without this script the first image +
 * all thumbs still render and the viewer still swipes; only the counter,
 * thumbnail ring and video autoplay are off.
 *
 * The thumbnail strip is a ds-thumbnail-rail (snippets/ds-thumbnail-rail.liquid),
 * whose tiles are ds-thumbnail atoms. This script is the shipped driver for that
 * rail when it sits inside a gallery: it moves the selection, restages the tile
 * ring, centres the selected tile, and swaps the counter. In Storybook
 * runtime/media-behaviour.ts drives the rail; the native swipe needs no JS.
 *
 * Authoring rules: src/behaviors/README.md. No import/export — the build wraps
 * this file in an IIFE and concatenates it into dist/sf-core.js.
 */

// The two class sets ds-thumbnail toggles for `selected`. MUST match
// selected_ring / live in snippets/ds-thumbnail.liquid — the snippet is the
// source of truth and server-renders the active tile; this only restages it when
// the selection changes. runtime/media-behaviour.ts mirrors the same sets;
// update all three together.
var TILE_SELECTED = ['sf-border-secondary'];
var TILE_IDLE = ['hover:sf-border-strong', 'hover:sf-shadow-2', 'focus-visible:sf-outline', 'focus-visible:sf-outline-focus', 'focus-visible:sf-outline-offset-focus'];

// The rail's SCROLL CONTAINER, which is not always the element carrying the
// [data-ds-thumbnail-rail] hook. In ds-gallery that hook sits on a positioning
// wrapper (lg:relative lg:w-gallery-rail, overflow visible) and the element that
// actually scrolls is the ds-thumbnail-rail inside it — scrolling the wrapper is
// a no-op, and its flex-direction is `row` even where the real strip is a column,
// so the axis comes out wrong too. The rail snippet always stamps its own
// orientation, so that attribute is what identifies the scroller; the hand-written
// rail in ds-cart-photo-lightbox carries both on one element and still matches.
function galleryRail(root) {
  return root.querySelector('[data-ds-thumbnail-rail-orientation]') ||
    root.querySelector('[data-ds-thumbnail-rail]');
}

// Centre the selected tile inside the rail. The rail hides its scrollbar
// (matching the live storefronts), so a tile past the fold has no affordance
// otherwise. Scrolls the RAIL only, never an ancestor, so a gallery sitting in a
// sticky column doesn't drag the page. Clamped by scrollTo, so the first/last
// tile simply rests against its end.
function centerRailTile(rail, tile) {
  var railBox = rail.getBoundingClientRect();
  var tileBox = tile.getBoundingClientRect();
  // Read the computed direction, not the orientation attribute: the responsive
  // rail is a row on mobile and a column from lg, so the scroll axis flips.
  var vertical = getComputedStyle(rail).flexDirection.indexOf('column') === 0;
  var offset = vertical
    ? tileBox.top - railBox.top - (railBox.height - tileBox.height) / 2
    : tileBox.left - railBox.left - (railBox.width - tileBox.width) / 2;
  // Honour a user who asked the OS for less motion; the jump still happens.
  var smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var target = vertical ? { top: rail.scrollTop + offset } : { left: rail.scrollLeft + offset };
  target.behavior = smooth ? 'smooth' : 'auto';
  rail.scrollTo(target);
}

// The active slide read back from the viewer's OWN scroll position — correct
// after a native swipe that stopped between two snap points as much as after our
// own scrollTo. Rounding picks the nearest snap point.
function galleryIndexFromScroll(track) {
  var w = track.clientWidth || 1;
  return Math.round(track.scrollLeft / w);
}

// The neighbours are lazy (only the active slide renders eager), so the FIRST
// swipe to each image would otherwise fetch+decode mid-scroll and stutter.
// Warming the two adjacent slides the moment the active one changes keeps the
// next swipe instant. Per the HTML spec, flipping an <img>'s loading from lazy
// to eager starts the fetch immediately, even while the slide is off-screen.
function preloadGalleryNeighbors(root, idx) {
  var track = root.querySelector('[data-ds-gallery-track]');
  if (!track) return;
  [idx - 1, idx + 1].forEach(function (target) {
    var img = track.querySelector('img[data-ds-gallery-slide][data-ds-gallery-index="' + target + '"]');
    if (img && img.loading === 'lazy') img.loading = 'eager';
  });
}

// Silence a slide's video. Called for the slide being LEFT (and for every slide
// when the lightbox closes), never for one that was not playing — an iframe
// reload is not free, and a never-visited embed must not be touched.
// A Shopify-hosted video is a real <video>, so pause() is enough. An
// external_video is a third-party iframe we cannot control without its JS API
// (YouTube ignores postMessage without enablejsapi), so reassigning src is the
// portable stop: it drops the player back to its poster.
function stopGalleryMedia(slide) {
  if (!slide) return;
  if (typeof slide.pause === 'function') {
    slide.pause();
    return;
  }
  var frame = slide.querySelector('iframe');
  if (frame) frame.src = frame.src;
}

// Landing on a video slide starts it, so the shopper sees motion instead of a
// still they have to press. Only the INLINE preview, which is the muted looping
// one: the lightbox player is unmuted-capable and has controls, and a browser
// blocks unprompted audio anyway, so starting that one would just be refused.
// play() rejects on its own for a codec or policy the browser dislikes — the
// poster stays, which is the honest fallback.
function playGalleryMedia(slide) {
  if (!slide || !slide.muted || typeof slide.play !== 'function') return;
  var played = slide.play();
  if (played && typeof played.catch === 'function') played.catch(function () {});
}

// The <video> for the slide that is currently active (null when the active slide
// is an image or an external embed).
function activeGalleryVideo(root) {
  var idx = Number(root.dataset.dsGalleryActive || 0);
  return root.querySelector('video[data-ds-gallery-video][data-ds-gallery-index="' + idx + '"]');
}

// Play the active video only while the gallery is actually on-screen, pause it
// otherwise. This is the "scroll to the video and it plays" behaviour: on the
// PDP the gallery scrolls in and out of view as the shopper reads, and a muted
// clip must not burn cycles behind the fold. Routed through here from BOTH a
// slide change (syncGalleryUI) and a scroll (the observer below), so the two
// share one play/pause decision. `__dsVisible` is undefined until the observer
// first reports — and stays so where IntersectionObserver is missing — which we
// read as visible, degrading to the plain "play on active slide" baseline.
function updateGalleryPlayback(root) {
  var video = activeGalleryVideo(root);
  if (!video) return;
  var hidden = galleryVisibility && root.__dsVisible === false;
  if (hidden) {
    video.pause();
  } else {
    playGalleryMedia(video);
  }
}

// One observer for every gallery on the page: it flips each root's visibility
// flag and re-evaluates playback. 0.5 = start once half the gallery is in view,
// which on mobile means the shopper has actually scrolled the media into frame.
var galleryVisibility = typeof IntersectionObserver !== 'undefined'
  ? new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        entry.target.__dsVisible = entry.isIntersecting;
        updateGalleryPlayback(entry.target);
      });
    }, { threshold: 0.5 })
  : null;

// Watch a gallery for scroll-in/out. Idempotent — a re-render (Theme Editor) or
// a second initGalleries pass must not stack duplicate observations.
function observeGallery(root) {
  if (!galleryVisibility || root.__dsObserved) return;
  root.__dsObserved = true;
  galleryVisibility.observe(root);
}

// Sync every derived bit of UI to `idx` WITHOUT scrolling. The scroll position
// is the source of truth, so this is called FROM the scroll listener as the
// track travels (native swipe or our own scrollTo alike) and once on init.
function syncGalleryUI(root, idx, centerSelected) {
  var count = Number(root.dataset.dsGalleryCount || 0);
  if (!count) return;
  idx = Math.max(0, Math.min(count - 1, idx));
  var prev = Number(root.dataset.dsGalleryActive || 0);
  if (prev !== idx) {
    stopGalleryMedia(root.querySelector('[data-ds-gallery-video][data-ds-gallery-index="' + prev + '"]'));
  }
  root.dataset.dsGalleryActive = String(idx);
  // Play/pause the new active slide's video by whether the gallery is in view.
  updateGalleryPlayback(root);
  // Warm the slides on either side so the next swipe doesn't decode mid-scroll.
  preloadGalleryNeighbors(root, idx);

  var railWrap = root.querySelector('[data-ds-thumbnail-rail]');
  if (railWrap) {
    // `data-ds-thumbnail-rail` sits on a plain wrapper (ds-gallery.liquid); the
    // element that actually overflows/scrolls is the ds-thumbnail-rail snippet
    // root inside it (it carries the orientation attribute). Centre THAT one —
    // scrolling the non-overflowing wrapper is a no-op, so the active tile never
    // came into view.
    var rail = railWrap.querySelector('[data-ds-thumbnail-rail-orientation]') || railWrap;
    rail.setAttribute('data-ds-thumbnail-rail-active', String(idx));
    rail.querySelectorAll('[data-ds-thumbnail-rail-item]').forEach(function (item) {
      var control = item.querySelector('[data-ds-thumbnail]');
      if (!control) return;
      var isActive = Number(item.getAttribute('data-ds-thumbnail-rail-index')) === idx;
      // Toggle the ring atomically: strip both sets, re-add the right one.
      TILE_SELECTED.forEach(function (c) { control.classList.remove(c); });
      TILE_IDLE.forEach(function (c) { control.classList.remove(c); });
      (isActive ? TILE_SELECTED : TILE_IDLE).forEach(function (c) { control.classList.add(c); });
      control.setAttribute('aria-pressed', String(isActive));
      if (isActive && centerSelected !== false) centerRailTile(rail, control);
    });
  }

  var cur = root.querySelector('[data-ds-gallery-counter-current]');
  if (cur) cur.textContent = String(idx + 1);
  updateGalleryButtons(root);
}

function updateGalleryButtons(root) {
  var count = Number(root.dataset.dsGalleryCount || 0);
  var idx = Number(root.dataset.dsGalleryActive || 0);
  var prev = root.querySelector('[data-ds-gallery-prev]');
  var next = root.querySelector('[data-ds-gallery-next]');
  // A looping gallery (the media lightbox) wraps, so only a single slide disables.
  var loop = root.hasAttribute('data-ds-gallery-loop');
  if (prev) prev.disabled = count <= 1 || (!loop && idx <= 0);
  if (next) next.disabled = count <= 1 || (!loop && idx >= count - 1);
}

// Scroll the viewer to slide `idx`. `instant` (and reduced-motion) override the
// track's CSS scroll-behavior: smooth for a jump the shopper shouldn't watch
// travel — opening the lightbox on the slide they swiped to, or the first paint.
function scrollGalleryTo(root, idx, instant) {
  var track = root.querySelector('[data-ds-gallery-track]');
  if (!track) return;
  var count = Number(root.dataset.dsGalleryCount || 0);
  var clamped = Math.max(0, Math.min(Math.max(0, count - 1), idx));
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var left = clamped * (track.clientWidth || 1);
  if (instant || reduce) {
    // A real, single-frame jump — used to keep the inline gallery and its
    // full-screen twin on the same slide when the lightbox opens/closes (and on
    // first paint). scrollTo({behavior:'auto'}) is spec-instant, but Safari and
    // in-app WebViews (Facebook/Instagram) still ANIMATE it on a track that is
    // scroll-snap + scroll-behavior:smooth — that stray glide is the "slide" the
    // paired gallery showed. Forcing scroll-behavior:auto inline (inline wins over
    // the sf-scroll-smooth class) and writing scrollLeft lands it with no motion
    // in every engine; restore the previous inline value next frame so ordinary
    // swipes and chevron moves stay smooth.
    var previousBehavior = track.style.scrollBehavior;
    track.style.scrollBehavior = 'auto';
    track.scrollLeft = left;
    requestAnimationFrame(function () {
      track.style.scrollBehavior = previousBehavior;
    });
    return;
  }
  track.scrollTo({ left: left, behavior: 'smooth' });
}

// Programmatic move (chevron, thumbnail, ds:gallery:set). Scrolls the viewer;
// the scroll listener restages the UI as the track travels. An `instant` jump
// may not fire a scroll event (already at target), so sync the UI directly too.
function setGalleryActive(root, next, centerSelected, instant) {
  var count = Number(root.dataset.dsGalleryCount || 0);
  if (!count) return;
  var idx = Math.max(0, Math.min(count - 1, next));
  scrollGalleryTo(root, idx, instant);
  if (instant) syncGalleryUI(root, idx, centerSelected);
}

// Looping gallery past either end (the media lightbox, ds-gallery `loop`). A
// plain scroll there would rewind across every slide in between, and a jump
// has no motion while every other step glides. So the target slide is moved
// next to the current one with CSS `order`, the track glides that one slide
// like any other step, and then the order and scroll are put back in the same
// frame, which shows no change.
function wrapGallery(root, dir) {
  var track = root.querySelector('[data-ds-gallery-track]');
  var count = Number(root.dataset.dsGalleryCount || 0);
  if (!track || count < 2 || root.__dsGalleryWrapping) return;
  var target = dir > 0 ? 0 : count - 1;
  var slide = track.children[target];
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!slide || reduce) {
    setGalleryActive(root, target, false, true);
    return;
  }

  var w = track.clientWidth || 1;
  var endLeft = dir > 0 ? (count - 1) * w : 0;
  var previousBehavior = track.style.scrollBehavior;
  var timer = 0;
  root.__dsGalleryWrapping = true;
  // Counter, active slide and video state flip now, as they do on any step.
  syncGalleryUI(root, target, false);

  // Park the target beside the current slide, which moves one place, and hold
  // the current slide still under the viewer.
  track.style.scrollBehavior = 'auto';
  slide.style.order = dir > 0 ? '1' : '-1';
  track.scrollLeft = dir > 0 ? (count - 2) * w : w;

  function finish() {
    if (!root.__dsGalleryWrapping) return;
    clearTimeout(timer);
    track.removeEventListener('scroll', onScroll);
    track.removeEventListener('scrollend', finish);
    track.style.scrollBehavior = 'auto';
    slide.style.order = '';
    track.scrollLeft = target * w;
    requestAnimationFrame(function () {
      track.style.scrollBehavior = previousBehavior;
      root.__dsGalleryWrapping = false;
    });
  }
  // scrollend is not in every engine yet: landing on the end position or a
  // timeout well past one slide's glide closes the step too.
  function onScroll() {
    if (Math.abs(track.scrollLeft - endLeft) < 1) finish();
  }

  requestAnimationFrame(function () {
    track.style.scrollBehavior = previousBehavior;
    track.addEventListener('scroll', onScroll, { passive: true });
    track.addEventListener('scrollend', finish);
    timer = setTimeout(finish, 1000);
    track.scrollTo({ left: endLeft, behavior: 'smooth' });
  });
}

// Restage the UI from the live scroll position, at most once per frame — a swipe
// fires scroll far more often than the active slide actually changes.
function bindGalleryScroll(root) {
  if (root.__dsGalleryScrollBound) return;
  var track = root.querySelector('[data-ds-gallery-track]');
  if (!track) return;
  root.__dsGalleryScrollBound = true;
  var queued = false;
  track.addEventListener('scroll', function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      // A wrap step reorders the slides mid-glide; wrapGallery owns the UI then.
      if (root.__dsGalleryWrapping) return;
      var idx = galleryIndexFromScroll(track);
      if (idx !== Number(root.dataset.dsGalleryActive || 0)) syncGalleryUI(root, idx);
    });
  }, { passive: true });
}

// The media column sticks at `--space-6` from lg. The photo note hangs off
// the bottom of that column, so while the column is pinned the last line sits
// below the viewport until the column unsticks at the end of the section.
// Cap the preview (`--ds-preview-max`) so the buttons and the full note fit.
// If the chrome alone is already too tall, pull `top` up instead.
function mediaStickyGap() {
  var n = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--space-6'));
  return n > 0 ? n : 24;
}

function mediaBottomCover() {
  var bar = document.querySelector('.sticky-btn-container');
  if (!bar || !bar.getClientRects().length) return 0;
  var pos = getComputedStyle(bar).position;
  if (pos !== 'fixed' && pos !== 'sticky') return 0;
  var rect = bar.getBoundingClientRect();
  if (rect.top >= window.innerHeight) return 0;
  return Math.max(0, window.innerHeight - rect.top);
}

function clearProductMediaFit(col) {
  col.style.top = '';
  col.style.removeProperty('--ds-preview-max');
}

// Natural height of the preview at the column's full width. Reading the
// rendered height loops: a cap shrinks it, the next pass thinks it fits, and
// the cap comes off.
function canvasNaturalHeight(canvas) {
  var parent = canvas.parentElement;
  var fullW = parent ? parent.clientWidth : 0;
  if (!canvas.width || !canvas.height || !fullW) return canvas.getBoundingClientRect().height;
  return (canvas.height / canvas.width) * fullW;
}

function fitProductMedia(col) {
  if (getComputedStyle(col).position !== 'sticky') {
    clearProductMediaFit(col);
    return;
  }
  var controls = col.querySelector('.customily-mobile-controls');
  var canvas = col.querySelector('[data-ds-gallery-viewer] > .cl-canvas-container canvas');
  if (!controls || !controls.getClientRects().length || !canvas) {
    clearProductMediaFit(col);
    return;
  }
  var gap = mediaStickyGap();
  var cover = Math.max(gap, mediaBottomCover());
  var rendered = canvas.getBoundingClientRect().height;
  var chrome = col.getBoundingClientRect().height - rendered;
  var maxH = window.innerHeight - gap - cover - chrome;
  var natural = canvasNaturalHeight(canvas);
  if (natural > maxH + 1 && maxH >= 160) {
    var next = Math.floor(maxH) + 'px';
    if (col.style.getPropertyValue('--ds-preview-max') !== next) {
      col.style.setProperty('--ds-preview-max', next);
    }
    col.style.top = '';
    return;
  }
  col.style.removeProperty('--ds-preview-max');
  var top = Math.min(gap, window.innerHeight - cover - col.getBoundingClientRect().height);
  if (top < gap - 0.5) col.style.top = Math.round(top) + 'px';
  else col.style.top = '';
}

function bindProductMediaFit(root) {
  var col = root.closest('[data-ds-product-media]');
  if (!col || col.__dsMediaFit) return;
  col.__dsMediaFit = true;
  if (window.ResizeObserver) new ResizeObserver(function () { fitProductMedia(col); }).observe(col);
  fitProductMedia(col);
}

function initGalleries() {
  document.querySelectorAll('[data-ds-gallery]').forEach(function (root) {
    observeGallery(root);
    bindGalleryScroll(root);
    bindProductMediaFit(root);
    var idx = Number(root.dataset.dsGalleryActive || 0);
    // Place the scroll at the server-rendered active slide with no animation,
    // then sync the derived UI. rAF: the track's clientWidth is 0 until layout.
    requestAnimationFrame(function () {
      scrollGalleryTo(root, idx, true);
      syncGalleryUI(root, idx, false);
    });
  });
}

if (!document.__dsGalleryBound) {
  document.__dsGalleryBound = true;
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGalleries, { once: true });
  } else {
    initGalleries();
  }
  // The Theme Editor re-renders a section into a fresh subtree; re-run so the new
  // gallery gets its scroll listener bound and its position set. Idempotent:
  // existing galleries just re-assert the slide they already show.
  document.addEventListener('shopify:section:load', initGalleries);
  window.addEventListener('resize', function () {
    document.querySelectorAll('[data-ds-product-media]').forEach(fitProductMedia);
  });
  if (window.MutationObserver) {
    new MutationObserver(function () {
      document.querySelectorAll('[data-ds-product-media]').forEach(fitProductMedia);
    }).observe(document.body, { childList: true });
  }
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var root = t.closest('[data-ds-gallery]');
    if (!root) return;
    var current = Number(root.dataset.dsGalleryActive || 0);

    var step = t.closest('[data-ds-gallery-prev]') ? -1 : t.closest('[data-ds-gallery-next]') ? 1 : 0;
    if (step) {
      // Let a wrap step land before the next one starts from its reordered track.
      if (root.__dsGalleryWrapping) return;
      var count = Number(root.dataset.dsGalleryCount || 0);
      var target = current + step;
      if (root.hasAttribute('data-ds-gallery-loop') && count > 1 && (target < 0 || target >= count)) {
        wrapGallery(root, step);
        return;
      }
      setGalleryActive(root, target);
      return;
    }

    var item = t.closest('[data-ds-thumbnail-rail-item]');
    if (item) {
      var idx = Number(item.getAttribute('data-ds-thumbnail-rail-index'));
      if (!Number.isNaN(idx)) setGalleryActive(root, idx);
    }
  });

  // Programmatic jump. media-lightbox.js dispatches this to keep the inline
  // gallery and its full-screen twin on the same image; a variant switch could
  // use it too. Delegated on document so galleries mounted later still respond.
  document.addEventListener('ds:gallery:set', function (e) {
    var root = e.target && e.target.closest && e.target.closest('[data-ds-gallery]');
    if (!root) return;
    var idx = Number(e.detail && e.detail.index);
    // `instant` skips the slide animation — the open/close sync is a jump to a
    // known slide, not a swipe the shopper should watch travel.
    var instant = !!(e.detail && e.detail.instant);
    if (!Number.isNaN(idx)) setGalleryActive(root, idx, false, instant);
  });

  // Stop everything playing in a gallery. media-lightbox.js dispatches this when
  // the modal closes — otherwise a video keeps playing (audible) behind a modal
  // that is only [aria-hidden], still painted and never unmounted.
  document.addEventListener('ds:gallery:stop', function (e) {
    var root = e.target && e.target.closest && e.target.closest('[data-ds-gallery]');
    if (!root) return;
    root.querySelectorAll('[data-ds-gallery-video]').forEach(stopGalleryMedia);
  });
}

} catch (sfError) {
if (typeof console !== 'undefined') console.error('[sf-core] behavior "gallery" failed to initialise:', sfError);
}
})();

/* header-nav.js */
(function () {
try {
/* header-nav — adds Amazon-style menu aim to desktop mega menus and controls
 * the mobile hamburger drawer with its single-open accordion branches.
 * Delegated listeners keep it Theme-Editor-safe and work for async Storybook
 * mounts. No import/export: the build wraps this file in an IIFE.
 */

(function () {
  if (document.__dsHeaderNavBound) return;
  document.__dsHeaderNavBound = true;

  var DESKTOP_QUERY = '(min-width: 1024px) and (hover: hover) and (pointer: fine)';
  var SAFE_TRIANGLE_TIMEOUT = 500;
  var CLOSE_DELAY = 120;
  var navState = new WeakMap();

  // Marker: CSS keeps :hover/:focus-within as the no-JS fallback; once this
  // attribute is set, header-nav.css hands fine-pointer hover to menu-aim.
  document.documentElement.setAttribute('data-ds-header-menu-aim', '');

  function desktopPointer(event) {
    return event.pointerType === 'mouse' && window.matchMedia(DESKTOP_QUERY).matches;
  }

  function stateFor(nav) {
    var state = navState.get(nav);
    if (!state) {
      state = {
        active: null,
        pending: null,
        triangle: null,
        lastPoint: null,
        closeTimer: 0,
        aimTimer: 0,
      };
      navState.set(nav, state);
    }
    return state;
  }

  function menuFor(item) {
    return item && item.querySelector(':scope > [data-ds-header-mega-menu]');
  }

  function setDesktopItem(item, open) {
    if (!item) return;
    item.toggleAttribute('data-ds-menu-open', open);
    var trigger = item.querySelector(':scope > [data-ds-header-nav-trigger]');
    if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function cancelTimers(state) {
    window.clearTimeout(state.closeTimer);
    window.clearTimeout(state.aimTimer);
    state.closeTimer = 0;
    state.aimTimer = 0;
  }

  function activateDesktopItem(nav, item) {
    var state = stateFor(nav);
    cancelTimers(state);
    if (state.active !== item) setDesktopItem(state.active, false);
    state.active = menuFor(item) ? item : null;
    state.pending = null;
    state.triangle = null;
    state.lastPoint = null;
    nav.removeAttribute('data-ds-menu-aiming');
    setDesktopItem(state.active, true);
    capMenuHeight(menuFor(state.active));
  }

  /* A panel taller than the screen below the bar (a long column of 44 touch
     rows on a 768-tall landscape tablet) scrolls inside itself instead of
     running past the bottom edge. Measured on open, once the panel is shown. */
  function capMenuHeight(menu) {
    if (!menu) return;
    var top = menu.getBoundingClientRect().top;
    menu.style.setProperty('--ds-header-mega-max-height', Math.max(200, Math.floor(window.innerHeight - top - 12)) + 'px');
  }

  function closeDesktopNav(nav) {
    var state = stateFor(nav);
    cancelTimers(state);
    setDesktopItem(state.active, false);
    state.active = null;
    state.pending = null;
    state.triangle = null;
    state.lastPoint = null;
    nav.removeAttribute('data-ds-menu-aiming');
  }

  function pointInTriangle(point, a, b, c) {
    function sign(p1, p2, p3) {
      return (p1.x - p3.x) * (p2.y - p3.y) - (p2.x - p3.x) * (p1.y - p3.y);
    }
    var d1 = sign(point, a, b);
    var d2 = sign(point, b, c);
    var d3 = sign(point, c, a);
    var hasNegative = d1 < 0 || d2 < 0 || d3 < 0;
    var hasPositive = d1 > 0 || d2 > 0 || d3 > 0;
    return !(hasNegative && hasPositive);
  }

  function armSafeTriangle(nav, event) {
    var state = stateFor(nav);
    var menu = menuFor(state.active);
    if (!menu) return;
    var bounds = menu.getBoundingClientRect();
    var edgeY = bounds.top + 8;
    var apex = state.lastPoint || { x: event.clientX, y: event.clientY };
    state.triangle = {
      startedAt: Date.now(),
      apex: { x: apex.x, y: apex.y },
      left: { x: bounds.left - 12, y: edgeY },
      right: { x: bounds.right + 12, y: edgeY },
    };
  }

  function insideSafeTriangle(state, event) {
    var triangle = state.triangle;
    if (!triangle || Date.now() - triangle.startedAt > SAFE_TRIANGLE_TIMEOUT) return false;
    return pointInTriangle(
      { x: event.clientX, y: event.clientY },
      triangle.apex,
      triangle.left,
      triangle.right,
    );
  }

  function deferToSafeTriangle(nav, item) {
    var state = stateFor(nav);
    cancelTimers(state);
    state.pending = item;
    nav.setAttribute('data-ds-menu-aiming', '');
    state.aimTimer = window.setTimeout(function () {
      activateDesktopItem(nav, state.pending);
    }, SAFE_TRIANGLE_TIMEOUT);
  }

  function scheduleDesktopClose(nav) {
    var state = stateFor(nav);
    window.clearTimeout(state.closeTimer);
    state.closeTimer = window.setTimeout(function () {
      var activeMenu = menuFor(state.active);
      if (state.active && !state.active.matches(':hover') && (!activeMenu || !activeMenu.matches(':hover'))) {
        closeDesktopNav(nav);
      }
    }, CLOSE_DELAY);
  }

  document.addEventListener('pointerover', function (event) {
    if (!desktopPointer(event) || !event.target.closest) return;
    var item = event.target.closest('[data-ds-header-nav-item]');
    var nav = item && item.closest('[data-ds-header-nav]');
    if (!nav || (event.relatedTarget && item.contains(event.relatedTarget))) return;

    var state = stateFor(nav);
    window.clearTimeout(state.closeTimer);
    state.closeTimer = 0;

    if (state.active === item) return;
    if (state.active && insideSafeTriangle(state, event)) {
      deferToSafeTriangle(nav, item);
      return;
    }
    activateDesktopItem(nav, item);
    stateFor(nav).lastPoint = { x: event.clientX, y: event.clientY };
  });

  document.addEventListener('pointerout', function (event) {
    if (!desktopPointer(event) || !event.target.closest) return;
    var item = event.target.closest('[data-ds-header-nav-item]');
    var nav = item && item.closest('[data-ds-header-nav]');
    if (!nav || stateFor(nav).active !== item) return;
    if (event.relatedTarget && item.contains(event.relatedTarget)) return;
    armSafeTriangle(nav, event);
    scheduleDesktopClose(nav);
  });

  document.addEventListener('pointermove', function (event) {
    if (!desktopPointer(event) || !event.target.closest) return;
    var nav = event.target.closest('[data-ds-header-nav]');
    if (!nav) return;
    var state = stateFor(nav);
    if (!state.pending) {
      var activeItem = event.target.closest('[data-ds-header-nav-item]');
      if (activeItem && activeItem === state.active) {
        state.lastPoint = { x: event.clientX, y: event.clientY };
      }
      return;
    }
    if (insideSafeTriangle(state, event)) return;

    var hoveredItem = event.target.closest('[data-ds-header-nav-item]');
    if (hoveredItem && hoveredItem.closest('[data-ds-header-nav]') === nav) {
      activateDesktopItem(nav, hoveredItem);
    } else {
      closeDesktopNav(nav);
    }
  });

  /* Touch path for the desktop bar (a landscape tablet, 1024+): a trigger is a
     real link, so a tap would leave before its panel is ever seen. The first
     tap opens the panel, a second tap on the same trigger follows the link, a
     tap anywhere else closes it. Keyed on the pointer that tapped, not on a
     media query, so a touch laptop with a mouse gets both paths.
     Whether the panel was open is read on pointerdown: the tap focuses the
     link before click fires, and the focusin handler below opens it. */
  document.addEventListener('pointerdown', function (event) {
    if (event.pointerType === 'mouse' || !event.target.closest) return;
    var trigger = event.target.closest('[data-ds-header-nav-trigger]');
    var item = trigger && trigger.closest('[data-ds-header-nav-item]');
    if (item) item.__dsTapWasOpen = item.hasAttribute('data-ds-menu-open');
  });

  document.addEventListener('click', function (event) {
    if (!event.target.closest) return;
    var trigger = event.target.closest('[data-ds-header-nav-trigger]');
    var item = trigger && trigger.closest('[data-ds-header-nav-item]');
    var nav = item && item.closest('[data-ds-header-nav]');
    if (nav && menuFor(item) && typeof item.__dsTapWasOpen === 'boolean') {
      var wasOpen = item.__dsTapWasOpen;
      item.__dsTapWasOpen = undefined;
      if (!wasOpen) {
        event.preventDefault();
        activateDesktopItem(nav, item);
      }
      return;
    }
    document.querySelectorAll('[data-ds-header-nav]').forEach(function (openNav) {
      if (stateFor(openNav).active && !openNav.contains(event.target)) closeDesktopNav(openNav);
    });
  });

  // Keep aria-expanded aligned with the keyboard path.
  document.addEventListener('focusin', function (event) {
    if (!event.target.closest || !window.matchMedia('(min-width: 1024px)').matches) return;
    var item = event.target.closest('[data-ds-header-nav-item]');
    var nav = item && item.closest('[data-ds-header-nav]');
    if (nav && menuFor(item)) activateDesktopItem(nav, item);
  });

  document.addEventListener('focusout', function (event) {
    if (!event.target.closest) return;
    var nav = event.target.closest('[data-ds-header-nav]');
    if (!nav || (event.relatedTarget && nav.contains(event.relatedTarget))) return;
    window.setTimeout(function () {
      if (!nav.contains(document.activeElement) && !nav.matches(':hover')) closeDesktopNav(nav);
    }, 0);
  });

  function parts(trigger) {
    var header = trigger && trigger.closest('[data-ds-header]');
    var menu = header && header.querySelector('[data-ds-header-mobile-menu]');
    return { header: header, menu: menu };
  }

  function sizeDrawer(menu) {
    if (!menu) return;
    var header = menu.closest('[data-ds-header]');
    var bar = header && header.querySelector('[data-ds-header-main-row]');
    var edge = bar || header;
    var top = edge ? edge.getBoundingClientRect().bottom : menu.getBoundingClientRect().top;
    /* Floor so a fractional edge never leaves a hairline of the page between
       the search row and the sheet. */
    top = Math.max(0, Math.min(window.innerHeight, Math.floor(top)));
    menu.style.setProperty('--ds-header-mobile-menu-top', top + 'px');
    menu.style.setProperty('--ds-header-mobile-menu-max-height', Math.max(0, window.innerHeight - top) + 'px');
    // The backdrop starts where the drawer does, under the header row.
    var scrim = header && header.querySelector('[data-ds-header-mobile-scrim]');
    if (scrim) scrim.style.setProperty('--ds-header-mobile-menu-top', top + 'px');
  }

  function syncPageScrollLock() {
    var hasOpenDrawer = document.querySelector(
      '[data-ds-header-mobile-menu][aria-hidden="false"]',
    );
    document.documentElement.toggleAttribute('data-ds-header-nav-scroll-lock', Boolean(hasOpenDrawer));
  }

  function setDrawer(trigger, open) {
    var found = parts(trigger);
    if (!found.menu) return;
    trigger.setAttribute('aria-controls', found.menu.id);
    if (open) sizeDrawer(found.menu);
    found.menu.setAttribute('aria-hidden', open ? 'false' : 'true');
    trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    trigger.setAttribute(
      'aria-label',
      open ? trigger.getAttribute('data-label-close') : trigger.getAttribute('data-label-open'),
    );
    var iconOpen = trigger.querySelector('[data-ds-header-menu-icon-open]');
    var iconClose = trigger.querySelector('[data-ds-header-menu-icon-close]');
    if (iconOpen) iconOpen.classList.toggle('sf-hidden', open);
    if (iconClose) iconClose.classList.toggle('sf-hidden', !open);
    syncPageScrollLock();
  }

  function setBranch(item, open) {
    var toggle = item.querySelector('[data-ds-mobile-menu-toggle]');
    var panel = item.querySelector('[data-ds-mobile-menu-panel]');
    var label = item.querySelector('[data-ds-mobile-menu-label]');
    var icon = item.querySelector('[data-ds-mobile-menu-icon]');
    var plus = item.querySelector('[data-ds-mobile-menu-plus]');
    var minus = item.querySelector('[data-ds-mobile-menu-minus]');
    if (!toggle || !panel) return;

    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    toggle.classList.toggle('sf-bg-badge-brand', open);
    toggle.classList.toggle('hover:sf-bg-surface-hover', !open);
    if (label) {
      label.classList.toggle('sf-text-action-primary-strong', open);
      label.classList.toggle('sf-text-primary', !open);
    }
    if (icon) {
      icon.classList.toggle('sf-text-action-primary-strong', open);
      icon.classList.toggle('sf-text-primary', !open);
    }
    if (plus) plus.classList.toggle('sf-hidden', open);
    if (minus) minus.classList.toggle('sf-hidden', !open);

    // Animate height instead of snapping display, so opening one branch and
    // closing another (single-open accordion) doesn't jump the layout.
    if (open) {
      panel.style.maxHeight = 'none';
      var h = panel.scrollHeight;
      panel.style.maxHeight = '0px';
      requestAnimationFrame(function () { panel.style.maxHeight = h + 'px'; });
      panel.addEventListener('transitionend', function onEnd() {
        panel.style.maxHeight = 'none';
        panel.removeEventListener('transitionend', onEnd);
      });
    } else {
      panel.style.maxHeight = panel.scrollHeight + 'px';
      requestAnimationFrame(function () { panel.style.maxHeight = '0px'; });
    }
  }

  document.addEventListener('click', function (event) {
    if (!event.target.closest) return;

    // A tap on the backdrop closes the drawer it sits under.
    var scrim = event.target.closest('[data-ds-header-mobile-scrim]');
    if (scrim) {
      var scrimHeader = scrim.closest('[data-ds-header]');
      (scrimHeader || document).querySelectorAll('[data-ds-header-menu-button][aria-expanded="true"]').forEach(function (trigger) {
        setDrawer(trigger, false);
      });
      return;
    }

    var menuTrigger = event.target.closest('[data-ds-header-menu-button]');
    if (menuTrigger) {
      event.preventDefault();
      setDrawer(menuTrigger, menuTrigger.getAttribute('aria-expanded') !== 'true');
      return;
    }

    var branchToggle = event.target.closest('[data-ds-mobile-menu-toggle]');
    if (!branchToggle) return;
    event.preventDefault();
    var item = branchToggle.closest('[data-ds-mobile-menu-item]');
    var drawer = branchToggle.closest('[data-ds-header-mobile-menu]');
    if (!item || !drawer) return;
    var willOpen = branchToggle.getAttribute('aria-expanded') !== 'true';
    // The single-open accordion collapses whichever sibling is open. Capture it
    // before closing so we can predict how far this heading will shift.
    var closingPanel = null;
    if (willOpen) {
      var openSibling = drawer.querySelector('[data-ds-mobile-menu-toggle][aria-expanded="true"]');
      openSibling = openSibling && openSibling.closest('[data-ds-mobile-menu-item]');
      if (openSibling && openSibling !== item) closingPanel = openSibling.querySelector('[data-ds-mobile-menu-panel]');
    }
    drawer.querySelectorAll('[data-ds-mobile-menu-item]').forEach(function (candidate) {
      if (candidate !== item) setBranch(candidate, false);
    });
    setBranch(item, willOpen);
    // Long panels can push the just-opened heading off-screen; pin it to the top
    // of the drawer's own scroll area (not scrollIntoView — the drawer is
    // overflow:hidden, and browsers scroll that ancestor too, corrupting layout).
    var scroller = drawer.querySelector('[data-ds-header-mobile-menu-scroll]');
    if (willOpen && scroller) {
      var openPanel = item.querySelector('[data-ds-mobile-menu-panel]');
      // Predict the settled scroll target and reposition there immediately.
      // The panels already animate max-height; smooth-scrolling at the same
      // time creates a competing animation against a layout that is moving.
      // The heading only shifts by the height of a sibling collapsing ABOVE it;
      // its own panel opens below the heading and never moves it. max-height:0
      // does not hide a panel from scrollHeight, so the open/close heights are
      // readable up front, before any transition runs.
      var toggleTop = branchToggle.getBoundingClientRect().top
        - scroller.getBoundingClientRect().top + scroller.scrollTop;
      var closingH = closingPanel ? closingPanel.scrollHeight : 0;
      var above = closingPanel
        && !(branchToggle.compareDocumentPosition(closingPanel) & Node.DOCUMENT_POSITION_FOLLOWING);
      var finalTop = toggleTop - (above ? closingH : 0);
      var finalContent = scroller.scrollHeight - closingH + (openPanel ? openPanel.scrollHeight : 0);
      var finalMax = finalContent - scroller.clientHeight;
      scroller.style.paddingBottom = '';
      if (finalMax > 0) {
        // Reserve just enough trailing space that even the last, short branch
        // can bring its heading all the way to the top.
        var pad = Math.ceil(finalTop - finalMax);
        if (pad > 0) scroller.style.paddingBottom = pad + 'px';
        scroller.scrollTo({ top: Math.max(0, finalTop), behavior: 'auto' });
      }
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-ds-header-menu-button][aria-expanded="true"]').forEach(function (trigger) {
      setDrawer(trigger, false);
      trigger.focus();
    });
  });

  document.addEventListener(
    'touchmove',
    function (event) {
      if (!document.documentElement.hasAttribute('data-ds-header-nav-scroll-lock')) return;
      if (event.target.closest && event.target.closest('[data-ds-header-mobile-menu]')) return;
      if (event.target.closest && event.target.closest('[data-ds-region-modal][aria-hidden="false"]')) return;
      event.preventDefault();
    },
    { passive: false },
  );

  function sizeOpenDrawers() {
    document.querySelectorAll('[data-ds-header-mobile-menu][aria-hidden="false"]').forEach(sizeDrawer);
  }

  /* The drawer top is the search row's bottom edge. Dismissing the
     announcement bar shortens the header while the drawer stays open; a size
     observer misses that when the bar's wrapper collapses without resizing
     the header box, so also remeasure when header children change. */
  if (typeof ResizeObserver === 'function') {
    var headerBox = new ResizeObserver(sizeOpenDrawers);
    function watchHeaders(root) {
      (root || document).querySelectorAll('[data-ds-header]').forEach(function (header) {
        headerBox.observe(header);
        if (header.__dsDrawerWatch || typeof MutationObserver !== 'function') return;
        header.__dsDrawerWatch = true;
        new MutationObserver(sizeOpenDrawers).observe(header, { childList: true, subtree: true });
      });
    }
    watchHeaders();
    document.addEventListener('shopify:section:load', function (event) {
      watchHeaders(event.target);
    });
  }

  document.addEventListener('ds:header-announcement-dismiss', function () {
    sizeOpenDrawers();
    requestAnimationFrame(sizeOpenDrawers);
  });

  window.addEventListener('resize', function () {
    if (window.innerWidth >= 1024) {
      document.querySelectorAll('[data-ds-header-menu-button][aria-expanded="true"]').forEach(function (trigger) {
        setDrawer(trigger, false);
      });
      return;
    }
    document.querySelectorAll('[data-ds-header-nav]').forEach(closeDesktopNav);
    sizeOpenDrawers();
  });
})();

} catch (sfError) {
if (typeof console !== 'undefined') console.error('[sf-core] behavior "header-nav" failed to initialise:', sfError);
}
})();

/* header-search.js */
(function () {
try {
/* header-search — below lg, focusing the header search pill expands it to the
 * full row: the brand cluster and the utility actions give way and a Cancel
 * control appears (Figma 2477:10415 / 7209:5419). One attribute on the row
 * carries the state; the CSS in the markup does the rest, so with no JS the
 * field is simply an inline search box that still submits.
 * Delegated listeners keep it Theme-Editor-safe. No import/export.
 */

(function () {
  if (document.__dsHeaderSearchBound) return;
  document.__dsHeaderSearchBound = true;

  var MOBILE = '(max-width: 1023px)';

  function rowFor(el) {
    return el && el.closest ? el.closest('[data-ds-header-main-row] > div') : null;
  }

  function setOpen(row, open) {
    if (!row) return;
    row.toggleAttribute('data-ds-search-open', open);
  }

  function syncPlaceholder(form) {
    var field = form && form.querySelector ? form.querySelector('input') : null;
    if (!field) return;
    var next = window.matchMedia(MOBILE).matches
      ? form.getAttribute('data-placeholder-mobile')
      : form.getAttribute('data-placeholder-desktop');
    if (next) field.setAttribute('placeholder', next);
  }

  function syncPlaceholders() {
    document.querySelectorAll('[data-ds-header-search]').forEach(syncPlaceholder);
  }

  syncPlaceholders();
  document.addEventListener('shopify:section:load', syncPlaceholders);

  document.addEventListener('focusin', function (event) {
    if (!event.target.closest || !window.matchMedia(MOBILE).matches) return;
    if (!event.target.closest('[data-ds-header-search]')) return;
    // The expanded row hides the hamburger, and the drawer has no other close
    // control — leaving both open would trap a touch user behind a scroll lock.
    document.querySelectorAll('[data-ds-header-menu-button][aria-expanded="true"]').forEach(function (trigger) {
      trigger.click();
    });
    setOpen(rowFor(event.target), true);
  });

  // Dismissing the keyboard by tapping the page blurs the field without a
  // Cancel click; without this the row stays expanded and the utility actions
  // (account, cart) remain hidden with no way back. Deferred by a task so a
  // Cancel click, which blurs the field first, still lands on its own handler.
  document.addEventListener('focusout', function (event) {
    if (!event.target.closest || !event.target.closest('[data-ds-header-search]')) return;
    var row = rowFor(event.target);
    window.setTimeout(function () {
      if (row && !row.contains(document.activeElement)) setOpen(row, false);
    }, 0);
  });

  document.addEventListener('click', function (event) {
    if (!event.target.closest) return;
    var cancel = event.target.closest('[data-ds-header-search-cancel]');
    if (!cancel) return;
    event.preventDefault();
    var row = rowFor(cancel);
    var field = row && row.querySelector('[data-ds-header-search] input');
    if (field) {
      field.value = '';
      field.blur();
    }
    setOpen(row, false);
  });

  // The field's own clear X (shown by CSS only while there is text): empty it,
  // tell anything listening on `input` (a predictive-search app) that it
  // changed, and keep the caret in the field for the next query.
  document.addEventListener('click', function (event) {
    if (!event.target.closest) return;
    var clear = event.target.closest('[data-ds-header-search-clear]');
    if (!clear) return;
    event.preventDefault();
    var field = clear.closest('[data-ds-header-search]').querySelector('input');
    if (!field) return;
    field.value = '';
    field.dispatchEvent(new Event('input', { bubbles: true }));
    field.focus();
  });

  // The pill is 44 tall but the field inside it is only its content box (32 on
  // the desktop bar), so a tap on the pill's own padding would land on nothing.
  // Hand it to the field: the whole pill is the 44 tap target (touch screens
  // from 1024, responsive-breakpoints.md). Only the pill itself — its buttons
  // keep their own clicks.
  document.addEventListener('click', function (event) {
    var pill = event.target;
    if (!pill.matches || !pill.matches('[data-ds-header-search]')) return;
    var field = pill.querySelector('input');
    if (!field) return;
    field.focus();
    field.click();
  });

  // The search button must never run an empty query: tapping it with a blank
  // field focuses the field instead of navigating to a bare /search — and below
  // lg that focus also expands the collapsed pill (via focusin). Universal, so it
  // holds in the collapsed pill, the expanded row, and the desktop bar alike.
  // Handled on the click (not the submit event) because a predictive-search app
  // can swallow the submit in the capture phase; cancelling the button's click
  // stops the form from ever submitting. A real query is left untouched, and
  // with no JS the form still posts normally.
  document.addEventListener('click', function (event) {
    if (!event.target.closest) return;
    var submit = event.target.closest('[data-ds-header-search] button[type="submit"]');
    if (!submit) return;
    var field = submit.closest('[data-ds-header-search]').querySelector('input');
    if (field && field.value.trim() !== '') return;
    event.preventDefault();
    if (field) {
      field.focus();
      // Forward the tap to the field itself so a predictive-search app that opens
      // its panel on the input's click (not just focus) still opens — same as
      // tapping the field directly. Safe: clicking an input submits nothing, and
      // this click's target is the input, so the guard above skips it.
      field.click();
    }
  });

  // Enter in an empty field would submit past the click guard above; block it so
  // a blank query never runs from the keyboard either.
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' || !event.target.closest) return;
    if (!event.target.closest('[data-ds-header-search]')) return;
    if (event.target.value != null && event.target.value.trim() === '') {
      event.preventDefault();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape' || !event.target.closest) return;
    if (!event.target.closest('[data-ds-header-search]')) return;
    var row = rowFor(event.target);
    if (event.target.blur) event.target.blur();
    setOpen(row, false);
  });

  // Above lg the row is never in the expanded state — the pill always sits
  // between the brand and the utility actions.
  window.addEventListener('resize', function () {
    syncPlaceholders();
    if (window.matchMedia(MOBILE).matches) return;
    document.querySelectorAll('[data-ds-search-open]').forEach(function (row) {
      setOpen(row, false);
    });
  });
})();

} catch (sfError) {
if (typeof console !== 'undefined') console.error('[sf-core] behavior "header-search" failed to initialise:', sfError);
}
})();

/* hero-slider.js */
(function () {
try {
/* hero-slider — homepage hero carousel: arrows, dots, autoplay.
 *
 * Autoplay does not start with the section: it arms after `load` plus a grace
 * window, or on the shopper's first touch, whichever comes first — advancing
 * while the page still loads competes with it and moves the banner out from
 * under someone who has not read it yet. See arm() for the reasoning, and for
 * the LCP claim this is NOT.
 *
 * The track is a scroll-snap container (snippets/ds-hero-slider.liquid), so
 * swipe already works with no JS and the first slide is always visible. This
 * only adds the controls: scrollTo the neighbouring slide, restage the dots
 * from the observed scroll position, advance on a timer when the section asks
 * for autoplay, and loop in both directions through a clone at each end (see
 * the clone block in bindHero).
 *
 * Driving the native scroll position (rather than a transform) means the
 * enhanced and baseline states never disagree — a swipe and an arrow click end
 * up in the same place, and the dots follow either one.
 *
 * Authoring rules: src/behaviors/README.md. No import/export.
 */

var HERO = '[data-ds-hero-slider]';

function bindHero(root) {
  if (root.dataset.dsHeroBound) return;
  root.dataset.dsHeroBound = '1';

  var track = root.querySelector('[data-ds-hero-track]');
  var slides = track ? Array.prototype.slice.call(track.children) : [];
  if (!track || slides.length < 2) {
    // One slide: the arrows would be dead controls, so remove the whole row.
    var controls = root.querySelector('[data-ds-hero-controls]');
    if (controls) controls.remove();
    return;
  }

  var dots = Array.prototype.slice.call(root.querySelectorAll('[data-ds-hero-dot]'));
  var interval = Number(root.dataset.dsHeroInterval || 0);
  var timer = null;
  var staged = -1;
  var armed = false;

  // Seamless loop in BOTH directions, the same construction product-rail uses:
  // the track reads [clone of last][reals][clone of first] and rests one slide
  // in. Leaving either end lands on a slide that is pixel-identical to the one
  // the shopper expects, and once that scroll has come to rest the offset is
  // teleported to the real twin — so a wrap never sweeps the whole run, which
  // reads as a reset rather than a loop.
  //
  // Both clones are made by JS and never by Liquid: the no-JS baseline must
  // paint the real first slide at offset 0, and it is the page's LCP element.
  var count = slides.length;
  var lastReal = count; // offset index of the last real slide
  var firstReal = 1; // offset index of the first real slide

  function makeClone(slide) {
    var clone = slide.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    clone.setAttribute('data-ds-hero-clone', '');
    clone.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach(function (el) {
      el.setAttribute('tabindex', '-1');
    });
    clone.querySelectorAll('img').forEach(function (img) {
      // A clone rests off-screen; inheriting the first slide's eager/high
      // priority would make it compete with the real LCP image.
      img.setAttribute('loading', 'lazy');
      img.removeAttribute('fetchpriority');
    });
    return clone;
  }

  // Where offset slide i starts, in the track's own scroll coordinates: read
  // off the slide itself, not computed as i × a width. Under a real browser
  // zoom the band's width is fractional, and i × any width the DOM reports
  // (clientWidth, the computed width) drifted further from slide i with every
  // step — a growing sliver of the neighbouring image, by the last slide wider
  // than the pixels src/hero.css clips. offsetLeft is in the same unzoomed CSS
  // px as scrollLeft (a rect is not, under CSS zoom) and is rounded per slide,
  // so its error stays under half a pixel instead of adding up.
  function slideStart(i) {
    var slide = track.children[i];
    if (!slide) return track.scrollLeft;
    return slide.offsetLeft - track.firstElementChild.offsetLeft;
  }

  track.appendChild(makeClone(slides[0]));
  track.insertBefore(makeClone(slides[count - 1]), slides[0]);
  // Prepending shifts the reals one slide right while the browser keeps
  // scrollLeft at 0 — which is now the leading clone. Correct it in the SAME
  // task, before a paint can show the last slide as the hero.
  track.scrollTo({ left: slideStart(firstReal), behavior: 'instant' });

  function offsetIndex() {
    // The slide whose start is nearest the scroll offset.
    var at = track.scrollLeft;
    var best = firstReal;
    var bestGap = Infinity;
    for (var i = 0; i < track.children.length; i += 1) {
      var gap = Math.abs(slideStart(i) - at);
      if (gap < bestGap) { bestGap = gap; best = i; }
    }
    return best;
  }

  function activeIndex() {
    // Nearest slide to the current scroll offset — correct after a swipe that
    // stopped between two snap points as well as after our own scrollTo. The
    // modulo folds each clone onto its real twin, so the dots read the slide
    // the shopper is actually looking at.
    return ((offsetIndex() - firstReal) % count + count) % count;
  }

  function goTo(offset) {
    // Takes an OFFSET index, so a caller can aim at a clone (0 or count + 1)
    // deliberately; anything else is clamped into the real run.
    var target = offset < 0 || offset > count + 1
      ? ((offset % count) + count) % count + firstReal
      : offset;
    track.scrollTo({
      left: slideStart(target),
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
    });
  }

  // Swap a clone for its real twin once the track has come to REST on it.
  // Never on a scroll frame: a smooth scroll still in flight RESUMES towards
  // its old target after the offset is rewritten (measured — the track parked
  // itself between two slides), so this only runs on `scrollend`, or on a short
  // idle debounce where that event does not exist.
  //
  // `behavior: 'instant'`, not 'auto' and not a scrollLeft write: the track
  // carries CSS scroll-behavior: smooth (sf-scroll-smooth), which BOTH of those
  // honour — the jump animated the whole run, i.e. exactly the sweep the clones
  // exist to avoid. 'instant' is the only value that overrides it.
  function recycle() {
    var at = offsetIndex();
    var jump = null;
    if (at === 0) jump = lastReal;
    else if (at === count + 1) jump = firstReal;
    if (jump === null) return;
    track.scrollTo({ left: slideStart(jump), behavior: 'instant' });
    restage();
  }

  function restage() {
    var active = activeIndex();
    // A swipe fires scroll every frame while the index changes only at snap
    // points, so without this the whole subtree's attributes were rewritten ~60
    // times a second and each write invalidated the layout the next frame read.
    if (active === staged) return;
    staged = active;
    slides.forEach(function (slide, i) {
      // Off-screen slides stay in the a11y tree only as much as a carousel
      // should: hidden from AT, and their links out of the tab order. Neither
      // clone is in `slides`, so both stay hidden for good.
      slide.setAttribute('aria-hidden', i === active ? 'false' : 'true');
    });
    dots.forEach(function (dot, i) {
      var on = i === active;
      dot.setAttribute('aria-selected', on ? 'true' : 'false');
      var pip = dot.querySelector('[data-ds-hero-dot-pip]');
      // The pip's two sizes live in src/hero.css, selected off this attribute.
      // JS binds data-ds-* only: duplicating the class lists here meant a token
      // change in the snippet left the JS toggling dead classes.
      if (pip) pip.setAttribute('data-ds-hero-dot-pip', on ? 'on' : 'off');
    });
  }

  function schedule() {
    window.clearInterval(timer);
    if (!armed || !interval) return;
    timer = window.setInterval(function () {
      if (!root.isConnected) { window.clearInterval(timer); return; }
      // Straight onto the next OFFSET, clone included: recycle() swaps it for
      // the real twin once the scroll has settled.
      goTo(offsetIndex() + 1);
    }, Math.max(2000, interval));
  }

  // Autoplay does not start with the section, because advancing while the page
  // is still loading costs the shopper twice: the timer competes for the main
  // thread with everything still parsing, it pulls the next slide's lazy
  // picture into a network that is still fetching what is on screen, and it
  // moves the banner out from under someone who has not finished reading the
  // first one.
  //
  // NOT an LCP fix, though it was written believing it was. Measured: a
  // three-slide hero at a 2s interval over 12s reports ONE candidate, at
  // 256ms, and never another — LCP only records a candidate that is LARGER
  // than the standing one, and every slide paints at the same size. See
  // check-hero.mjs, which pins that measurement so the claim cannot come back.
  var AUTOPLAY_GRACE_MS = 4000;

  function arm() {
    if (armed) return;
    armed = true;
    schedule();
  }

  function armAfterLoad() {
    window.setTimeout(arm, AUTOPLAY_GRACE_MS);
  }

  // A shopper who reaches for the carousel has finished waiting for the page,
  // so their first touch arms it too rather than making them sit out the grace.
  ['pointerdown', 'keydown'].forEach(function (name) {
    root.addEventListener(name, arm, { passive: true, once: true });
  });

  if (document.readyState === 'complete') armAfterLoad();
  else window.addEventListener('load', armAfterLoad, { once: true });

  var prev = root.querySelector('[data-ds-hero-prev]');
  var next = root.querySelector('[data-ds-hero-next]');
  if (prev) prev.addEventListener('click', function () { goTo(offsetIndex() - 1); schedule(); });
  if (next) next.addEventListener('click', function () { goTo(offsetIndex() + 1); schedule(); });
  dots.forEach(function (dot, i) {
    dot.addEventListener('click', function () { goTo(i + firstReal); schedule(); });
  });

  // Throttle to one restage per frame: scroll fires far more often than the
  // dots can meaningfully change.
  var queued = false;
  var hasScrollEnd = 'onscrollend' in window;
  var idle = null;
  track.addEventListener('scroll', function () {
    if (!hasScrollEnd) {
      window.clearTimeout(idle);
      idle = window.setTimeout(recycle, 150);
    }
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(function () { queued = false; restage(); });
  }, { passive: true });
  if (hasScrollEnd) track.addEventListener('scrollend', recycle);

  // Autoplay must not run away while the shopper is reading or tabbing through.
  root.addEventListener('mouseenter', function () { window.clearInterval(timer); });
  root.addEventListener('mouseleave', schedule);
  root.addEventListener('focusin', function () { window.clearInterval(timer); });
  root.addEventListener('focusout', function (event) {
    if (!root.contains(event.relatedTarget)) schedule();
  });

  // Neither hover nor focus exists on a touch device, so without the two gates
  // below autoplay kept scrolling the largest element on the page after the
  // shopper had left it behind, and a backgrounded tab woke up mid-burst.
  var onScreen = true;
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) window.clearInterval(timer);
    else if (onScreen) schedule();
  });

  if (typeof IntersectionObserver !== 'undefined') {
    new IntersectionObserver(function (entries) {
      onScreen = entries[entries.length - 1].isIntersecting;
      if (onScreen) schedule();
      else window.clearInterval(timer);
    }).observe(root);
  }

  restage();
  schedule();
}

function initHeroSliders(scope) {
  if (!scope) return;
  if (scope.matches && scope.matches(HERO)) bindHero(scope);
  if (scope.querySelectorAll) scope.querySelectorAll(HERO).forEach(bindHero);
}

if (!document.__dsHeroSliderBound) {
  document.__dsHeroSliderBound = true;
  var startHeroSliders = function () { initHeroSliders(document); };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startHeroSliders, { once: true });
  } else {
    startHeroSliders();
  }
  // Shopify Theme Editor re-renders a section into a fresh DOM subtree.
  document.addEventListener('shopify:section:load', startHeroSliders);

  // Sections injected after load (async section rendering, Storybook mount):
  // re-scan on the next frame, then stop. Watching the whole document forever
  // meant every unrelated mutation on the storefront — cart drawer, apps — woke
  // this up to re-query for a slider count that is fixed once the section is in.
  // The Theme Editor is covered by shopify:section:load above.
  if (typeof MutationObserver !== 'undefined') {
    var rescanQueued = false;
    var observer = new MutationObserver(function () {
      if (rescanQueued) return;
      rescanQueued = true;
      requestAnimationFrame(function () {
        rescanQueued = false;
        startHeroSliders();
        if (document.querySelector(HERO)) observer.disconnect();
      });
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
}

} catch (sfError) {
if (typeof console !== 'undefined') console.error('[sf-core] behavior "hero-slider" failed to initialise:', sfError);
}
})();

/* image-fallback.js */
(function () {
try {
/* image-fallback — a ds-image <img> that fails to load retries twice with
 * backoff (a composited preview can 404 briefly while it finishes generating
 * server-side, e.g. cart "Save as new" — CART-60). Its data-ds-image-loading
 * spinner covers the frame until load succeeds or retries are exhausted, then
 * the <img> hides itself so the tinted frame shows instead of a broken icon.
 *
 * Authoring rules: src/behaviors/README.md. No import/export.
 */

if (!document.__dsImageFallbackBound) {
  document.__dsImageFallbackBound = true;
  var MAX_RETRIES = 2;

  // A blur-up placeholder (data-ds-image-lqip) fades off the photo instead of
  // vanishing; `instant` skips that for an image already there before the page
  // was interactive, and for a failure, where there is no photo to reveal.
  function hideSpinner(img, instant) {
    var wrap = img.closest('[data-ds-image]');
    var spinner = wrap && wrap.querySelector('[data-ds-image-loading]');
    if (!spinner) return;
    if (!instant && spinner.hasAttribute('data-ds-image-lqip')) {
      spinner.setAttribute('data-ds-image-lqip', 'done');
      spinner.removeAttribute('role');
      spinner.setAttribute('aria-hidden', 'true');
      return;
    }
    spinner.hidden = true;
  }

  // This script is deferred, so a cached image can finish loading — firing its
  // one-time 'load' event — before the listener below is even attached, leaving
  // the spinner stuck over a photo that's already there.
  // The blur-up preview is an <img> inside the frame too; its own load or error
  // says nothing about the photo, so every path below skips it.
  function isPreview(img) {
    return img.hasAttribute('data-ds-image-lqip-img');
  }

  document.querySelectorAll('[data-ds-image] img').forEach(function (img) {
    if (isPreview(img)) return;
    if (img.complete && img.naturalWidth > 0) hideSpinner(img, true);
  });

  document.addEventListener(
    'load',
    function (e) {
      if (e.target instanceof HTMLImageElement && !isPreview(e.target)) hideSpinner(e.target);
    },
    true,
  );

  document.addEventListener(
    'error',
    function (e) {
      var img = e.target;
      if (!(img instanceof HTMLImageElement) || !img.src || img.hidden || isPreview(img)) return;
      if (!img.closest('[data-ds-image]')) return;
      var retries = Number(img.dataset.dsImageRetries || 0);
      if (retries >= MAX_RETRIES) {
        img.hidden = true;
        hideSpinner(img, true);
        return;
      }
      img.dataset.dsImageRetries = String(retries + 1);
      var src = img.src;
      var sep = src.indexOf('?') === -1 ? '?' : '&';
      setTimeout(function () {
        img.src = src + sep + '_retry=' + Date.now();
      }, 800 * (retries + 1));
    },
    true,
  );
}

} catch (sfError) {
if (typeof console !== 'undefined') console.error('[sf-core] behavior "image-fallback" failed to initialise:', sfError);
}
})();

/* image-lightbox.js */
(function () {
try {
/* image-lightbox — a shared single-image zoom. Any element with
 * [data-ds-image-zoom] and a data-ds-image-zoom-src opens the ds-image-lightbox
 * dialog showing that one image full size (add-on / cross-sell thumbnails today).
 * One dialog serves the whole page; the clicked element's src/alt are injected on
 * open.
 *
 * It owns only the dialog: open/close, portal to <body> (so a sticky/transformed
 * ancestor never traps its z-index — same reason as media-lightbox.js), scroll
 * lock, focus trap + restore. Progressive enhancement: without this script the
 * thumbnails are plain images, nothing breaks.
 *
 * Authoring rules: src/behaviors/README.md. No import/export.
 */

(function () {
  if (document.__dsImageLightboxBound) return;
  document.__dsImageLightboxBound = true;

  var lastTrigger = null;

  function getModal() {
    // A fixed overlay must live at the root to stack above everything; it is
    // authored inside the add-on block, which can sit in a stacking context.
    var all = document.querySelectorAll('[data-ds-image-lightbox]');
    for (var i = 1; i < all.length; i++) {
      all[i].parentNode && all[i].parentNode.removeChild(all[i]); // drop duplicates
    }
    var modal = all[0] || null;
    if (modal && modal.parentNode !== document.body) document.body.appendChild(modal);
    return modal;
  }

  function isOpen(modal) {
    return !!modal && modal.getAttribute('aria-hidden') === 'false';
  }

  function open(trigger) {
    var modal = getModal();
    if (!modal) return;
    var src = trigger.getAttribute('data-ds-image-zoom-src');
    if (!src) return;

    var alt = trigger.getAttribute('data-ds-image-zoom-alt') || '';
    var img = modal.querySelector('[data-ds-image-lightbox-img]');
    if (img) {
      img.setAttribute('src', src);
      img.setAttribute('alt', alt);
    }

    // A bare trigger (cart uploaded photo) drops the Close / Checkout row and
    // names the dialog itself; the CSS hides the row off this attribute.
    var bare = trigger.hasAttribute('data-ds-image-zoom-bare');
    if (bare) modal.setAttribute('data-ds-image-lightbox-bare', '');
    else modal.removeAttribute('data-ds-image-lightbox-bare');

    // Heading: cart preview keeps "Preview"; else an explicit title, else alt.
    var titleEl = modal.querySelector('[data-ds-image-lightbox-title]');
    if (titleEl && modal.hasAttribute('data-ds-image-lightbox-cart')) {
      if (titleEl.__dsDefaultTitle == null) titleEl.__dsDefaultTitle = titleEl.textContent;
      var cartTitle = bare && trigger.getAttribute('data-ds-image-zoom-title');
      titleEl.textContent = cartTitle || titleEl.__dsDefaultTitle;
    } else if (titleEl) {
      var title = trigger.getAttribute('data-ds-image-zoom-title') || alt;
      if (title) titleEl.textContent = title;
    }

    lastTrigger = trigger;
    modal.setAttribute('aria-hidden', 'false');
    modal.setAttribute('data-ds-page-lock', '');

    var close = modal.querySelector('[data-ds-image-lightbox-close]');
    if (close) window.requestAnimationFrame(function () { close.focus({ focusVisible: false }); });
  }

  function close() {
    var modal = getModal();
    if (!modal) return;
    modal.setAttribute('aria-hidden', 'true');
    modal.removeAttribute('data-ds-page-lock');
    var img = modal.querySelector('[data-ds-image-lightbox-img]');
    if (img) img.removeAttribute('src'); // don't keep the last image decoded/visible
    if (lastTrigger && typeof lastTrigger.focus === 'function') lastTrigger.focus();
    lastTrigger = null;
  }

  function trapTab(e, modal) {
    var dialog = modal.querySelector('[data-ds-image-lightbox-dialog]') || modal;
    var focusable = Array.prototype.filter.call(
      dialog.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])',
      ),
      function (el) {
        return el.offsetParent !== null || el === document.activeElement;
      },
    );
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    } else if (!dialog.contains(document.activeElement)) {
      e.preventDefault();
      first.focus();
    }
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;

    if (e.target.closest('[data-ds-image-lightbox-close]')) {
      e.preventDefault();
      close();
      return;
    }

    var trigger = e.target.closest('[data-ds-image-zoom]');
    if (trigger) {
      e.preventDefault();
      open(trigger);
      return;
    }

    var modal = getModal();
    if (isOpen(modal) && e.target === modal) close();
  });

  // Keyboard-open for the non-button triggers (an <img role="button" tabindex=0>).
  document.addEventListener('keydown', function (e) {
    var modal = getModal();
    if (isOpen(modal)) {
      if (e.key === 'Escape') { close(); return; }
      if (e.key === 'Tab') { trapTab(e, modal); return; }
    }
    if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
      var trigger = e.target.closest && e.target.closest('[data-ds-image-zoom]');
      if (trigger) {
        e.preventDefault();
        open(trigger);
      }
    }
  });

  // Portal up front so the first open never flashes trapped under a sticky column.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', getModal, { once: true });
  } else {
    getModal();
  }
})();

} catch (sfError) {
if (typeof console !== 'undefined') console.error('[sf-core] behavior "image-lightbox" failed to initialise:', sfError);
}
})();

/* input-counter.js */
(function () {
try {
/* input-counter — live "N/max" character count for a maxlength text field.
 * Binds [data-ds-input] with an [data-ds-input-counter] readout and a field
 * carrying maxlength (see snippets/ds-input.liquid). Progressive enhancement:
 * the field enforces maxlength natively; the readout just stays at its initial
 * server-rendered value without JS.
 *
 * Authoring rules: src/behaviors/README.md. No import/export.
 */

function syncInputCounter(input) {
  var wrap = input.closest('[data-ds-input]');
  var counter = wrap && wrap.querySelector('[data-ds-input-counter]');
  var max = input.getAttribute('maxlength');
  if (!counter || !max) return;
  counter.textContent = input.value.length + '/' + max;
}

if (!document.__dsInputCounterBound) {
  document.__dsInputCounterBound = true;
  document.addEventListener('input', function (e) {
    var field = e.target;
    if (field instanceof HTMLInputElement && field.matches('[data-ds-input] input[maxlength]')) {
      syncInputCounter(field);
    }
  });
}

} catch (sfError) {
if (typeof console !== 'undefined') console.error('[sf-core] behavior "input-counter" failed to initialise:', sfError);
}
})();

/* jump.js */
(function () {
try {
/* jump — scroll to the element a control names in [data-ds-jump].
 *
 * The value is a CSS selector, not an id, because the target is usually another
 * section whose id is generated by Shopify (the reviews band is
 * `ds-product-reviews-<section.id>-band`), so the caller can only name its hook.
 * A target inside a closed ds-accordion is opened first — scrolling to content
 * of zero height lands nowhere.
 *
 * Progressive enhancement: without this the control is inert, which is exactly
 * what the row was before it became a control.
 *
 * Authoring rules: src/behaviors/README.md. No import/export.
 */

if (!document.__dsJumpBound) {
  document.__dsJumpBound = true;

  document.addEventListener('click', function (e) {
    var control = e.target.closest && e.target.closest('[data-ds-jump]');
    if (!control) return;
    var target = document.querySelector(control.getAttribute('data-ds-jump') || '');
    if (!target) return;
    e.preventDefault();

    var panel = target.closest('[data-ds-accordion-content]');
    if (panel) {
      var trigger = panel.parentNode.querySelector('[data-ds-accordion-trigger]');
      if (trigger && trigger.getAttribute('aria-expanded') === 'false') trigger.click();
    }

    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
}

} catch (sfError) {
if (typeof console !== 'undefined') console.error('[sf-core] behavior "jump" failed to initialise:', sfError);
}
})();

/* media-lightbox.js */
(function () {
try {
/* media-lightbox — opens the full-screen product image viewer (ds-media-lightbox)
 * from the gallery's main image or its ds-media-zoom trigger, and closes it
 * again. Rebuilds the "click the image → see it big in a modal" UX the PDP was
 * missing (T2147), modelled on the live wanderprints.com behaviour.
 *
 * It owns only the dialog: open/close, body scroll-lock, focus (trap + restore)
 * and keeping the modal on the same image as the inline gallery. The viewer
 * itself — track, chevrons, counter — is a plain ds-gallery in `bare` mode, so
 * behaviors/gallery.js drives it. The two galleries are paired by id: the inline
 * root carries data-ds-gallery-zoom="<id>" and the overlay is #<id>. Index is
 * synced both ways with the `ds:gallery:set` event gallery.js listens for.
 *
 * Open/closed is one attribute, [aria-hidden]; src/media-lightbox.css carries the
 * fade off it so a display utility never cuts the transition. Progressive
 * enhancement: without this script the gallery still swaps images inline, the
 * modal just never opens.
 *
 * Authoring rules: src/behaviors/README.md. No import/export.
 */

(function () {
  if (document.__dsMediaLightboxBound) return;
  document.__dsMediaLightboxBound = true;

  var lastTrigger = null;

  function isOpen(overlay) {
    return !!overlay && overlay.getAttribute('aria-hidden') === 'false';
  }

  // Portal the overlay to <body>. It is authored inside ds-gallery, which on the
  // PDP sits in a `position: sticky` column — and sticky creates its own stacking
  // context, trapping the overlay's z-index below the buy-box column that paints
  // after it (the variant pills would show over the modal). A fixed overlay must
  // live at the root to stack above everything. Also drops any stale twin a
  // section re-render (Theme Editor) may have left with the same id.
  function hoist(overlay) {
    if (!overlay) return overlay;
    if (overlay.id) {
      document.querySelectorAll('[data-ds-media-lightbox]').forEach(function (el) {
        if (el !== overlay && el.id === overlay.id && el.parentNode) {
          el.parentNode.removeChild(el);
        }
      });
    }
    if (overlay.parentNode !== document.body) document.body.appendChild(overlay);
    return overlay;
  }

  function hoistAll() {
    document.querySelectorAll('[data-ds-media-lightbox]').forEach(hoist);
  }

  function openOverlayEl() {
    var list = document.querySelectorAll('[data-ds-media-lightbox]');
    for (var i = 0; i < list.length; i++) {
      if (isOpen(list[i])) return list[i];
    }
    return null;
  }

  // The active-slide <video> of a gallery root — the inline preview or the
  // modal's own copy. null when the active slide is an image or an iframe embed.
  function activeVideo(galleryRoot) {
    if (!galleryRoot) return null;
    var idx = Number(galleryRoot.dataset.dsGalleryActive || 0);
    return galleryRoot.querySelector(
      'video[data-ds-gallery-video][data-ds-gallery-index="' + idx + '"]',
    );
  }

  // Continue a clip on the OTHER element at the position it was left. The inline
  // preview and the modal are two <video>s pointing at the same media, so this is
  // what "don't reload, keep playing" means across the boundary: seek to `time`
  // and, if it was rolling, resume. `preload="none"` leaves readyState 0 with no
  // seekable range yet — setting currentTime then is stored as the default start
  // position, and the loadedmetadata re-seek covers browsers that drop it, so the
  // element opens at `time` instead of flashing frame 0. Range requests + the
  // HTTP cache mean the bytes come back without a fresh full download.
  function resumeVideoAt(video, time, play) {
    if (!video) return;
    var seek = function () {
      try {
        if (Math.abs((video.currentTime || 0) - time) > 0.25) video.currentTime = time;
      } catch (e) {}
    };
    seek();
    if (video.readyState < 1) video.addEventListener('loadedmetadata', seek, { once: true });
    if (play) {
      var played = video.play();
      if (played && typeof played.catch === 'function') played.catch(function () {});
    }
  }

  function openFor(root, opener) {
    if (!root) return;
    var id = root.getAttribute('data-ds-gallery-zoom');
    var overlay = id ? hoist(document.getElementById(id)) : null;
    if (!overlay) return;

    lastTrigger = opener || root.querySelector('[data-ds-media-zoom-trigger]') || null;

    // Snapshot the inline preview BEFORE stopping it, so the modal picks the clip
    // up where the shopper left it instead of restarting at 0.
    var fromVideo = activeVideo(root);
    var snapshot = fromVideo
      ? { time: fromVideo.currentTime || 0, playing: !fromVideo.paused }
      : null;

    // Whatever the inline gallery was playing must not keep playing under the
    // modal — the shopper has moved to the big viewer.
    root.dispatchEvent(new CustomEvent('ds:gallery:stop', { bubbles: true }));
    overlay.setAttribute('aria-hidden', 'false');
    overlay.setAttribute('data-ds-page-lock', '');

    // Start the modal on whatever image the inline gallery is showing.
    var inner = overlay.querySelector('[data-ds-gallery]');
    if (inner) {
      inner.dispatchEvent(
        new CustomEvent('ds:gallery:set', {
          bubbles: true,
          // instant: the modal must open already ON this slide, never slide to it.
          detail: { index: Number(root.dataset.dsGalleryActive || 0), instant: true },
        }),
      );
      // Hand the position to the modal's own player. A preview that was rolling
      // continues MUTED (the modal's controls are where the shopper unmutes), so
      // there is neither a jump back to frame 0 nor surprise audio. The click is
      // a user gesture, so even the play() call is allowed.
      var toVideo = activeVideo(inner);
      if (toVideo && snapshot) {
        if (snapshot.playing) toVideo.muted = true;
        resumeVideoAt(toVideo, snapshot.time, snapshot.playing);
      }
    }

    // The image opens at fit; wire the slide-change reset and clear any zoom the
    // last open left on this overlay's images.
    ensureZoomObserver(overlay);
    resetZoom(overlay);

    var closeBtn = overlay.querySelector('[data-ds-media-zoom-close]');
    if (closeBtn) window.requestAnimationFrame(function () { closeBtn.focus({ focusVisible: false }); });
  }

  function closeOverlay(overlay) {
    if (!overlay) return;

    // Leave the inline gallery on the image the shopper stepped to in the modal.
    var inner = overlay.querySelector('[data-ds-gallery]');
    var outer = overlay.id
      ? document.querySelector('[data-ds-gallery-zoom="' + overlay.id + '"]')
      : null;

    // Snapshot the modal player before it is stopped, to carry the position back
    // to the inline preview — closing must continue the clip, not rewind it to
    // where it stood when the modal opened.
    var fromVideo = inner ? activeVideo(inner) : null;
    var snapshot = fromVideo
      ? { time: fromVideo.currentTime || 0, playing: !fromVideo.paused }
      : null;

    if (inner && outer) {
      outer.dispatchEvent(
        new CustomEvent('ds:gallery:set', {
          bubbles: true,
          // instant: the inline gallery behind the modal jumps to match, so it is
          // not caught mid-slide when the overlay fades away.
          detail: { index: Number(inner.dataset.dsGalleryActive || 0), instant: true },
        }),
      );
      // ds:gallery:set already had gallery.js play or pause the inline preview by
      // whether the gallery is on screen; only correct its position and let that
      // visibility decision stand (never unmute — the inline stays a muted
      // preview, so `!toVideo.paused` here is that decision, not the modal's).
      var toVideo = activeVideo(outer);
      if (toVideo && snapshot) resumeVideoAt(toVideo, snapshot.time, !toVideo.paused);
    }
    // The overlay is only [aria-hidden] — still in the DOM and still painted —
    // so a video left playing keeps its audio going over the page. gallery.js
    // owns the media, so ask it to stop rather than reaching into the slides.
    if (inner) inner.dispatchEvent(new CustomEvent('ds:gallery:stop', { bubbles: true }));

    // Drop any zoom so the next open starts at fit, and abandon a gesture that was
    // still mid-flight when the modal was dismissed.
    resetZoom(overlay);
    clearZoomGesture();

    overlay.setAttribute('aria-hidden', 'true');
    overlay.removeAttribute('data-ds-page-lock');
    if (lastTrigger && typeof lastTrigger.focus === 'function') lastTrigger.focus();
    lastTrigger = null;
  }

  // Tab must cycle inside the dialog while open; the page behind is still painted
  // ([aria-hidden] only), so focus would otherwise walk out of the viewer.
  function trapTab(e, overlay) {
    var dialog = overlay.querySelector('[data-ds-media-lightbox-dialog]') || overlay;
    var focusable = Array.prototype.filter.call(
      dialog.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])',
      ),
      function (el) {
        return el.offsetParent !== null || el === document.activeElement;
      },
    );
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    } else if (!dialog.contains(document.activeElement)) {
      e.preventDefault();
      first.focus();
    }
  }

  // ─── Zoom (pinch / drag on mobile, wheel + double-click + drag on desktop) ───
  // The modal is where a shopper inspects the mockup up close, so its active image
  // gets a hand-driven zoom. The zoom lives entirely on the active
  // <img data-ds-gallery-main> as a `translate3d(...) scale(...)` transform — it is
  // layered ON TOP of the track's own translateX (which owns slide position), so
  // the two never fight: the track slides, the image zooms within its frame (the
  // viewer's overflow-hidden clips the magnified image).
  //
  // gallery.js already binds a one-finger swipe on the same viewer to change
  // slides. So zoom must defer to swipe at scale 1 (a plain drag still flips the
  // image) and TAKE OVER once zoomed or on a two-finger pinch. It does that from
  // the capture phase on `document`: a capture listener runs before gallery's
  // bubble listener on the viewer, so calling stopPropagation there keeps the
  // swipe from ever seeing the gesture — but only when the gesture is ours.
  var ZOOM_MAX = 3;
  var zPointers = {}; // pointerId -> {x,y}  (live touches over the viewer)
  var zImg = null; // image the current gesture drives
  var zMode = null; // 'pan' | 'pinch' | null
  var zLast = { x: 0, y: 0 }; // last single-pointer position (pan)
  var zLastDist = 0; // last two-finger distance (pinch)
  var zLastMid = { x: 0, y: 0 }; // last two-finger midpoint (pinch)

  function zState(img) {
    return img.__dsZoom || (img.__dsZoom = { scale: 1, tx: 0, ty: 0 });
  }

  // The active image of the bare gallery inside an overlay (null when the active
  // slide is a video — zoom is images only, so gallery.js keeps the swipe there).
  function activeZoomImg(viewer) {
    var root = viewer && viewer.closest('[data-ds-gallery]');
    if (!root) return null;
    var idx = Number(root.dataset.dsGalleryActive || 0);
    var img = root.querySelector(
      'img[data-ds-gallery-main][data-ds-gallery-index="' + idx + '"]',
    );
    if (img) return img;
    // Storybook / placeholder path: a single main image carries no index.
    var mains = root.querySelectorAll('img[data-ds-gallery-main]');
    return mains.length === 1 ? mains[0] : null;
  }

  // Keep the magnified image from panning past its own edges: at scale s the image
  // box is s× the viewer, so it may travel at most (s-1)·half in each axis before a
  // gutter would show. Snaps back to centred at scale 1.
  function clampZoom(img) {
    var z = zState(img);
    if (z.scale <= 1) {
      z.scale = 1;
      z.tx = 0;
      z.ty = 0;
      return;
    }
    var v = img.closest('[data-ds-gallery-viewer]');
    var w = (v ? v.clientWidth : img.clientWidth) || 1;
    var h = (v ? v.clientHeight : img.clientHeight) || 1;
    var maxX = ((z.scale - 1) * w) / 2;
    var maxY = ((z.scale - 1) * h) / 2;
    z.tx = Math.max(-maxX, Math.min(maxX, z.tx));
    z.ty = Math.max(-maxY, Math.min(maxY, z.ty));
  }

  function applyZoom(img, animate) {
    var z = zState(img);
    var viewer = img.closest('[data-ds-gallery-viewer]');
    img.style.transition = animate
      ? 'transform var(--duration-base) var(--ease-standard)'
      : 'none';
    img.style.transformOrigin = 'center center';
    img.style.transform =
      'translate3d(' + z.tx + 'px,' + z.ty + 'px,0) scale(' + z.scale + ')';
    img.style.cursor = z.scale > 1 ? 'grab' : 'zoom-in';
    img.style.willChange = z.scale > 1 ? 'transform' : 'auto';
    if (z.scale > 1) img.setAttribute('data-ds-zoomed', 'true');
    else img.removeAttribute('data-ds-zoomed');
    // Own the touches only while zoomed; at scale 1 hand pan-y back so gallery.js
    // keeps its one-finger swipe (and vertical page gestures) working.
    if (viewer) viewer.style.touchAction = z.scale > 1 ? 'none' : 'pan-y';
  }

  // Focal point of a client coord expressed as an offset from the viewer centre —
  // the space the transform's translate lives in.
  function focal(img, clientX, clientY) {
    var v = img.closest('[data-ds-gallery-viewer]') || img;
    var r = v.getBoundingClientRect();
    return { x: clientX - (r.left + r.width / 2), y: clientY - (r.top + r.height / 2) };
  }

  // Scale toward a fixed focal point: solve t1 so the screen point under the
  // cursor/pinch-centre stays put across the scale change (t1 = F − (s1/s0)(F − t0)).
  function zoomToward(img, newScale, fx, fy) {
    var z = zState(img);
    newScale = Math.max(1, Math.min(ZOOM_MAX, newScale));
    var s0 = z.scale || 1;
    z.tx = fx - (newScale / s0) * (fx - z.tx);
    z.ty = fy - (newScale / s0) * (fy - z.ty);
    z.scale = newScale;
    clampZoom(img);
  }

  // Return every zoomed image in scope to its resting (unzoomed, centred) state.
  // Called on open, close, and any slide change so a fresh slide never inherits
  // the previous one's zoom.
  function resetZoom(scope) {
    (scope || document)
      .querySelectorAll('img[data-ds-gallery-main]')
      .forEach(function (img) {
        if (!img.__dsZoom) return;
        img.__dsZoom = { scale: 1, tx: 0, ty: 0 };
        applyZoom(img, false);
      });
  }

  function clearZoomGesture() {
    zMode = null;
    zImg = null;
    zPointers = {};
  }

  // Settle the end of a gesture: snap a barely-zoomed image back to 1 (so a tiny
  // pinch does not leave it stuck at 1.01) and animate the last frame.
  function finishZoomGesture() {
    if (zImg) {
      var z = zState(zImg);
      if (z.scale <= 1.02) {
        z.scale = 1;
        z.tx = 0;
        z.ty = 0;
      }
      clampZoom(zImg);
      applyZoom(zImg, true);
    }
    clearZoomGesture();
  }

  function twoPoints() {
    var ks = Object.keys(zPointers);
    return [zPointers[ks[0]], zPointers[ks[1]]];
  }
  function ptDist(a, b) {
    return Math.hypot(a.x - b.x, a.y - b.y);
  }
  function ptMid(a, b) {
    return { x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 };
  }

  // Reset the active image whenever the modal slides to a different one — covers
  // chevrons, the open-time index sync, and any programmatic ds:gallery:set.
  function ensureZoomObserver(overlay) {
    var root = overlay.querySelector('[data-ds-gallery]');
    if (!root || root.__dsZoomObserved || typeof MutationObserver === 'undefined') return;
    root.__dsZoomObserved = true;
    // Only a REAL index change resets — the pinch-start snap rewrites the
    // attribute to its current value, and that must not clear a zoom in flight.
    var last = root.dataset.dsGalleryActive;
    new MutationObserver(function () {
      var now = root.dataset.dsGalleryActive;
      if (now === last) return;
      last = now;
      resetZoom(overlay);
    }).observe(root, { attributes: true, attributeFilter: ['data-ds-gallery-active'] });
  }

  // pointerdown — decide who owns the gesture. Two fingers → pinch; one finger on
  // an already-zoomed image → pan; otherwise leave it for gallery.js's swipe.
  document.addEventListener(
    'pointerdown',
    function (e) {
      var overlay = e.target.closest && e.target.closest('[data-ds-media-lightbox]');
      if (!overlay || !isOpen(overlay)) return;
      // Never hijack the chevrons / close / any control.
      if (e.target.closest('button, a, [data-ds-gallery-prev], [data-ds-gallery-next]')) return;
      if (e.button != null && e.button > 0) return;
      var viewer = e.target.closest('[data-ds-gallery-viewer]');
      if (!viewer) return;
      var img = activeZoomImg(viewer);
      if (!img) return; // video slide → gallery.js

      zPointers[e.pointerId] = { x: e.clientX, y: e.clientY };
      var ids = Object.keys(zPointers);

      if (ids.length >= 2) {
        // Pinch: a first finger may already have started a gallery drag — snap the
        // track back to the current slide so the pinch starts from a clean frame.
        var root = viewer.closest('[data-ds-gallery]');
        if (root) {
          root.dispatchEvent(
            new CustomEvent('ds:gallery:set', {
              bubbles: true,
              detail: { index: Number(root.dataset.dsGalleryActive || 0), instant: true },
            }),
          );
        }
        zImg = img;
        zMode = 'pinch';
        var p = twoPoints();
        zLastDist = ptDist(p[0], p[1]);
        zLastMid = ptMid(p[0], p[1]);
        img.style.transition = 'none';
        try { viewer.setPointerCapture(e.pointerId); } catch (err) {}
        e.stopPropagation();
        e.preventDefault();
      } else if (zState(img).scale > 1) {
        zImg = img;
        zMode = 'pan';
        zLast = { x: e.clientX, y: e.clientY };
        img.style.transition = 'none';
        img.style.cursor = 'grabbing';
        try { viewer.setPointerCapture(e.pointerId); } catch (err) {}
        e.stopPropagation();
        e.preventDefault();
      } else {
        // Scale 1, single pointer: this is a swipe — gallery.js owns it.
        zMode = null;
      }
    },
    true,
  );

  document.addEventListener(
    'pointermove',
    function (e) {
      if (!zMode || !zImg || !(e.pointerId in zPointers)) return;
      zPointers[e.pointerId] = { x: e.clientX, y: e.clientY };
      e.stopPropagation();
      e.preventDefault();

      var z = zState(zImg);
      if (zMode === 'pinch') {
        if (Object.keys(zPointers).length < 2) return;
        var p = twoPoints();
        var d = ptDist(p[0], p[1]);
        var m = ptMid(p[0], p[1]);
        var v = zImg.closest('[data-ds-gallery-viewer]');
        var r = v.getBoundingClientRect();
        var cx = r.left + r.width / 2;
        var cy = r.top + r.height / 2;
        var fx = m.x - cx;
        var fy = m.y - cy;
        // Follow the midpoint (two-finger drag)…
        z.tx += fx - (zLastMid.x - cx);
        z.ty += fy - (zLastMid.y - cy);
        // …then scale about that same midpoint.
        var s0 = z.scale || 1;
        var s1 = Math.max(1, Math.min(ZOOM_MAX, s0 * (d / (zLastDist || d))));
        z.tx = fx - (s1 / s0) * (fx - z.tx);
        z.ty = fy - (s1 / s0) * (fy - z.ty);
        z.scale = s1;
        clampZoom(zImg);
        applyZoom(zImg, false);
        zLastDist = d;
        zLastMid = m;
      } else if (zMode === 'pan') {
        z.tx += e.clientX - zLast.x;
        z.ty += e.clientY - zLast.y;
        zLast = { x: e.clientX, y: e.clientY };
        clampZoom(zImg);
        applyZoom(zImg, false);
      }
    },
    true,
  );

  function zoomPointerEnd(e) {
    if (!(e.pointerId in zPointers)) return;
    delete zPointers[e.pointerId];
    if (zMode) e.stopPropagation();
    var ids = Object.keys(zPointers);
    if (zMode === 'pinch' && ids.length === 1) {
      // Second finger lifted mid-pinch: keep dragging with the one that remains.
      if (zState(zImg).scale > 1) {
        zMode = 'pan';
        zLast = zPointers[ids[0]];
      } else {
        finishZoomGesture();
      }
    } else if (zMode === 'pan' && ids.length >= 1) {
      zLast = zPointers[ids[0]];
    } else if (ids.length === 0) {
      finishZoomGesture();
    }
  }
  document.addEventListener('pointerup', zoomPointerEnd, true);
  document.addEventListener('pointercancel', zoomPointerEnd, true);

  // Desktop wheel — zoom toward the cursor. The modal already locks page scroll,
  // so the wheel is free to mean "zoom".
  document.addEventListener(
    'wheel',
    function (e) {
      var overlay = e.target.closest && e.target.closest('[data-ds-media-lightbox]');
      if (!overlay || !isOpen(overlay)) return;
      var viewer = e.target.closest('[data-ds-gallery-viewer]');
      if (!viewer) return;
      var img = activeZoomImg(viewer);
      if (!img) return;
      e.preventDefault();
      var f = focal(img, e.clientX, e.clientY);
      zoomToward(img, zState(img).scale * Math.exp(-e.deltaY * 0.0015), f.x, f.y);
      applyZoom(img, false);
    },
    { passive: false },
  );

  // Desktop double-click — toggle between fit and 2×, zooming toward the cursor.
  document.addEventListener('dblclick', function (e) {
    var overlay = e.target.closest && e.target.closest('[data-ds-media-lightbox]');
    if (!overlay || !isOpen(overlay)) return;
    var viewer = e.target.closest('[data-ds-gallery-viewer]');
    if (!viewer) return;
    var img = activeZoomImg(viewer);
    if (!img) return;
    e.preventDefault();
    var z = zState(img);
    if (z.scale > 1) {
      z.scale = 1;
      z.tx = 0;
      z.ty = 0;
      applyZoom(img, true);
    } else {
      var f = focal(img, e.clientX, e.clientY);
      zoomToward(img, 2, f.x, f.y);
      applyZoom(img, true);
    }
  });

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    // Close: the X control inside the overlay.
    var closeBtn = t.closest('[data-ds-media-lightbox-close]');
    if (closeBtn) {
      e.preventDefault();
      closeOverlay(closeBtn.closest('[data-ds-media-lightbox]'));
      return;
    }

    // Open: the explicit zoom trigger button over the image.
    var trigger = t.closest('[data-ds-media-zoom-trigger]');
    if (trigger) {
      e.preventDefault();
      openFor(trigger.closest('[data-ds-gallery]'), trigger);
      return;
    }

    // Close: clicking the dimmed backdrop (the overlay itself, not its card).
    var overlay = t.closest('[data-ds-media-lightbox]');
    if (overlay && isOpen(overlay) && t === overlay) {
      closeOverlay(overlay);
      return;
    }

    // Open: ONLY a real gallery slide opens the zoom — never the whole viewer.
    // Personalization apps (Customily) drop an interactive <canvas> over the main
    // image; keying on [data-ds-gallery-main] means a click on that canvas (or any
    // app overlay sitting above the image) is not ours to catch, so it never
    // hijacks into an empty modal. The explicit zoom button above still works.
    // The inline video preview carries the same marker on purpose: it has no
    // controls, so a click on it is the same "see it big" gesture as on an image,
    // and the modal is where that video gets its real player.
    var mainImg = t.closest('[data-ds-gallery-main]');
    if (mainImg) {
      var imgRoot = mainImg.closest('[data-ds-gallery]');
      // Only the inline gallery is zoomable (it carries data-ds-gallery-zoom); the
      // bare gallery inside the modal has none, so its own images never re-open it.
      if (imgRoot && imgRoot.getAttribute('data-ds-gallery-zoom')) openFor(imgRoot, null);
    }
  });

  document.addEventListener('keydown', function (e) {
    var overlay = openOverlayEl();
    if (!overlay) return;
    if (e.key === 'Escape') {
      closeOverlay(overlay);
      return;
    }
    if (e.key === 'Tab') trapTab(e, overlay);
  });

  // Portal overlays out of their sticky/stacking-context columns up front, so the
  // first open never flashes trapped-under-the-buy-box.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hoistAll, { once: true });
  } else {
    hoistAll();
  }
})();

} catch (sfError) {
if (typeof console !== 'undefined') console.error('[sf-core] behavior "media-lightbox" failed to initialise:', sfError);
}
})();

/* number-input.js */
(function () {
try {
/* number-input — stepper +/- buttons around a native <input type=number>.
 * Binds [data-ds-number-input] and data-ds-number-input-{decrease,increase}
 * (see snippets/ds-number-input.liquid). The native field stays the value
 * store; buttons dispatch input/change on it so theme code listens on the field.
 * Progressive enhancement: the field is usable by keyboard without JS.
 *
 * Authoring rules: src/behaviors/README.md. No import/export.
 */

var NUMBER = '[data-ds-number-input]';
var DECREASE = '[data-ds-number-input-decrease]';
var INCREASE = '[data-ds-number-input-increase]';
// Settle time before a stepper click commits its 'change' — the event other
// behaviors (e.g. cart-lines.js) treat as "fire the network request". Without
// this, holding + fires one fetch per click instead of one per burst.
var CHANGE_SETTLE = 400;

function numBound(input, attr, fallback) {
  var raw = input.getAttribute(attr);
  if (raw === null || raw === '') return fallback;
  var value = Number(raw);
  return Number.isNaN(value) ? fallback : value;
}

function numCurrent(input, min) {
  var value = Number(input.value);
  if (!Number.isNaN(value)) return value;
  return min === -Infinity ? 0 : min;
}

function numSync(root) {
  var input = root.querySelector('input[type="number"]');
  if (!input) return;
  var min = numBound(input, 'min', -Infinity);
  var max = numBound(input, 'max', Infinity);
  var value = numCurrent(input, min);
  var decrease = root.querySelector(DECREASE);
  var increase = root.querySelector(INCREASE);
  if (decrease) decrease.disabled = input.disabled || value <= min;
  if (increase) increase.disabled = input.disabled || value >= max;
}

function numStep(root, direction) {
  var input = root.querySelector('input[type="number"]');
  if (!input || input.disabled) return;
  var min = numBound(input, 'min', -Infinity);
  var max = numBound(input, 'max', Infinity);
  var size = numBound(input, 'step', 1) || 1;
  var value = numCurrent(input, min);
  var next = Math.min(max, Math.max(min, value + direction * size));
  if (next === value) return;
  input.value = String(next);
  input.dispatchEvent(new Event('input', { bubbles: true }));
  numSync(root);
  if (input.__dsChangeTimer) window.clearTimeout(input.__dsChangeTimer);
  input.__dsChangeTimer = window.setTimeout(function () {
    input.__dsChangeTimer = 0;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }, CHANGE_SETTLE);
}

// A typed value bypasses numStep's own clamp entirely, and PDP add-to-cart forms
// carry novalidate (so the browser's own min/max check never runs) — so -1 or a
// blank field would otherwise reach /cart/add.js untouched. Runs on the capture
// phase so it lands before any other 'change' listener (cart-lines.js, form
// submit) reads the field, regardless of script load order.
// ponytail: no upper bound when the field carries no `max` (PDP/cart never set
// one today) — inventory-based caps would be invented business logic. Add a
// `max` in ds-number-input.liquid callers once inventory limits are wired.
function numClamp(input) {
  var min = numBound(input, 'min', -Infinity);
  var max = numBound(input, 'max', Infinity);
  var value = Number(input.value);
  if (!Number.isFinite(value)) value = min === -Infinity ? 0 : min;
  var clamped = Math.min(max, Math.max(min, value));
  if (String(clamped) !== input.value) input.value = String(clamped);
}

if (!document.__dsNumberInputBound) {
  document.__dsNumberInputBound = true;

  document.addEventListener('click', function (e) {
    var target = e.target;
    if (!target || !target.closest) return;
    var button = target.closest(DECREASE + ',' + INCREASE);
    if (!button || button.disabled) return;
    var root = button.closest(NUMBER);
    if (root) numStep(root, button.matches(INCREASE) ? 1 : -1);
  });

  document.addEventListener('input', function (e) {
    var field = e.target;
    if (field instanceof HTMLInputElement && field.matches(NUMBER + ' input[type="number"]')) {
      var root = field.closest(NUMBER);
      if (root) numSync(root);
    }
  });

  document.addEventListener('change', function (e) {
    var field = e.target;
    if (field instanceof HTMLInputElement && field.matches(NUMBER + ' input[type="number"]')) {
      numClamp(field);
      var root = field.closest(NUMBER);
      if (root) numSync(root);
    }
  }, true);
}

} catch (sfError) {
if (typeof console !== 'undefined') console.error('[sf-core] behavior "number-input" failed to initialise:', sfError);
}
})();

/* order-lookup.js */
(function () {
try {
/**
 * order-lookup — busy state on the Track order CTA (SF0026 #1651).
 *
 * Swaps the idle / busy button pair Liquid already rendered. Does not perform
 * a real order lookup — that lives outside this theme. Prevents a second press
 * while busy; restores idle if the page stays put (no navigation).
 */
(function () {
  function setBusy(root, on) {
    var idle = root.querySelector('[data-ds-order-lookup-idle]');
    var busy = root.querySelector('[data-ds-order-lookup-busy]');
    if (!idle || !busy) return;

    var from = on ? idle : busy;
    var to = on ? busy : idle;
    var carry = from.contains(document.activeElement);

    idle.classList.toggle('sf-hidden', on);
    busy.classList.toggle('sf-hidden', !on);
    idle.classList.toggle('sf-block', !on);
    busy.classList.toggle('sf-block', on);

    if (!carry) return;
    var target = to.querySelector('button');
    if (target && typeof target.focus === 'function') target.focus();
  }

  function onSubmit(event) {
    var root = event.target.closest('[data-ds-order-lookup]');
    if (!root) return;

    var order = root.querySelector('[data-ds-order-lookup-order]');
    var email = root.querySelector('[data-ds-order-lookup-email]');
    if (order && !String(order.value || '').trim()) {
      event.preventDefault();
      return;
    }
    if (email && !String(email.value || '').trim()) {
      event.preventDefault();
      return;
    }

    setBusy(root, true);
  }

  function bind(root) {
    if (!root || root.hasAttribute('data-ds-order-lookup-bound')) return;
    root.setAttribute('data-ds-order-lookup-bound', '');
    root.addEventListener('submit', onSubmit);
  }

  function scan() {
    document.querySelectorAll('[data-ds-order-lookup]').forEach(bind);
  }

  scan();
  document.addEventListener('shopify:section:load', scan);
})();

} catch (sfError) {
if (typeof console !== 'undefined') console.error('[sf-core] behavior "order-lookup" failed to initialise:', sfError);
}
})();

/* page-lock.js */
(function () {
try {
/* page-lock — holds the page still behind an open sheet, modal or lightbox,
 * iOS Safari included.
 *
 * Contract: the behavior that owns an overlay sets [data-ds-page-lock] on it
 * when it opens and removes it when it closes. That is the whole API. The page
 * stays locked while any element in the document carries the attribute, so
 * nested overlays need no bookkeeping, and an open overlay removed by a Theme
 * Editor re-render unlocks the page on its own.
 *
 * `overflow: hidden` on html or body does not hold on iOS: a drag on the scrim
 * pans the page, and focusing a field scrolls it (BY-115). So the body is
 * pinned in place at its current offset, and html carries [data-ds-page-locked]
 * while it is — pinning resets the window scroll to 0, and scroll listeners
 * (scroll-top.js) skip that jump. Unlocking puts the page back where it was.
 *
 * While locked, a one-finger drag may only move something that can still
 * scroll that way inside a locked overlay; anything else (the scrim, a header,
 * a list at its end) is dropped. Two fingers are a pinch and pass through.
 *
 * Opt-in [data-ds-page-lock-fit] on the overlay pins it to the visual viewport
 * (top and height), so it stays above the iOS keyboard; its CSS can cap heights
 * from --ds-page-lock-viewport. Each change fires `ds:page-lock:fit` on the
 * overlay with { top, height, resized } for the owner to react to.
 *
 * Authoring rules: src/behaviors/README.md. No import/export.
 */

(function () {
  if (document.__dsPageLockBound) return;
  document.__dsPageLockBound = true;

  var ATTR = 'data-ds-page-lock';
  var LOCKED = 'data-ds-page-locked';
  var FIT = 'data-ds-page-lock-fit';
  var STYLE = ['position', 'top', 'left', 'right', 'width', 'overflow'];
  var html = document.documentElement;
  var viewport = window.visualViewport;
  var saved = null;
  var fitted = [];

  function lock() {
    var body = document.body;
    saved = { scroll: window.pageYOffset, style: {} };
    STYLE.forEach(function (prop) { saved.style[prop] = body.style[prop]; });
    html.setAttribute(LOCKED, '');
    body.style.position = 'fixed';
    body.style.top = -saved.scroll + 'px';
    body.style.left = '0';
    body.style.right = '0';
    body.style.width = '100%';
    body.style.overflow = 'hidden';
  }

  function unlock() {
    var body = document.body;
    STYLE.forEach(function (prop) { body.style[prop] = saved.style[prop]; });
    window.scrollTo({ top: saved.scroll, behavior: 'instant' });
    html.removeAttribute(LOCKED);
    saved = null;
  }

  // ── Visual-viewport fit ────────────────────────────────────────────────

  function fit(entry) {
    // Pinch-zoom shrinks the visual viewport too; the overlay stays as it is
    // until the page is back at its own scale.
    if (viewport.scale > 1.01) return;
    var top = viewport.offsetTop;
    var height = viewport.height;
    if (entry.top === top && entry.height === height) return;
    var resized = entry.height !== height;
    entry.top = top;
    entry.height = height;
    var el = entry.el;
    el.style.top = top + 'px';
    el.style.bottom = 'auto';
    el.style.height = height + 'px';
    el.style.setProperty('--ds-page-lock-viewport', height + 'px');
    el.dispatchEvent(new CustomEvent('ds:page-lock:fit', {
      detail: { top: top, height: height, resized: resized },
    }));
  }

  function unfit(entry) {
    var el = entry.el;
    el.style.removeProperty('top');
    el.style.removeProperty('bottom');
    el.style.removeProperty('height');
    el.style.removeProperty('--ds-page-lock-viewport');
  }

  function refit() {
    fitted.forEach(fit);
  }

  if (viewport) {
    viewport.addEventListener('resize', refit);
    viewport.addEventListener('scroll', refit);
  }

  // ── State ──────────────────────────────────────────────────────────────

  function sync() {
    var open = document.querySelectorAll('[' + ATTR + ']');
    if (open.length && !saved) lock();
    else if (!open.length && saved) unlock();

    if (!viewport) return;
    var next = [];
    Array.prototype.forEach.call(open, function (el) {
      if (!el.hasAttribute(FIT)) return;
      var entry = null;
      for (var i = 0; i < fitted.length; i++) {
        if (fitted[i].el === el) entry = fitted[i];
      }
      next.push(entry || { el: el, top: null, height: null });
    });
    fitted.forEach(function (entry) {
      if (next.indexOf(entry) === -1) unfit(entry);
    });
    fitted = next;
    refit();
  }

  // The observer runs right after the handler that flipped the attribute,
  // before the next paint, and between the listeners of one user event.
  new MutationObserver(sync).observe(html, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: [ATTR],
  });
  sync();

  // ── Touch guard ────────────────────────────────────────────────────────

  function canScroll(el, axis, delta) {
    var style = getComputedStyle(el);
    if (axis === 'y') {
      if (!/auto|scroll/.test(style.overflowY) || el.scrollHeight <= el.clientHeight + 1) return false;
      if (delta > 0) return el.scrollTop > 0;
      return el.scrollTop + el.clientHeight < el.scrollHeight - 1;
    }
    if (!/auto|scroll/.test(style.overflowX) || el.scrollWidth <= el.clientWidth + 1) return false;
    // Logical start/end: scrollLeft runs 0 → negative in a right-to-left box.
    var left = Math.abs(el.scrollLeft);
    var start = style.direction === 'rtl' ? delta < 0 : delta > 0;
    if (start) return left > 0;
    return left + el.clientWidth < el.scrollWidth - 1;
  }

  var lastX = 0;
  var lastY = 0;

  document.addEventListener('touchstart', function (event) {
    lastX = event.touches[0].clientX;
    lastY = event.touches[0].clientY;
  }, { passive: true });

  document.addEventListener('touchmove', function (event) {
    if (!saved || event.touches.length > 1 || !event.cancelable) return;
    var x = event.touches[0].clientX;
    var y = event.touches[0].clientY;
    var dx = x - lastX;
    var dy = y - lastY;
    lastX = x;
    lastY = y;
    var target = event.target.nodeType === 1 ? event.target : event.target.parentElement;
    var root = target && target.closest('[' + ATTR + ']');
    if (!root) {
      event.preventDefault();
      return;
    }
    var axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
    var delta = axis === 'x' ? dx : dy;
    if (!delta) return;
    for (var el = target; el; el = el.parentElement) {
      if (canScroll(el, axis, delta)) return;
      if (el === root) break;
    }
    event.preventDefault();
  }, { passive: false });
})();

} catch (sfError) {
if (typeof console !== 'undefined') console.error('[sf-core] behavior "page-lock" failed to initialise:', sfError);
}
})();

/* product-rail.js */
(function () {
try {
/* product-rail — category/product bands' finite carousel: arrows and swipe.
 *
 * Binds EVERY rail, not just the always-scrolling one. The other shape wraps
 * into a grid from md but still scrolls below it, and arrows follow the
 * scrolling rather than the shape — so the same file drives both and simply
 * asks, at each width, whether this track scrolls at all.
 *
 * The track is already a native horizontal scroller (snippets/ds-product-rail
 * .liquid), so swipe works with no JS and every tile is reachable by keyboard
 * before this file runs. This adds the two things the markup cannot express:
 * the arrows scroll by a whole number of tiles, and the buttons disable at the
 * real start/end of the row.
 *
 * How far one click travels is the section's call, and it differs by end — the
 * mobile track shows fewer tiles, so the desktop jump would overshoot the whole
 * viewport. Both counts arrive as attributes and the breakpoint is read from
 * `--breakpoint-md` rather than typed here, so a token change moves the JS with
 * the CSS.
 *
 * Authoring rules: src/behaviors/README.md. No import/export.
 */

var RAIL = '[data-ds-product-rail]';

function desktopQuery() {
  var token = window
    .getComputedStyle(document.documentElement)
    .getPropertyValue('--breakpoint-md')
    .trim();
  return '(min-width: ' + (token || '768px') + ')';
}

function bindRail(root) {
  if (root.dataset.dsRailBound) return;
  root.dataset.dsRailBound = '1';

  var track = root.querySelector('[data-ds-product-rail-track]');
  var nav = root.querySelector('[data-ds-carousel-nav]');
  if (!track) return;

  var reals = Array.prototype.slice.call(track.children);
  if (!reals.length) {
    // An empty track may be filled later by another behaviour (PLP Recently
    // Viewed fetches its tiles after load). Hide the arrows and bind once the
    // first tile lands, instead of removing them for good.
    if (nav) nav.hidden = true;
    delete root.dataset.dsRailBound;
    if (typeof MutationObserver !== 'undefined' && !root.dataset.dsRailWaiting) {
      root.dataset.dsRailWaiting = '1';
      var waiter = new MutationObserver(function () {
        if (!track.children.length) return;
        waiter.disconnect();
        delete root.dataset.dsRailWaiting;
        bindRail(root);
      });
      waiter.observe(track, { childList: true });
    }
    return;
  }

  // Read once: a section cannot change its own settings without the Theme
  // Editor re-rendering the whole subtree, which re-binds from scratch.
  var stepDesktop = Math.max(1, Number(root.dataset.dsRailStep) || 1);
  var stepMobile = Math.max(1, Number(root.dataset.dsRailStepMobile) || 1);
  var wide = window.matchMedia(desktopQuery());
  var prev = root.querySelector('[data-ds-carousel-nav-prev]');
  var next = root.querySelector('[data-ds-carousel-nav-next]');

  function tilesPerClick() {
    return Math.max(1, wide.matches ? stepDesktop : stepMobile);
  }

  function step() {
    // One tile plus one gutter, measured rather than assumed: the tile width is
    // the `auto-cols-rail-*` calc off the per-view count and the gutter changes
    // at md, so any number hardcoded here would be wrong at one end or the
    // other.
    // The track's CURRENT first tile, not the one captured at bind: the
    // homepage reviews band refills its track from Judge.me after this runs,
    // and a detached tile measures 0.
    var first = track.firstElementChild || reals[0];
    var box = first.getBoundingClientRect().width;
    var gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
    return box + gap;
  }

  function scrollable() {
    // Asked of the layout, not of the summed tile widths. A wrapped grid's
    // tiles add up far wider than the track while the track itself does not
    // scroll at all — summing them reported overflow on a grid.
    return track.scrollWidth > track.clientWidth + 1;
  }

  function updateNav() {
    if (!nav) return;
    var canScroll = scrollable();
    nav.hidden = !canScroll;
    var atStart = !canScroll || track.scrollLeft <= 1;
    var atEnd = !canScroll || track.scrollLeft >= track.scrollWidth - track.clientWidth - 1;
    if (prev) prev.disabled = atStart;
    if (next) next.disabled = atEnd;
  }

  function restage() {
    track.scrollLeft = Math.min(track.scrollLeft, Math.max(0, track.scrollWidth - track.clientWidth));
    updateNav();
  }

  function scrollBy(direction) {
    var max = Math.max(0, track.scrollWidth - track.clientWidth);
    var target = Math.max(0, Math.min(max,
      track.scrollLeft + direction * step() * tilesPerClick()));
    // A smooth scroll reports its first scroll event on a later frame. Update
    // from the clamped destination immediately so Prev becomes usable as soon
    // as Next is pressed instead of looking stuck during the animation.
    if (prev) prev.disabled = target <= 1;
    if (next) next.disabled = target >= max - 1;
    track.scrollTo({
      left: target,
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
    });
  }

  if (prev) prev.addEventListener('click', function () { scrollBy(-1); });
  if (next) next.addEventListener('click', function () { scrollBy(1); });

  var scrollQueued = false;
  track.addEventListener('scroll', function () {
    if (scrollQueued) return;
    scrollQueued = true;
    window.requestAnimationFrame(function () {
      scrollQueued = false;
      updateNav();
    });
  }, { passive: true });

  // The per-view count is a media query, so a width change moves both the tile
  // width and the gutter — every number above has to be re-measured.
  // Width only. restage() clamps the scroll position, so running it on every
  // observed box change — a tile's image settling, a label wrapping — would
  // yank the row back to the start mid-browse.
  var lastWidth = 0;
  function onResize() {
    var width = track.clientWidth;
    if (width === lastWidth) return;
    lastWidth = width;
    restage();
  }

  if (typeof ResizeObserver !== 'undefined') {
    var queued = false;
    new ResizeObserver(function () {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(function () { queued = false; onResize(); });
    }).observe(track);
  } else {
    window.addEventListener('resize', onResize);
  }

  lastWidth = track.clientWidth;
  restage();
}

function initRails(scope) {
  if (!scope) return;
  if (scope.matches && scope.matches(RAIL)) bindRail(scope);
  if (scope.querySelectorAll) scope.querySelectorAll(RAIL).forEach(bindRail);
}

if (!document.__dsProductRailBound) {
  document.__dsProductRailBound = true;
  var startRails = function () { initRails(document); };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startRails, { once: true });
  } else {
    startRails();
  }
  document.addEventListener('shopify:section:load', startRails);

  if (typeof MutationObserver !== 'undefined') {
    var rescanQueued = false;
    var observer = new MutationObserver(function () {
      if (rescanQueued) return;
      rescanQueued = true;
      requestAnimationFrame(function () {
        rescanQueued = false;
        startRails();
        if (document.querySelector(RAIL)) observer.disconnect();
      });
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
}

} catch (sfError) {
if (typeof console !== 'undefined') console.error('[sf-core] behavior "product-rail" failed to initialise:', sfError);
}
})();

/* product-reviews.js */
(function () {
try {
/* product-reviews — the reviews band's UI: summary rail, list, pager / Load
 * more, filter + sort panels, photo strip and lightbox.
 *
 * The UI is shared; the DATA is not. A band reads its reviews from one source,
 * picked once on mount, and every request after that goes to the same source:
 *
 *   product-reviews-data-sf.js       WanderCo SF API (the app's own mirror)
 *   product-reviews-data-judgeme.js  Judge.me's public widget feed — the fallback
 *
 * Each source hands this file the same plain review objects ({ id, author,
 * rating, dateIso, body, photos, … }) and answers the same questions — list
 * page N, strip page N, how many a draft filter holds — so nothing below knows
 * which one it is talking to, beyond the capability flags a source declares
 * (`photoServer`, `countsByRequest`, …). SF is used when the shop has it on, the
 * API answers, and it holds reviews for a product Judge.me has reviews for;
 * otherwise Judge.me (`data-ds-reviews-sf` on the root records the choice).
 *
 * Authoring rules: src/behaviors/README.md. No import/export.
 */

var ROOT = '[data-ds-product-reviews]';
/* Five was read off the Figma frame, and it turns out to be the merchant's own
 * setting rather than a coincidence: `shop.metafields.judgeme.settings` carries
 * jdgmSettings, which opens `{"pagination":5,…}`. So this page size is what a
 * shopper already sees in Judge.me's widget, and the two do not disagree.
 * Left as a literal on purpose — that metafield is a 39KB <script> tag, and
 * regexing a number out of it in Liquid to arrive back at 5 buys nothing. If a
 * merchant ever changes it there, change it here. */
var PER_PAGE = 5;

/* ── Shared rendering helpers ─────────────────────────────────────────────── */

/* The flag as an SVG from flag-icons (MIT, flag.<cc>.svg in the theme's own
 * assets), not the prototype's emoji: Windows ships no flag glyphs, so the
 * emoji came out as the two letters "US" on most desktops, and the prototype
 * marks the emoji as a stopgap until real flag icons exist. The name comes
 * from Intl in the page's language, falling back to the code where
 * Intl.DisplayNames is missing. */
function countryName(code) {
  try {
    var lang = document.documentElement.lang || 'en';
    return new Intl.DisplayNames([lang], { type: 'region' }).of(code) || code;
  } catch (error) {
    return code;
  }
}

/* Shared by the review list and the customer-photos lightbox. Null when the
 * review has no code, the code is Vietnam (merchant call), or the theme did
 * not ship flag-icons. The caller decides whether a miss removes the slot
 * (a cloned review) or only hides it (the one lightbox, reused per photo). */
function countryFlagImage(review, src) {
  if (!review.country || review.country === 'VN' || !src || src.indexOf('flag.us.svg') === -1) return null;
  var name = countryName(review.country);
  var img = document.createElement('img');
  img.src = src.replace('flag.us.svg', 'flag.' + review.country.toLowerCase() + '.svg');
  img.alt = name;
  img.title = name;
  img.width = 4;
  img.height = 3;
  img.loading = 'lazy';
  img.decoding = 'async';
  return img;
}

/* SF0126 — display form for a product average rating.
 * Ceil to one decimal (Math.ceil(avg * 10) / 10), then always print one decimal
 * place so "5" stays "5.0" and 4.96 becomes "5.0". Shared by the reviews-band
 * summary and (via the same Liquid rule) the buy-box title rating so both
 * surfaces never disagree. */
function formatAverageRating(avg) {
  var n = typeof avg === 'number' ? avg : parseFloat(avg);
  if (avg == null || avg === '' || isNaN(n)) return null;
  return (Math.ceil(n * 10) / 10).toFixed(1);
}

/* Write a source's aggregate ({ averageValue, count, dist }) into the summary
 * rail: the big score, the star row, the "Based on N reviews" line and the five
 * distribution bars. Idempotent, so it runs whether the Liquid seed was already
 * right (the common case) or stale. Null leaves the server render alone. */
function applyAggregate(root, agg) {
  if (!agg) return;

  /* A number the merchant typed in the theme editor is the final word — the
   * section stamps it on the root, and the widget metafield may not overwrite
   * it. */
  /* SF0126: ceil to 1 decimal + always one decimal digit (see formatAverageRating). */
  var averageText = formatAverageRating(agg.averageValue);
  if (averageText != null && !root.hasAttribute('data-ds-reviews-score-pinned')) {
    var scoreEl = root.querySelector('[data-ds-reviews-score]');
    if (scoreEl) scoreEl.textContent = averageText;
  }

  if (agg.averageValue != null && !isNaN(agg.averageValue)) {
    var stars = root.querySelector('[data-ds-reviews-stars] [data-ds-rating]');
    if (stars) setStars(stars, agg.averageValue);
  }

  if (agg.count != null && !root.hasAttribute('data-ds-reviews-count-pinned')) {
    // Swap only the number, leaving the localized wording ("Based on …", "Basé
    // sur …") untouched — the count is the one thing that moved.
    var summaryEl = root.querySelector('[data-ds-reviews-summary]');
    if (summaryEl && /\d/.test(summaryEl.textContent)) {
      summaryEl.textContent = summaryEl.textContent.replace(/\d[\d.,]*/, String(agg.count));
    }
  }

  var order = [5, 4, 3, 2, 1];
  var peak = Math.max(agg.dist[5], agg.dist[4], agg.dist[3], agg.dist[2], agg.dist[1], 0);
  // No histogram in the widget markup (peak 0) means we have no published
  // distribution — leave whatever the server rendered rather than zeroing every
  // bar. A genuinely review-less product shows the empty card, not bars, anyway.
  var bars = peak > 0 ? root.querySelector('[data-ds-rating-bars]') : null;
  if (bars) {
    bars.querySelectorAll('[data-ds-rating-bar-row]').forEach(function (row, index) {
      var freq = agg.dist[order[index]] || 0;
      // Percent of the peak row, matching ds-rating-bars' own scaling. Set as an
      // inline width so it wins over the attribute-keyed rules in rating-bars.css
      // without needing a class for every possible percentage.
      var fill = row.querySelector('[data-ds-rating-bar-fill]');
      if (fill) fill.style.width = (peak > 0 ? Math.round((freq * 100) / peak) : 0) + '%';
      var spans = row.querySelectorAll(':scope > span');
      var count = spans[spans.length - 1];
      if (count) count.textContent = String(freq);
    });
  }
}

/* The filter panel's star rows carry each level's count
 * (`data-ds-reviews-rating-total`, read by the "Show N reviews" button) and lock
 * a level with no reviews. The Liquid draws them from Judge.me's histogram; a
 * source that counts for itself rewrites them from its own `dist`, so the
 * button, the lock and the list agree with the source the band reads. */
function applyRatingRows(root, dist) {
  if (!dist) return;
  root.querySelectorAll('[data-ds-reviews-rating-row]').forEach(function (row) {
    var stars = parseInt(row.getAttribute('data-ds-reviews-rating-row'), 10);
    if (dist[stars] === undefined) return;
    var total = parseInt(dist[stars], 10) || 0;
    row.setAttribute('data-ds-reviews-rating-total', String(total));
    var input = row.querySelector('input[name="ds-reviews-rating"]');
    if (!input) return;
    input.disabled = total === 0;
    var label = row.querySelector('label[for="' + input.id + '"][aria-hidden="true"]');
    if (!label) return;
    label.classList.toggle('sf-opacity-50', total === 0);
    label.classList.toggle('sf-cursor-not-allowed', total === 0);
    label.classList.toggle('sf-cursor-pointer', total !== 0);
  });
}

/* 57231 → "57.2k", 1284 → "1.3k", 950 → "950" — the hub header's Liquid rule. */
function compactCount(n) {
  if (n < 1000) return String(n);
  var tenths = Math.round(n / 100);
  var tenth = tenths % 10;
  return Math.floor(tenths / 10) + (tenth ? '.' + tenth : '') + 'k';
}

/* The reviews page's header (ds-reviews-hub-header: score, total, five bars) is
 * drawn by the Liquid from Judge.me's shop metafields. A source that counts for
 * itself redraws it from its own aggregate, in place: only the numbers move,
 * the translated wording stays (the old numbers ride on data-ds-reviews-hub-*). */
function applyHubHeader(root, agg) {
  if (!agg || !root.id) return;
  var row = document.querySelector('[data-ds-reviews-star][data-ds-reviews-for="' + root.id + '"]');
  var hub = row && row.closest('[data-ds-reviews-hub]');
  if (!hub) return;

  var avgText = formatAverageRating(agg.averageValue);
  var score = hub.querySelector('[data-ds-reviews-hub-score-value]');
  if (score && avgText) {
    var oldScore = score.textContent.trim();
    score.textContent = avgText;
    var rated = score.getAttribute('aria-label');
    if (rated && oldScore) score.setAttribute('aria-label', rated.replace(oldScore, avgText));
  }

  if (typeof agg.count === 'number') {
    var short = hub.querySelector('[data-ds-reviews-hub-count-short]');
    if (short) short.textContent = '(' + compactCount(agg.count) + ')';
    var abbr = hub.querySelector('[data-ds-reviews-hub-count-abbr]');
    if (abbr) {
      var oldShort = abbr.getAttribute('data-ds-reviews-hub-count-abbr');
      var oldFull = abbr.getAttribute('data-ds-reviews-hub-count-full');
      var full = String(agg.count).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      if (oldShort) abbr.textContent = abbr.textContent.replace(oldShort, compactCount(agg.count));
      if (oldFull) abbr.setAttribute('title', (abbr.getAttribute('title') || '').replace(oldFull, full));
      abbr.setAttribute('data-ds-reviews-hub-count-abbr', compactCount(agg.count));
      abbr.setAttribute('data-ds-reviews-hub-count-full', full);
    }
  }

  var dist = agg.dist || {};
  var total = (dist[5] || 0) + (dist[4] || 0) + (dist[3] || 0) + (dist[2] || 0) + (dist[1] || 0);
  if (!total) return;
  hub.querySelectorAll('[data-ds-reviews-star][data-ds-reviews-hub-count]').forEach(function (button) {
    var stars = parseInt(button.getAttribute('data-ds-reviews-star'), 10);
    var n = dist[stars] || 0;
    var pct = Math.round((n * 100) / total);
    var label = n > 0 && pct === 0 ? '<1%' : pct + '%';
    var fill = button.querySelector('[data-ds-rating-bar-fill]');
    if (fill) {
      fill.setAttribute('data-ds-rating-bar-fill', String(pct));
      fill.style.width = pct + '%';
    }
    var pctEl = button.querySelector('[data-ds-reviews-hub-pct]');
    var oldLabel = pctEl ? pctEl.textContent.trim() : '';
    if (pctEl) pctEl.textContent = label;
    var oldCount = button.getAttribute('data-ds-reviews-hub-count');
    var aria = button.getAttribute('aria-label') || '';
    if (oldLabel) aria = aria.replace(oldLabel, label);
    if (oldCount !== null) aria = aria.replace('(' + oldCount + ')', '(' + n + ')');
    button.setAttribute('aria-label', aria);
    button.setAttribute('data-ds-reviews-hub-count', String(n));
  });
}

/* Judge.me renders its timestamps client-side, so the DOM text is usually
 * empty and only the ISO attribute is trustworthy. Absolute English wording
 * (e.g. "Sep 18, 2026") is built here from that stamp — short month, day
 * without a leading zero, comma, four-digit year. UTC calendar day so a
 * Z-suffixed ISO does not shift the date by local offset. */
var REVIEW_MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
function absoluteDate(iso) {
  if (!iso) return '';
  var m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(iso));
  var y, mo, day;
  if (m) {
    y = Number(m[1]);
    mo = Number(m[2]);
    day = Number(m[3]);
  } else {
    var then = Date.parse(iso);
    if (isNaN(then)) return '';
    var d = new Date(then);
    y = d.getUTCFullYear();
    mo = d.getUTCMonth() + 1;
    day = d.getUTCDate();
  }
  if (mo < 1 || mo > 12 || day < 1) return '';
  return REVIEW_MONTHS[mo - 1] + ' ' + day + ', ' + y;
}

/* ── Rendering ────────────────────────────────────────────────────────────── */

/* Fill one cloned ds-review-item. Every optional node is REMOVED rather than
 * hidden when its data is missing, so the article's flex gaps close up the way
 * they would have if Liquid had never rendered it. */
function fillReview(node, review, photoTemplate, flagSrc) {
  // photoTemplate here is the REVIEW tile (76 -> 140), not the strip's (84).
  var author = node.querySelector('[data-ds-review-author]');
  if (author) author.textContent = review.author;


  /* Removed, not blanked: an empty <p> still takes a flex gap, and no review on
   * this store carries a title today. */
  var title = node.querySelector('[data-ds-review-title]');
  if (title) {
    if (!review.title) title.remove();
    else title.textContent = review.title;
  }

  // A rating-only review (SF keeps them: they are in its counts) drops the empty paragraph, as the title does.
  var body = node.querySelector('[data-ds-review-body]');
  if (body) {
    if (!review.body) body.remove();
    else body.textContent = review.body;
  }

  /* "Purchased item: {name}" — reviews page only; a PDP review has no product
   * and the line goes. */
  var product = node.querySelector('[data-ds-review-product]');
  if (product) {
    var productLink = product.querySelector('[data-ds-review-product-link]');
    if (!review.product || !productLink) product.remove();
    else {
      productLink.textContent = review.product.title;
      productLink.setAttribute('href', review.product.href || '#');
    }
  }

  var date = node.querySelector('[data-ds-review-date]');
  if (date) {
    date.setAttribute('datetime', review.dateIso);
    date.textContent = absoluteDate(review.dateIso);
  }

  var stars = node.querySelector('[data-ds-rating]');
  if (stars) setStars(stars, review.rating);

  /* "Verified Buyer" is hardcoded for every review (SF0341 issue 5): the badge stays
   * on the node and nothing here reads a verified flag — there is no verified
   * filter or sort either. */

  var flag = node.querySelector('[data-ds-review-flag]');
  if (flag) {
    /* No Vietnam flag: the merchant's call (SF0026 review) — those reviews
     * show the name without one, as if Judge.me had sent no code. A code
     * flag-icons has no file for leaves no broken-image box. */
    var img = countryFlagImage(review, flagSrc);
    if (!img) flag.remove();
    else {
      img.onerror = function () { flag.remove(); };
      flag.textContent = '';
      flag.appendChild(img);
    }
  }

  var photos = node.querySelector('[data-ds-review-photos]');
  if (photos) {
    if (!review.photos.length) {
      photos.remove();
    } else {
      photos.innerHTML = '';
      review.photos.forEach(function (photo) {
        var tile = photoTemplate.content.firstElementChild.cloneNode(true);
        var img = tile.querySelector('img');
        if (img) {
          img.setAttribute('src', photo.src);
          img.removeAttribute('srcset');
          img.setAttribute('alt', '');
        }
        // The lightbox walks the whole product's strip, not just this review's,
        // so a body photo opens at its position in that flat list.
        tile.setAttribute('data-ds-reviews-photo-src', photo.src);
        photos.appendChild(tile);
      });
    }
  }

  var reply = node.querySelector('[data-ds-review-reply]');
  if (reply) {
    if (!review.reply) {
      reply.remove();
    } else {
      var replyBody = reply.querySelector('[data-ds-review-reply-body]');
      if (replyBody) replyBody.textContent = review.reply;
    }
  }
  return node;
}

/* ds-rating draws five stacked star pairs and reveals the overlay with a width
 * utility. Re-pointing it at another score means toggling those same classes —
 * no new markup, no second star implementation here. */
function setStars(container, score) {
  var halves = Math.max(0, Math.min(10, Math.round(score * 2)));
  container.setAttribute('data-ds-rating-value', String(score));
  // Each slot is `<span class="sf-relative">{svg}{overlay?}</span>`; the overlay
  // is the only child <span>, and it exists on every slot because the template
  // renders ds-rating at its default 5.
  container.querySelectorAll('[role="img"] > span').forEach(function (slot, index) {
    var overlay = slot.querySelector('span');
    if (!overlay) return;
    var filled = (index + 1) * 2;
    overlay.classList.remove('sf-w-full', 'sf-w-1/2', 'sf-hidden');
    if (halves >= filled) overlay.classList.add('sf-w-full');
    else if (halves === filled - 1) overlay.classList.add('sf-w-1/2');
    else overlay.classList.add('sf-hidden');
  });
}

/* ── One band ─────────────────────────────────────────────────────────────── */

/* Page size per band: the PDP keeps the merchant's 5, the reviews page asks for
 * 10 (prototype ReviewsBlock `pageSize={10}`). One UI page is still one request
 * — the all-reviews feed honours per_page up to 25. */
function bandPageSize(root) {
  return parseInt(root.getAttribute('data-ds-reviews-per-page'), 10) || 5;
}

// Pair the sort radios with the machine values the section listed beside their
// labels — see the sort_values param on ds-product-reviews. Same positional
// contract the <select> had; only the control changed.
function pairSortValues(root) {
  var sortBox = root.querySelector('[data-ds-reviews-sort]');
  var sortInputs = root.querySelectorAll('[data-ds-reviews-sort-option]');
  if (!sortBox || !sortInputs.length) return;
  var values = (sortBox.getAttribute('data-ds-reviews-sort') || '').split(',');
  sortInputs.forEach(function (input, index) {
    if (values[index]) input.value = values[index];
  });
}

/* Pick the band's data source, once, then mount the UI on it.
 *
 * SF first, when the shop has it on (`__WC_REVIEW_SF_SOURCE__`), the API URL was
 * injected and it is not known to be down: one round trip asks for the stats
 * and list page 1 together. SF answers and holds reviews — or Judge.me holds
 * none either — and the band is SF's. SF failing, slow, or empty for a product
 * Judge.me has reviews for (not synced into the app yet), and the band is
 * Judge.me's. The skeleton covers the wait. */
function setup(root) {
  var source = root.querySelector('[data-ds-reviews-source]');
  if (!source) return;
  var sources = window.WcReviewData || {};
  if (!sources.judgeme) {
    // The data layer did not load: leave Judge.me's own widget showing.
    source.classList.remove('sf-hidden');
    return;
  }
  pairSortValues(root);
  var perPage = bandPageSize(root);
  var feedAll = root.getAttribute('data-ds-reviews-feed') === 'all';
  var jm = sources.judgeme(root, { perPage: perPage, feedAll: feedAll, source: source });
  var sf = sources.sf ? sources.sf(root, { perPage: perPage }) : null;
  if (!sf) {
    root.setAttribute('data-ds-reviews-sf', '0');
    mount(root, jm);
    return;
  }
  root.setAttribute('data-ds-reviews-sf', 'pending');
  var picked = root.querySelector('[data-ds-reviews-sort-option]:checked');
  sf.load(picked ? picked.value : '').then(function (ok) {
    var jmCount = jm.aggregate && typeof jm.aggregate.count === 'number' ? jm.aggregate.count : jm.seed.length;
    var useSf = ok && (sf.aggregate.count > 0 || jmCount === 0);
    root.setAttribute('data-ds-reviews-sf', useSf ? '1' : '0');
    mount(root, useSf ? sf : jm);
  }, function () {
    root.setAttribute('data-ds-reviews-sf', '0');
    mount(root, jm);
  });
}

/* The band's UI over one data source (see the header). */
function mount(root, data) {
  // Shadows the file-level default for everything inside this band.
  var PER_PAGE = bandPageSize(root);
  var feedAll = root.getAttribute('data-ds-reviews-feed') === 'all';
  /* The strip is fetched page by page from the server (SF, PDP and reviews page alike) rather than as one whole set. */
  var stripPaged = feedAll || !!data.stripPaged;
  var source = root.querySelector('[data-ds-reviews-source]');
  var list = root.querySelector('[data-ds-reviews-list]');
  var template = root.querySelector('[data-ds-review-template]');
  var photoTemplate = root.querySelector('[data-ds-reviews-photo-template]');
  var reviewPhotoTemplate = root.querySelector('[data-ds-review-photo-template]');
  var flagSrc = root.getAttribute('data-ds-reviews-flag-src') || '';
  var morePhotoTemplate = root.querySelector('[data-ds-reviews-photo-more-template]');
  var pageTemplate = root.querySelector('[data-ds-reviews-page-template]');
  var ellipsisTemplate = root.querySelector('[data-ds-reviews-ellipsis-template]');
  if (!source || !list || !template) return;
  if (!photoTemplate || !morePhotoTemplate || !pageTemplate || !ellipsisTemplate) return;
  if (!reviewPhotoTemplate) return;

  // Reconcile the summary rail with the source's numbers first — this is
  // independent of the list below, so it also corrects a rating-only product
  // where the source has nothing to render.
  var aggregate = data.aggregate;
  applyAggregate(root, aggregate);
  if (data.rewritesRatingRows && aggregate) {
    applyRatingRows(root, aggregate.dist);
    if (feedAll) applyHubHeader(root, aggregate);
  }

  var all = data.seed;
  // Nothing to render: fall back to Judge.me's own widget and stand down. The
  // source node ships hidden (the Liquid `sf-hidden`, to kill the first-paint
  // flash), so un-hide it here — otherwise a widget the source can't read would
  // leave a blank column instead of Judge.me's working one. A source that can
  // fetch its first reviews another way (Judge.me with an empty metafield) gets
  // one try first.
  if (!all.length) {
    if (data.fillSeed && !root.dataset.dsSeeded) {
      root.dataset.dsSeeded = '1';
      data.fillSeed().then(function (ok) {
        if (ok) mount(root, data);
        else source.classList.remove('sf-hidden');
      });
      return;
    }
    source.classList.remove('sf-hidden');
    return;
  }

  var state = { sort: '', rating: 0, photo: false, variants: [], page: 1, shown: PER_PAGE, complete: false };
  // Every photo on the product, flattened, each remembering the review it came
  // from — the lightbox steps through this rather than through the reviews.
  var strip = [];
  /* Which review each rendered row shows, so a photo inside a review body can
   * find its own review when the strip does not hold that photo (see the
   * lightbox click handler). */
  var reviewOfNode = typeof WeakMap !== 'undefined' ? new WeakMap() : null;

  source.classList.add('sf-hidden');

  /* The CONTIGUOUS prefix from page 1 of the current query. Used by mobile
   * (which appends) and by the photo filter; desktop reads `rowsForPage`
   * directly.
   *
   * Contiguous, not "every page loaded": desktop fetches per click, so the cache
   * can be {1, 5, 6}. Concatenating all three puts page 5's first review at
   * index 6 — mobile's `state.shown` and `appendMore` (next page = length + 1)
   * both count by position, so a sparse cache yields rows in the wrong place and
   * asks for the wrong page. Cutting at the first gap is enough to keep both
   * honest. */
  function loadedRows() {
    syncQuery();
    var out = [];
    for (var n = 1; pages[n]; n += 1) out = out.concat(pages[n]);
    return out;
  }

  /* The set the LOCAL filters run on. Judge.me has no parameter that filters by
   * photo — all of them were probed (`with_pictures`, `has_pictures`,
   * `pictures_only`, `filter_pictures`, `media`, `only_pictures`: `total_count`
   * never moved) — so "which reviews have photos" can only be answered by
   * reading reviews.
   *
   * The source is the reviews `loadStrip` ALREADY fetched, not whichever pages
   * the shopper happened to click through. It costs no extra request and is wide
   * enough to still have a pager. The shop sets
   * `default_sort_method = pictures-first`, so reviews with photos sit in one
   * block at the front — the first 20 are the densest stretch of photos a single
   * request can reach.
   *
   * The remaining limit, stated plainly: a review with photos beyond that block
   * is out of this filter's reach. Reaching it means reading every review, which
   * is sequential pagination. */
  function photoPool() {
    /* The same source as `stripVisible`, and they may not diverge. The old
     * version fell back to `loadedRows()` when `loadStrip` failed while the strip
     * still drew from `all` — so the shopper could click a photo the filter could
     * not reach: forcing `loadStrip` to fail with 7 photo reviews gave a list of
     * 5 rows, NO pager, and "See this review" on the seventh tile silently did
     * nothing. The filter's set must be exactly the strip's, never smaller. */
    return stripRows && stripRows.length ? stripRows : all;
  }

  /* A review's position in an array, matched on Judge.me's `id`, falling back to
   * object identity only when the review carries no id. */
  function indexOfReview(rows, wanted) {
    if (!wanted) return -1;
    if (!wanted.id) return rows.indexOf(wanted);
    for (var i = 0; i < rows.length; i += 1) {
      if (rows[i] === wanted || rows[i].id === wanted.id) return i;
    }
    return -1;
  }

  /* The strip's set with the active filters applied. The underlying request
   * carries no filter parameters, so rating/variant have to be applied
   * locally — the same thing `visible()` does when it runs on this set. */
  function stripVisible() {
    return (stripRows || all).filter(function (review) {
      if (!review.photos.length) return false;
      if (state.rating && review.rating !== state.rating) return false;
      if (state.variants.length && state.variants.indexOf(review.variant || '') === -1) return false;
      return true;
    });
  }

  /* `filters` defaults to the committed `state`. An open filter panel passes
   * a draft read from the form so "Show N reviews" can count a selection that
   * has not been applied yet. */
  function visibleWith(filters) {
    var f = filters || state;
    /* Turning on the photo filter swaps the source: from the list (which the
     * server already filtered by sort/rating) to the strip's set (one request
     * carrying NO filter parameters). So on that swap the rating must be
     * applied LOCALLY — otherwise it vanishes in silence. Filtering those 20
     * is exact, not an approximation. */
    var onPool = f.photo && !data.photoServer;
    if (onPool) return sortPool(photoPool().filter(keep));
    return loadedRows().filter(keep);

    function keep(review) {
      if (f.photo && !review.photos.length) return false;
      if (onPool && f.rating && review.rating !== f.rating) return false;
      if (f.variants.length && f.variants.indexOf(review.variant || '') === -1) return false;
      return true;
    }
  }

  function visible() {
    return visibleWith(state);
  }

  /* Whether "With photos" runs on the strip's set in memory (Judge.me's PDP
   * widget endpoint cannot filter by photo) rather than as a server query (SF
   * and Judge.me's all-reviews feed can) — the source's `photoServer`. */
  function photoLocal(filters) {
    return !!(filters || state).photo && !data.photoServer;
  }

  /* Sort LOCALLY, and only for the strip's set.
   *
   * That set arrives from a request carrying no `sort_by` (deliberately — it is
   * the only way to ask for the shop's pictures-first order), so without a local
   * sort, changing the sort while "With photos" is on is a click that does
   * nothing: the trigger reads "Lowest rating" while the list sits still. The set
   * is 20 reviews already in memory, so sorting it is exact rather than
   * approximate.
   *
   * "Pictures first" keeps the server's order — that IS pictures-first. */
  function sortPool(rows) {
    var parts = String(currentSort() || '').split('|');
    var key = parts[0];
    var dir = parts[1] === 'asc' ? 1 : -1;
    if (!key || key === 'pictures') return rows;
    return rows.slice().sort(function (a, b) {
      if (key === 'rating') return (a.rating - b.rating) * dir;
      if (key === 'helpful') {
        var votes = (a.helpful - b.helpful) * dir;
        if (votes) return votes;
        return Date.parse(b.dateIso || 0) - Date.parse(a.dateIso || 0);
      }
      return (Date.parse(a.dateIso || 0) - Date.parse(b.dateIso || 0)) * dir;
    });
  }

  /* Two breakpoints, read from tokens rather than typed here so the JS moves
   * with the CSS (prototype ReviewsBlock / ReviewFilterPicker):
   *   - the list paginates from tablet-air (820) and appends with Load more
   *     below it — Figma 3445:26357 vs 2787:6734;
   *   - Filter and Sort open as a dropdown from tablet-mini (744) and as a
   *     bottom sheet below it: every tablet gets the desktop picker. */
  function atLeast(token, fallback) {
    var value = getComputedStyle(document.documentElement).getPropertyValue(token).trim();
    var px = parseInt(value, 10) || fallback;
    return window.matchMedia('(min-width: ' + px + 'px)').matches;
  }
  function isDesktop() {
    return atLeast('--breakpoint-tablet-air', 820);
  }
  function panelsDrop() {
    return atLeast('--breakpoint-tablet-mini', 744);
  }

  /* The real list and the skeleton trade places. `aria-busy` goes on the real
   * list rather than the skeleton: the skeleton is aria-hidden, so to a screen
   * reader the thing that is busy IS the list. */
  function setBusy(on) {
    var skeleton = root.querySelector('[data-ds-reviews-skeleton]');
    list.setAttribute('aria-busy', on ? 'true' : 'false');

    /* Lock Sort and Filter while waiting. They run on the loaded set, so using
     * them before the data is in returns an answer that is true-of-what-arrived
     * and then changes itself when the rest lands — measured: the same "With
     * photos" box read "Show 5 reviews" and became "Show 16 reviews" with the
     * shopper touching nothing. Better unusable for a few seconds than an answer
     * that will move. */
    ['filter', 'sort'].forEach(function (key) {
      var trigger = root.querySelector('[data-ds-reviews-toggle="' + key + '"]');
      if (trigger) trigger.disabled = on;
    });

    if (!skeleton) return;
    skeleton.classList.toggle('sf-hidden', !on);
    list.classList.toggle('sf-hidden', on);
  }

  function renderList() {
    var desktop = isDesktop();
    /* Photo mode runs on what is already loaded (photos sit in one block at the
     * front under `pictures_first`), so it slices the flat array. Otherwise
     * desktop reads EXACTLY the matching API page — one page, one request, no
     * accumulation. */
    var totalPages = photoLocal()
      ? Math.max(1, Math.ceil(visible().length / PER_PAGE))
      : pageCount();
    if (state.page > totalPages) state.page = totalPages;
    var slice = desktop
      ? (photoLocal()
          ? visible().slice((state.page - 1) * PER_PAGE, state.page * PER_PAGE)
          : rowsForPage(state.page))
      : visible().slice(0, state.shown);

    list.innerHTML = '';
    slice.forEach(function (review) {
      var node = template.content.firstElementChild.cloneNode(true);
      list.appendChild(fillReview(node, review, reviewPhotoTemplate, flagSrc));
      if (reviewOfNode) reviewOfNode.set(node, review);
    });

    /* "No reviews match" is a CONCLUSION, so it must stay quiet while the list
     * is waiting on the API — there is nothing to conclude yet — and equally
     * quiet when the request just failed: "could not ask" and "asked, and there
     * are none" are two different statements. */
    var empty = root.querySelector('[data-ds-reviews-empty]');
    if (empty) {
      var busy = list.getAttribute('aria-busy') === 'true';
      empty.classList.toggle('sf-hidden', slice.length > 0 || busy || !!failed[state.page]);
    }

    renderPagination(totalPages);

    syncMore();
  }

  /* The mobile "Load more" pill only ever grows the list, so it appends rather
   * than going through renderList's clear-and-rebuild — that would replay the
   * fade-in on every row already on screen, not just the new ones. The new
   * nodes go in with data-ds-review-enter set (review-list.css's opacity 0 /
   * translateY state), then a forced reflow before it is cleared so the
   * browser commits that starting frame first — without it, the add and the
   * remove would coalesce into one paint and the transition would never run.
   * Not requestAnimationFrame: rAF is paused while the tab is backgrounded,
   * which would strand the row invisible until the shopper returns to it. */
  /* Mobile appends. Each press adds exactly one page, which is exactly one
   * request — `per_page=5` matches this button's step, so nothing has to be
   * gathered. */
  function appendMore() {
    var need = state.shown + PER_PAGE;
    var have = visible().length;
    if (have < need && !photoLocal()) {
      var next = Math.floor(state.shown / PER_PAGE) + 1;
      var token = ++ticket;
      setMoreBusy(true);
      return fetchUiPage(next).then(function () {
        setMoreBusy(false);
        if (token !== ticket) return;
        appendSlice();
      });
    }
    return appendSlice();
  }

  function appendSlice() {
    var rows = visible();
    var slice = rows.slice(state.shown, state.shown + PER_PAGE);
    /* Advance by exactly the rows just added. Adding a hard PER_PAGE moves the
     * cursor even on a press that appended nothing, and from then on the button
     * skips real reviews. */
    state.shown += slice.length;

    var added = slice.map(function (review) {
      var node = template.content.firstElementChild.cloneNode(true);
      fillReview(node, review, reviewPhotoTemplate, flagSrc);
      if (reviewOfNode) reviewOfNode.set(node, review);
      node.setAttribute('data-ds-review-enter', '');
      list.appendChild(node);
      return node;
    });

    if (added.length) added[0].offsetHeight; // eslint-disable-line no-unused-expressions
    added.forEach(function (node) { node.removeAttribute('data-ds-review-enter'); });

    syncMore();
  }

  /* The load-more button while the network is out: swap to the spinner variant
   * Liquid already rendered. Both variants are real ds-buttons, so no class is
   * hand-written here, and the busy one carries `sf-pointer-events-none` so a
   * second press cannot get through. */
  function setMoreBusy(on) {
    var idle = root.querySelector('[data-ds-reviews-more-idle]');
    var busy = root.querySelector('[data-ds-reviews-more-busy]');
    if (!idle || !busy) return;

    /* Swapping the button must CARRY FOCUS with it. The button just pressed is
     * the one about to be `display:none`, so without this focus falls to
     * `<body>`: a keyboard shopper's second Enter does nothing and Tab restarts
     * from the top of the page. The old version set `button.disabled = true`, so
     * focus stayed — swapping two nodes means doing that work by hand.
     *
     * Only move focus when it is actually inside this pair; a shopper who
     * pressed and then went elsewhere is left alone. */
    var from = on ? idle : busy;
    var to = on ? busy : idle;
    var carry = from.contains(document.activeElement);

    idle.classList.toggle('sf-hidden', on);
    busy.classList.toggle('sf-hidden', !on);

    if (!carry) return;
    var target = to.querySelector('button');
    if (target && typeof target.focus === 'function') target.focus();
  }

  /* Whether the "Load more" pill stays or goes — one rule shared by `renderList`
   * and `appendSlice`.
   *
   * The yardstick is the query's TOTAL, not the row count in memory. Measured
   * against what is loaded, `state.shown` after the first press always equals
   * exactly the rows just fetched, so the pill hides itself on that first press
   * with 415 reviews still behind it — the reported "load more on mobile
   * disappears after one click".
   *
   * The photo filter is a genuine exception: it runs locally on the strip's set,
   * so that set is the whole of what the filter has. */
  function syncMore() {
    var pill = root.querySelector('[data-ds-reviews-more]');
    if (!pill) return;
    var total;
    if (photoLocal()) {
      total = visible().length;
    } else {
      total = pagesTotal || all.length;
      total = Math.min(total, data.maxReviews);
      /* Once the real bottom is known, use the real bottom rather than the number
       * the server claims. `total_count` can exceed what the endpoint will serve
       * (measured: claims 210, serves 192). Measured only against 210, the pill
       * is still showing at review 192 while the next press lands on a page
       * already loaded — a button that lives forever and adds nothing.
       *
       * The yardstick is the ROWS loaded contiguously, not
       * `lastKnownPage * PER_PAGE`: the bottom page is usually shorter than a
       * full one (the 6-review fixture ends with a page of 1), so multiplying
       * overshoots in exactly the place this is meant to fix. */
      if (lastKnownPage && pages[lastKnownPage]) total = Math.min(total, loadedRows().length);
    }
    /* Hide Load more after a real fail so aggregate pageCount does not imply
     * more pages to fetch. Also hide when the next mobile page already failed
     * and is not cached — pressing again would only re-fail. */
    var nextMobile = Math.floor(state.shown / PER_PAGE) + 1;
    var hideForFail = !!failed[state.page]
      || (!photoLocal() && !!failed[nextMobile] && !pages[nextMobile]);
    pill.classList.toggle('sf-hidden', isDesktop() || state.shown >= total || hideForFail);
  }

  /* Which page numbers to draw. Figma's `1 2 3 … 10` is the first-page case of
   * one rule: the run always shows page 1, the current page with a neighbour
   * either side, and the last page — and near the start that collapses to the
   * first three. Everything else becomes a gap marker. Without this a product
   * with 35 reviews would draw seven buttons, and one with 300 would draw
   * sixty. */
  function pageRun(pages) {
    /* A window of THREE numbers, and it only slides when the shopper clicks the
     * number at its EDGE — the one next to the ellipsis. Clicking the middle
     * number leaves the window where it is, because the next page is already
     * sitting there and no room needs making.
     *
     *   1 2 3 … 86   click 2 (middle) → 1 2 3 … 86   window holds
     *                click 3 (edge)   → 2 3 4 … 86   slides one step
     *                click 4 (edge)   → 3 4 5 … 86
     *
     * Symmetric in both directions: clicking the LEFT edge slides it back, so
     * walking backwards also always leaves a number to click rather than sending
     * the shopper hunting for the Prev arrow.
     *
     * That is why the window carries STATE — `runStart` remembers where it
     * stands instead of being recomputed from `state.page`. Derived purely from
     * the current page, the current page either always leads (sliding on every
     * click, including middle ones) or always centres (never showing an edge).
     * Neither is this.
     *
     * A long jump — straight to the last page, or a filter change that returns to
     * page 1 — makes the window follow rather than crawl there one step at a
     * time. */
    var cur = state.page;
    var maxStart = Math.max(1, pages - 2);
    if (runStart > maxStart) runStart = maxStart;

    if (cur < runStart) runStart = cur;
    else if (cur > runStart + 2) runStart = cur - 2;
    else if (cur === runStart + 2) runStart = cur - 1;
    else if (cur === runStart && cur > 1) runStart = cur - 1;

    runStart = Math.max(1, Math.min(runStart, maxStart));

    var run = [];
    for (var n = runStart; n <= Math.min(runStart + 2, pages); n += 1) run.push(n);
    var last = run[run.length - 1];
    if (last < pages) {
      if (pages - last > 1) run.push(null); // gap marker
      run.push(pages);
    }
    return run;
  }

  /* Every interaction goes through here: fetch the page that is wanted, then
   * draw. A response whose ticket is stale is dropped — on two quick clicks, the
   * first result arriving late would paint over the page the shopper is actually
   * looking at. */
  function show(uiPage) {
    state.page = Math.max(1, uiPage);
    if (photoLocal() || rowsForPage(state.page).length) {
      setBusy(false);
      renderList();
      renderFilterTrigger();
      renderApply();
      return Promise.resolve();
    }
    var token = ++ticket;
    setBusy(true);
    return fetchUiPage(state.page).then(function () {
      if (token !== ticket) return;
      /* An empty page means we went past the bottom. `per_page=5` returns empty
       * in exactly the right place, so `lastKnownPage` already knows — just fall
       * back to it. */
      if (!rowsForPage(state.page).length && lastKnownPage) state.page = Math.min(state.page, lastKnownPage);
      setBusy(false);
      renderList();
      renderFilterTrigger();
      renderApply();
    });
  }

  function renderPagination(pages) {
    var nav = root.querySelector('[data-ds-reviews-pagination]');
    var slot = root.querySelector('[data-ds-reviews-pages]');
    if (!nav || !slot) return;
    /* Hide pager after a real fail so aggregate pageCount does not imply a
     * browsable list. */
    var show = pages >= 2 && isDesktop() && !failed[state.page];
    nav.classList.toggle('sf-hidden', !show);
    nav.classList.toggle('sf-flex', show);
    slot.innerHTML = '';
    if (!show) return;

    pageRun(pages).forEach(function (page) {
      if (page === null) {
        slot.appendChild(ellipsisTemplate.content.firstElementChild.cloneNode(true));
        return;
      }
      var button = pageTemplate.content.firstElementChild.cloneNode(true);
      button.textContent = String(page);
      button.setAttribute('data-page', String(page));
      if (page === state.page) {
        button.setAttribute('aria-current', 'page');
        /* Reviews page: the current page is not a stop for Tab, as in the
         * prototype's Pagination (`disabled` on the active button). */
        if (root.getAttribute('data-ds-reviews-layout') === 'page') button.disabled = true;
      }
      slot.appendChild(button);
    });

    setArrow('[data-ds-reviews-prev]', state.page <= 1);
    setArrow('[data-ds-reviews-next]', state.page >= pages);
  }

  function setArrow(selector, disabled) {
    var control = root.querySelector(selector + ' button, ' + selector + ' a');
    if (control) control.disabled = disabled;
  }

  function renderPhotoStrip() {
    var block = root.querySelector('[data-ds-reviews-photos]');
    var track = root.querySelector('[data-ds-reviews-photos-track]');
    if (!block || !track) return;

    /* The strip MUST follow the active filter. It used to show every photo
     * regardless, so filtering to 1★ and then clicking a 5★ photo was routine —
     * and "See this review" would then hunt for a review outside the filtered
     * set and land on the wrong page. Filtering the strip by the same state is
     * the only fix at the root: whatever the shopper can click is guaranteed to
     * be in the list. */
    var photos = [];
    stripVisible().forEach(function (review) {
      review.photos.forEach(function (photo) {
        photos.push({ src: photo.src, full: photo.full, review: review });
      });
    });
    /* An open lightbox points into the old `strip` by INDEX, so replacing the
     * array under it makes that index meaningless: open tile 13 of the
     * metafield's 15 photos, let `loadStrip` land with 25 in a different order,
     * and Next jumps to an unrelated photo while the counter goes from "13 / 15"
     * to "14 / 25". Re-anchor by `src` — the same photo is the same URL — and
     * only fall back to 0 when the photo on screen is gone from the new set. */
    /* A lightbox walking one review's own photos (`shots`) does not point into
     * the strip, so there is nothing to re-anchor. */
    var pinned = !shots && lightbox && lightbox.getAttribute('aria-hidden') === 'false'
      ? strip[lightboxAt] && strip[lightboxAt].src
      : null;

    strip = photos;

    if (pinned) {
      var found = -1;
      for (var s = 0; s < photos.length; s += 1) {
        if (photos[s].src === pinned) { found = s; break; }
      }
      lightboxAt = found < 0 ? 0 : found;
      /* The counter must state the new total immediately, not wait for an arrow
       * press. */
      var counter = lightbox.querySelector('[data-ds-photo-lightbox-counter]');
      if (counter && photos.length) counter.textContent = stripPosition(lightboxAt) + ' / ' + stripPhotoTotal();
    }

    if (!photos.length) {
      /* Do NOT conclude anything before the answer arrives. A null `stripRows`
       * means `loadStrip` has not returned, and the set under consideration is
       * still the metafield's five reviews — on a product whose first five carry
       * no photos, the whole block would be hidden and then reappear seconds
       * later, shoving the list and everything under it down. That is precisely
       * the jump the placeholders exist to prevent. Keep the block and its
       * placeholders until there is a real answer.
       *
       * Once the answer is in and still empty (filtered to 1★ with no 1★ review
       * carrying photos), then remove it, rather than leaving an empty rail with
       * a badge reading 0. */
      if (!stripSettled) return;
      track.innerHTML = '';
      block.classList.add('sf-hidden');
      block.classList.remove('sf-flex');
      return;
    }
    track.innerHTML = '';

    /* Figma shows ten tiles and folds the remainder into the last one as
     * "+7" — so the strip never grows past ten no matter how many photos the
     * product has collected. The tenth stands for itself plus the hidden ones,
     * which is why the count subtracts nine and not ten. */
    var MAX_TILES = 10;
    /* Before `loadStrip` returns, this set is only the photos of the metafield's
     * reviews — LOADING, not an answer. Say so: measured, the strip drew 7 tiles
     * and quietly became 19, with the count following and nothing in between to
     * signal it.
     *
     * So while waiting, the rest of the row is placeholders placed AFTER the real
     * photos: the first-paint data stays viewable immediately, and the room for
     * what is coming is already reserved — when it lands it replaces in place
     * rather than growing. The "+N" overflow tile waits too: do not print N
     * before N is known. */
    var loading = !stripSettled;
    /* While loading, the LAST tile is always a placeholder, even when ten photos
     * are already in hand.
     *
     * Without this rule, a first strip page that returns ten photos looks
     * finished — ten real photos, no placeholders, badge hidden — and then the
     * second request lands and the tenth tile quietly becomes "+31" while the
     * badge appears. Measured exactly that: three states, the middle one carrying
     * no sign at all that more was on the way.
     *
     * Reserving the last tile makes that slot visibly pending for the whole wait,
     * and when the data lands it becomes either a real photo or the "+N" chip —
     * replaced in place, not grown. */
    var cap = loading ? MAX_TILES - 1 : MAX_TILES;
    var shown = photos.slice(0, cap);
    var photoTotal = stripPhotoTotal();
    /* "+N" is the badge less the nine tiles before it, in the badge's own
     * unit, so the two always read off one number (QC r7). */
    var hidden = photoTotal - (MAX_TILES - 1);
    var overflowing = photoTotal > MAX_TILES;

    shown.forEach(function (photo, index) {
      var overflow = !loading && overflowing && index === MAX_TILES - 1;
      var source = overflow ? morePhotoTemplate : photoTemplate;
      var tile = source.content.firstElementChild.cloneNode(true);
      var img = tile.querySelector('img');
      if (img) {
        img.setAttribute('src', photo.src);
        img.removeAttribute('srcset');
        img.setAttribute('alt', '');
      }
      if (overflow) {
        var badge = tile.querySelector('[data-ds-reviews-photo-more]');
        if (badge) badge.textContent = '+' + hidden;
      }
      tile.setAttribute('data-ds-reviews-photo-index', String(index));
      track.appendChild(tile);
    });

    /* Liquid's placeholder block covers the stretch BEFORE JS runs. From here on
     * the placeholders live inside the track itself, after the real photos, so
     * take one of them as a template before removing the block — the classes stay
     * written in Liquid rather than retyped in JS. */
    var strip_skeleton = root.querySelector('[data-ds-reviews-photos-skeleton]');
    if (strip_skeleton) {
      if (!stripPlaceholder && strip_skeleton.firstElementChild) {
        stripPlaceholder = strip_skeleton.firstElementChild.cloneNode(true);
      }
      strip_skeleton.remove();
    }

    if (loading && stripPlaceholder) {
      for (var g = shown.length; g < MAX_TILES; g += 1) {
        var ghost = stripPlaceholder.cloneNode(true);
        ghost.setAttribute('aria-hidden', 'true');
        ghost.setAttribute('data-ds-reviews-photo-ghost', '');
        track.appendChild(ghost);
      }
    }

    /* The badge counts EXACTLY the photos in the strip — which is also the number
     * the lightbox can page through, so the label and the thing being clicked
     * tell one story. It is NOT the product's total: knowing that would mean
     * reading every review, and Judge.me has no endpoint that counts them.
     * Redrawn whenever the strip changes, so it starts as the metafield's photos
     * and becomes the count of whatever `loadStrip` brought back.
     *
     * ds-badge keeps its copy in a `.label` span beside optional icons — write to
     * that, not to the badge, or the icons go with the text. */
    var badge = root.querySelector('[data-ds-reviews-photos-count]');
    if (badge) {
      var label = badge.querySelector('.label') || badge.querySelector('[data-ds-badge] > span') || badge;
      label.textContent = String(photoTotal);
      /* While loading, show NO number. The first-paint figure counts the
       * metafield's five reviews, not the strip's set — publishing it promises
       * something about to be corrected, and it was measured going from 7 to 19
       * under the shopper's hand. */
      badge.classList.toggle('sf-hidden', loading || strip.length === 0);
    }

    block.classList.remove('sf-hidden');
    block.classList.add('sf-flex');
    syncStripNav();
  }

  /* Arrows only where they do something. A strip of three photos on a desktop
   * column never scrolls, and ds-product-rail already set the precedent: drop
   * the nav rather than leave two dead controls on a row that cannot move. */
  function syncStripNav() {
    var track = root.querySelector('[data-ds-reviews-photos-track]');
    var nav = root.querySelector('[data-ds-reviews-photos] [data-ds-carousel-nav]');
    if (!track || !nav) return;

    var scrolls = track.scrollWidth > track.clientWidth + 1;
    nav.hidden = !scrolls;
    if (!scrolls) return;

    var prev = nav.querySelector('[data-ds-carousel-nav-prev]');
    var next = nav.querySelector('[data-ds-carousel-nav-next]');
    // A fractional column (DPR 2, a 538.5 strip) stops the scroll a pixel or
    // so short of scrollWidth, so a 1px tolerance never reached the end.
    var atStart = track.scrollLeft <= 2;
    var atEnd = Math.ceil(track.scrollLeft + track.clientWidth) >= track.scrollWidth - 2;
    /* Reviews page: both arrows stay live at the ends, as the prototype's
     * strip draws them (QC r7) — a press at an end simply has nowhere to go. */
    var keepLive = root.getAttribute('data-ds-reviews-layout') === 'page';
    if (prev) prev.disabled = keepLive ? false : atStart;
    if (next) next.disabled = keepLive ? false : atEnd;
  }

  /* The two CONTENT checkboxes carry no number.
   *
   * "With photos": Judge.me has no endpoint, no parameter and no aggregate for
   * photos — all 34 operations in their docs were checked, and no path contains
   * media/picture/photo. The only thing close is `has_published_pictures` on
   * `GET /reviews`, and that endpoint needs a private token, so it cannot ship in
   * a theme. The number is therefore only obtainable by reading every review.
   *
   * A bare label works fine; a filter need not announce its result before you
   * use it. */

  /* The VARIANT group only exists when Judge.me actually carried one — it is a
   * custom question the merchant may never have asked, so the Liquid ships the
   * fieldset empty and hidden and this fills it from the parsed set or leaves it
   * out entirely. Cloning the checkbox already in the CONTENT group keeps every
   * class in Liquid, the same rule the photo tiles follow. */
  function renderVariants() {
    var group = root.querySelector('[data-ds-reviews-group="variant"]');
    var slot = root.querySelector('[data-ds-reviews-variants]');
    var sample = root.querySelector('[data-ds-reviews-filter="photo"] [data-ds-checkbox]');
    if (!group || !slot || !sample) return;

    var names = [];
    (stripRows || all).forEach(function (review) {
      if (review.variant && names.indexOf(review.variant) === -1) names.push(review.variant);
    });
    if (!names.length) return;

    slot.innerHTML = '';
    names.forEach(function (name, index) {
      var wrap = document.createElement('span');
      wrap.setAttribute('data-ds-reviews-variant', name);
      var box = sample.cloneNode(true);
      var input = box.querySelector('input');
      var id = root.id + '-variant-' + index;
      if (input) {
        input.id = id;
        input.name = 'ds-reviews-variant';
        /* Keep whatever is already selected. `renderVariants` runs again when
         * `loadStrip` returns, and hard-coding `false` here makes the shopper's
         * tick vanish from the panel while `state.variants` is still filtering —
         * the next interaction reads the DOM back and silently drops that
         * filter. */
        input.checked = state.variants.indexOf(name) !== -1;
        input.removeAttribute('data-ds-checkbox-indeterminate');
      }
      var label = box.querySelector('label');
      if (label) label.setAttribute('for', id);
      var text = box.querySelector('label > span:last-child > span:first-child');
      if (text) text.textContent = name;
      wrap.appendChild(box);
      slot.appendChild(wrap);
    });

    group.classList.remove('sf-hidden');
    group.classList.add('sf-flex');
  }

  /* ── Panels ───────────────────────────────────────────────────────────────
   * A dropdown from md up and a bottom sheet below it, one tree either way.
   * Open/closed is [aria-hidden] alone — src/reviews-panel.css carries the fade
   * and the slide off it, so toggling a display utility here would cut the
   * close animation off (experience.md, "Toggling sf-hidden killed the close
   * animation"). Body scroll is only locked for the sheet: locking it for a
   * desktop dropdown would freeze the page behind a 240px panel.
   */
  function panel(name) {
    return root.querySelector('[data-ds-reviews-panel="' + name + '"]');
  }

  function panelOpen(name) {
    var box = panel(name);
    return !!box && box.getAttribute('aria-hidden') === 'false';
  }

  /* One at a time, expressed as "which panel is open" rather than as a toggle
   * per panel: opening one has to close the other (two dropdowns overlap on a
   * narrow column, two sheets stack), and writing that as setPanel calling
   * itself made opening Sort close Sort — the nested call re-ran the same loop
   * and shut the panel that had just been opened. One writer over both panels
   * cannot have that bug. `name` is null for "none open". */
  function showPanel(name) {
    // Which presentation this panel is in. The breakpoint comes from
    // panelsDrop, which reads the token, so the CSS and the JS cannot disagree
    // about where the sheet becomes a dropdown; src/reviews-panel.css hangs the
    // full-height slide off this attribute rather than off an @media whose 744
    // would have to be typed a second time.
    var sheet = !panelsDrop();

    ['filter', 'sort'].forEach(function (key) {
      var box = panel(key);
      if (!box) return;
      var open = key === name;

      if (sheet) box.setAttribute('data-ds-reviews-sheet', '');
      else box.removeAttribute('data-ds-reviews-sheet');
      var was = box.getAttribute('aria-hidden') === 'false';
      box.setAttribute('aria-hidden', open ? 'false' : 'true');
      // Only the mobile sheet locks the page (page-lock.js); a 240px desktop
      // dropdown that froze the whole document behind it would be a bug, not
      // a modal.
      box.toggleAttribute('data-ds-page-lock', open && sheet);

      var trigger = root.querySelector('[data-ds-reviews-toggle="' + key + '"]');
      if (trigger) trigger.setAttribute('aria-expanded', String(open));

      // Opening moves focus onto the panel's first control — otherwise the
      // trigger reads "expanded" while keyboard/AT focus is still sitting on
      // the trigger itself, one Tab short of the content that just appeared.
      // Closing mirrors it back, but only if focus is still inside the panel
      // being closed — otherwise closing one panel would steal focus from the
      // control the shopper just moved to.
      if (open) {
        /* The first VISIBLE one, not the first in the markup. The panel header
         * carries `md:sf-hidden`, so from md up its close button is display:none
         * — calling `focus()` on it silently does nothing. */
        var fields = box.querySelectorAll(
          'input, select, textarea, button, [href], [tabindex]:not([tabindex="-1"])'
        );
        for (var f = 0; f < fields.length; f++) {
          if (fields[f].offsetParent === null) continue;
          if (typeof fields[f].focus === 'function') fields[f].focus();
          break;
        }
      } else if (was && trigger && typeof trigger.focus === 'function' && box.contains(document.activeElement)) {
        trigger.focus();
      }
    });
  }

  function closePanels() {
    showPanel(null);
  }

  /* The Sort trigger reads the choice back ("Sort: Most Helpful"), which is
   * the whole point of collapsing a select into a button — the value has to stay
   * visible while the panel is shut. */
  function renderSortTrigger() {
    var trigger = root.querySelector('[data-ds-reviews-toggle="sort"]');
    var picked = root.querySelector('[data-ds-reviews-sort-option]:checked');
    if (!trigger || !picked) return;
    var label = picked.closest('label');
    var text = label && label.querySelector('span');
    // ds-button wraps its copy in a <span> beside the optional icons; writing to
    // the control itself would take the chevron out with the text.
    var slot = trigger.querySelector(':scope > span');
    if (!slot || !text) return;
    var pattern = root.getAttribute('data-ds-reviews-sort-pattern') || '%s';

    /* SoT `.wp-rsp__trigger`: muted "Sort:" + medium-weight value. Built from
     * nodes rather than innerHTML — the label comes from the translation file,
     * and a translation file is not a place that should carry markup. */
    var parts = pattern.split('%s');
    var value = document.createElement('span');
    value.className = 'sf-font-medium';
    value.setAttribute('data-ds-reviews-sort-value', '');
    value.textContent = text.textContent.trim();

    slot.textContent = '';
    slot.appendChild(document.createTextNode(parts[0]));
    slot.appendChild(value);
    if (parts[1]) slot.appendChild(document.createTextNode(parts[1]));
  }

  /* The Filter trigger carries the number of reviews the current selection
   * yields, the way Figma 7262:24752 draws it ("Filter (6)"). With nothing
   * selected it is just "Filter". */
  function renderFilterTrigger() {
    var trigger = root.querySelector('[data-ds-reviews-toggle="filter"]');
    if (!trigger) return;
    var slot = trigger.querySelector(':scope > span');
    if (!slot) return;
    if (!trigger.dataset.dsLabel) trigger.dataset.dsLabel = slot.textContent.trim();

    var picked =
      (state.rating ? 1 : 0) + (state.photo ? 1 : 0) + state.variants.length;
    if (!picked) {
      slot.textContent = trigger.dataset.dsLabel;
      return;
    }
    var total = queryTotal();
    if (total === null) {
      slot.textContent = trigger.dataset.dsLabel;
      return;
    }
    var pattern = root.getAttribute('data-ds-reviews-count-pattern') || '%1 (%2)';
    slot.textContent = pattern
      .replace('%1', trigger.dataset.dsLabel)
      .replace('%2', String(total));
  }

  /* How many reviews the current selection will yield — or `null` when that
   * cannot be known.
   *
   * It can be known because each star row already carries its own count
   * (`data-ds-reviews-rating-total`, server-rendered), and that count lives in
   * the same universe as the server's: measured on product 9902457880859
   * (2026-09-17) the histogram says 4 stars = 41, and `filter_rating=4` returns
   * exactly `total_count=41`. `filter_rating` matches EXACTLY rather than "and
   * up", so one lookup settles it — no request.
   *
   * "With photos" and the variant filter have no such cell to
   * read, and knowing them would mean reading every review. Return `null` so the
   * display drops the number. A figure that is true-of-what-loaded is a figure
   * that will change under the shopper's hand, which is worse than none. */
  function queryTotal(filters) {
    var f = filters || state;
    /* The photo and variant filters run LOCALLY, so the server's `total_count`
     * says nothing about them. But a number does exist: the button reads "Show N
     * reviews", and the N it promises is the row count the filter will put on
     * screen — `visible().length`. Not an approximation of "how many reviews on
     * this product carry photos"; that is a different question and Judge.me
     * cannot answer it.
     *
     * The condition is that the set must be STILL, or the number moves under the
     * shopper's hand. For the photo filter the set is only still once `loadStrip`
     * has FULLY finished — it may take up to two requests, see
     * `STRIP_MAX_PAGES`. Until then, no number. */
    if (f.photo && !data.photoServer) {
      /* Gate on `stripSettled`, NOT on `stripRows`: `loadStrip` assigns
       * `stripRows` right after the first page and then fetches a second, so
       * treating `stripRows` as "done" publishes a number that is still growing —
       * ticking "With photos" in that window takes the button from "Show 20
       * reviews" to "Show 23 reviews" with the shopper touching nothing. Exactly
       * what this gate exists to prevent. */
      if (!stripSettled) return null;
      /* Settled with no photos means the answer is 0, not "unknown" — `visible()`
       * returns [] and that 0 goes straight to the button. */
      return visibleWith(f).length;
    }
    /* The variant filter yields NO number. Its set is `loadedRows()`, and that
     * set grows every time the shopper turns a page — the button would walk from
     * "Show 2 reviews" to "Show 9 reviews" with nobody touching it. The same
     * instability the branch above rejects, so reject it identically. The photo
     * branch can produce a number because its set is `stripRows`, a finished
     * fetch that does not grow; variants have no equivalent, and Judge.me has no
     * parameter that filters by variant either. */
    if (f.variants.length) return null;
    /* Once this query has made a request, the server has stated its total. That
     * is the real number for every sort/rating combination, including the ones
     * no table lookup can answer. It only appears after the data lands, and
     * once landed it does not move.
     *
     * Only trust the committed query's total when the draft matches what was
     * fetched — otherwise a mobile draft rating would still show the previous
     * query's count. */
    if (pagesTotalFromServer && filtersMatchState(f)) return pagesTotal;
    /* `peekDraftTotal` caches the server's `total_count` for a draft so the
     * button can say "Show N reviews" the first time a box is ticked — not
     * only after the list has already been filtered once. `0` is an answer. */
    /* The star rows' counts come from the header histogram, which on the
     * all-reviews feed includes store reviews the list never shows (QC r4: 3★
     * read "Show 524", the list held 506). So there a star draft is counted by
     * the server too. */
    if (data.countsByRequest(f)) {
      var peeked = draftTotals[queryKey(f)];
      return typeof peeked === 'number' ? peeked : null;
    }
    if (f.rating) return ratingTotal(f.rating);
    return aggregate && typeof aggregate.count === 'number' ? aggregate.count : null;
  }

  function filtersMatchState(f) {
    if (f.rating !== state.rating) return false;
    if (f.photo !== state.photo) return false;
    if (f.variants.length !== state.variants.length) return false;
    for (var i = 0; i < f.variants.length; i++) {
      if (state.variants.indexOf(f.variants[i]) === -1) return false;
    }
    return true;
  }

  /* The sheet's primary action counts what the shopper is about to see, so the
   * number has to move with every tick rather than only on open. While the
   * filter panel is open the ticks are a draft — count from the form, do not
   * apply yet. */
  function renderApply() {
    var button = root.querySelector('[data-ds-reviews-apply]');
    if (!button) return;
    var slot = button.querySelector(':scope > span') || button;
    var draft = panelOpen('filter') ? readFilterDraft() : null;
    var total = queryTotal(draft);
    /* Reviews page: Clear is inert while the draft picks nothing (prototype
     * `.wp-rfp__clear:disabled`). */
    var clear = root.getAttribute('data-ds-reviews-layout') === 'page' && root.querySelector('[data-ds-reviews-clear]');
    if (clear) {
      var d = draft || state;
      clear.disabled = !(d.rating || d.photo || d.variants.length);
    }
    /* A draft the table cannot answer has no number until its count request
     * lands. Ask now; the reply calls back into here. Photo and variant stay numberless
     * on purpose — their sets are not a Judge.me `total_count`. */
    var serverCounts = draft && !draft.variants.length && data.countsByRequest(draft);
    if (total === null && serverCounts) {
      peekDraftTotal(draft);
    }
    if (total === null) {
      slot.textContent = root.getAttribute('data-ds-reviews-apply-plain') || button.textContent;
      return;
    }
    // "Show 1 review", not "Show 1 reviews": the singular is its own translated pattern.
    var pattern = (total === 1 && root.getAttribute('data-ds-reviews-apply-pattern-one')) ||
      root.getAttribute('data-ds-reviews-apply-pattern') || '%s';
    slot.textContent = pattern.replace('%s', String(total));
  }

  /* ── Data: one UI page = one API page ────────────────────────────────────
   *
   * `per_page=5` is the number Judge.me's own widget uses, and it paginates
   * CORRECTLY: measured on a 420-review product, pages 1→84 each returned five
   * distinct reviews and page 85 came back empty — matching `total_count`
   * exactly.
   *
   * Asking for a large `per_page` does the opposite: the windows overlap. On the
   * same product, 20 pages at `per_page=100` returned 567 raw reviews but only
   * 277 distinct ones, and never an empty page to signal the end. The whole
   * earlier "gather the set" architecture was built on that broken mode, which is
   * why the pager read 56 pages instead of 84.
   *
   * Since the UI also shows five per page, the two line up: UI page N is API page
   * N — one request, no accumulation, no offset arithmetic, no de-duplication. */
  var pages = {};
  var stripRows = null;
  /* One placeholder sampled from Liquid's skeleton block, kept so it can be
   * cloned. */
  var stripPlaceholder = null;
  /* Whether `loadStrip` has an answer yet — including when the answer is
   * "failed".
   *
   * Do not use `!stripRows` as the loading flag: it merges "not back yet" with
   * "came back and failed", so a failed request leaves a row of placeholders
   * pulsing forever and a badge that never states a number. Failure is also an
   * ending, just one with less data. */
  var stripSettled = false;
  var pagesQuery = '';
  var pagesTotalFromServer = false;
  /* `total_count` for a draft, keyed like `currentQuery`. The list
   * stays on the committed query; this map only fills the Show N label. */
  var draftTotals = {};
  var draftInflight = {};
  var pagesTotal = aggregate && aggregate.count ? aggregate.count : all.length;
  var lastKnownPage = 0;
  /* Where the pager's window currently stands — see `pageRun`. */
  var runStart = 1;
  var inflight = {};
  /* Which pages just failed (network error / non-OK response). Used to tell
   * "nothing yet" apart from "asked, and there are no reviews" — those say two
   * different things to the shopper. */
  var failed = {};
  var ticket = 0;

  /* The strip's set comes from the source's `strip`: Judge.me pages 20 reviews
   * at a time in its pictures-first default order; SF answers with every photo
   * review in one request (`/sf/media`) and has no page 2.
   *
   * The number of strip pages we may request, page 1 included. Two, no more:
   * enough to cover the photo block on every product in this store (the longest
   * measured is 23, and two pages cover 40) while staying a FIXED number — not
   * "ask until empty", which on another product could become hundreds of
   * requests. */
  var STRIP_MAX_PAGES = 2;

  /* Paged strip (the all-reviews feed, and a PDP whose source pages it — SF). The strip asks for page 1 of the photo reviews that
   * match the active star filter and takes the TOTAL from the
   * response — the strip draws ten tiles at most ("+N" on the last), so one
   * page fills it and the count is what the shopper needs. Further pages are
   * fetched only by the lightbox, when the shopper steps toward the end of what
   * is loaded (`loadMoreStrip`). The PDP keeps its two-page pictures-first
   * read below: its endpoint has no photo filter and no photo count. */
  var stripTotal = null;
  /* PDP on a source that pages the strip (SF): every photo of the product under the active star filter. The header
   * and the "+N" tile count photos while only a page or two of them is loaded. Null = unknown, count what is loaded. */
  var stripPhotoCount = null;
  var stripPagesLoaded = 0;
  /* Reviews the paged strip has received, photo or not: what `stripTotal` counts. Strip rows keep photo reviews only,
   * so a video-only review still moves paging forward. */
  var stripSeen = 0;
  var stripKey = '';
  var stripToken = 0;
  var stripMore = null;

  /* Never empty: `stripKey` doubles as "the strip has been loaded", and '' reads as "not yet". */
  function stripFilterKey() {
    return 'r' + (state.rating || 0);
  }

  /* The filters a server-filtered strip (the all-reviews feed) is asked with. */
  function stripQuery() {
    return { rating: state.rating };
  }

  function loadStripAll() {
    var token = ++stripToken;
    stripKey = stripFilterKey();
    stripRows = null;
    stripTotal = null;
    stripPhotoCount = null;
    stripPagesLoaded = 0;
    stripSeen = 0;
    stripMore = null;
    stripSettled = false;
    renderPhotoStrip();
    return data.strip(1, stripQuery()).then(function (res) {
      if (token !== stripToken) return;
      stripSettled = true;
      if (res) {
        var rows = res.rows;
        var t = res.total;
        stripTotal = isNaN(t) ? rows.length : Math.max(t, rows.length);
        stripPhotoCount = typeof res.photos === 'number' ? res.photos : null;
        stripRows = rows;
        stripPagesLoaded = 1;
        stripSeen = stripGot(res);
        renderVariants();
      }
      renderPhotoStrip();
      renderFilterTrigger();
      renderApply();
      // Page 1 held only video reviews: the strip has nothing to draw, so walk on to the first photo.
      if (res && !res.rows.length && stripHasMore()) loadMoreStrip();
    });
  }

  /* Reviews a strip page carried; a source that does not say (Judge.me) is counted by its rows. */
  function stripGot(res) {
    return typeof res.got === 'number' ? res.got : res.rows.length;
  }

  function stripHasMore() {
    return stripPaged && stripSettled && !!stripRows && stripTotal !== null &&
      Math.max(stripSeen, stripRows.length) < Math.min(stripTotal, data.maxReviews);
  }

  /* The next page of photo reviews, for the lightbox. One request at a time.
   * A source that states how many reviews a page carried (SF, true server
   * paging): a page with no review ends the set, one with only video reviews
   * (no photo row) moves straight on to the next. Any other source (Judge.me,
   * whose capped feed repeats pages): a page that brings nothing new ends it. */
  function loadMoreStrip() {
    if (!stripHasMore()) return Promise.resolve();
    if (stripMore) return stripMore;
    var token = stripToken;
    stripMore = data.strip(stripPagesLoaded + 1, stripQuery()).then(function (res) {
      stripMore = null;
      if (token !== stripToken || !res) return;
      var seen = {};
      stripRows.forEach(function (r) { if (r.id) seen[r.id] = true; });
      var fresh = res.rows.filter(function (r) { return !r.id || !seen[r.id]; });
      var counted = typeof res.got === 'number';
      var got = stripGot(res);
      stripPagesLoaded += 1;
      stripSeen += got;
      if (!fresh.length && (!counted || !got)) stripTotal = Math.max(stripSeen, stripRows.length);
      else if (fresh.length) stripRows = stripRows.concat(fresh);
      renderPhotoStrip();
      if (counted && got && !fresh.length && stripHasMore()) return loadMoreStrip();
    });
    return stripMore;
  }

  /* What the strip counts. The badge, the "+N" tile and the lightbox counter
   * all read these two functions, so they tell one story, as on the PDP.
   *
   * On the all-reviews feed the unit is the REVIEW with photos, not the photo.
   * The one number Judge.me states up front is how many reviews carry photos
   * (`number_of_product_reviews` under `sort_by=with_pictures`); the number of
   * photos is only known after reading every page — 50 requests for the
   * 1000 reviews the feed will serve. A photo count built from "loaded photos +
   * one per review still to come" moved as pages landed (QC r6: 1001 → 1003),
   * so the strip counts reviews instead: fixed from the first response, capped
   * at the source's `maxReviews` like everything the feed serves. Elsewhere (PDP): photos
   * loaded, as before. */
  function stripCountsReviews() {
    return feedAll && stripTotal !== null && !!stripRows;
  }

  function stripPhotoTotal() {
    if (stripCountsReviews()) return Math.min(stripTotal, data.maxReviews);
    /* A paged PDP strip loads ten reviews at a time, so what is loaded undercounts — the source states the real
     * number of photos. */
    if (stripPhotoCount !== null) return Math.max(stripPhotoCount, strip.length);
    return strip.length;
  }

  /* 1-based position of photo `index` in that unit: on the all-reviews feed,
   * the position of its review among the strip's reviews (every photo of one
   * review shares it); elsewhere the photo's own position. */
  function stripPosition(index) {
    if (!stripCountsReviews()) return index + 1;
    var seen = {};
    var n = 0;
    for (var i = 0; i <= index && i < strip.length; i += 1) {
      var r = strip[i].review || {};
      var key = r.id || ('#' + i);
      if (!seen[key]) { seen[key] = true; n += 1; }
    }
    return Math.max(1, n);
  }

  /* Strip page N's reviews, or null when the request failed. */
  function fetchStripPage(n) {
    if (!data.hasTarget) return Promise.resolve(null);
    return data.strip(n, stripQuery()).then(function (res) {
      return res ? res.rows : null;
    });
  }

  function loadStrip() {
    if (stripPaged && data.hasTarget) return loadStripAll();
    if (!data.hasTarget) {
      stripSettled = true;
      return Promise.resolve();
    }

    /* Ask for another page ONLY when the last one was all photo reviews — that is
     * evidence the photo block runs longer than what just arrived, not a guess.
     * The shop sets `default_sort_method = pictures-first`, so reviews with
     * photos sit in one block at the front (measured on three products: blocks of
     * 23 / 4 / 1), which makes "this page is all photos" mean the block's bottom
     * has not been reached.
     *
     * A page SHORTER than 20 is also the end, so stop. And the page count is
     * capped at `STRIP_MAX_PAGES`, making the worst case two requests, known in
     * advance. On a product with more than 40 photo reviews the filter still
     * cannot reach the tail — reaching it means reading every review, which is
     * sequential pagination. */
    function step(n, gathered) {
      return fetchStripPage(n).then(function (rows) {
        if (rows === null) return gathered;
        var merged = gathered.concat(rows);
        var everyHasPhoto = rows.length > 0 && rows.every(function (r) { return r.photos.length > 0; });
        if (n < STRIP_MAX_PAGES && rows.length === 20 && everyHasPhoto) {
          /* Draw what is already in hand before asking for more: the shopper sees
           * photos immediately, and the rest lands in the slots the placeholders
           * are holding. */
          stripRows = merged;
          renderPhotoStrip();
          return step(n + 1, merged);
        }
        return merged;
      });
    }

    return step(1, []).then(function (rows) {
      stripSettled = true;
      if (rows && rows.length) {
        stripRows = rows;
        renderVariants();
      }
      /* With nothing received, the strip keeps the metafield reviews' photos —
       * fewer, but real photos, which beats a row of empty boxes. */
      renderPhotoStrip();
      /* And redraw the two places that carry a NUMBER. The photo filter's count
       * is withheld until `stripSettled`, so if the shopper ticked "With photos"
       * during the wait, this is the only moment the button gets to learn the
       * answer — without this call it sits at "Show reviews" until the next
       * interaction. */
      renderFilterTrigger();
      renderApply();
    });
  }

  function queryKey(filters) {
    var f = filters || state;
    return currentSort() + '|' + (f.rating || '') + '|' + (data.photoServer && f.photo ? 'p' : '');
  }

  function currentQuery() {
    return queryKey(state);
  }


  /* What the source is asked for: the sort plus the filters it can apply
   * (`filters` defaults to the committed `state`). */
  function queryOf(filters) {
    var f = filters || state;
    return { sort: currentSort(), rating: f.rating, photo: f.photo };
  }

  /* Ask the source how many reviews a draft will show, without changing the
   * list. The result is cached, including 0. A failed request does not call
   * back into `renderApply`, or a null total would ask again forever. */
  function peekDraftTotal(filters) {
    var key = queryKey(filters);
    if (typeof draftTotals[key] === 'number' || draftInflight[key]) return;
    if (!data.hasTarget) return;
    draftInflight[key] = true;
    data.count(queryOf(filters)).then(function (t) {
      delete draftInflight[key];
      if (t === null) return;
      draftTotals[key] = t;
      renderApply();
    }, function () {
      delete draftInflight[key];
    });
  }

  /* Changing the query changes the whole set. Drop the old query's loaded pages
   * rather than keeping a cache per sort/rating combination — returning
   * to an earlier choice costs exactly one request, which is not worth holding
   * memory for. */
  function syncQuery() {
    var q = currentQuery();
    if (q === pagesQuery) return;
    pagesQuery = q;
    pages = {};
    inflight = {};
    failed = {};
    lastKnownPage = 0;
    pagesTotalFromServer = false;
    /* The new query's total — do NOT reset it to 0. At 0, `pageCount` falls back
     * to `all.length`, which is the metafield's five reviews, which is one page,
     * which means the pager disappears; that was the "change sort, come back to
     * Most helpful, lose pagination" bug, because the default query does not
     * fetch and so nothing rebuilt it.
     *
     * And read only sources that do NOT depend on the cache — the cache was
     * cleared a few lines above. `queryTotal()` is unusable here: it has branches
     * that return `visible().length`, and `visible()` reads `loadedRows()`, which
     * reads the very `pages` object just emptied → 0 → the pager disappears
     * again, only triggered by a variant instead of a sort.
     *
     * Rating has its count sitting on the star row already (server-rendered).
     * Everything else takes the whole set's total as the mark, and the first
     * request's `total_count` corrects it. */
    var rated = ratingTotal();
    pagesTotal = rated === null ? (aggregate && aggregate.count) || all.length : rated;
    /* A count the server already gave for this exact query (a draft's "Show
     * N") beats the histogram where the source says so — SF, and Judge.me's
     * all-reviews feed, whose histogram includes store reviews. */
    if (data.trustDraftTotals && typeof draftTotals[q] === 'number') pagesTotal = draftTotals[q];
  }

  /* How many reviews sit at the selected star level, read from the
   * server-rendered attribute.
   *
   * `null` means UNKNOWN (no star selected, or the attribute could not be read).
   * `0` is an answer, not a blank — and it has to be returnable: a `0` folded
   * into `null` makes the button read "Show reviews" for a star level whose
   * correct answer is "Show 0 reviews", while `pagesTotal` jumps to the whole
   * product's total and draws a pager for an empty query. Measured on product
   * 9902474002715: 9 reviews, with 4 of the 5 star levels at zero. */
  function ratingTotal(rating) {
    var stars = rating == null ? state.rating : rating;
    if (!stars) return null;
    var row = root.querySelector('[data-ds-reviews-rating-row="' + stars + '"]');
    var raw = row && row.getAttribute('data-ds-reviews-rating-total');
    if (raw == null || raw === '') return null;
    var n = parseInt(raw, 10);
    return isNaN(n) ? null : n;
  }

  function fetchUiPage(n) {
    syncQuery();
    if (pages[n]) return Promise.resolve(pages[n]);
    if (inflight[n]) return inflight[n];
    /* No product/shop attrs → nothing to ask. Do not retry an empty URL. */
    if (!data.hasTarget) return Promise.resolve([]);
    var q = pagesQuery;

    function accept(res) {
      delete failed[n];
      var rows = res.rows;
      pages[n] = rows;
      /* `!isNaN` rather than truthiness: `total_count: 0` is the server ANSWERING
       * that this query is empty, not the server staying silent. Discard it and
       * `pagesTotalFromServer` never turns on, `pagesTotal` keeps the guess made
       * before asking, the Load more pill measures against the wrong mark and
       * the chip loses its number. */
      var t = res.total;
      if (!isNaN(t)) {
        pagesTotal = t;
        pagesTotalFromServer = true;
        renderFilterTrigger();
        renderApply();
      }
      /* The REAL bottom, measured by what the server returns rather than what it
       * claims.
       *
       * An empty page is the bottom: `per_page=5` returns empty in exactly the
       * right place (measured: page 85 of a 420-review product), unlike a large
       * `per_page`, which keeps returning rows forever.
       *
       * A SHORT page is also the bottom, and has to count — otherwise a product
       * whose `total_count` exceeds what it serves (measured: claims 210, serves
       * 192) stops on a page of 2 rows with `lastKnownPage` still 0, because
       * nobody ever asks for the empty page behind it. `per_page=5` returns
       * exactly 5 for every page that has data (measured pages 1→84), so fewer
       * than 5 means the end. */
      var got = res.got;
      if (!got) lastKnownPage = Math.max(1, n - 1);
      else if (got < PER_PAGE) lastKnownPage = n;
      delete inflight[n];
      return rows;
    }

    function giveUp() {
      /* `inflight[n]` must be cleared: keeping a promise already resolved to []
       * means every later click on that page resolves empty instantly, leaving
       * the page dead until the shopper changes sort/rating or reloads.
       * And do NOT write `pages[n]` — a 503 / network blip is not "this page has
       * no reviews". */
      delete inflight[n];
      if (q === pagesQuery) failed[n] = true;
      return [];
    }

    /* One promise covers every attempt (see RETRY_DELAYS), so concurrent callers
     * still share a single `inflight[n]`. Busy/skeleton stay up across the
     * retries — `show` awaits this promise and only clears them when it settles. */
    var req = data.page(n, queryOf()).then(function (res) {
      /* The query changed: this result is meaningless, and `syncQuery` already
       * replaced `inflight` with a fresh object, so there is nothing to clean
       * up. */
      if (q !== pagesQuery) return [];
      return res ? accept(res) : giveUp();
    });

    inflight[n] = req;
    return req;
  }

  /* Page N's reviews, or empty if it has not been fetched. There is NO exception
   * for page 1: the metafield is Judge.me's widget rendered in the shop's default
   * order, while the list asks in the selected sort — taking page 1 from one and
   * pages 2+ from the other stitches two different orderings together, measured
   * as 30 rendered rows holding only 23 distinct reviews. */
  function rowsForPage(n) {
    syncQuery();
    return pages[n] || [];
  }

  function pageCount() {
    var reach = pagesTotal || all.length;
    reach = Math.min(reach, data.maxReviews);
    var n = Math.max(1, Math.ceil(reach / PER_PAGE));
    if (lastKnownPage) n = Math.min(n, lastKnownPage);
    return n;
  }

  // The sort radios already carry their machine values (pairSortValues, setup).
  function currentSort() {
    var picked = root.querySelector('[data-ds-reviews-sort-option]:checked');
    return picked ? picked.value : '';
  }

  /* Read the filter form without committing. Ticks stay a draft until
   * "Show N reviews" on every breakpoint. */
  function readFilterDraft() {
    var rating = root.querySelector('[name="ds-reviews-rating"]:checked');
    var photo = root.querySelector('[data-ds-reviews-filter="photo"] input');
    var variants = [];
    root.querySelectorAll('[data-ds-reviews-variant] input:checked').forEach(function (input) {
      var wrap = input.closest('[data-ds-reviews-variant]');
      if (wrap) variants.push(wrap.getAttribute('data-ds-reviews-variant'));
    });
    return {
      rating: rating ? parseInt(rating.value, 10) || 0 : 0,
      photo: !!(photo && photo.checked),
      variants: variants,
    };
  }

  /* Put the committed filters back on the form — discard a draft when the
   * panel closes without Show N reviews. */
  function writeFilterDraft(filters) {
    root.querySelectorAll('[name="ds-reviews-rating"]').forEach(function (input) {
      input.checked = !!filters.rating && String(filters.rating) === String(input.value);
    });
    var photo = root.querySelector('[data-ds-reviews-filter="photo"] input');
    if (photo) photo.checked = !!filters.photo;
    root.querySelectorAll('[data-ds-reviews-variant]').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      var name = wrap.getAttribute('data-ds-reviews-variant');
      if (input) input.checked = filters.variants.indexOf(name) !== -1;
    });
  }

  /* Every control in both panels reports through here: read the DOM back into
   * `state`, re-sort, and repaint. Reading the inputs rather than tracking each
   * one's own toggle means "Clear all" only has to reset the form controls. */
  function syncFromPanels() {
    var draft = readFilterDraft();
    state.rating = draft.rating;
    state.photo = draft.photo;
    state.variants = draft.variants;

    state.shown = PER_PAGE;
    renderSortTrigger();
    // The strip must follow the filter, or the shopper can click a photo that is
    // not in the list and "See this review" lands on the wrong page. On the
    // all-reviews feed it follows by asking the server again.
    if (stripPaged && stripKey && stripFilterKey() !== stripKey) loadStripAll();
    else renderPhotoStrip();
    renderStarFilter();
    // A new query starts at its own page 1; `show` fetches exactly that page.
    return show(1);
  }

  /* ── Reviews page: header star rows + the active-star chip ──────────────
   * ds-reviews-hub-header draws the distribution OUTSIDE this band (above the
   * summary band), each row a button naming this band in
   * `data-ds-reviews-for`. A press sets the same rating filter the Filter
   * panel's Rating group sets — pressing the active row again clears it — so
   * the two controls can never disagree: both write the form, both commit
   * through `syncFromPanels`. */
  var starRows = root.id
    ? document.querySelectorAll('[data-ds-reviews-star][data-ds-reviews-for="' + root.id + '"]')
    : [];
  var starChip = root.querySelector('[data-ds-reviews-star-chip]');

  function setStarFilter(stars) {
    writeFilterDraft({
      rating: stars,
      photo: state.photo,
      variants: state.variants.slice(),
    });
    syncFromPanels();
  }

  /* Mirror the committed rating onto the header rows (`aria-pressed`) and the
   * chip under the controls ("5 stars ×", prototype `.wp-reviews__star-chip`).
   * The chip's wording comes from Liquid as a pattern, like the sort trigger's. */
  function renderStarFilter() {
    starRows.forEach(function (row) {
      var on = String(state.rating) === row.getAttribute('data-ds-reviews-star');
      row.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    if (!starChip) return;
    starChip.classList.toggle('sf-hidden', !state.rating);
    if (!state.rating) return;
    var label = state.rating === 1
      ? root.getAttribute('data-ds-reviews-star-chip-one') || '1 star'
      : (root.getAttribute('data-ds-reviews-star-chip-pattern') || '%s stars').replace('%s', state.rating);
    var button = starChip.querySelector('[data-ds-chip]');
    var text = button && button.querySelector('span > span');
    if (text) text.textContent = label;
    if (button) {
      button.setAttribute('aria-label', (root.getAttribute('data-ds-reviews-star-chip-remove') || '%s').replace('%s', label));
    }
  }

  starRows.forEach(function (row) {
    row.addEventListener('click', function () {
      var stars = parseInt(row.getAttribute('data-ds-reviews-star'), 10) || 0;
      setStarFilter(state.rating === stars ? 0 : stars);
    });
  });
  if (starChip) {
    starChip.addEventListener('click', function (event) {
      if (!event.target.closest('[data-ds-chip]')) return;
      setStarFilter(0);
    });
  }

  /* Filter sheet: discard an un-applied draft before closing. Sort commits on
   * change, so there is nothing to restore for it. */
  function dismissFilterDraft() {
    if (!panelOpen('filter')) return;
    writeFilterDraft({
      rating: state.rating,
      photo: state.photo,
      variants: state.variants.slice(),
    });
  }

  function closeFilterOrPanels() {
    dismissFilterDraft();
    closePanels();
  }

  root.addEventListener('change', function (event) {
    if (!event.target.closest('[data-ds-reviews-panel]')) return;
    // Sort always commits immediately — one choice, then close.
    if (event.target.hasAttribute('data-ds-reviews-sort-option')) {
      syncFromPanels();
      closePanels();
      return;
    }
    // Filter ticks are a draft. Show N reviews is what commits them, on every
    // breakpoint — a tick must not change the list underneath the open panel.
    if (event.target.closest('[data-ds-reviews-panel="filter"]')) {
      renderApply();
      return;
    }
    syncFromPanels();
  });

  root.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-ds-reviews-toggle]');
    if (toggle) {
      event.preventDefault();
      var name = toggle.getAttribute('data-ds-reviews-toggle');
      if (panelOpen(name)) {
        if (name === 'filter') dismissFilterDraft();
        showPanel(null);
      } else {
        // Opening filter: form must mirror committed state (a prior discard or
        // desktop edit could leave inputs ahead of state).
        if (name === 'filter') {
          writeFilterDraft({
            rating: state.rating,
            photo: state.photo,
            variants: state.variants.slice(),
          });
        }
        showPanel(name);
        renderApply();
      }
      return;
    }

    // "Show N reviews" commits the draft, then closes.
    var apply = event.target.closest('[data-ds-reviews-apply]');
    if (apply) {
      event.preventDefault();
      syncFromPanels();
      closePanels();
      return;
    }

    var dismiss = event.target.closest('[data-ds-reviews-panel-close]');
    if (dismiss) {
      event.preventDefault();
      closeFilterOrPanels();
      return;
    }

    var clear = event.target.closest('[data-ds-reviews-clear]');
    if (clear) {
      event.preventDefault();
      root.querySelectorAll('[data-ds-reviews-panel="filter"] input').forEach(function (input) {
        input.checked = false;
      });
      // Clear only resets the draft. Show N reviews is what changes the list.
      renderApply();
      return;
    }

    // Clicking the overlay of the mobile sheet, or anywhere outside an open
    // desktop dropdown, closes it. Inside the card, nothing.
    if (!event.target.closest('[data-ds-reviews-panel-card]')) closeFilterOrPanels();

    var more = event.target.closest('[data-ds-reviews-more]');
    if (more) {
      event.preventDefault();
      appendMore();
      return;
    }

    var page = event.target.closest('[data-ds-reviews-page]');
    if (page) {
      event.preventDefault();
      show(parseInt(page.getAttribute('data-page'), 10) || 1);
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }

    var pager = event.target.closest('[data-ds-reviews-prev], [data-ds-reviews-next]');
    if (pager) {
      event.preventDefault();
      var step = pager.hasAttribute('data-ds-reviews-next') ? 1 : -1;
      show(state.page + step);
      return;
    }

    var arrow = event.target.closest('[data-ds-carousel-nav-prev], [data-ds-carousel-nav-next]');
    if (arrow) {
      var track = root.querySelector('[data-ds-reviews-photos-track]');
      if (track) {
        var step = track.clientWidth * 0.8;
        track.scrollBy({ left: arrow.hasAttribute('data-ds-carousel-nav-next') ? step : -step, behavior: 'smooth' });
      }
    }
  });

  /* A dropdown has to close on a click anywhere else on the page, not just
   * elsewhere in the band — the handler above only sees clicks inside `root`. */
  document.addEventListener('click', function (event) {
    if (!panelOpen('filter') && !panelOpen('sort')) return;
    if (root.contains(event.target)) return;
    closeFilterOrPanels();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    if (!panelOpen('filter') && !panelOpen('sort')) return;
    closeFilterOrPanels();
  });

  /* The write-a-review button is NOT wired here. It used to open Judge.me's own
   * form, because posting a review looked like it needed a token. It does not:
   * behaviors/review-form.js posts straight to their public endpoint, and owns
   * every [data-ds-reviews-write] control on the page. */


  /* ── Lightbox ─────────────────────────────────────────────────────────────
   * Opened from any photo tile — the strip's or one inside a review body. It
   * walks the flat `strip`, not the reviews, so "next" moves to the next photo
   * on the product the way the Figma frame's "2 / 14" implies, even when that
   * crosses into another review.
   */

  var lightbox = document.querySelector('[data-ds-photo-lightbox]');
  var lightboxAt = 0;
  /* The set the lightbox walks. Null = the strip, which is what a strip tile
   * and any body photo the strip holds open into. A body photo the strip does
   * NOT hold — the strip is one capped request (40 photo reviews on the
   * reviews page, two pages of 20 on a PDP), while the list pages through all
   * of them — opens into its own review's photos instead. Falling back to the
   * strip's first photo showed another reviewer and another product (QC r1). */
  var shots = null;
  function lightboxSet() {
    return shots || strip;
  }
  var lightboxOpener = null;

  function lightboxShow(index) {
    var set = lightboxSet();
    if (!lightbox || !set.length) return;
    lightboxAt = (index + set.length) % set.length;
    var shot = set[lightboxAt];
    var review = shot.review || {};

    var img = lightbox.querySelector('[data-ds-photo-lightbox-image]');
    if (img) img.src = shot.full || shot.src;

    var author = lightbox.querySelector('[data-ds-photo-lightbox-author]');
    if (author) author.textContent = review.author || '';

    /* Same flag as the review list. The lightbox is one node reused for every
     * photo, so a missing flag is hidden rather than removed, and it is put
     * back on the credentials line before each paint. "Verified Buyer" is
     * shown for every review (SF0341), so that line is never empty. */
    var credentials = lightbox.querySelector('[data-ds-photo-lightbox-credentials]');
    var flag = lightbox.querySelector('[data-ds-photo-lightbox-flag]');
    var verified = lightbox.querySelector('[data-ds-photo-lightbox-verified]');
    if (verified) verified.classList.remove('sf-hidden');
    if (credentials) credentials.classList.remove('sf-hidden');
    if (flag && credentials && verified) credentials.insertBefore(flag, verified);
    if (flag) {
      var flagImg = countryFlagImage(review, flagSrc);
      flag.textContent = '';
      if (!flagImg) flag.classList.add('sf-hidden');
      else {
        flagImg.onerror = function () { flag.textContent = ''; flag.classList.add('sf-hidden'); };
        flag.appendChild(flagImg);
        flag.classList.remove('sf-hidden');
      }
    }

    var date = lightbox.querySelector('[data-ds-photo-lightbox-date]');
    if (date) {
      date.setAttribute('datetime', review.dateIso || '');
      date.textContent = absoluteDate(review.dateIso || '');
    }

    var stars = lightbox.querySelector('[data-ds-rating]');
    if (stars) setStars(stars, review.rating || 0);

    var title = lightbox.querySelector('[data-ds-photo-lightbox-title]');
    if (title) {
      title.textContent = review.title || '';
      title.classList.toggle('sf-hidden', !review.title);
    }

    var body = lightbox.querySelector('[data-ds-photo-lightbox-body]');
    if (body) body.textContent = review.body || '';

    // Judge.me only carries a variant when the merchant asks for one as a
    // custom question, so this line is usually absent rather than empty.
    var variant = lightbox.querySelector('[data-ds-photo-lightbox-variant]');
    if (variant) {
      variant.textContent = review.variant || '';
      variant.classList.toggle('sf-hidden', !review.variant);
    }

    var counter = lightbox.querySelector('[data-ds-photo-lightbox-counter]');
    var setTotal = shots ? set.length : stripPhotoTotal();
    var setAt = shots ? lightboxAt + 1 : stripPosition(lightboxAt);
    if (counter) counter.textContent = setAt + ' / ' + setTotal;

    /* One photo has nowhere to step to: hide ‹ › rather than leave two
     * controls that do nothing (QC r2 note). */
    ['[data-ds-photo-lightbox-prev]', '[data-ds-photo-lightbox-next]'].forEach(function (selector) {
      var arrow = lightbox.querySelector(selector);
      if (arrow) arrow.classList.toggle('sf-hidden', set.length <= 1 && !(!shots && stripHasMore()));
    });

    renderLightboxProduct(review.product);
  }

  /* "Purchased item" in the lightbox — shop-wide reviews only: thumb, name,
   * price, one link to the PDP. Judge.me's markup carries the name, the link
   * and the image but no price, so the price is read from the storefront's own
   * `/products/<handle>.js` the first time a product is shown, cached per URL,
   * and the line simply stays empty if that fails. A PDP review has no
   * product and the block stays hidden. */
  var priceCache = {};

  function formatPrice(cents) {
    var format = (root.getAttribute('data-ds-reviews-money') || '${{amount}}').replace(/<[^>]*>/g, '');
    return format.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, ((Number(cents) || 0) / 100).toFixed(2));
  }

  /* Price and featured image off the storefront's own `/products/<handle>.js`,
   * cached per URL. The image is only used when the source sent none (SF
   * carries the product's name and handle, not its picture). */
  function productInfo(href) {
    var path = String(href || '').split('?')[0].split('#')[0];
    if (!/\/products\/[^/]+$/.test(path)) return Promise.resolve(null);
    if (!priceCache[path]) {
      priceCache[path] = fetch(path + '.js', { headers: { Accept: 'application/json' } })
        .then(function (response) { return response.ok ? response.json() : null; })
        .then(function (json) {
          if (!json) return null;
          return {
            price: typeof json.price_min === 'number' ? formatPrice(json.price_min) : null,
            image: typeof json.featured_image === 'string' ? json.featured_image : '',
          };
        })
        .catch(function () { return null; });
    }
    return priceCache[path];
  }

  function renderLightboxProduct(product) {
    var block = lightbox && lightbox.querySelector('[data-ds-photo-lightbox-product]');
    if (!block) return;
    var show = !!(product && product.title);
    block.classList.toggle('sf-hidden', !show);
    block.classList.toggle('sf-flex', show);
    if (!show) return;

    block.setAttribute('href', product.href || '#');
    var title = block.querySelector('[data-ds-photo-lightbox-product-title]');
    if (title) title.textContent = product.title;
    var img = block.querySelector('[data-ds-photo-lightbox-product-image]');
    if (img) {
      img.classList.toggle('sf-hidden', !product.image);
      if (product.image) img.src = product.image;
    }
    var price = block.querySelector('[data-ds-photo-lightbox-product-price]');
    if (price) {
      price.textContent = '';
      price.classList.add('sf-hidden');
    }
    var wanted = product.href;
    productInfo(product.href).then(function (info) {
      // The shopper may have stepped to another photo while this was out.
      if (!info || block.getAttribute('href') !== wanted) return;
      if (price && info.price) {
        price.textContent = info.price;
        price.classList.remove('sf-hidden');
      }
      if (img && !product.image && info.image) {
        img.src = info.image;
        img.classList.remove('sf-hidden');
      }
    });
  }

  /* One step through the lightbox. Walking the strip on the all-reviews feed,
   * the next page of photo reviews is fetched three photos before the end of
   * what is loaded, and a step past the end waits for it rather than wrapping
   * back to the first photo. */
  /* While the next page is on its way, both arrows are disabled and the viewer
   * reports busy, so a press neither sits there silently nor queues up jumps
   * that all land at once (QC r6). */
  var lightboxWaiting = false;
  function setLightboxWaiting(on) {
    lightboxWaiting = on;
    if (!lightbox) return;
    var viewer = lightbox.querySelector('[data-ds-photo-lightbox-viewer]');
    if (viewer) viewer.setAttribute('aria-busy', on ? 'true' : 'false');
    ['[data-ds-photo-lightbox-prev] button', '[data-ds-photo-lightbox-next] button'].forEach(function (selector) {
      var button = lightbox.querySelector(selector);
      if (button) button.disabled = on;
    });
  }

  function lightboxStep(delta) {
    if (lightboxWaiting) return;
    if (!shots && delta > 0 && stripHasMore()) {
      if (lightboxAt + delta >= strip.length) {
        var from = lightboxAt;
        setLightboxWaiting(true);
        loadMoreStrip().then(function () {
          setLightboxWaiting(false);
          /* A failed page leaves the shopper where they were rather than
           * wrapping back to the first photo. */
          if (from + delta < strip.length) lightboxShow(lightboxAt + delta);
        });
        return;
      }
      if (lightboxAt + delta >= strip.length - 3) loadMoreStrip();
    }
    lightboxShow(lightboxAt + delta);
  }

  function lightboxOpen(index, trigger) {
    if (!lightbox) return;
    lightboxOpener = trigger || null;
    lightboxShow(index);
    lightbox.setAttribute('aria-hidden', 'false');
    lightbox.setAttribute('data-ds-page-lock', '');
    var close = lightbox.querySelector('[data-ds-photo-lightbox-close] button');
    if (close) close.focus({ focusVisible: false });
  }

  function lightboxClose() {
    if (!lightbox) return;
    lightbox.setAttribute('aria-hidden', 'true');
    lightbox.removeAttribute('data-ds-page-lock');
    if (lightboxOpener && typeof lightboxOpener.focus === 'function') lightboxOpener.focus();
    lightboxOpener = null;
  }

  /* Bring row `at` of `visible()` on screen: desktop turns to its page, mobile
   * appends far enough to hold it. */
  function revealReview(at) {
    var node;
    if (isDesktop()) {
      state.page = Math.floor(at / PER_PAGE) + 1;
      renderList();
      node = list.children[at % PER_PAGE];
    } else {
      if (at >= state.shown) state.shown = at + 1;
      renderList();
      node = list.children[at];
    }
    if (node) node.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  /* A tile in the strip knows its index; a tile in a review body knows only its
   * URL, so it finds itself in the strip by that. */
  root.addEventListener('click', function (event) {
    var tile = event.target.closest('[data-ds-reviews-photo]');
    if (!tile || !lightbox) return;
    var index = tile.getAttribute('data-ds-reviews-photo-index');
    if (index !== null) {
      if (!strip.length) return;
      event.preventDefault();
      shots = null;
      lightboxOpen(parseInt(index, 10) || 0, tile);
      return;
    }
    var src = tile.getAttribute('data-ds-reviews-photo-src');
    var found = -1;
    strip.forEach(function (shot, i) {
      if (found < 0 && shot.src === src) found = i;
    });
    if (found >= 0) {
      event.preventDefault();
      shots = null;
      lightboxOpen(found, tile);
      return;
    }
    var item = tile.closest('[data-ds-review-item]');
    var review = reviewOfNode && item ? reviewOfNode.get(item) : null;
    if (!review || !review.photos.length) return;
    event.preventDefault();
    shots = review.photos.map(function (photo) {
      return { src: photo.src, full: photo.full, review: review };
    });
    var at = 0;
    shots.forEach(function (shot, i) {
      if (shot.src === src) at = i;
    });
    lightboxOpen(at, tile);
  });

  if (lightbox) {
    lightbox.addEventListener('click', function (event) {
      if (event.target === lightbox || event.target.closest('[data-ds-photo-lightbox-close]')) {
        event.preventDefault();
        lightboxClose();
        return;
      }
      if (event.target.closest('[data-ds-photo-lightbox-prev]')) {
        event.preventDefault();
        lightboxStep(-1);
        return;
      }
      if (event.target.closest('[data-ds-photo-lightbox-next]')) {
        event.preventDefault();
        lightboxStep(1);
        return;
      }
      if (event.target.closest('[data-ds-photo-lightbox-see]')) {
        event.preventDefault();
        var seen = lightboxSet();
        var wanted = seen[lightboxAt] && seen[lightboxAt].review;
        lightboxClose();
        if (!wanted) return;
        // The review is rarely one of the rows already on screen, and the two
        // breakpoints hide it differently: desktop paginates, so the review sits
        // on a page that is not the current one; mobile appends, so it sits past
        // what has been appended so far. Reaching it therefore means moving the
        // page on desktop and raising the appended count on mobile — running the
        // desktop branch on mobile lands on the wrong row, or on no row at all.
        /* The review behind a photo comes from the strip's set (one `per_page=20`
         * request), while the list can be on any page of the current query — the
         * two barely overlap, so searching the list directly almost always misses
         * and the button silently does nothing. That was the bug.
         *
         * Turning on "With photos" is the correct and cheapest route: that
         * filter's set IS the strip's set, so the review is certainly present and
         * it costs no request. The shopper can see which mode they are in because
         * the Filter chip changes with it — carrying someone to the review they
         * clicked without saying so is the confusing version.
         *
         * Matched on `id` rather than object identity: the review in `strip` and
         * the one in the list are parsed from two different responses, so the same
         * review is two objects. When `loadStrip` fails, the strip is built from
         * the metafield while `photoPool()` returns the list's rows — `indexOf`
         * never matches and the button goes silent again, the very bug this
         * exists to fix. */
        var at = indexOfReview(visible(), wanted);
        if (at >= 0) {
          revealReview(at);
          return;
        }
        if (!wanted.photos || !wanted.photos.length) return;
        var box = root.querySelector('[data-ds-reviews-filter="photo"] input');
        if (!box || box.checked) return;
        box.checked = true;
        /* Through `syncFromPanels` rather than assigning `state.photo`
         * directly: it is the one place that reads the DOM back into state, so
         * the Filter chip, the Done button and the list all tell one story. */
        var shown = syncFromPanels();
        if (!data.photoServer) {
          at = indexOfReview(visible(), wanted);
          if (at >= 0) revealReview(at);
          return;
        }
        /* Where "With photos" is a server query (SF, the all-reviews feed), its
         * rows arrive a page at a time, so walk them in order until the review
         * turns up — no further than the strip reaches, since that is where the
         * review came from. */
        var reach = Math.ceil(((stripRows && stripRows.length) || PER_PAGE) / PER_PAGE) + 1;
        var seek = function (n) {
          var found = indexOfReview(visible(), wanted);
          if (found >= 0) return revealReview(found);
          if (n > reach || n > pageCount()) return;
          return fetchUiPage(n).then(function () { seek(n + 1); });
        };
        shown.then(function () { seek(2); });
      }
    });

    document.addEventListener('keydown', function (event) {
      if (lightbox.getAttribute('aria-hidden') !== 'false') return;
      if (event.key === 'Escape') lightboxClose();
      if (event.key === 'ArrowLeft') lightboxStep(-1);
      if (event.key === 'ArrowRight') lightboxStep(1);
    });

    /* Touch/pen swipe over the photo — the same step the arrows do. The viewer
     * is a single <img> whose src is swapped (no scroll track), so this can't
     * follow the finger; it commits on release past a threshold, and Judge.me's
     * strip wraps via the modulo in lightboxShow. touch-action: pan-y keeps the
     * mobile bottom-sheet vertically scrollable while horizontal drags are ours. */
    var swipeArea = lightbox.querySelector('[data-ds-photo-lightbox-viewer]');
    if (swipeArea) {
      swipeArea.style.touchAction = 'pan-y';
      var sx = 0, sy = 0, sdx = 0, sid = null, sDown = false, sHor = false;

      // Kill the browser's native image drag while a mouse drag is ours.
      swipeArea.addEventListener('dragstart', function (event) {
        if (sDown) event.preventDefault();
      });

      swipeArea.addEventListener('pointerdown', function (event) {
        // Primary button only; touch, pen and mouse all drag to step photos.
        if (event.button != null && event.button > 0) return;
        sDown = true; sHor = false; sdx = 0;
        sx = event.clientX; sy = event.clientY; sid = event.pointerId;
      });

      swipeArea.addEventListener('pointermove', function (event) {
        if (!sDown || event.pointerId !== sid) return;
        var mx = event.clientX - sx;
        var my = event.clientY - sy;
        if (!sHor) {
          if (Math.abs(mx) < 10 && Math.abs(my) < 10) return;
          // A mostly-vertical drag is the shopper scrolling the sheet — bow out.
          if (Math.abs(mx) <= Math.abs(my)) { sDown = false; return; }
          sHor = true;
          try { swipeArea.setPointerCapture(sid); } catch (err) {}
        }
        sdx = mx;
        event.preventDefault();
      });

      var endSwipe = function (event) {
        if (!sDown || (sid !== null && event.pointerId !== sid)) return;
        var moved = sdx;
        var wasHorizontal = sHor;
        sDown = false; sHor = false;
        try { if (sid !== null) swipeArea.releasePointerCapture(sid); } catch (err) {}
        sid = null;
        if (!wasHorizontal) return;
        var threshold = Math.min(80, (swipeArea.clientWidth || 1) * 0.2);
        if (moved <= -threshold) lightboxStep(1);
        else if (moved >= threshold) lightboxStep(-1);
      };

      swipeArea.addEventListener('pointerup', endSwipe);
      swipeArea.addEventListener('pointercancel', endSwipe);
    }
  }

  /* Rotating a phone or dragging a desktop window across tablet-air swaps which control
   * owns the list. Without this the shopper keeps whichever they had — a pager
   * on a 375 screen, or a stranded "Load more" beside page numbers. */
  var stripTrack = root.querySelector('[data-ds-reviews-photos-track]');
  if (stripTrack) stripTrack.addEventListener('scroll', syncStripNav, { passive: true });

  var wasDesktop = isDesktop();
  var wasDrop = panelsDrop();
  window.addEventListener('resize', function () {
    syncStripNav();
    var now = isDesktop();
    var drop = panelsDrop();
    // The same panel is a sheet on one side of tablet-mini and a dropdown on
    // the other, and the two lock body scroll differently. Closing on the way
    // across is cheaper than reconciling that, and leaves no scroll lock
    // stranded on a desktop page.
    if (drop !== wasDrop) {
      wasDrop = drop;
      closePanels();
    }
    if (now === wasDesktop) return;
    wasDesktop = now;
    closePanels();
    state.page = 1;
    state.shown = PER_PAGE;
    renderList();
  });

  /* Mount costs exactly TWO requests and no more: one for the list's page 1, one
   * for the photo strip (`per_page=20`). Later pages are fetched as they are
   * clicked. On SF the list's page 1 already came with the source choice (the
   * source hands it over without asking again), so only the strip remains.
   *
   * The page count comes from the source's aggregate, so the pager is there
   * immediately, and the first request's `total_count` corrects it if they
   * disagree. */
  renderSortTrigger();
  renderFilterTrigger();

  /* The list does NOT come from the seed, not even its first page. Judge.me's
   * seed is the widget metafield rendered in the shop's default order
   * (`pictures-first`), while the list asks in the selected sort — `date` by
   * default. Two different orderings. Taking page 1 from one and pages 2+ from
   * the other stitches two lists together: measured on product 9902457880859,
   * 30 rendered rows held only 23 distinct reviews — 7 repeats — and photos
   * appeared only in the first five rows, because exactly those five came from
   * the pictures-first ordering.
   *
   * So page 1 goes through the source like every other page: one ordering,
   * nothing repeated, nothing missed. The skeleton covers that stretch. */
  setBusy(true);
  var firstPage = show(1);
  // Draw the strip immediately from the seed's photos; `loadStrip` then
  // replaces it with the wider set. Drawing it up front keeps the block present
  // from the start rather than appearing late and shoving the list down.
  renderPhotoStrip();
  renderVariants();
  renderApply();
  // After the list's page 1, not beside it: two parallel requests on arrival
  // were enough, with a couple of hard reloads, to trip Judge.me's burst limit
  // (its RETRY_DELAYS). The strip already shows the seed's photos meanwhile.
  firstPage.then(loadStrip, loadStrip);
}

function init(scope) {
  (scope || document).querySelectorAll(ROOT).forEach(function (root) {
    if (root.dataset.dsBound) return;
    root.dataset.dsBound = '1';
    setup(root);
  });
}

/* The data sources (product-reviews-data-*.js) are concatenated AFTER this file
 * in sf-core.js, so mount once the whole bundle has run: on DOMContentLoaded, or
 * one microtask from now when the document is already parsed. */
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () { init(); });
} else {
  Promise.resolve().then(function () { init(); });
}

// Theme editor re-renders a section into a fresh subtree; bind that one too.
document.addEventListener('shopify:section:load', function (event) {
  init(event.target);
});

} catch (sfError) {
if (typeof console !== 'undefined') console.error('[sf-core] behavior "product-reviews" failed to initialise:', sfError);
}
})();

/* product-reviews-data-judgeme.js */
(function () {
try {
/* product-reviews-data-judgeme — Judge.me as the data source of a reviews band.
 *
 * The UI (product-reviews.js) is shared; the data is not. Each source turns its
 * own feed into the same plain review objects the UI renders, and this file is
 * the Judge.me one: the public widget endpoints, their URLs, retries and the
 * `.jdgm-rev` HTML they answer with. The WanderCo SF API is the other source
 * (product-reviews-data-sf.js); a band uses SF when it can and falls back to
 * this one. Nothing here knows SF exists.
 *
 * Why parse HTML at all. Judge.me publishes no JSON a storefront can read: the
 * `judgeme.review_widget_data` metafield does not exist, the cache server and
 * `api.judge.me/api/v1/widgets/*` answer with pre-rendered HTML, and the one
 * real JSON endpoint needs a private token that cannot ship in a theme. What IS
 * open is `api.judge.me/reviews/reviews_for_widget` — no token at all — and it
 * returns `{"html": …}`. So HTML is the only feed, and reading it is the price
 * of not standing up an App Proxy.
 *
 * What makes that safe enough. Judge.me stamps the review's actual data onto
 * attributes — data-review-id, data-verified-buyer, data-score, and a <time>
 * with a real datetime — and those change far less often than class names. The
 * parser reads attributes first and falls back to a class only for the body,
 * the author and the reply, where there is nothing else. If a page yields no
 * parsable reviews, the original widget is left visible: the failure mode is
 * Judge.me's own design, never an empty column.
 *
 * Exposes `window.WcReviewData.judgeme(root, { perPage, feedAll, source })` (the
 * reviews band) and `window.WcReviewData.judgemeShopCards(source)` (homepage
 * cards, ds-customer-reviews).
 * Authoring rules: src/behaviors/README.md. No import/export.
 */

var JM_API = 'https://api.judge.me/reviews/reviews_for_widget';

/* The shop-wide feed: what Judge.me's own all-reviews widget pages with (its
 * "Load More" on /pages/reviews-1). Same `page` / `per_page` / `filter_rating` /
 * `verified_only` / `sort_by` / `sort_dir` levers, measured 2026-10-10; the
 * differences are listed where they bite — see `allSort` and `payloadTotal`.
 * A band opts in with `data-ds-reviews-feed="all"` (ds-product-reviews
 * `feed: 'all'`, the reviews page). */
var JM_ALL_API = 'https://api.judge.me/reviews/all_reviews_js_based';

/* The band's sort values (`helpful|desc`, …, shared with the PDP) as this
 * endpoint names them. Measured, first 10 reviews each:
 *   no sort_by / sort_by=most_helpful → thumbs-up 53, 34, 31… (the default)
 *   sort_by=helpful                   → silently newest first (unknown value)
 *   sort_by=created_at                → newest first, whatever sort_dir says
 *   sort_by=rating + sort_dir=asc     → 1★ first; desc → 5★ first
 *   sort_by=pictures_first            → photo reviews first, count unchanged
 * So `helpful` and `pictures` must be renamed, and `date` maps to created_at. */
function allSort(chosen) {
  var parts = String(chosen || '').split('|');
  var key = { helpful: 'most_helpful', date: 'created_at', rating: 'rating', pictures: 'pictures_first' }[parts[0]] || '';
  if (!key) return '';
  var dir = key === 'rating' || key === 'created_at' ? parts[1] : '';
  return '&sort_by=' + key + (dir ? '&sort_dir=' + encodeURIComponent(dir) : '');
}

/* How many reviews the query holds. reviews_for_widget says `total_count`; the
 * all-reviews feed has no such key and instead splits the FILTERED set into
 * `number_of_product_reviews` + `number_of_shop_reviews` (filter_rating=1 →
 * 322 + 43, the histogram's 365). The list only shows product reviews, so the
 * product half is its total. NaN when the payload carries neither. */
function payloadTotal(payload) {
  if (!payload) return NaN;
  var t = parseInt(payload.total_count, 10);
  if (!isNaN(t)) return t;
  return parseInt(payload.number_of_product_reviews, 10);
}

/* The ceiling for ONE request. Judge.me promises nothing about timing, and a
 * page that hangs forever leaves a permanent skeleton and two locked controls —
 * the shopper cannot get out. On timeout we abort and retry (RETRY_DELAYS);
 * only once every attempt has failed do we release the controls — an empty page
 * is at least one you can ask for again. */
var PAGE_TIMEOUT = 8000;

/* How long to wait before each retry of a failed Judge.me request.
 *
 * Judge.me rate-limits the widget endpoint per IP and answers 429 with no
 * Retry-After. Measured on product 9902457880859 (2026-09-25): 30 requests one
 * after another (~2/s) all came back 200, while three rounds of 3 in parallel
 * hit 429 on the second round — it is the burst that trips it, not the count —
 * and the block had lifted within a second. So an immediate retry lands inside
 * the same burst and fails again; a short wait is what clears it. Jittered so two
 * tabs reloaded together do not retry in lockstep. */
var RETRY_DELAYS = [1000, 2000, 4000];

/* One request with retries. Resolves to the JSON payload, or null once every
 * attempt failed. Only 429, 5xx, a network error or the timeout are retried — a
 * 4xx other than 429 will say the same thing the next time. */
function fetchReviewsJson(url) {
  function attempt(index) {
    var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var timer = setTimeout(function () { if (controller) controller.abort(); }, PAGE_TIMEOUT);
    return fetch(url, controller ? { signal: controller.signal } : undefined)
      .then(function (response) {
        clearTimeout(timer);
        if (response.ok) return response.json();
        var retryable = response.status === 429 || response.status >= 500;
        return retryable ? again(index) : null;
      }, function () {
        clearTimeout(timer);
        return again(index);
      })
      .catch(function () { return null; });
  }
  function again(index) {
    if (index >= RETRY_DELAYS.length) return null;
    var delay = RETRY_DELAYS[index] * (0.75 + Math.random() * 0.5);
    return new Promise(function (resolve) { setTimeout(resolve, delay); })
      .then(function () { return attempt(index + 1); });
  }
  return attempt(0);
}

/* ── Parsing ──────────────────────────────────────────────────────────────── */

function text(node, selector) {
  var found = node.querySelector(selector);
  return found ? found.textContent.trim() : '';
}

/* One `.jdgm-rev` element to a plain object. Returns null for anything that
 * carries no body — Judge.me emits placeholder rows we have no design for. */
function parseReview(el) {
  var body = text(el, '.jdgm-rev__body');
  if (!body) return null;

  var title = text(el, '.jdgm-rev__title');
  var rating = el.querySelector('.jdgm-rev__rating');
  var time = el.querySelector('.jdgm-rev__timestamp');
  var reply = text(el, '.jdgm-rev__reply');

  var photos = [];
  var product = null;
  /* The all-reviews feed names the product each review is about, and puts the
   * shop's own product image into the same picture row as the customer's
   * photos, told apart only by `jdgm-rev__product-picture`. That image is the
   * PRODUCT, not evidence (spec 12-reviews: #2557), so it leaves the photo set
   * and travels with the product instead. */
  var prodLink = el.querySelector('.jdgm-rev__prod-link');
  if (prodLink && prodLink.textContent.trim()) {
    var prodPic = el.querySelector('.jdgm-rev__product-picture');
    var prodImg = prodPic && prodPic.querySelector('img');
    product = {
      title: prodLink.textContent.trim(),
      href: prodLink.getAttribute('href') || '',
      image: (prodImg && (prodImg.getAttribute('data-src') || prodImg.getAttribute('src'))) || (prodPic && prodPic.getAttribute('href')) || '',
    };
  }
  el.querySelectorAll('.jdgm-rev__pic-link').forEach(function (link) {
    if (link.classList.contains('jdgm-rev__product-picture')) return;
    var img = link.querySelector('img');
    // Judge.me lazy-loads its own thumbnails, so the real URL sits in data-src
    // on the <img> while the anchor holds the full-size one.
    var src = (img && (img.getAttribute('data-src') || img.getAttribute('src'))) || link.getAttribute('href');
    if (src) photos.push({ src: src, full: link.getAttribute('href') || src });
  });

  return {
    id: el.getAttribute('data-review-id') || '',
    helpful: parseInt(el.getAttribute('data-thumb-up-count'), 10) || 0,
    author: text(el, '.jdgm-rev__author'),
    /* The variant the review was left on, which Judge.me only carries when the
     * merchant configured it as a custom question — `.jdgm-rev__custom-form` is
     * present but EMPTY on this store. So this is '' far more often than not,
     * and the filter panel's VARIANT group stays hidden on that evidence rather
     * than drawing an empty fieldset. */
    variant: text(el, '.jdgm-rev__variant') || text(el, '.jdgm-rev__custom-form'),
    // Shown only by the lightbox — the reviews list's Figma frame hides it.
    title: title,
    /* Two-letter code Judge.me stamps on `.jdgm-rev__location` once the shop
     * turns on "Show reviewer country flag"; '' when the review has none. */
    country: countryCode(el),
    rating: rating ? parseInt(rating.getAttribute('data-score'), 10) || 0 : 0,
    /* The all-reviews feed stamps `data-content='2025-11-08 14:04:04 UTC'`
     * where the product widget has a datetime; the UI's date formatter reads
     * either. */
    dateIso: time ? time.getAttribute('datetime') || time.getAttribute('data-content') || '' : '',
    body: body,
    photos: photos,
    reply: reply,
    product: product,
  };
}

function countryCode(el) {
  var location = el.querySelector('.jdgm-rev__location');
  var code = location ? (location.getAttribute('data-country-code') || '').toUpperCase() : '';
  return /^[A-Z]{2}$/.test(code) ? code : '';
}

function parseAll(root) {
  var out = [];
  root.querySelectorAll('.jdgm-rev').forEach(function (el) {
    var review = parseReview(el);
    if (review) out.push(review);
  });
  return out;
}

/* Judge.me's newer Review Widget answers reviews_for_widget with `reviews[]`
 * (JSON) and no `html`. Same review object as `parseReview`, read straight off
 * the fields; a review with no body is skipped the same way. */
function jsonReview(r) {
  var box = document.createElement('div');
  box.innerHTML = r.body_html || '';
  var body = box.textContent.trim();
  if (!body) return null;
  var code = String(r.location_country_code || '').toUpperCase();
  return {
    id: r.uuid ? String(r.uuid) : '',
    helpful: parseInt(r.thumb_up, 10) || 0,
    author: r.reviewer_name || '',
    variant: r.product_variant_title || '',
    title: r.title || '',
    country: /^[A-Z]{2}$/.test(code) ? code : '',
    rating: parseInt(r.rating, 10) || 0,
    dateIso: r.created_at || '',
    body: body,
    photos: (r.pictures_urls || []).map(function (p) {
      var src = typeof p === 'string' ? p : (p && (p.compact || p.small || p.url || p.original)) || '';
      var full = typeof p === 'string' ? p : (p && (p.original || p.huge || p.url)) || src;
      return { src: src, full: full };
    }).filter(function (p) { return p.src; }),
    reply: r.reply_content || '',
    product: null,
  };
}

/* What a list / strip response holds: the parsed reviews, the query's total
 * (NaN when unstated) and how many reviews the server SENT (`got`, counting
 * the ones the parser skips — it is what tells the UI it reached the bottom). */
function readPayload(payload) {
  if (payload.html || !Array.isArray(payload.reviews)) {
    var holder = document.createElement('div');
    holder.innerHTML = payload.html || '';
    return { rows: parseAll(holder), total: payloadTotal(payload), got: holder.querySelectorAll('.jdgm-rev').length };
  }
  var rows = [];
  payload.reviews.forEach(function (r) {
    var review = jsonReview(r);
    if (review) rows.push(review);
  });
  // The JSON widget may state its total under `pagination`; failing that, the
  // page count times the page size (exact on the last page).
  var pg = payload.pagination || {};
  var exact = [payload.total_count, pg.total_count, pg.total_entries, pg.total]
    .map(function (v) { return parseInt(v, 10); })
    .filter(function (v) { return v >= 0; })[0];
  var per = pg.per_page || payload.reviews.length;
  var total = exact !== undefined ? exact
    : pg.total_pages ? (pg.current_page >= pg.total_pages
      ? (pg.current_page - 1) * per + payload.reviews.length
      : pg.total_pages * per)
    : NaN;
  return { rows: rows, total: total, got: payload.reviews.length };
}

/* The published aggregate, read off the widget metafield the section already
 * parked in the source node. Judge.me stamps its DISPLAYED numbers onto the
 * `.jdgm-rev-widg` root (data-average-rating / data-number-of-reviews) and the
 * per-star frequencies onto `.jdgm-histogram__row` (data-rating + data-
 * frequency). These are the same values the Liquid seeds the summary with;
 * re-reading them keeps the rail correct after a theme-editor re-render and
 * self-heals if the server seed ever parsed the markup wrong. Returns null when
 * the widget markup carries no aggregate, so the server render is left alone. */
function readAggregate(source) {
  var widg = source.querySelector('.jdgm-rev-widg') || source.querySelector('.jdgm-all-reviews__header');
  if (!widg) return null;
  var avgAttr = widg.getAttribute('data-average-rating');
  /* The all-reviews header counts product AND store reviews; the list it feeds
   * holds product reviews only, so its own total is the product half (QC r4:
   * Clear all read "Show 58193", the list held 56106). */
  var cntAttr = widg.getAttribute('data-number-of-product-reviews') || widg.getAttribute('data-number-of-reviews');
  if (avgAttr == null && cntAttr == null) return null;

  var dist = { 5: 0, 4: 0, 3: 0, 2: 0, 1: 0 };
  source.querySelectorAll('.jdgm-histogram__row').forEach(function (row) {
    var stars = parseInt(row.getAttribute('data-rating'), 10);
    if (dist[stars] === undefined) return;
    dist[stars] = parseInt(row.getAttribute('data-frequency'), 10) || 0;
  });

  var avgNum = avgAttr != null ? parseFloat(avgAttr) : NaN;
  return {
    averageValue: avgAttr != null && !isNaN(avgNum) ? avgNum : null,
    count: cntAttr != null ? parseInt(cntAttr, 10) || 0 : null,
    dist: dist,
  };
}

/* ── One band ─────────────────────────────────────────────────────────────── */

function createJudgeMe(root, opts) {
  var perPage = opts.perPage;
  var feedAll = !!opts.feedAll;
  var source = opts.source;
  var productId = root.getAttribute('data-ds-reviews-product');
  var shop = root.getAttribute('data-ds-reviews-shop');

  /* `q` is the UI's query: { sort, rating, photo } — `sort` is the
   * band's radio value (`helpful|desc`, …). */
  function pageUrl(n, q) {
    if (feedAll && shop) {
      return (
        JM_ALL_API +
        '?url=' + encodeURIComponent(shop) +
        '&shop_domain=' + encodeURIComponent(shop) +
        '&platform=shopify&per_page=' + perPage + '&page=' + n +
        /* "With photos" is a server filter on this feed (`with_pictures`, it
         * counts and pages like any other query), so the list is every photo
         * review, not the strip's first page. It travels as a sort_by, so it
         * takes the sort's place while it is on. */
        (q.photo ? '&sort_by=with_pictures' : allSort(q.sort)) +
        (q.rating ? '&filter_rating=' + encodeURIComponent(q.rating) : '')
      );
    }
    if (!productId || !shop) return '';
    /* Same names as the shop-wide feed. The radios still say `helpful|desc`,
     * `date|desc`, `pictures|desc`; `allSort` renames them. The old names are
     * ignored and the list stays newest. */
    return (
      JM_API +
      '?url=' + encodeURIComponent(shop) +
      '&shop_domain=' + encodeURIComponent(shop) +
      '&platform=shopify&product_id=' + encodeURIComponent(productId) +
      '&per_page=' + perPage + '&page=' + n +
      allSort(q.sort) +
      (q.rating ? '&filter_rating=' + encodeURIComponent(q.rating) : '')
    );
  }

  /* Photo strip requests carry `per_page=20` and no `sort_by`.
   *
   * Omitting the sort is deliberate — the shop sets
   * `default_sort_method = pictures-first`, so the default already pushes reviews
   * with photos to the front; sending any `sort_by` overwrites that (measured:
   * no sort → 20 reviews all with photos; with a sort → 27 reviews, 1 with a
   * photo).
   *
   * `per_page=20` is a MEASURED number, not a chosen one: the endpoint caps a
   * response at 20 rows. Measured on product 9902457880859 (2026-09-17) —
   * per_page 5/10/15/20 returned exactly 5/10/15/20, while 25/30/50/100 all
   * returned 20.
   *
   * Shop-wide, the strip asks for `sort_by=with_pictures` — on that feed it is a
   * real filter (only reviews carrying a customer photo, counted 5,923 of
   * 56,087) — narrowed by the active star filter. */
  function stripUrl(n, q) {
    if (feedAll && shop) {
      return (
        JM_ALL_API +
        '?url=' + encodeURIComponent(shop) +
        '&shop_domain=' + encodeURIComponent(shop) +
        '&platform=shopify&sort_by=with_pictures&per_page=20&page=' + n +
        (q.rating ? '&filter_rating=' + encodeURIComponent(q.rating) : '')
      );
    }
    if (!productId || !shop) return '';
    return (
      JM_API +
      '?url=' + encodeURIComponent(shop) +
      '&shop_domain=' + encodeURIComponent(shop) +
      '&platform=shopify&product_id=' + encodeURIComponent(productId) +
      '&per_page=20&page=' + n
    );
  }

  var data = {
    name: 'judgeme',
    /* "With photos" is a server query only on the all-reviews feed. The product
     * widget endpoint has no photo filter — every parameter was probed
     * (`with_pictures`, `has_pictures`, `pictures_only`, `filter_pictures`,
     * `media`, `only_pictures`: `total_count` never moved) — so on a PDP the UI
     * filters the strip's set in memory. */
    photoServer: feedAll,
    /* A draft count the server gave for this exact query may stand in for the
     * histogram only on the all-reviews feed, whose histogram includes store
     * reviews the list never shows. */
    trustDraftTotals: feedAll,
    // The strip is read 20 at a time (see `stripUrl`).
    stripWhole: false,
    /* How deep the all-reviews feed goes: the first 1000 reviews of any query,
     * whatever the sort or filter. Measured 2026-10-10 — per_page=10 serves
     * distinct pages up to 100, per_page=20 up to 50, and every page past that
     * returns the last page again (most_helpful, created_at, verified_only,
     * filter_rating=4 alike). The reviews page stops its pager, Load more and
     * lightbox there rather than repeat (QC r4). Counts still state the true size
     * of the query. The product widget has no such ceiling. */
    maxReviews: feedAll ? 1000 : Infinity,
    hasTarget: !!pageUrl(1, {}),
    aggregate: readAggregate(source),
    /* The widget metafield's reviews, rendered server-side in the shop's
     * default order. */
    seed: parseAll(source),

    /* Which draft counts need one request: on the all-reviews feed a star or
     * photo draft is counted by the server. Photo on a PDP is counted from the
     * strip instead. */
    countsByRequest: function (f) {
      return !!(feedAll && (f.photo || f.rating));
    },

    /* List page `n` of query `q`: { rows, total, got }, or null once every
     * attempt failed. */
    page: function (n, q) {
      return fetchReviewsJson(pageUrl(n, q)).then(function (payload) {
        return payload ? readPayload(payload) : null;
      });
    },

    /* Strip page `n`: { rows, total }, or null on failure. */
    strip: function (n, q) {
      return fetchReviewsJson(stripUrl(n, q || {})).then(function (payload) {
        if (!payload) return null;
        var res = readPayload(payload);
        return { rows: res.rows, total: res.total };
      });
    },

    /* How many reviews a draft will show, without changing the list: one
     * request, no retry — a failed count only leaves the button without a
     * number. Resolves to the total, or null. */
    count: function (q) {
      var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
      var timer = setTimeout(function () { if (controller) controller.abort(); }, PAGE_TIMEOUT);
      return fetch(pageUrl(1, q), controller ? { signal: controller.signal } : undefined)
        .then(function (response) { return response.ok ? response.json() : null; })
        .then(function (payload) {
          clearTimeout(timer);
          var t = payloadTotal(payload);
          return isNaN(t) ? null : t;
        }, function () {
          clearTimeout(timer);
          return null;
        });
    },

    /* An empty widget metafield (the newer Review Widget renders client-side and
     * leaves it blank) gets page 1 from the API instead. Resolves true when that
     * produced reviews (now in `seed`). */
    fillSeed: function () {
      if (feedAll || !productId || !shop) return Promise.resolve(false);
      var url = JM_API +
        '?url=' + encodeURIComponent(shop) +
        '&shop_domain=' + encodeURIComponent(shop) +
        '&platform=shopify&product_id=' + encodeURIComponent(productId) +
        '&per_page=' + perPage + '&page=1';
      return fetchReviewsJson(url).then(function (payload) {
        if (!payload) return false;
        if (payload.html) source.innerHTML = payload.html;
        data.seed = readPayload(payload).rows;
        return data.seed.length > 0;
      });
    },
  };
  return data;
}

/* ── Homepage cards (ds-customer-reviews) ─────────────────────────────────
 * The homepage band reads Judge.me's shop metafields the section parked in its
 * hidden source node. TWO feeds, read in this order:
 *
 *   `.jdgm-rev`          — the all-reviews page (all_reviews_0 + all_reviews_1).
 *                          The SAME markup the PDP widget uses, so the same
 *                          attributes: data-verified-buyer, data-score,
 *                          data-product-title, data-product-url. Preferred,
 *                          because an attribute survives a restyle where a
 *                          class does not.
 *   `.jdgm-carousel-item` — the featured carousel. Every field is a class with
 *                          no attribute twin and the rating has no data-score
 *                          at all, so this is only the fallback.
 *
 * A card: { body, author, product, href, image, rating, verified }. */

/* One `.jdgm-rev` to a card. Everything but the body and the author comes off
 * an attribute, which is why this feed is preferred. */
function parseShopReview(el) {
  var body = text(el, '.jdgm-rev__body');
  if (!body) return null;

  var rating = el.querySelector('.jdgm-rev__rating');
  var pic = el.querySelector('.jdgm-rev__pic-link img');

  return {
    body: body,
    author: text(el, '.jdgm-rev__author'),
    product: el.getAttribute('data-product-title') || '',
    href: el.getAttribute('data-product-url') || '',
    image: pic ? pic.getAttribute('data-src') || pic.getAttribute('src') || '' : '',
    rating: rating ? parseInt(rating.getAttribute('data-score'), 10) || 5 : 5,
  };
}

/* One `.jdgm-carousel-item` to a card, or null when it carries no review body —
 * the carousel pads itself with product-only tiles. */
function parseCarouselItem(el) {
  var body = text(el, '.jdgm-carousel-item__review-body');
  if (!body) return null;

  var link = el.querySelector('a.jdgm-carousel-item__product, .jdgm-carousel-item__product a, a.jdgm-carousel-item__full-review-link');

  /* The carousel's rating carries NO `data-score` — unlike the review widget's,
   * which does. It states the score in `aria-label` ("5 stars") over a run of
   * `.jdgm-star.jdgm--on` spans. Counting the lit stars is the reading that
   * cannot be broken by a locale change; the label is the fallback. Reading
   * data-score here (which is what shipped first) silently made every card five
   * stars, and a wall of fives is exactly the thing a shopper stops believing. */
  var ratingEl = el.querySelector('.jdgm-carousel-item__review-rating');
  var rating = 5;
  if (ratingEl) {
    var lit = ratingEl.querySelectorAll('.jdgm-star.jdgm--on').length;
    if (lit > 0) {
      rating = lit;
    } else {
      var label = parseInt(ratingEl.getAttribute('aria-label'), 10);
      if (label > 0) rating = label;
    }
  }

  /* `jdgm-carousel-item__product-image` is the class on the <img> ITSELF, not on
   * a wrapper around one. Its `alt` is the product title, which is the only
   * place the title appears when the carousel's theme drops the product line. */
  var image = el.querySelector('img.jdgm-carousel-item__product-image, .jdgm-carousel-item__image-wrapper img');

  return {
    body: body,
    author: text(el, '.jdgm-carousel-item__reviewer-name'),
    product: text(el, '.jdgm-carousel-item__product-title') || (image ? image.getAttribute('alt') || '' : ''),
    href: link ? link.getAttribute('href') || '' : '',
    // Judge.me lazy-loads, so the real URL is usually on data-src.
    image: image ? image.getAttribute('data-src') || image.getAttribute('src') || '' : '',
    rating: rating,
  };
}

/* The homepage cards in the source node: the all-reviews feed, else the
 * featured carousel. [] when neither parses. */
function shopCards(source) {
  var cards = [];
  source.querySelectorAll('.jdgm-rev').forEach(function (el) {
    var card = parseShopReview(el);
    if (card) cards.push(card);
  });
  if (!cards.length) {
    source.querySelectorAll('.jdgm-carousel-item').forEach(function (el) {
      var card = parseCarouselItem(el);
      if (card) cards.push(card);
    });
  }
  return cards;
}

if (typeof window !== 'undefined') {
  window.WcReviewData = window.WcReviewData || {};
  window.WcReviewData.judgeme = createJudgeMe;
  window.WcReviewData.judgemeShopCards = shopCards;
}

} catch (sfError) {
if (typeof console !== 'undefined') console.error('[sf-core] behavior "product-reviews-data-judgeme" failed to initialise:', sfError);
}
})();

/* product-reviews-data-sf.js */
(function () {
try {
/* product-reviews-data-sf — the WanderCo SF API as the data source of a reviews
 * band.
 *
 * The UI (product-reviews.js) is shared; the data is not. This source reads the
 * app's own review mirror (co-review-sf-api) and hands the UI the same plain
 * review objects the Judge.me source does — straight from JSON, no HTML in
 * between. The API does its own filtering, sorting and counting, so every
 * query goes to the server as itself: `page`, `sort`, `rating`,
 * `with_photos`, and `total_count` is the answer.
 *
 * The band falls back to Judge.me (product-reviews-data-judgeme.js) when SF is
 * off for the shop, not configured, failing, or holds no reviews for a product
 * Judge.me has reviews for. That choice is made once per band on mount;
 * afterwards every request of the band goes to the source it picked.
 *
 *   GET {apiUrl}/sf/stats?store_id&product_external_id
 *     → { count, avg, per_rating: {1..5}, with_media_count }
 *   GET {apiUrl}/sf/reviews?store_id&product_external_id&limit&page&sort
 *       [&rating=1..5][&with_photos=true]
 *     → { items: [...], total_count, page, per_page, total_pages }
 *   GET {apiUrl}/sf/media?store_id&product_external_id
 *     → { media: [...], reviews: [...] } — every review with photos, one request
 *
 * Without `product_external_id`, all three cover the WHOLE shop (every product
 * review, each item carrying its `product: { title, handle }`) — the reviews
 * page (`data-ds-reviews-feed="all"`). There `/sf/media` pages (`page`,
 * `limit=20`, `rating` → `total_count`): thousands of photo reviews
 * do not fit one request. The strip always has its own endpoint, so
 * `/sf/reviews` serves the list only.
 *
 * `store_id` is the shop's permanent domain; the product id is sent as a GID.
 * The API URL is injected at build time into `#wc-review-config`
 * (ds-product-reviews section); the shop metafield `wanderco.review_source =
 * judgeme` turns SF off (`window.__WC_REVIEW_SF_SOURCE__`).
 *
 * Exposes `window.WcReviewData.sf(root, { perPage })` → source, or null when SF
 * must not be used for this band. The homepage band (ds-customer-reviews) does
 * not use SF: its cards stay Judge.me's / the merchant's.
 * Authoring rules: src/behaviors/README.md. No import/export.
 */

/* One request's ceiling. Past it the band would rather use Judge.me than keep
 * the shopper looking at a skeleton. */
var SF_TIMEOUT = 4000;

/* A failing SF API is remembered for the tab (sessionStorage) for this long, so
 * every product page during an outage goes straight to Judge.me instead of
 * waiting out the timeout first. */
var DOWN_TTL = 5 * 60 * 1000;
var DOWN_KEY = 'wc-review-sf-down-until';

/* The band's sort radios (`helpful|desc`, …) as the API names them. */
var SORTS = {
  'helpful|desc': 'helpful',
  'date|desc': 'newest',
  'date|asc': 'oldest',
  'rating|desc': 'rating_desc',
  'rating|asc': 'rating_asc',
  'pictures|desc': 'pictures_first',
};

function sfSort(value) {
  return SORTS[String(value || '')] || 'helpful';
}

function apiBase() {
  var el = document.getElementById('wc-review-config');
  if (!el) return null;
  try {
    var cfg = JSON.parse(el.textContent);
    var url = cfg && cfg.apiUrl ? String(cfg.apiUrl).trim() : '';
    // An un-injected token (`__REVIEW_SF_API_URL__`) is not a URL: SF stays off.
    return /^https?:\/\//.test(url) ? url.replace(/\/+$/, '') : null;
  } catch (error) {
    return null;
  }
}

function markDown() {
  try {
    window.sessionStorage.setItem(DOWN_KEY, String(Date.now() + DOWN_TTL));
  } catch (error) {
    // Storage blocked: only this page falls back.
  }
}

function isDown() {
  try {
    return parseInt(window.sessionStorage.getItem(DOWN_KEY), 10) > Date.now();
  } catch (error) {
    return false;
  }
}

/* GET with a timeout. Resolves to the JSON, or null on a non-2xx, a network
 * error, the timeout or a body that is not JSON. Only the mount-time loads
 * (`load`) mark the API down: a later page / count / strip request failing is
 * that one request's problem — it must not switch every band in the tab to
 * Judge.me for five minutes. */
function getJson(url) {
  var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
  var timer = setTimeout(function () { if (controller) controller.abort(); }, SF_TIMEOUT);
  return fetch(url, { headers: { accept: 'application/json' }, signal: controller ? controller.signal : undefined })
    .then(function (response) { return response.ok ? response.json() : null; })
    .catch(function () { return null; })
    .then(function (json) {
      clearTimeout(timer);
      return json;
    });
}

/* One API item to the review object the UI renders. A rating-only review (no
 * body) is kept: SF's `total_count` and stats count it, so dropping it would
 * leave a page short and the counts promising rows that never show.
 * `withProduct`: the shop-wide feed, where each review names its product
 * ("Purchased item"); a PDP review does not. */
function toReview(item, withProduct) {
  if (!item || item.id == null) return null;
  var body = item.body ? String(item.body).trim() : '';
  var code = String(item.country_code || '').toUpperCase();
  return {
    id: String(item.id || ''),
    helpful: parseInt(item.helpful_count, 10) || 0,
    author: item.reviewer_name || '',
    variant: '',
    title: item.title || '',
    country: /^[A-Z]{2}$/.test(code) ? code : '',
    rating: parseInt(item.rating, 10) || 0,
    dateIso: item.external_created_at || '',
    body: body,
    photos: (Array.isArray(item.pictures) ? item.pictures : []).map(function (p) {
      var full = typeof p === 'string' ? p : (p && p.url) || '';
      var src = typeof p === 'string' ? p : (p && (p.thumbnail_url || p.url)) || '';
      return { src: src, full: full || src };
    }).filter(function (p) { return p.src; }),
    reply: item.reply_body || '',
    product: withProduct ? toProduct(item.product) : null,
  };
}

/* The image is left to the UI, which reads it off `/products/<handle>.js`. */
function toProduct(p) {
  if (!p || !p.title) return null;
  return { title: String(p.title), href: p.handle ? '/products/' + encodeURIComponent(p.handle) : '', image: '' };
}

/* A list response to { rows, total, got }, or null when it is not one. */
function readList(json, withProduct) {
  if (!json || !Array.isArray(json.items)) return null;
  var rows = [];
  json.items.forEach(function (item) {
    var review = toReview(item, withProduct);
    if (review) rows.push(review);
  });
  var total = parseInt(json.total_count, 10);
  return { rows: rows, total: isNaN(total) ? NaN : total, got: json.items.length };
}

/* /sf/stats to the aggregate the UI's summary rail takes. */
function readStats(json) {
  if (!json || typeof json.count !== 'number') return null;
  var per = json.per_rating || {};
  var avg = parseFloat(json.avg);
  return {
    averageValue: isNaN(avg) ? null : avg,
    count: json.count,
    dist: {
      5: parseInt(per[5], 10) || 0,
      4: parseInt(per[4], 10) || 0,
      3: parseInt(per[3], 10) || 0,
      2: parseInt(per[2], 10) || 0,
      1: parseInt(per[1], 10) || 0,
    },
  };
}

function createSf(root, opts) {
  if (!window.__WC_REVIEW_SF_SOURCE__ || isDown()) return null;
  var base = apiBase();
  var shop = root.getAttribute('data-ds-reviews-shop');
  var productId = root.getAttribute('data-ds-reviews-product');
  var feedAll = root.getAttribute('data-ds-reviews-feed') === 'all';
  if (!base || !shop || (!feedAll && !productId)) return null;
  var perPage = opts.perPage;
  // No product = the whole shop.
  var target = '?store_id=' + encodeURIComponent(shop) +
    (feedAll ? '' : '&product_external_id=' + encodeURIComponent('gid://shopify/Product/' + productId));

  /* `q` is the UI's query: { sort, rating, photo }. */
  function listUrl(n, limit, q) {
    return base + '/sf/reviews' + target +
      '&limit=' + limit + '&page=' + n + '&sort=' + sfSort(q.sort) +
      (q.rating ? '&rating=' + encodeURIComponent(q.rating) : '') +
      (q.photo ? '&with_photos=true' : '');
  }

  /* Page 1 that `load` already fetched, handed out once to the list's first
   * request for that same query instead of asking again. */
  var primed = {};

  function list(url) {
    if (primed[url]) {
      var hit = primed[url];
      delete primed[url];
      return Promise.resolve(hit);
    }
    return getJson(url).then(function (json) {
      return readList(json, feedAll);
    });
  }

  var data = {
    name: 'sf',
    // The API filters by photo (`with_photos`) and counts it.
    photoServer: true,
    trustDraftTotals: true,
    // `aggregate.dist` is SF's own count: the rating rows are redrawn from it.
    rewritesRatingRows: true,
    // PDP: `strip` returns every photo review at once (`/sf/media`); the shop-wide
    // strip pages (see `strip`).
    /* The strip is paged on the server in both layouts: ten photo reviews at a time on a PDP, twenty on the
     * reviews page (`/sf/media`, product- or shop-wide) — the lightbox asks for more as it nears the end. */
    stripPaged: true,
    // The API pages as deep as the query goes.
    maxReviews: Infinity,
    hasTarget: true,
    aggregate: null,
    seed: [],
    // Raw /sf/stats, kept for the counts it already holds (with media).
    stats: null,

    /* Star counts come from the stats histogram (written onto the rating rows);
     * anything with photos is one count request. */
    countsByRequest: function (f) {
      return !!f.photo;
    },

    /* Stats + list page 1 in the band's default sort, together. Resolves true
     * when both answered, filling `aggregate` and `seed`. */
    load: function (sort) {
      var firstUrl = listUrl(1, perPage, { sort: sort });
      return Promise.all([getJson(base + '/sf/stats' + target), list(firstUrl)]).then(function (r) {
        var stats = readStats(r[0]);
        var first = r[1];
        if (!stats || !first) {
          // The band's choice failed on SF: remember the outage for the tab.
          markDown();
          return false;
        }
        data.stats = r[0];
        data.aggregate = stats;
        data.seed = first.rows;
        primed[firstUrl] = first;
        return true;
      });
    },

    page: function (n, q) {
      return list(listUrl(n, perPage, q));
    },

    /* The photo strip, from `/sf/media`, one page of photo reviews under the active star filter: ten a page on a
     * PDP, twenty shop-wide. Both come back with the query's review total, so the lightbox can ask for the next
     * page as it nears the end; the PDP also gets the product's photo count for its header. */
    strip: function (n, q) {
      var f = q || {};
      var url = base + '/sf/media' + target +
        '&limit=' + (feedAll ? 20 : 10) + '&page=' + n +
        (f.rating ? '&rating=' + encodeURIComponent(f.rating) : '');
      return getJson(url).then(function (json) {
        if (!json || !Array.isArray(json.reviews)) return null;
        var rows = [];
        json.reviews.forEach(function (item) {
          var review = toReview(item, feedAll);
          if (review && review.photos.length) rows.push(review);
        });
        var total = parseInt(json.total_count, 10);
        var photos = parseInt(json.photo_count, 10);
        /* `total` = reviews with media for the query (what paging walks); `got` = reviews this page carried,
         * video-only ones included, so a page with no photo row is not mistaken for the end; `photos` = every
         * photo of the product under the active star filter (the PDP's "Customer photos (N)" and "+N" read it).
         * Shop-wide has no photo count — that feed counts reviews. */
        return {
          rows: rows,
          total: isNaN(total) ? rows.length : total,
          got: json.reviews.length,
          photos: feedAll || isNaN(photos) ? null : photos,
        };
      });
    },

    /* A single filter the stats already counted costs nothing; a combination
     * is one request. */
    count: function (q) {
      var s = data.stats;
      if (s && !q.rating && q.photo) {
        if (typeof s.with_media_count === 'number') return Promise.resolve(s.with_media_count);
      }
      return list(listUrl(1, 1, q)).then(function (res) {
        return res && !isNaN(res.total) ? res.total : null;
      });
    },
  };
  return data;
}

if (typeof window !== 'undefined') {
  window.WcReviewData = window.WcReviewData || {};
  window.WcReviewData.sf = createSf;
}

} catch (sfError) {
if (typeof console !== 'undefined') console.error('[sf-core] behavior "product-reviews-data-sf" failed to initialise:', sfError);
}
})();

/* product-variants.js */
(function () {
try {
/* product-variants — fully client-side PDP variant selection.
 * Reads every variant's option values + availability from a JSON payload
 * embedded once by ds-product-variants.liquid, so changing ANY option (Style,
 * Color, Size, ...) resolves the matching variant and updates selection,
 * cross-option availability, price, gallery and URL instantly — no server
 * round-trip, even when the change invalidates other options' selections.
 * Progressive enhancement: without JS every value remains a normal variant
 * URL, server-resolved to its best matching variant.
 * Authoring rules: src/behaviors/README.md. No import/export.
 *
 * ponytail: cross-option fallback keeps a later option when the new variant
 * has the same value. Colour is matched by name, not the whole string, so
 * "Tshirt Forest Green" survives a switch to "Hoodie Forest Green". Size and
 * every other later option still have to match exactly. A colour the new
 * style does not sell falls through to the first available match.
 */

function dsParseVariants(picker) {
  var script = picker.querySelector('script[data-ds-product-variants-json]');
  if (!script) return [];
  try {
    var parsed = JSON.parse(script.textContent);
    return Array.isArray(parsed) ? parsed : [];
  } catch (e) {
    return [];
  }
}

function dsInitialSelection(picker, variants) {
  var id = Number(picker.dataset.dsSelectedVariantId);
  var current = null;
  for (var i = 0; i < variants.length; i++) {
    if (variants[i].id === id) { current = variants[i]; break; }
  }
  if (!current) current = variants[0];
  return { 1: current.option1, 2: current.option2, 3: current.option3 };
}

// "Tshirt Forest Green" and "Hoodie Forest Green" are the same colour. The
// style prefix is option1, in both the hyphenated form and the squashed one
// ("T-shirt" -> "Tshirt"), matching ds-product-variant-value.liquid.
function dsColorName(value, style) {
  var cleaned = value == null ? '' : String(value);
  var prefix = style == null ? '' : String(style);
  var squash = prefix.replace(/[-\s]/g, '');
  function strip(token) {
    if (!token) return;
    var at = cleaned.indexOf(token);
    if (at < 0) return;
    cleaned = cleaned.slice(0, at) + cleaned.slice(at + token.length);
  }
  strip(prefix);
  if (squash !== prefix) strip(squash);
  return cleaned.trim().toLowerCase();
}

// Resolve the variant to select after `position` changes to `value`, keeping
// as much of the rest of `selection` as possible: options before `position`
// must match exactly (mirrors the picker's own colour/size scoping), options
// after are kept on a best-effort basis, available beats unavailable.
// `colorPosition` is the colour option (0 when the product has none).
// `styleForColor` is the style the current colour string was chosen under —
// the style BEFORE this click — so the name strip uses the right prefix.
function dsPickVariant(variants, selection, position, colorPosition, styleForColor) {
  var best = null;
  var bestScore = -1;
  var i, p, v, score, priorOk;
  var colorStyle = styleForColor != null ? styleForColor : selection[1];

  for (i = 0; i < variants.length; i++) {
    v = variants[i];
    if (v['option' + position] !== selection[position]) continue;

    priorOk = true;
    for (p = 1; p < position; p++) {
      if (selection[p] != null && v['option' + p] !== selection[p]) { priorOk = false; break; }
    }
    if (!priorOk) continue;

    score = v.available ? 1000 : 0;
    for (p = position + 1; p <= 3; p++) {
      if (selection[p] == null) continue;
      if (colorPosition && p === colorPosition) {
        var want = dsColorName(selection[p], colorStyle);
        var got = dsColorName(v['option' + p], v.option1);
        if (want && want === got) score += 100;
      } else if (v['option' + p] === selection[p]) {
        score += 10;
      }
    }
    if (score > bestScore) { bestScore = score; best = v; }
  }

  if (!best) {
    for (i = 0; i < variants.length; i++) {
      if (variants[i]['option' + position] === selection[position]) { best = variants[i]; break; }
    }
  }
  return best;
}

// Does some available variant carry `value` at `position` given only the
// options BEFORE `position` (mirrors dsPickVariant's priorOk) — later
// options are best-effort, not a filter. Checking ALL positions instead would
// deadlock: e.g. after Style changes and auto-corrects Color, the old Style
// value would depend on the new Color matching it, which it never will, so
// it would stay hidden forever with nothing left to reveal it.
function dsValueAvailable(variants, selection, position, value) {
  for (var i = 0; i < variants.length; i++) {
    var v = variants[i];
    if (v['option' + position] !== value || !v.available) continue;

    var ok = true;
    for (var p = 1; p < position; p++) {
      if (selection[p] != null && v['option' + p] !== selection[p]) { ok = false; break; }
    }
    if (ok) return true;
  }
  return false;
}

function dsSetLinkSelected(link, selected) {
  // "true", the value Liquid renders: toggleAttribute writes "", which the
  // [aria-current='true'] rules (variants.css, bmsm.css) do not match, so a
  // clicked chip fell back to the 1px rest border.
  if (selected) link.setAttribute('aria-current', 'true');
  else link.removeAttribute('aria-current');

  if (link.hasAttribute('data-ds-bmsm-pill')) return;

  if (link.hasAttribute('data-ds-color-swatch')) {
    link.classList.toggle('sf-border-transparent', selected);
    link.classList.toggle('sf-outline', selected);
    link.classList.toggle('sf-outline-ring', selected);
    link.classList.toggle('sf-outline-secondary', selected);
    link.classList.toggle('sf-outline-offset-selected', selected);
    link.classList.toggle('sf-border-default', !selected);
  } else {
    // Border width stays fixed (sf-border-emphasis, set server-side); only
    // colour toggles, so selecting a value never resizes its box and shifts
    // the row (was device-dependent since it hinged on text-wrap timing).
    link.classList.toggle('sf-border-action-secondary', selected);
    link.classList.toggle('sf-text-badge-secondary', selected);
    link.classList.toggle('sf-border-default', !selected);
    link.classList.toggle('sf-text-primary', !selected);
    // Selected or not, an enabled value tints on hover / press (Liquid renders
    // both states that way), so the classes are only ever added here.
    link.classList.add('hover:sf-bg-surface-hover', 'active:sf-bg-surface-pressed');
  }
}

function dsSyncDroplistTriggers(picker) {
  picker.querySelectorAll('[data-ds-variant-droplist]').forEach(function (droplist) {
    var selectedRow = droplist.querySelector('[data-ds-variants-layout="row"][aria-current]');
    var trigger = droplist.querySelector('[data-ds-variants-layout="trigger"]');
    if (!selectedRow || !trigger) return;

    var rowLabel = selectedRow.querySelector('[data-ds-variants-label]');
    var triggerLabel = trigger.querySelector('[data-ds-variants-label]');
    if (rowLabel && triggerLabel) triggerLabel.textContent = rowLabel.textContent;

    var rowPrice = selectedRow.querySelector('[data-ds-variants-price]');
    var triggerPrice = trigger.querySelector('[data-ds-variants-price]');
    if (triggerPrice) triggerPrice.textContent = rowPrice ? rowPrice.textContent : '';

    trigger.setAttribute('data-ds-variants-value', selectedRow.getAttribute('data-ds-variants-value') || '');
  });
}

// wanderprints-theme main, VariantSelector.getUnitPrice: parseInt the option
// value ("2 PCS" -> 2, "2-pack" -> 2). More than one piece floors the cents;
// anything else, including a value that does not start with a number, is the
// variant price itself.
function dsUnitCents(cents, value) {
  var quantity = parseInt(value, 10);
  if (quantity > 1) return Math.floor(cents / quantity);
  return cents;
}

// wanderprints-theme main, VariantSelector.findVariant: the first available
// variant whose set options all match. A later option is not a best-effort
// colour match; if it is set, it has to be that value.
function dsFindAvailableVariant(variants, selection) {
  for (var i = 0; i < variants.length; i++) {
    var variant = variants[i];
    if (variant.available === false) continue;
    var ok = true;
    for (var level = 1; level <= 3; level++) {
      var value = selection[level];
      var got = variant['option' + level];
      if (value && got && got !== value) { ok = false; break; }
    }
    if (ok) return variant;
  }
  return null;
}

function dsVariantMoney(picker, cents) {
  var format = (picker.getAttribute('data-ds-product-variants-money') || '${{amount}}').replace(/<[^>]*>/g, '');
  var amount = (Number(cents) || 0) / 100;
  var text = amount.toFixed(2);
  if (/\{\{\s*amount_no_decimals/.test(format)) text = String(Math.round(amount));
  else if (/\{\{\s*amount_with_comma_separator/.test(format)) text = text.replace('.', ',');
  return format.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, text);
}

// Pack pills are rendered once, against the style that was selected at page
// load. A later Style click changes the real variant price, so each pill's
// "/pc" has to be recomputed from the variant that pairs that pack with the
// selection now on the page.
function dsSyncUnitPrices(picker, variants, selection) {
  picker.querySelectorAll('[data-ds-product-variant-option][data-ds-unit-suffix]').forEach(function (wrapper) {
    var node = wrapper.querySelector('[data-ds-bmsm-pill-bot], [data-ds-variants-unit-price]');
    if (!node) return;
    var position = Number(wrapper.dataset.optionPosition);
    var value = wrapper.dataset.optionValue;
    if (!position) return;

    var trial = { 1: selection[1], 2: selection[2], 3: selection[3] };
    trial[position] = value;
    var variant = dsFindAvailableVariant(variants, trial);
    if (!variant || !Number.isFinite(variant.priceCents)) return;

    node.textContent = dsVariantMoney(picker, dsUnitCents(variant.priceCents, value)) + (wrapper.getAttribute('data-ds-unit-suffix') || '');
  });
}

function dsUpdatePrice(productSection, variant) {
  var price = productSection.querySelector('[data-ds-product-price]');
  if (!price) return;

  var amount = price.querySelector('[data-ds-price-amount]');
  if (amount) amount.textContent = variant.price || '';

  var compare = price.querySelector('[data-ds-price-compare]');
  if (compare) {
    compare.textContent = variant.compareAtPrice || '';
    compare.hidden = !variant.compareAtPrice;
  }

  var discount = price.querySelector('[data-ds-price-discount]');
  if (discount) {
    var label = discount.querySelector('[data-ds-badge] .label');
    if (label) label.textContent = variant.discount || '';
    discount.hidden = !variant.discount;
  }
}

function dsUpdateForms(productSection, variantId) {
  productSection.querySelectorAll('input[name="id"]').forEach(function (input) {
    input.value = variantId;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
}

function dsUpdateGallery(productSection, imageId) {
  if (!imageId) return;
  var tile = productSection.querySelector('[data-ds-thumbnail-rail-image-id="' + imageId + '"] [data-ds-thumbnail]');
  if (tile) tile.click();
}

function dsApplyVariant(picker, productSection, variants, selection, variant) {
  [1, 2, 3].forEach(function (p) {
    if (variant['option' + p] != null) selection[p] = variant['option' + p];
  });

  picker.querySelectorAll('[data-ds-product-variant-option]').forEach(function (wrapper) {
    var position = Number(wrapper.dataset.optionPosition);
    var value = wrapper.dataset.optionValue;
    if (!position || value == null) return;

    var selected = selection[position] === value;
    var available = dsValueAvailable(variants, selection, position, value);
    wrapper.hidden = !available && !selected;

    var link = wrapper.querySelector('[data-ds-variants], [data-ds-color-swatch]');
    if (link) dsSetLinkSelected(link, selected);
  });

  dsSyncDroplistTriggers(picker);
  dsSyncUnitPrices(picker, variants, selection);
  dsUpdatePrice(productSection, variant);
  dsUpdateForms(productSection, variant.id);
  dsUpdateGallery(productSection, variant.imageId);

  var url = new URL(window.location.href);
  url.searchParams.set('variant', variant.id);
  url.searchParams.delete('option_values');
  url.searchParams.delete('section_id');
  window.history.replaceState({}, '', url.toString());

  productSection.dispatchEvent(new CustomEvent('variant:change', {
    detail: { variantId: variant.id, url: url.toString() },
    bubbles: true,
  }));
}

if (!document.__dsProductVariantsBound) {
  document.__dsProductVariantsBound = true;

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var link = target.closest(
      '[data-ds-product-variants] a[data-ds-variants], [data-ds-product-variants] a[data-ds-color-swatch]'
    );
    if (!link) return;

    var wrapper = link.closest('[data-ds-product-variant-option]');
    var picker = link.closest('[data-ds-product-variants]');
    var productSection = link.closest('[data-ds-product-section]');
    if (!wrapper || !picker || !productSection) return;

    var position = Number(wrapper.dataset.optionPosition);
    var value = wrapper.dataset.optionValue;
    if (!position || value == null) return;

    if (!picker.__dsVariants) picker.__dsVariants = dsParseVariants(picker);
    var variants = picker.__dsVariants;
    if (!variants.length) return; // no JSON payload — fall back to native navigation

    if (!picker.__dsSelection) picker.__dsSelection = dsInitialSelection(picker, variants);
    var selection = picker.__dsSelection;
    var previous = selection[position];
    var styleForColor = selection[1];
    var colorPosition = Number(picker.dataset.dsColorPosition) || 0;
    selection[position] = value;

    var variant = dsPickVariant(variants, selection, position, colorPosition, styleForColor);
    if (!variant) { selection[position] = previous; return; }

    event.preventDefault();
    dsApplyVariant(picker, productSection, variants, selection, variant);
  });
}

} catch (sfError) {
if (typeof console !== 'undefined') console.error('[sf-core] behavior "product-variants" failed to initialise:', sfError);
}
})();

/* region-modal.js */
(function () {
try {
/* region-modal — opens the shared "Region and language" dialog (ds-region-modal)
 * from any [data-ds-locale-open] trigger (header / footer locale selector),
 * filters the country list, and on row-click sets the localization form's
 * country_code and submits it (POST /localization) to switch country + currency.
 *
 * Singleton: ds-region-modal is meant to render once per page, but the header and
 * footer selectors may each include one. On init we keep the first modal in the
 * DOM and remove any extras so every trigger drives the same dialog.
 *
 * Progressive enhancement: without this script the triggers are inert and the
 * modal stays hidden — nothing breaks, the country just can't be changed from the
 * selector until JS loads.
 *
 * Open/closed is one attribute, [aria-hidden]. src/region-modal.css carries the
 * fade + slide off it so the sheet stays painted while it animates out; toggling
 * a display utility here would cut that off.
 *
 * Authoring rules: src/behaviors/README.md. No import/export.
 */

(function () {
  if (document.__dsRegionModalBound) return;
  document.__dsRegionModalBound = true;

  var lastTrigger = null;

  function getModal() {
    return document.querySelector('[data-ds-region-modal]');
  }

  function dedupe() {
    var modals = document.querySelectorAll('[data-ds-region-modal]');
    for (var i = 1; i < modals.length; i++) {
      modals[i].parentNode && modals[i].parentNode.removeChild(modals[i]);
    }
  }

  function openModal(trigger) {
    // Sections can mount after this behavior initializes (Theme Editor and
    // Storybook do this), so enforce the singleton again at interaction time.
    dedupe();
    var modal = getModal();
    if (!modal) return;
    lastTrigger = trigger || null;
    modal.setAttribute('aria-hidden', 'false');
    modal.setAttribute('data-ds-page-lock', '');

    var search = modal.querySelector('[data-ds-region-search]');
    if (search) {
      search.value = '';
      applyFilter(modal, '');
      // Focus after paint so the dialog is visible first.
      window.requestAnimationFrame(function () {
        search.focus();
      });
    }
  }

  function closeModal() {
    var modal = getModal();
    if (!modal) return;
    modal.setAttribute('aria-hidden', 'true');
    modal.removeAttribute('data-ds-page-lock');
    var dialog = modal.querySelector('[data-ds-region-dialog]');
    if (dialog) dialog.style.minHeight = '';
    if (lastTrigger && typeof lastTrigger.focus === 'function') {
      lastTrigger.focus();
    }
    lastTrigger = null;
  }

  function isOpen(modal) {
    return !!modal && modal.getAttribute('aria-hidden') === 'false';
  }

  // Tab must cycle inside the dialog while it is open, otherwise focus walks the
  // page behind the sheet — which is still rendered ([aria-hidden] only).
  function trapTab(e) {
    var modal = getModal();
    if (!isOpen(modal)) return;
    var dialog = modal.querySelector('[data-ds-region-dialog]') || modal;
    var focusable = Array.prototype.filter.call(
      dialog.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])',
      ),
      function (el) {
        return el.offsetParent !== null || el === document.activeElement;
      },
    );
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    } else if (!dialog.contains(document.activeElement)) {
      e.preventDefault();
      first.focus();
    }
  }

  function applyFilter(modal, rawQuery) {
    var query = (rawQuery || '').trim().toLowerCase();
    var searching = query.length > 0;

    // Lock the card at the height it had before the list shrinks, measured
    // before rows hide. Clearing the query releases it.
    var dialog = modal.querySelector('[data-ds-region-dialog]');
    if (dialog) {
      if (searching) {
        if (!dialog.style.minHeight) {
          dialog.style.minHeight = Math.round(dialog.getBoundingClientRect().height) + 'px';
        }
      } else {
        dialog.style.minHeight = '';
      }
    }

    var popularGroup = modal.querySelector('[data-ds-region-group="popular"]');
    var popularLabel = modal.querySelector('[data-ds-region-popular-label]');
    var allLabel = modal.querySelector('[data-ds-region-all-label]');
    var allGroup = modal.querySelector('[data-ds-region-group="all"]');
    var popularSection = modal.querySelector('[data-ds-region-section="popular"]');
    var allSection = modal.querySelector('[data-ds-region-section="all"]');
    var empty = modal.querySelector('[data-ds-region-empty]');

    // ALL COUNTRIES excludes popular rows (SoT rest filter). Search both groups
    // so popular countries stay findable; hide section titles while querying.
    if (popularLabel) popularLabel.hidden = searching;
    if (allLabel) allLabel.hidden = searching;

    var visible = 0;
    var popularVisible = 0;
    var allVisible = 0;
    [popularGroup, allGroup].forEach(function (group) {
      if (!group) return;
      var options = group.querySelectorAll('[data-ds-region-option]');
      options.forEach(function (opt) {
        var haystack = opt.getAttribute('data-search') || '';
        var match = !searching || haystack.indexOf(query) !== -1;
        var li = opt.closest('li') || opt;
        li.hidden = !match;
        if (match) {
          visible++;
          if (group === popularGroup) popularVisible++;
          else allVisible++;
        }
      });
    });

    // Hide an empty section shell (title + list) so search results don't leave
    // a blank POPULAR block when only ALL matches.
    if (popularSection) popularSection.hidden = searching && popularVisible === 0;
    if (allSection) allSection.hidden = searching && allVisible === 0;
    if (!searching) {
      if (popularSection) popularSection.hidden = false;
      if (allSection) allSection.hidden = false;
    }

    if (empty) empty.classList.toggle('sf-hidden', visible > 0);
  }

  function selectCountry(option) {
    var modal = getModal();
    if (!modal || modal.getAttribute('aria-busy') === 'true') return;
    var form = modal.querySelector('[data-ds-region-form]');
    var input = modal.querySelector('[data-ds-region-country-input]');
    var value = option.getAttribute('data-value');
    if (!form || !input || !value) return;
    input.value = value;
    modal.setAttribute('aria-busy', 'true');
    var pending = modal.querySelector('[data-ds-region-pending]');
    if (pending) pending.hidden = false;
    // Paint the scrim before the localization POST locks the page.
    requestAnimationFrame(function () {
      if (typeof form.requestSubmit === 'function') form.requestSubmit();
      else form.submit();
    });
  }

  dedupe();

  // Open
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest && e.target.closest('[data-ds-locale-open]');
    if (trigger) {
      e.preventDefault();
      openModal(trigger);
    }
  });

  // Close (X button) + close on overlay (click outside the dialog) + select row
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;

    if (e.target.closest('[data-ds-region-close]')) {
      e.preventDefault();
      closeModal();
      return;
    }

    var option = e.target.closest('[data-ds-region-option]');
    if (option) {
      e.preventDefault();
      selectCountry(option);
      return;
    }

    var modal = getModal();
    if (isOpen(modal) && e.target === modal) {
      closeModal();
    }
  });

  // Filter as the user types
  document.addEventListener('input', function (e) {
    if (!e.target.closest) return;
    if (!e.target.matches('[data-ds-region-search]')) return;
    var modal = e.target.closest('[data-ds-region-modal]');
    if (modal) applyFilter(modal, e.target.value);
  });

  // Esc closes; Tab stays inside the dialog
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var modal = getModal();
      if (isOpen(modal)) closeModal();
      return;
    }
    if (e.key === 'Tab') trapTab(e);
  });
})();

} catch (sfError) {
if (typeof console !== 'undefined') console.error('[sf-core] behavior "region-modal" failed to initialise:', sfError);
}
})();

/* review-form.js */
(function () {
try {
/* review-form — opens the write-a-review sheet and posts it to Judge.me.
 *
 * This one CAN submit for real, which the rest of the reviews work could not.
 * Judge.me's own widget posts a review to `api.judge.me/api/v1/reviews` with a
 * body of `{url, shop_domain, platform}` plus the fields — and no api_token
 * anywhere (their `shopParams()` returns exactly those three). So a storefront
 * may post directly: no App Proxy, no secret in the theme. Photos use the same
 * public pair — GET a presigned target, PUT the file, send the returned key
 * back as `picture_keys[n]`.
 *
 * Moderation is why the success state says "once our team has checked it over"
 * rather than "your review is live": Judge.me queues new reviews, and a shopper
 * who does not know that submits again.
 *
 * Open/close follows region-modal.js exactly — [aria-hidden] on the overlay
 * drives both the animation (review-form.css) and the a11y tree, focus is
 * trapped while open and handed back to whatever opened it on close.
 *
 * Authoring rules: src/behaviors/README.md. No import/export.
 */

var FORM = '[data-ds-review-form]';
var TRIGGER = '[data-ds-reviews-write]';
var API = 'https://api.judge.me/api/v1/reviews';
var PRESIGN = 'https://api.judge.me/api/v1/pictures/presigned_data';
// The ceiling in Judge.me's own presigned policy (content-length-range).
var MAX_PHOTO_BYTES = 10 * 1024 * 1024;

var FOCUSABLE =
  'a[href],button:not([disabled]),textarea:not([disabled]),input:not([disabled]),select:not([disabled]),[tabindex]:not([tabindex="-1"])';

function visible(el) {
  return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
}

function setup(overlay) {
  var dialog = overlay.querySelector('[data-ds-review-form-dialog]');
  var form = overlay.querySelector('[data-ds-review-form-element]');
  var body = overlay.querySelector('[data-ds-review-form-body]');
  var counter = overlay.querySelector('[data-ds-review-form-counter]');
  var submitBox = overlay.querySelector('[data-ds-review-form-submit]');
  var errorBox = overlay.querySelector('[data-ds-review-form-error]');
  var done = overlay.querySelector('[data-ds-review-form-done]');
  if (!dialog || !form || !body) return;

  var submitOff = overlay.querySelector('[data-ds-review-form-submit-off]');
  var submitOn = overlay.querySelector('[data-ds-review-form-submit-on]');
  var submit = submitOn && submitOn.querySelector('button');
  var max = parseInt(overlay.getAttribute('data-ds-review-form-max'), 10) || 200;
  var min = parseInt(overlay.getAttribute('data-ds-review-form-min'), 10) || 10;
  var maxPhotos = parseInt(overlay.getAttribute('data-ds-review-form-photos'), 10) || 5;
  var files = [];
  var opener = null;
  // Copy the behaviour needs but must not contain: a behaviour cannot call `| t`,
  // so every string rides in on an attribute.
  var copy = {
    helper: overlay.getAttribute('data-ds-review-form-helper') || '',
    helperShort: overlay.getAttribute('data-ds-review-form-helper-short') || '',
    removePhoto: overlay.getAttribute('data-ds-review-form-photo-remove') || '',
    photosFull: overlay.getAttribute('data-ds-review-form-photos-full') || '',
    photoTooBig: overlay.getAttribute('data-ds-review-form-photo-too-big') || '',
  };

  /* ── open / close ─────────────────────────────────────────────────────── */

  function open(trigger) {
    opener = trigger || null;
    overlay.setAttribute('aria-hidden', 'false');
    // page-lock.js pins the page; overflow on <html> or <body> alone left it
    // scrolling underneath on iOS.
    overlay.setAttribute('data-ds-page-lock', '');
    var first = dialog.querySelector(FOCUSABLE);
    if (first) first.focus();
  }

  function close() {
    overlay.setAttribute('aria-hidden', 'true');
    overlay.removeAttribute('data-ds-page-lock');
    if (opener && typeof opener.focus === 'function') opener.focus();
    opener = null;
  }

  function isOpen() {
    return overlay.getAttribute('aria-hidden') === 'false';
  }

  // Any write-a-review control on the page opens this one sheet — the band's
  // button and the empty state's both carry the same hook. The hook sits on a
  // full-width wrapper (ds-button has no attributes slot), so only a click that
  // actually lands on the button/link inside opens — not the empty flex space.
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest(TRIGGER);
    if (!trigger || overlay.contains(trigger)) return;
    var control = event.target.closest('button, a');
    if (!control || !trigger.contains(control)) return;
    event.preventDefault();
    open(control);
  });

  overlay.addEventListener('click', function (event) {
    // Clicking the scrim closes; clicking anywhere inside the card does not.
    if (event.target === overlay) {
      close();
      return;
    }
    if (event.target.closest('[data-ds-review-form-close], [data-ds-review-form-cancel]')) {
      event.preventDefault();
      close();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (!isOpen()) return;
    if (event.key === 'Escape') {
      close();
      return;
    }
    if (event.key !== 'Tab') return;
    // Tab must cycle inside the dialog, or focus walks the page behind it.
    var stops = Array.prototype.filter.call(dialog.querySelectorAll(FOCUSABLE), visible);
    if (!stops.length) return;
    var first = stops[0];
    var last = stops[stops.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  /* ── stars ────────────────────────────────────────────────────────────── */

  /* Fill every star up to the chosen one. Both glyphs are already in the label
   * (see ds-review-form.liquid) — the colour stays orange throughout and only
   * the hollow/solid pair swaps, which is what Figma draws. */
  function paintStars(value) {
    overlay.querySelectorAll('[data-ds-review-form-star-label]').forEach(function (label) {
      var index = parseInt(label.getAttribute('data-ds-review-form-star-label'), 10);
      var hollow = label.querySelector('[data-ds-review-form-star-hollow]');
      var solid = label.querySelector('[data-ds-review-form-star-solid]');
      if (hollow) hollow.classList.toggle('sf-hidden', index <= value);
      if (solid) solid.classList.toggle('sf-hidden', index > value);
    });
  }

  overlay.addEventListener('change', function (event) {
    var star = event.target.closest('[data-ds-review-form-star]');
    if (!star) return;
    paintStars(parseInt(star.value, 10) || 0);
    refresh();
  });

  /* ── body counter ─────────────────────────────────────────────────────── */

  var helper = overlay.querySelector('[data-ds-review-form-body-helper]');

  body.addEventListener('input', function () {
    if (counter) counter.textContent = body.value.length + '/' + max;
    // Figma's desktop frame shows the budget and its mobile frame shows the
    // floor; both are true, so the helper says whichever one the shopper is
    // currently failing. Silent while the field is still untouched.
    if (helper) {
      var length = body.value.trim().length;
      helper.textContent = length > 0 && length < min ? copy.helperShort : copy.helper;
    }
    refresh();
  });

  /* ── photos ───────────────────────────────────────────────────────────── */

  var fileInput = overlay.querySelector('[data-ds-review-form-file]');
  var thumbs = overlay.querySelector('[data-ds-review-form-thumbs]');

  // The dashed dropzone is a <label> wrapping this screen-reader-only file input
  // (ds-review-form.liquid), so a click anywhere in the box opens the native
  // picker with no JS — nothing to bind here, only its `change` to read below.

  if (fileInput) {
    fileInput.addEventListener('change', function () {
      var overflowed = false;
      var oversized = false;
      Array.prototype.forEach.call(fileInput.files || [], function (file) {
        if (files.length >= maxPhotos) {
          overflowed = true;
          return;
        }
        // Judge.me's presigned policy carries content-length-range 0..10485760,
        // so a bigger file is rejected by S3 with nothing useful to show for it.
        if (file.size > MAX_PHOTO_BYTES) {
          oversized = true;
          return;
        }
        files.push(file);
      });
      fileInput.value = '';
      // Dropping the extras silently looks like the picker failed.
      if ((overflowed || oversized) && errorBox) {
        errorBox.textContent = oversized ? copy.photoTooBig : copy.photosFull;
        errorBox.classList.remove('sf-hidden');
      }
      renderThumbs();
      refresh();
    });
  }

  function renderThumbs() {
    if (!thumbs) return;
    thumbs.innerHTML = '';
    thumbs.classList.toggle('sf-hidden', files.length === 0);
    thumbs.classList.toggle('sf-flex', files.length > 0);
    files.forEach(function (file, index) {
      var item = document.createElement('li');
      item.className = 'sf-relative sf-h-review-photo-strip sf-w-review-photo-strip sf-overflow-hidden sf-rounded-md sf-bg-subtle';
      var img = document.createElement('img');
      img.className = 'sf-h-full sf-w-full sf-object-cover';
      img.alt = '';
      img.src = URL.createObjectURL(file);
      item.appendChild(img);
      var remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'sf-absolute sf-right-1 sf-top-1 sf-inline-flex sf-h-6 sf-w-6 sf-cursor-pointer sf-items-center sf-justify-center sf-rounded-circle sf-border-0 sf-bg-inverse sf-text-inverse';
      remove.textContent = '×';
      remove.setAttribute('aria-label', copy.removePhoto);
      remove.setAttribute('data-ds-review-form-remove', String(index));
      item.appendChild(remove);
      thumbs.appendChild(item);
    });
  }

  overlay.addEventListener('click', function (event) {
    var remove = event.target.closest('[data-ds-review-form-remove]');
    if (!remove) return;
    event.preventDefault();
    files.splice(parseInt(remove.getAttribute('data-ds-review-form-remove'), 10), 1);
    renderThumbs();
  });

  /* Judge.me's public two-step, matched to what their own uploader actually
   * sends (widget_form.js `_prepareFormData`). The shape is easy to get wrong
   * and fails silently, which is what happened here first: the presigned
   * response has NO `fields.key` — the key is built from a top-level
   * `key_prefix` plus the filename, appended BEFORE the other fields, with the
   * file last. Reading `fields.key` threw, the catch swallowed it, and every
   * photo was quietly dropped from the review.
   *
   * S3 answers 201 (the policy sets success_action_status), and the key we
   * built is what Judge.me wants back as `picture_keys[n]`.
   */

  // Their normalisation, kept identical so a name we accept is a name S3's
  // policy accepts: strip anything outside [a-z0-9-_.], and if that leaves no
  // basename at all, stand a timestamp in for it.
  function safeName(file) {
    var stripped = String(file.name || '').replace(/[^a-z0-9-_.]/gi, '');
    var parts = stripped.split('.');
    var ext = parts.pop();
    if (!parts.join('').length) stripped = Date.now() + '.' + ext;
    return encodeURIComponent(stripped);
  }

  function uploadPhotos() {
    if (!files.length) return Promise.resolve([]);
    var shop = overlay.getAttribute('data-ds-review-form-shop');
    var query =
      '?url=' + encodeURIComponent(shop) +
      '&shop_domain=' + encodeURIComponent(shop) +
      '&platform=shopify';

    return fetch(PRESIGN + query)
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (presigned) {
        if (!presigned || !presigned.url || !presigned.key_prefix) return [];
        return Promise.all(
          files.map(function (file) {
            var key = presigned.key_prefix + safeName(file);
            var data = new FormData();
            data.append('key', key);
            Object.keys(presigned.fields || {}).forEach(function (field) {
              data.append(field, presigned.fields[field]);
            });
            data.append('file', file);
            return fetch(presigned.url, { method: 'POST', body: data })
              .then(function (r) { return r.ok ? key : null; })
              .catch(function () { return null; });
          }),
        ).then(function (keys) { return keys.filter(Boolean); });
      })
      .catch(function () { return []; });
  }

  /* ── validity ─────────────────────────────────────────────────────────── */

  function rating() {
    var picked = overlay.querySelector('[data-ds-review-form-star]:checked');
    return picked ? parseInt(picked.value, 10) : 0;
  }

  function refresh() {
    var name = overlay.querySelector('[data-ds-review-form-name]');
    var email = overlay.querySelector('[data-ds-review-form-email]');
    var ready = !!(
      rating() > 0 &&
      body.value.trim().length >= min &&
      name && name.value.trim() &&
      email && email.value.trim() && email.checkValidity()
    );
    if (submitOff) submitOff.classList.toggle('sf-hidden', ready);
    if (submitOn) submitOn.classList.toggle('sf-hidden', !ready);
  }

  form.addEventListener('input', refresh);

  /* ── submit ───────────────────────────────────────────────────────────── */

  form.addEventListener('submit', function (event) {
    event.preventDefault();
    if (!submit || submit.disabled) return;

    var shop = overlay.getAttribute('data-ds-review-form-shop');
    var productId = overlay.getAttribute('data-ds-review-form-product');
    var name = overlay.querySelector('[data-ds-review-form-name]');
    var email = overlay.querySelector('[data-ds-review-form-email]');

    submit.disabled = true;
    if (errorBox) errorBox.classList.add('sf-hidden');

    uploadPhotos().then(function (keys) {
      var payload = new FormData();
      payload.append('url', shop);
      payload.append('shop_domain', shop);
      payload.append('platform', 'shopify');
      payload.append('id', productId);
      payload.append('rating', String(rating()));
      payload.append('body', body.value.trim());
      payload.append('name', name ? name.value.trim() : '');
      payload.append('email', email ? email.value.trim() : '');
      keys.forEach(function (key, index) {
        payload.append('picture_keys[' + index + ']', key);
      });

      return fetch(API, { method: 'POST', body: payload })
        .then(function (response) {
          if (!response.ok) throw new Error('rejected');
          form.classList.add('sf-hidden');
          if (done) {
            done.classList.remove('sf-hidden');
            done.classList.add('sf-flex');
          }
        })
        .catch(function () {
          if (errorBox) {
            errorBox.textContent = overlay.getAttribute('data-ds-review-form-error-text') || errorBox.textContent;
            errorBox.classList.remove('sf-hidden');
          }
          submit.disabled = false;
        });
    });
  });

  paintStars(0);
  refresh();
}

function init(scope) {
  (scope || document).querySelectorAll(FORM).forEach(function (overlay) {
    if (overlay.dataset.dsBound) return;
    overlay.dataset.dsBound = '1';
    setup(overlay);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () { init(); });
} else {
  init();
}

document.addEventListener('shopify:section:load', function (event) {
  init(event.target);
});

} catch (sfError) {
if (typeof console !== 'undefined') console.error('[sf-core] behavior "review-form" failed to initialise:', sfError);
}
})();

/* save-for-later.js */
(function () {
try {
/* save-for-later — the cart's "Save for later" list.
 *
 * WHERE IT LIVES (DEFAULT0260): localStorage, not a customer metafield. A theme
 * has no backend, and a metafield can only be written for a logged-in customer
 * through the Admin API — impossible for the guest who is most of a POD store's
 * traffic (Baymard: save-for-later is a cart-abandonment tool, so it has to work
 * before sign-in). localStorage keeps it client-only and guest-first. The
 * trade-off, accepted here: the list is per-browser, not cross-device, and is
 * cleared with site data. The cart itself stays the source of truth for the
 * purchase; this is only a holding shelf.
 *
 * Snapshot: saving a line reads what the cart page renders — title, image,
 * price, variant, and the VISIBLE personalization (line item properties). Hidden
 * `_`-properties are not in the DOM (Liquid drops them), so Move to Cart cannot
 * restore them; a proof URL a POD app stamped as `_proof` would be re-generated
 * by that app on the new line, not carried. Documented, not silent.
 *
 * Moving to cart re-adds by variant id (the part of the line key before ':')
 * with the saved properties, then reloads so the line list and Order Summary
 * reflect the new line — no partial client re-render to drift from the server.
 *
 * Reads/writes the grid rendered by snippets/ds-cart-saved.liquid, cloning its
 * <template> per entry. Binds data-ds-* only. Authoring rules: README.md.
 */
var SFL_CART_ITEM = '[data-ds-cart-item]';

function sflKey() {
  var host = '';
  try { host = window.location.host || ''; } catch (e) { host = ''; }
  return 'ds:cart:saved:' + host;
}

function sflRead() {
  try {
    var raw = window.localStorage.getItem(sflKey());
    var list = raw ? JSON.parse(raw) : [];
    return Array.isArray(list) ? list : [];
  } catch (e) {
    return [];
  }
}

function sflWrite(list) {
  try {
    window.localStorage.setItem(sflKey(), JSON.stringify(list));
  } catch (e) {
    /* private mode / quota — the shelf is a convenience, so fail quiet */
  }
}

function sflUrl(path) {
  var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
  return (root || '/') + path;
}

// The line key is `<variant_id>:<properties_hash>`; the id is what /cart/add.js
// wants back.
function sflVariantId(key) {
  return String(key || '').split(':')[0];
}

function sflText(root, selector) {
  var el = root.querySelector(selector);
  return el ? el.textContent.trim() : '';
}

function sflSnapshot(line) {
  var key = line.getAttribute('data-ds-cart-item-key') || '';
  var img = line.querySelector('img[src]');
  var titleEl = line.querySelector('[data-ds-cart-item-title]');
  var options = [];
  // The chosen options render as the caption spans directly under the title.
  var optionWrap = titleEl && titleEl.parentNode ? titleEl.parentNode.querySelector('div') : null;
  if (optionWrap) {
    optionWrap.querySelectorAll('span').forEach(function (span) {
      var text = span.textContent.trim();
      if (text) options.push(text);
    });
  }
  var properties = {};
  line.querySelectorAll('[data-ds-cart-item-properties] > div').forEach(function (row) {
    var dt = row.querySelector('dt');
    var dd = row.querySelector('dd');
    if (dt && dd) properties[dt.textContent.trim()] = dd.textContent.trim();
  });
  return {
    id: sflVariantId(key),
    key: key,
    title: titleEl ? titleEl.textContent.trim() : '',
    url: titleEl && titleEl.getAttribute('href') ? titleEl.getAttribute('href') : '',
    image: img ? img.getAttribute('src') : '',
    price: sflText(line, '[data-ds-price-amount]'),
    compareAt: sflText(line, '[data-ds-price-compare]'),
    variant: options.join(' / '),
    properties: properties,
  };
}

function sflAddEntry(entry) {
  if (!entry.id) return;
  var list = sflRead().filter(function (e) { return e.key !== entry.key; });
  list.unshift(entry);
  sflWrite(list);
}

function sflRemoveEntry(key) {
  sflWrite(sflRead().filter(function (e) { return e.key !== key; }));
}

// Fill one cloned card from an entry, toggling the optional rows off when the
// entry has nothing for them.
function sflFillCard(card, entry) {
  card.setAttribute('data-ds-cart-favorite-key', entry.key);
  var title = card.querySelector('[data-ds-cart-favorite-title]');
  if (title) {
    title.textContent = entry.title || '';
    if (entry.url && title.tagName === 'A') title.setAttribute('href', entry.url);
    else if (title.tagName === 'A') title.removeAttribute('href');
  }
  var img = card.querySelector('img');
  if (img) {
    if (entry.image) { img.setAttribute('src', entry.image); img.setAttribute('alt', entry.title || ''); }
  }
  var toggle = function (selector, value) {
    var el = card.querySelector(selector);
    if (!el) return;
    if (value) { el.textContent = value; el.hidden = false; el.style.display = ''; }
    else { el.hidden = true; el.style.display = 'none'; }
  };
  toggle('[data-ds-cart-favorite-variant]', entry.variant);
  toggle('[data-ds-cart-favorite-type]', entry.productType);
  var amount = card.querySelector('[data-ds-price-amount]');
  if (amount) amount.textContent = entry.price || '';
  var compare = card.querySelector('[data-ds-price-compare]');
  if (compare) {
    if (entry.compareAt) { compare.textContent = entry.compareAt; compare.hidden = false; compare.style.display = ''; }
    else { compare.hidden = true; compare.style.display = 'none'; }
  }
  var unit = card.querySelector('[data-ds-price-unit]');
  if (unit) { unit.hidden = !entry.unit; unit.style.display = entry.unit ? '' : 'none'; if (entry.unit) unit.textContent = entry.unit; }
  return card;
}

function sflRender() {
  var section = document.querySelector('[data-ds-cart-saved]');
  if (!section) return;
  var grid = section.querySelector('[data-ds-cart-saved-grid]');
  var template = section.querySelector('[data-ds-cart-saved-template]');
  if (!grid || !template) return;
  var list = sflRead();
  var count = section.querySelector('[data-ds-cart-saved-count]');
  if (count) count.textContent = String(list.length);

  if (!list.length) {
    section.hidden = true;
    grid.textContent = '';
    return;
  }
  section.hidden = false;

  var pageSize = Number(section.getAttribute('data-ds-cart-saved-page-size')) || 4;
  var expanded = section.getAttribute('data-ds-cart-saved-expanded') === 'true';
  var shown = expanded ? list : list.slice(0, pageSize);

  grid.textContent = '';
  shown.forEach(function (entry) {
    var clone = template.content.firstElementChild.cloneNode(true);
    sflFillCard(clone, entry);
    grid.appendChild(clone);
  });

  var moreWrap = section.querySelector('[data-ds-cart-saved-more-wrap]');
  if (moreWrap) moreWrap.hidden = expanded || list.length <= pageSize;
}

function sflSave(line) {
  var key = line.getAttribute('data-ds-cart-item-key');
  if (!key) return;
  sflAddEntry(sflSnapshot(line));
  // Take the line out of the cart. Saving is intentional — no undo window; the
  // way back is Move to Cart — so this commits straight away.
  fetch(sflUrl('cart/change.js'), {
    method: 'POST',
    headers: { Accept: 'application/json', 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    body: JSON.stringify({ id: key, quantity: 0 }),
  })
    .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
    .then(function (result) {
      if (!result.ok) {
        // Put the entry back on the shelf's failure: the line is still in the cart.
        sflRemoveEntry(key);
        document.dispatchEvent(new CustomEvent('ds:cart:error', { detail: result.data }));
        return;
      }
      if (line.parentNode) line.parentNode.removeChild(line);
      document.dispatchEvent(new CustomEvent('ds:cart:updated', { detail: result.data }));
      sflRender();
    })
    .catch(function (error) {
      sflRemoveEntry(key);
      document.dispatchEvent(new CustomEvent('ds:cart:error', { detail: { error: String(error) } }));
    });
}

function sflMoveToCart(card) {
  var key = card.getAttribute('data-ds-cart-favorite-key');
  var entry = sflRead().filter(function (e) { return e.key === key; })[0];
  if (!entry || !entry.id) return;
  card.setAttribute('aria-busy', 'true');
  fetch(sflUrl('cart/add.js'), {
    method: 'POST',
    headers: { Accept: 'application/json', 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    body: JSON.stringify({ id: entry.id, quantity: 1, properties: entry.properties || {} }),
  })
    .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
    .then(function (result) {
      card.removeAttribute('aria-busy');
      if (!result.ok) {
        document.dispatchEvent(new CustomEvent('ds:cart:error', { detail: result.data }));
        return;
      }
      sflRemoveEntry(key);
      document.dispatchEvent(new CustomEvent('ds:cart:moved', { detail: { id: entry.id } }));
      // Reload so the line list and Order Summary come from the server, not a
      // client guess. Tests set __dsSflNoReload to inspect the call instead.
      if (!window.__dsSflNoReload) window.location.reload();
      else sflRender();
    })
    .catch(function (error) {
      card.removeAttribute('aria-busy');
      document.dispatchEvent(new CustomEvent('ds:cart:error', { detail: { error: String(error) } }));
    });
}

if (!document.__dsSflBound) {
  document.__dsSflBound = true;

  document.addEventListener('click', function (event) {
    var target = event.target && event.target.closest ? event.target : null;
    if (!target) return;

    var save = target.closest('[data-ds-cart-item-save]');
    if (save) {
      var line = save.closest(SFL_CART_ITEM);
      if (line) { event.preventDefault(); sflSave(line); }
      return;
    }

    var move = target.closest('[data-ds-cart-favorite-move]');
    if (move) {
      var card = move.closest('[data-ds-cart-favorite]');
      if (card) { event.preventDefault(); sflMoveToCart(card); }
      return;
    }

    var remove = target.closest('[data-ds-cart-favorite-remove]');
    if (remove) {
      var rcard = remove.closest('[data-ds-cart-favorite]');
      if (rcard) { event.preventDefault(); sflRemoveEntry(rcard.getAttribute('data-ds-cart-favorite-key')); sflRender(); }
      return;
    }

    var more = target.closest('[data-ds-cart-saved-more]');
    if (more) {
      var section = more.closest('[data-ds-cart-saved]');
      if (section) { event.preventDefault(); section.setAttribute('data-ds-cart-saved-expanded', 'true'); sflRender(); }
    }
  });

  sflRender();
}

} catch (sfError) {
if (typeof console !== 'undefined') console.error('[sf-core] behavior "save-for-later" failed to initialise:', sfError);
}
})();

/* scroll-top.js */
(function () {
try {
/* scroll-top — reveals the site-wide floating "scroll to top" FAB once the page
 * has been scrolled past a threshold, and smooth-scrolls to the top on click.
 * Binds [data-ds-scroll-top] (see snippets/ds-scroll-to-top.liquid). Each button
 * carries its own reveal threshold in data-ds-scroll-top (px, merchant setting).
 *
 * Progressive enhancement: the button server-renders hidden (inline display:none)
 * and this reveals it on scroll, so with no JS it never shows — a scroll-to-top
 * control can only smooth-scroll with JS anyway (same reveal-on-scroll shape as
 * sticky-bar.js). Honours prefers-reduced-motion by jumping instead of animating.
 *
 * Authoring rules: src/behaviors/README.md. No import/export.
 */

if (!document.__dsScrollTopBound) {
  document.__dsScrollTopBound = true;

  // Toggle each FAB's inline display in step with the scroll position. Inline
  // display (not a class) so it overrides the responsive device-visibility
  // utilities the button carries; '' restores those, 'none' hides.
  function dsScrollTopUpdate() {
    var buttons = document.querySelectorAll('[data-ds-scroll-top]');
    if (!buttons.length) return;
    // An overlay that pins the page (page-lock.js) resets the window scroll to
    // 0 while it is open; that is not the shopper scrolling up.
    if (document.documentElement.hasAttribute('data-ds-page-locked')) return;
    var y = window.pageYOffset || document.documentElement.scrollTop || 0;
    for (var i = 0; i < buttons.length; i++) {
      var after = Number(buttons[i].getAttribute('data-ds-scroll-top')) || 0;
      buttons[i].style.display = y > after ? '' : 'none';
    }
  }

  // Delegate on document so a button added by a Theme-Editor section re-render is
  // handled without re-binding.
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-ds-scroll-top]');
    if (!trigger) return;
    event.preventDefault();
    var reduce =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
  });

  window.addEventListener('scroll', dsScrollTopUpdate, { passive: true });
  window.addEventListener('resize', dsScrollTopUpdate);
  // Theme editor re-adds/reorders sections without a full reload.
  document.addEventListener('shopify:section:load', dsScrollTopUpdate);

  dsScrollTopUpdate();
}

} catch (sfError) {
if (typeof console !== 'undefined') console.error('[sf-core] behavior "scroll-top" failed to initialise:', sfError);
}
})();

/* search-results.js */
(function () {
try {
/* search-results — fills the ds-search shell from the search app.
 *
 * Flow, data, filters and sort are the tenant's legacy search page
 * (lib.search.js, theme `main`): one Searchanise `getresults` call per state
 * with the same parameters (36 per page, sortBy / sortOrder, restrictBy per
 * facet, the multi-currency `union[price]`), and the state mirrored into the
 * URL with replaceState in the same shape:
 *   ?q=dog+mom&sort=price,asc&filter[snize_facet5]=Gifts For Her|Gifts For Him&filter[price]=20,40&page=2
 * The filter groups are the legacy ones: every facet of the app's catalog-wide
 * facet list (one request with no query, as the legacy page made) except
 * Rating, in the order (and with any renames) the section lists, the rest in
 * the app's order; Price is a min–max range (the legacy
 * slider, drawn as the prototype's Min / Max inputs). Option counts come from
 * the query's own answer.
 *
 * Interaction is the prototype's (storybook `3 · Pages/Search/Full Page`):
 * - Sidebar (from lg): a pick applies at once; the grid shows its loading
 *   cells and comes back.
 * - Sheet (below lg): picks are a draft. The primary button reads "Apply"
 *   until the draft differs from what is applied, then "Show N products" for
 *   the draft (re-counted on every pick), "No products" and disabled at 0.
 *   X, the scrim and Esc drop the draft; Clear all clears only the draft.
 * - Every option carries its match count for the query — the other groups
 *   applied plus that option. An option with none shows no count but stays
 *   pickable, as on the legacy page (SF0342).
 * - Applied filters show as chips over the grid; each removes itself.
 * - A page change scrolls to the top of the page body as the PLP does
 *   (collection-listing.js): smoothly on the click, then once more with no
 *   animation when the new grid is in. Focus is not moved.
 * - No results: the no-results box (Did you mean = the app's first
 *   suggestion). Filters leave nothing: the filter empty box with the chips
 *   and "Popular in “query”" (the unfiltered top results).
 *
 * Cards come from the ds-product-tile section, one request per product
 * (`/products/<handle>?section_id=ds-product-tile`), the card Recently Viewed
 * and the collection grid draw. Every other piece of markup is cloned from the
 * snippet's <template>s, so this file sets text, attributes and `hidden` only.
 *
 * Authoring rules: src/behaviors/README.md. No import/export.
 */

(function () {
  if (document.__dsSearchResultsBound) return;
  document.__dsSearchResultsBound = true;

  // The search app's own results widget also starts on any path containing
  // "search-results-page": it injects #snize_results, renders a second result
  // set and pushes its own (double-encoded) URL into history. This page draws
  // the results, so that widget must not start. Searchanise starts it only when
  // its `ResultsDiv` selector matches something, so point the selector at an
  // element that never exists. (`ResultsShow: 'N'` is not an option: on the
  // results path it makes Searchanise `location.replace('/')`.) The value is
  // pinned with a setter because init.js may run after this and write
  // "#snize_results" into the same options object; autocomplete and the
  // results path (`ResultsFormPath`) are left alone.
  if (document.querySelector('[data-ds-search]')) {
    var app = window.Searchanise || (window.Searchanise = {});
    var pin = function (options) {
      if (!options || typeof options !== 'object') return;
      try {
        Object.defineProperty(options, 'ResultsDiv', {
          configurable: true,
          enumerable: true,
          get: function () { return '[data-ds-search-app-results-off]'; },
          set: function () {},
        });
      } catch (error) {
        options.ResultsDiv = '[data-ds-search-app-results-off]';
      }
    };
    app.options = app.options || {};
    pin(app.options);
    if (app.userOptions && app.userOptions !== app.options) pin(app.userOptions);
  }

  var ENDPOINT = 'https://www.searchserverapi1.com/getresults';
  var SHEET = '(max-width: 743px)';
  var DESKTOP = '(min-width: 1024px)';
  var VISIBLE_OPTIONS = 8;

  function fill(text, map) {
    var out = String(text || '');
    Object.keys(map).forEach(function (key) {
      out = out.split(key).join(map[key]);
    });
    return out;
  }

  function number(n) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en').format(n);
    } catch (error) {
      return String(n);
    }
  }

  function clone(template) {
    return template ? template.content.firstElementChild.cloneNode(true) : null;
  }

  function copySel(sel) {
    var out = {};
    Object.keys(sel).forEach(function (key) {
      if (sel[key] && sel[key].length) out[key] = sel[key].slice();
    });
    return out;
  }

  function sameSel(a, b) {
    var norm = function (sel) {
      return JSON.stringify(Object.keys(sel).filter(function (k) { return sel[k].length; }).sort().map(function (k) {
        return [k, sel[k].slice().sort()];
      }));
    };
    return norm(a) === norm(b);
  }

  function rootPath() {
    var routes = window.Shopify && window.Shopify.routes;
    return (routes && routes.root) || '/';
  }

  function setup(root) {
    if (root.dataset.dsBound) return;
    var configEl = root.querySelector('[data-ds-search-config]');
    if (!configEl) return;
    var cfg;
    try {
      cfg = JSON.parse(configEl.textContent);
    } catch (error) {
      return;
    }
    root.dataset.dsBound = '1';

    // Shopify's `t` escapes "&" (and quotes) in plain keys; these strings go
    // in as text, so undo that once here ("& above", not "&amp; above").
    var t = {};
    var decoder = document.createElement('textarea');
    Object.keys(cfg.i18n || {}).forEach(function (key) {
      decoder.innerHTML = cfg.i18n[key];
      t[key] = decoder.value;
    });
    var groups = [];
    var perPage = parseInt(cfg.perPage, 10) || 36;
    var localCountries = String(cfg.localCountries || '').split(',').map(function (c) { return c.trim().toUpperCase(); });
    var moneyParts = String(cfg.money || '$__N__').split('__N__');

    var q = function (sel) { return root.querySelector(sel); };
    var qa = function (sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };
    var templates = {
      group: q('template[data-ds-filter-group]'),
      checkbox: q('template[data-ds-filter-option="checkbox"]'),
      price: q('template[data-ds-filter-price]'),
      chip: q('template[data-ds-search-chip]'),
      skeleton: q('template[data-ds-search-skeleton]'),
    };
    var sortValues = qa('template[data-ds-search-sort-option]').map(function (el) {
      return el.getAttribute('data-ds-search-sort-option');
    });

    var header = q('[data-ds-collection-header]');
    var heading = header && header.querySelector('h1');
    var countPill = q('[data-ds-collection-header-count]');
    var results = q('[data-ds-search-results]');
    var empty = q('[data-ds-search-empty]');
    var grid = q('[data-ds-search-grid]');
    var nomatch = q('[data-ds-search-nomatch]');
    var pager = q('[data-ds-search-pagination]');
    var sheet = q('[data-ds-search-sheet]');
    var sheetPanel = q('[data-ds-search-sheet-panel]');
    var sheetApply = q('[data-ds-search-sheet-apply]');
    var sheetClear = q('[data-ds-search-sheet-clear]');
    var filterOpen = q('[data-ds-search-filter-open]');

    // ── State ────────────────────────────────────────────────────────────
    // sel: { attribute: [values] } — facet values. custom: the Min / Max
    // price range ({ min, max }, either may be null).

    function readUrl() {
      var params = new URLSearchParams(window.location.search);
      var st = { q: (params.get('q') || '').trim(), sort: sortValues[0], page: 1, sel: {}, custom: null };
      var sort = (params.get('sort') || '').replace(',', '-');
      if (sortValues.indexOf(sort) !== -1) st.sort = sort;
      var page = parseInt(params.get('page'), 10);
      if (page > 0) st.page = page;
      params.forEach(function (value, name) {
        // Shopify's preview bar re-encodes the URL once more (filter%5Bx%5D).
        try {
          name = decodeURIComponent(name);
        } catch (error) {
          /* keep it as it came */
        }
        var match = name.match(/^filter\[(.+)\]$/);
        if (!match || !value) return;
        var key = match[1];
        var values = value.split('|').filter(Boolean);
        if (key === 'price') {
          var lo = parseFloat(values[0].split(',')[0]);
          var hi = parseFloat(values[0].split(',')[1]);
          if (!isNaN(lo) || !isNaN(hi)) st.custom = { min: isNaN(lo) ? null : lo, max: isNaN(hi) ? null : hi };
        } else {
          st.sel[key] = values;
        }
      });
      return st;
    }

    // `q` stays what the shopper typed, even when the app corrected it (the
    // legacy page's hidden widget rewrote it to the correction): a reload then
    // still reads "No results for “ornamnet”. Showing results for “ornament”".
    function writeUrl(st) {
      // Parameters the search does not own (view, preview_theme_id…) stay.
      var params = new URLSearchParams();
      new URLSearchParams(window.location.search).forEach(function (value, name) {
        var plain = name;
        try {
          plain = decodeURIComponent(name);
        } catch (error) {
          /* keep it as it came */
        }
        if (plain === 'q' || plain === 'sort' || plain === 'page' || /^filter(\[|%5B)/i.test(plain)) return;
        params.append(name, value);
      });
      if (st.q) params.set('q', st.q);
      params.set('sort', st.sort.replace('-', ','));
      Object.keys(st.sel).forEach(function (key) {
        if (st.sel[key].length) params.set('filter[' + key + ']', st.sel[key].join('|'));
      });
      if (st.custom) params.set('filter[price]', priceRange(st.custom));
      if (st.page > 1) params.set('page', st.page);
      window.history.replaceState(window.history.state, '', window.location.pathname + '?' + params.toString());
    }

    var state = readUrl();
    var draft = null;
    var last = null; // { data } — the applied state's answer
    var cards = {};
    var ui = { sidebar: {}, sheet: {} };
    // A misspelled query is corrected by the first, unfiltered answer, and that
    // correction is reused for every later request (counts, filters, pages) of
    // the query. A correction that only comes with filters on is not kept: it
    // is the app widening a filtered query that found nothing (a pick with no
    // match, SF0342), not a typo, and keeping it would search the wider query
    // once the filter is removed.
    var corrections = {};
    var runSeq = 0;
    var draftSeq = 0;
    var paging = false;

    function appliedCount(st) {
      var n = 0;
      Object.keys(st.sel).forEach(function (key) { n += st.sel[key].length; });
      return n + (st.custom ? 1 : 0);
    }

    // ── Search app ───────────────────────────────────────────────────────

    // The legacy slider's value: "min,max" (an open end left empty).
    function priceRange(custom) {
      return (custom.min == null ? 0 : custom.min) + ',' + (custom.max == null ? '' : custom.max);
    }

    // Straight from the state (as the legacy page did), so a filter in the URL
    // applies before the facet list has loaded.
    function restrictions(st) {
      var out = [];
      Object.keys(st.sel).forEach(function (attr) {
        if (attr !== 'price' && st.sel[attr].length) out.push(['restrictBy[' + attr + ']', st.sel[attr].join('|')]);
      });
      if (st.custom) out.push(['restrictBy[price]', priceRange(st.custom)]);
      return out;
    }

    function currencyParams(p) {
      var country = String(cfg.country || 'US').toUpperCase();
      if (localCountries.indexOf(country) === -1) return;
      var currency = cfg.currency || 'USD';
      p.set('union[price][min]', 'price_' + country + '_' + currency);
      p.set('shopify_currency', currency);
      p.set('shopify_country', country);
    }

    // Filter groups as the legacy page built them: the catalog's facets minus
    // Rating, Price only when it has a range.
    // The section's order list: "attribute" or "attribute | Label" per line.
    var order = String(cfg.filterOrder || '').split(/\r?\n/).map(function (line) {
      var parts = line.split('|');
      return { attr: parts[0].trim(), label: (parts[1] || '').trim() };
    }).filter(function (o) { return o.attr; });

    function rank(attr) {
      for (var i = 0; i < order.length; i++) if (order[i].attr === attr) return i;
      return order.length;
    }

    function toGroups(data) {
      return ((data && data.facets) || []).filter(function (f) {
        if (!f.attribute || f.attribute === 'Rating' || f.title === 'Rating') return false;
        if (f.attribute === 'price') return Boolean(f.buckets && f.buckets[0] && f.buckets[0].value !== '0.0000,0.0000');
        return true;
      }).map(function (f) {
        return {
          key: f.attribute,
          attr: f.attribute,
          type: f.attribute === 'price' ? 'price' : 'facet',
          label: (order[rank(f.attribute)] || {}).label || f.title || f.attribute,
          open: true,
          values: (f.buckets || []).map(function (b) { return { value: b.value, label: b.title || b.value }; }),
          rank: rank(f.attribute),
        };
      }).map(function (g, i) {
        g.index = i;
        return g;
      }).sort(function (a, b) {
        // Listed groups in the section's order; the rest keep the app's order.
        return a.rank - b.rank || a.index - b.index;
      });
    }

    var catalog = null;
    function loadGroups() {
      if (!catalog) {
        catalog = request(state, { catalog: true }).then(function (data) {
          groups = toGroups(data);
        }, function () {
          groups = [];
        });
      }
      return catalog;
    }

    function request(st, opts) {
      var url = new URL(ENDPOINT);
      var p = url.searchParams;
      var sort = st.sort.split('-');
      p.set('api_key', cfg.apiKey);
      if (opts.catalog) {
        // The legacy facet list: the whole catalog, no query, no sort.
        p.set('maxResults', '1');
        p.set('facets', 'true');
        currencyParams(p);
        return fetch(url.toString()).then(function (response) {
          if (!response.ok) throw new Error('HTTP ' + response.status);
          return response.json();
        });
      }
      p.set('q', corrections[st.q] || st.q);
      p.set('sortBy', sort[0]);
      p.set('sortOrder', sort[1] || 'desc');
      p.set('startIndex', opts.start || 0);
      p.set('maxResults', opts.max || 1);
      p.set('items', 'true');
      p.set('facets', opts.facets ? 'true' : 'false');
      p.set('facetsShowUnavailableOptions', 'false');
      p.set('ResultsDescriptionStrings', '0');
      p.set('ResultsTitleStrings', '2');
      p.set('collection', 'search-results-page');
      // Every request corrects the query the same way, or a count for a
      // misspelled query would read 0 while its results do not.
      p.set('queryCorrection', 'true');
      if (opts.suggestions) {
        // 6, not the legacy 3: Related Searches shows up to 6 (09-search
        // continuation spec); the legacy page fetched 3 and never showed them.
        p.set('suggestions', 'true');
        p.set('suggestionsMaxResults', '6');
      }
      currencyParams(p);
      restrictions(opts.sel || st).forEach(function (pair) {
        p.set(pair[0], pair[1]);
      });
      return fetch(url.toString()).then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.json();
      });
    }

    function total(data) {
      return parseInt(data && data.totalItems, 10) || 0;
    }

    // ── Cards ────────────────────────────────────────────────────────────

    function handleOf(item) {
      var match = String(item.link || '').match(/\/products\/([^/?#]+)/);
      if (!match) return null;
      try {
        return decodeURIComponent(match[1]);
      } catch (error) {
        return match[1];
      }
    }

    function fetchCard(handle) {
      if (cards[handle]) return cards[handle];
      var url = rootPath() + 'products/' + encodeURIComponent(handle) + '?section_id=ds-product-tile';
      cards[handle] = fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (response) {
          if (!response.ok) return null;
          return response.text().then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var holder = doc.querySelector('[data-ds-product-tile]');
            return holder && holder.firstElementChild ? holder.firstElementChild : null;
          });
        })
        .catch(function () {
          delete cards[handle];
          return null;
        });
      return cards[handle];
    }

    function loadCards(items) {
      var handles = (items || []).map(handleOf).filter(Boolean);
      return Promise.all(handles.map(fetchCard)).then(function (list) {
        return list.filter(Boolean).map(function (card) { return document.importNode(card, true); });
      });
    }

    // ── Rendering: header, states ────────────────────────────────────────

    function showLoading() {
      root.setAttribute('aria-busy', 'true');
      if (countPill) countPill.hidden = true;
      if (pager) pager.hidden = true;
      if (nomatch) nomatch.hidden = true;
      if (grid && templates.skeleton) {
        grid.hidden = false;
        grid.setAttribute('aria-busy', 'true');
        grid.replaceChildren(templates.skeleton.content.cloneNode(true));
      }
    }

    function setHeader(st, data, isEmpty) {
      if (data && data.correctedQuery && data.correctedQuery !== st.q && !appliedCount(st)) corrections[st.q] = data.correctedQuery;
      var corrected = corrections[st.q] || '';
      var shown = corrected || st.q;
      if (heading) {
        heading.textContent = !st.q ? heading.textContent : fill(isEmpty ? t.titleEmpty : t.title, { __Q__: shown });
      }
      // The header field keeps the query in force — the corrected one when the
      // app corrected it (Baymard #346), unless the shopper is typing there.
      document.querySelectorAll('[data-ds-header-search] input').forEach(function (input) {
        if (!st.q || input === document.activeElement) return;
        if (!input.value || input.value === st.q) input.value = shown;
      });
      var line = q('[data-ds-search-corrected]');
      if (line) {
        line.hidden = !corrected || isEmpty;
        var from = line.querySelector('[data-ds-search-corrected-from]');
        var to = line.querySelector('[data-ds-search-corrected-to]');
        if (from) from.textContent = '\u201c' + st.q + '\u201d';
        if (to) to.textContent = '\u201c' + corrected + '\u201d';
      }
    }

    function setCount(n) {
      if (!countPill) return;
      countPill.textContent = fill(n === 1 ? t.countOne : t.countOther, { __N__: number(n) });
      countPill.hidden = false;
    }

    function showEmpty(st, data) {
      if (results) results.hidden = true;
      if (empty) empty.hidden = false;
      if (countPill) countPill.hidden = true;
      var suggestion = ((data && data.suggestions) || []).filter(function (s) {
        return s && s.toLowerCase() !== st.q.toLowerCase();
      })[0];
      var dym = q('[data-ds-search-dym]');
      var tip = q('[data-ds-search-tip]');
      var link = q('[data-ds-search-dym-link]');
      if (dym && link && suggestion) {
        link.textContent = suggestion;
        link.href = searchHref(suggestion);
      }
      if (dym) dym.hidden = !suggestion;
      if (tip) tip.hidden = Boolean(suggestion);
    }

    // A query link back to this page; an alternate template in force
    // (`view=search`, a preview) stays on it.
    function searchHref(term) {
      var view = new URLSearchParams(window.location.search).get('view');
      return (cfg.searchUrl || window.location.pathname) + '?q=' + encodeURIComponent(term) + (view ? '&view=' + encodeURIComponent(view) : '');
    }

    function setRelated(st, data) {
      var wrap = q('[data-ds-search-related]');
      if (!wrap) return;
      var block = wrap.querySelector('[data-ds-trending-searches]');
      var list = wrap.querySelector('[data-ds-trending-searches-list]');
      var chip = wrap.querySelector('template[data-ds-trending-searches-chip]');
      if (!block || !list || !chip) return;
      var seen = {};
      seen[st.q.toLowerCase()] = true;
      if (corrections[st.q]) seen[corrections[st.q].toLowerCase()] = true;
      var terms = ((data && data.suggestions) || []).filter(function (s) {
        var key = String(s || '').toLowerCase();
        if (!key || seen[key]) return false;
        seen[key] = true;
        return true;
      }).slice(0, 6);
      list.replaceChildren();
      terms.forEach(function (term) {
        var item = clone(chip);
        var a = item.querySelector('a');
        a.href = searchHref(term);
        a.textContent = term;
        list.appendChild(item);
      });
      block.hidden = !terms.length;
      wrap.hidden = !terms.length;
    }

    // ── Rendering: sort, pagination ──────────────────────────────────────

    function renderSort(st) {
      var template = q('template[data-ds-search-sort-option="' + st.sort + '"]');
      qa('[data-ds-search-sort]').forEach(function (host, index) {
        var picker = clone(template);
        if (!picker) return;
        // Two hosts (bar, toolbar): keep the panel ids unique.
        if (index) {
          picker.querySelectorAll('[id]').forEach(function (el) { el.id += '-' + index; });
          picker.querySelectorAll('[aria-controls]').forEach(function (el) {
            el.setAttribute('aria-controls', el.getAttribute('aria-controls') + '-' + index);
          });
        }
        host.replaceChildren(picker);
      });
    }

    // ds-pagination's range (MUI, boundary 1): siblings 0 below 744 (m), 1 from 744 (d).
    function pageRange(current, count) {
      var endFirst = count - 2;
      var mStart = Math.max(Math.min(current, count - 2), 3);
      var mEnd = Math.min(Math.max(current, 3), endFirst);
      var dStart = Math.max(Math.min(current - 1, count - 4), 3);
      var dEnd = Math.min(Math.max(current + 1, 5), endFirst);
      var out = [];
      var prevM = 0;
      var prevD = 0;
      for (var p = 1; p <= count; p++) {
        var inM = p === 1 || p === count || (p >= mStart && p <= mEnd) || (p === 2 && mStart <= 3) || (p === count - 1 && mEnd >= endFirst);
        var inD = p === 1 || p === count || (p >= dStart && p <= dEnd) || (p === 2 && dStart <= 3) || (p === count - 1 && dEnd >= endFirst);
        var gapM = inM && prevM > 0 && p > prevM + 1;
        var gapD = inD && prevD > 0 && p > prevD + 1;
        if (gapM || gapD) out.push({ gap: true, m: gapM, d: gapD });
        if (inM || inD) out.push({ page: p, m: inM, d: inD });
        if (inM) prevM = p;
        if (inD) prevD = p;
      }
      return out;
    }

    function protoParts() {
      var get = function (name) {
        var tpl = q('template[data-ds-search-pagination-proto="' + name + '"]');
        return tpl ? tpl.content.firstElementChild : null;
      };
      var mid = get('mid');
      var first = get('first');
      var lastProto = get('last');
      if (!mid || !first || !lastProto) return null;
      // Base parts with no per-width visibility; onlyAt() stamps it back.
      var bare = function (el) {
        if (!el) return null;
        var copy = el.cloneNode(true);
        copy.classList.remove('sf-hidden', 'tablet-mini:sf-hidden', 'tablet-mini:sf-inline-flex');
        copy.classList.add('sf-inline-flex');
        return copy;
      };
      var link = bare(mid.querySelector('a[data-ds-pagination-item]:not([rel])'));
      var dots = bare(mid.querySelector('span[aria-hidden="true"]:not([data-ds-pagination-item])'));
      return {
        nav: mid,
        prev: mid.querySelector('a[rel="prev"]'),
        next: mid.querySelector('a[rel="next"]'),
        prevOff: first.querySelector('span[data-ds-pagination-item]'),
        nextOff: lastProto.querySelector('span[data-ds-pagination-item]:last-child'),
        current: mid.querySelector('[aria-current="page"]'),
        link: link,
        dots: dots,
      };
    }

    // Visibility per width, as ds-pagination stamps it.
    function onlyAt(el, part) {
      if (part.m && part.d) return el;
      if (part.gap) el.classList.remove('sf-inline-flex');
      if (part.m) {
        if (part.gap) el.classList.add('sf-inline-flex');
        el.classList.add('tablet-mini:sf-hidden');
      } else {
        el.classList.add('sf-hidden');
        el.classList.add('tablet-mini:sf-inline-flex');
      }
      return el;
    }

    function pageHref(st, n) {
      var params = new URLSearchParams(window.location.search);
      if (n > 1) params.set('page', n);
      else params.delete('page');
      return window.location.pathname + '?' + params.toString();
    }

    function renderPagination(st, count, from, to, all) {
      if (!pager) return;
      var host = pager.querySelector('[data-ds-search-pages]');
      var showing = pager.querySelector('[data-ds-search-showing]');
      var parts = protoParts();
      if (count <= 1 || !host || !parts) {
        pager.hidden = true;
        return;
      }
      if (showing) showing.textContent = fill(t.showing, { __FROM__: number(from), __TO__: number(to), __TOTAL__: number(all) });
      var nav = parts.nav.cloneNode(false);
      var arrow = function (live, off, n) {
        if (!live || !off) return null;
        var el = (n ? live : off).cloneNode(true);
        if (n) {
          el.href = pageHref(st, n);
          el.setAttribute('data-page', n);
        }
        return el;
      };
      var prev = arrow(parts.prev, parts.prevOff, st.page > 1 ? st.page - 1 : 0);
      if (prev) nav.appendChild(prev);
      pageRange(st.page, count).forEach(function (part) {
        var el;
        if (part.gap) {
          el = parts.dots.cloneNode(true);
        } else if (part.page === st.page) {
          el = parts.current.cloneNode(true);
          el.textContent = part.page;
          el.setAttribute('aria-label', fill(t.page, { __N__: part.page }));
        } else {
          el = parts.link.cloneNode(true);
          el.textContent = part.page;
          el.href = pageHref(st, part.page);
          el.setAttribute('data-page', part.page);
          el.setAttribute('aria-label', fill(t.page, { __N__: part.page }));
        }
        nav.appendChild(onlyAt(el, part));
      });
      var next = arrow(parts.next, parts.nextOff, st.page < count ? st.page + 1 : 0);
      if (next) nav.appendChild(next);
      host.replaceChildren(nav);
      pager.hidden = false;
    }

    // ── Rendering: filters ───────────────────────────────────────────────

    function money(n) {
      var value = Math.round(n * 100) / 100;
      return moneyParts.join(String(value));
    }

    function customLabel(custom) {
      if (custom.min != null && custom.max != null) return fill(t.priceBetween, { __MIN__: money(custom.min), __MAX__: money(custom.max) });
      if (custom.min != null) return fill(t.priceAbove, { __MIN__: money(custom.min) });
      return fill(t.priceUpTo, { __MAX__: money(custom.max) });
    }

    // Options of a group: the catalog's values (the legacy list), each with the
    // query's count — null while unknown, 0 when the query's answer lacks it.
    function optionsOf(g, st, data) {
      if (g.type === 'price') return [];
      var facet = ((data && data.facets) || []).filter(function (f) { return f.attribute === g.attr; })[0];
      var counts = {};
      ((facet && facet.buckets) || []).forEach(function (b) { counts[b.value] = parseInt(b.count, 10) || 0; });
      var list = g.values.filter(function (o) { return o.value; }).map(function (o) {
        return { value: o.value, label: o.label, count: data ? counts[o.value] || 0 : null };
      });
      // A picked value the catalog no longer lists stays, so it can be unpicked.
      (st.sel[g.key] || []).forEach(function (v) {
        if (!list.some(function (o) { return o.value === v; })) list.push({ value: v, label: v, count: data ? counts[v] || 0 : null });
      });
      return list;
    }

    // A price field's text as last written from state. A focused field still
    // showing it has no edit in progress and takes a new value; one whose text
    // differs is mid-edit and is left alone.
    function showPrice(input, value) {
      var text = value == null ? '' : String(value);
      input.value = text;
      input.setAttribute('data-ds-filter-price-shown', text);
    }

    // focusTo: where focus is moving while a price commit re-renders the panel
    // (focusout's relatedTarget — Min → Max, or iOS's ↑ / ↓ field arrows).
    function renderPanel(host, hostName, st, data, focusTo) {
      if (!host || !templates.group) return;
      var active = document.activeElement;
      var focusKey = active && host.contains(active) && active.getAttribute('data-ds-filter-key');
      // The Price group is kept in place, not rebuilt, while a field in it has
      // focus or is about to: a replaced input loses focus, and on iOS that
      // closes the keyboard (moving Max → Min with the ↑ arrow did, BY-115).
      var oldPrice = host.querySelector('[data-ds-filter-section="price"]');
      var keep = oldPrice && ((active && oldPrice.contains(active)) || (focusTo && oldPrice.contains(focusTo))) ? oldPrice : null;
      var frag = document.createDocumentFragment();
      groups.forEach(function (g) {
        var options = optionsOf(g, st, data);
        if (!options.length && g.type === 'facet') return;
        var view = ui[hostName][g.key] || (ui[hostName][g.key] = { open: g.open, all: false });
        if (keep && g.type === 'price') {
          var keptBadge = keep.querySelector('[data-ds-filter-group-count]');
          keptBadge.textContent = st.custom ? 1 : 0;
          keptBadge.hidden = !st.custom;
          keep.querySelectorAll('[data-ds-filter-price-min], [data-ds-filter-price-max]').forEach(function (input) {
            if (input === document.activeElement && input.value !== input.getAttribute('data-ds-filter-price-shown')) return;
            var end = input.hasAttribute('data-ds-filter-price-min') ? 'min' : 'max';
            showPrice(input, st.custom ? st.custom[end] : null);
          });
          frag.appendChild(document.createComment('price'));
          return;
        }
        var section = clone(templates.group);
        section.setAttribute('data-ds-filter-section', g.key);
        var toggle = section.querySelector('[data-ds-filter-group-toggle]');
        var body = section.querySelector('[data-ds-filter-group-body]');
        var bodyId = root.id + '-' + hostName + '-' + g.key.replace(/[^a-z0-9_-]/gi, '');
        body.id = bodyId;
        toggle.setAttribute('aria-controls', bodyId);
        toggle.setAttribute('aria-expanded', view.open ? 'true' : 'false');
        toggle.setAttribute('data-ds-filter-key', 'group:' + g.key);
        toggle.setAttribute('data-ds-filter-group', g.key);
        body.hidden = !view.open;
        section.querySelector('[data-ds-filter-group-label]').textContent = g.label;
        section.querySelector('[data-ds-filter-group-legend]').textContent = g.label;
        var picked = g.type === 'price' ? (st.custom ? 1 : 0) : (st.sel[g.key] || []).length;
        var badge = section.querySelector('[data-ds-filter-group-count]');
        badge.textContent = picked;
        badge.hidden = !picked;

        var fieldset = section.querySelector('[data-ds-filter-options]');
        var shown = view.all ? options : options.slice(0, VISIBLE_OPTIONS);
        shown.forEach(function (o) {
          var row = clone(templates.checkbox);
          var input = row.querySelector('input');
          var on = (st.sel[g.key] || []).indexOf(o.value) !== -1;
          input.removeAttribute('id');
          input.name = 'ds-filter-' + hostName;
          input.value = o.value;
          input.checked = on;
          input.setAttribute('data-ds-filter-input', g.key);
          input.setAttribute('data-ds-filter-key', g.key + '\u0000' + o.value);
          row.querySelector('[data-ds-filter-option-label]').textContent = o.label;
          // Every catalog value stays pickable, as on the legacy page: a 0 here
          // is the facet count for the query as typed, but once the value is
          // picked the app may correct the query (suggestions) and find items
          // (SF0342). A 0 shows no count rather than a misleading "(0)".
          row.querySelector('[data-ds-filter-option-count]').textContent = !o.count ? '' : '(' + number(o.count) + ')';
          fieldset.appendChild(row);
        });
        var more = section.querySelector('[data-ds-filter-more]');
        if (options.length > VISIBLE_OPTIONS) {
          more.hidden = false;
          more.textContent = view.all ? t.viewLess : fill(t.viewMore, { __N__: options.length - VISIBLE_OPTIONS });
          more.setAttribute('aria-expanded', view.all ? 'true' : 'false');
          more.setAttribute('aria-controls', bodyId);
          more.setAttribute('data-ds-filter-group', g.key);
          more.setAttribute('data-ds-filter-key', 'more:' + g.key);
        }
        if (g.type === 'price' && templates.price) {
          var price = clone(templates.price);
          price.querySelectorAll('[data-ds-filter-price-symbol]').forEach(function (el) {
            el.textContent = moneyParts[0] || moneyParts[1] || '';
          });
          var min = price.querySelector('[data-ds-filter-price-min]');
          var max = price.querySelector('[data-ds-filter-price-max]');
          showPrice(min, st.custom ? st.custom.min : null);
          showPrice(max, st.custom ? st.custom.max : null);
          min.setAttribute('data-ds-filter-key', 'price:min');
          max.setAttribute('data-ds-filter-key', 'price:max');
          body.appendChild(price);
        }
        frag.appendChild(section);
      });
      if (keep) {
        // Swap everything around the kept group; the group itself never leaves the DOM.
        Array.prototype.slice.call(host.children).forEach(function (child) {
          if (child !== keep) host.removeChild(child);
        });
        var before = true;
        Array.prototype.slice.call(frag.childNodes).forEach(function (node) {
          if (node.nodeType === 8) {
            before = false;
            return;
          }
          if (before) host.insertBefore(node, keep);
          else host.appendChild(node);
        });
        return;
      }
      host.replaceChildren(frag);
      if (focusKey) {
        var back = Array.prototype.filter.call(host.querySelectorAll('[data-ds-filter-key]'), function (el) {
          return el.getAttribute('data-ds-filter-key') === focusKey;
        })[0];
        if (back) back.focus({ preventScroll: true });
      }
    }

    function chipsOf(st) {
      var out = [];
      Object.keys(st.sel).forEach(function (attr) {
        st.sel[attr].forEach(function (v) {
          out.push({ key: attr, value: v, label: v });
        });
      });
      if (st.custom) out.push({ key: 'price', value: '__custom', label: fill(t.priceChip, { __V__: customLabel(st.custom) }) });
      return out;
    }

    function renderApplied(st, isNomatch) {
      var n = appliedCount(st);
      var chips = chipsOf(st);
      qa('[data-ds-search-chips]').forEach(function (list) {
        var inBox = Boolean(list.closest('[data-ds-search-nomatch]'));
        // With nothing left, the chips live in the empty box only.
        var show = inBox ? isNomatch : !isNomatch;
        list.replaceChildren();
        if (!show) return;
        chips.forEach(function (c) {
          var item = clone(templates.chip);
          if (!item) return;
          item.querySelector('[data-ds-search-chip-label]').textContent = c.label;
          var button = item.querySelector('button, a');
          if (button) {
            button.setAttribute('data-ds-search-remove', c.key);
            button.setAttribute('data-ds-search-remove-value', c.value);
            button.setAttribute('aria-label', button.getAttribute('aria-label') + ': ' + c.label);
          }
          list.appendChild(item);
        });
      });
      var applied = q('[data-ds-search-applied]');
      if (applied) applied.hidden = !n || isNomatch;
      var title = q('[data-ds-search-applied-title]');
      if (title) title.textContent = fill(n === 1 ? t.appliedOne : t.appliedOther, { __N__: n });
      var clear = q('[data-ds-search-clear]');
      if (clear) {
        clear.hidden = !n;
        clear.textContent = fill(t.clearAllCount, { __N__: n });
      }
      var badge = q('[data-ds-search-filter-badge]');
      if (badge) {
        badge.hidden = !n;
        badge.textContent = n;
      }
    }

    // ── The run: applied state → page ────────────────────────────────────

    function scrollToResults() {
      var main = grid && grid.parentElement;
      if (!main) return;
      var top = main.getBoundingClientRect().top;
      if (top >= 0) return;
      var desktop = window.matchMedia(DESKTOP).matches;
      window.scrollTo({ top: window.pageYOffset + top - (desktop ? 16 : 64), behavior: 'smooth' });
    }

    // Paging, as the PLP: the click scrolls smoothly to the top of the page body
    // (16 above it), and once the new grid is in the window settles there again
    // with no animation — the skeleton shrinks the page and grows it back while
    // the first scroll runs, and on iOS that left the new page short of its top
    // (BY-096).
    function scrollToListing(behavior) {
      var top = root.getBoundingClientRect().top + window.pageYOffset - 16;
      window.scrollTo({ top: Math.max(top, 0), behavior: behavior });
    }

    function run(opts) {
      var seq = ++runSeq;
      var st = state;
      writeUrl(st);
      if (paging) scrollToListing('smooth');
      else if (!opts || !opts.initial) scrollToResults();
      showLoading();

      if (!st.q || !cfg.apiKey) {
        setHeader(st, null, true);
        showEmpty(st, null);
        root.setAttribute('aria-busy', 'false');
        return;
      }

      Promise.all([request(st, { start: perPage * (st.page - 1), max: perPage, facets: true, suggestions: true }), loadGroups()])
        .then(function (out) {
          var data = out[0];
          if (seq !== runSeq) return;
          var all = total(data);
          retried = false;
          // Past the last page the app answers 0 items and a 0 total, so a 0 on
          // page > 1 cannot tell "page out of range" from "no results": ask page
          // 1 for the total and land on the last page (0 → the empty state).
          if (!all && st.page > 1) {
            request(st, { max: 1, suggestions: true }).then(function (head) {
              if (seq !== runSeq) return;
              state.page = Math.max(1, Math.ceil(total(head) / perPage));
              run({ initial: true });
            }, function () {
              if (seq === runSeq) fail(st);
            });
            return;
          }
          var pages = Math.max(1, Math.ceil(all / perPage));
          // A page past the end (filters narrowed it): go to the last one.
          if (all && st.page > pages) {
            state.page = pages;
            run({ initial: true });
            return;
          }
          var filtered = appliedCount(st) > 0;
          if (!all && !filtered) {
            setHeader(st, data, true);
            showEmpty(st, data);
            root.setAttribute('aria-busy', 'false');
            return;
          }

          if (empty) empty.hidden = true;
          if (results) results.hidden = false;
          setHeader(st, data, false);
          renderSort(st);
          last = { data: data };
          renderPanel(q('[data-ds-filter-host="sidebar"]'), 'sidebar', st, data);
          setRelated(st, data);

          if (!all) {
            renderApplied(st, true);
            setCount(all);
            grid.hidden = true;
            nomatch.hidden = false;
            root.setAttribute('aria-busy', 'false');
            fillNomatchRail(st, seq);
            return;
          }
          renderApplied(st, false);

          loadCards(data.items).then(function (list) {
            if (seq !== runSeq) return;
            var frag = document.createDocumentFragment();
            list.forEach(function (card) {
              var li = document.createElement('li');
              li.className = 'sf-min-w-0';
              li.appendChild(card);
              frag.appendChild(li);
            });
            grid.replaceChildren(frag);
            grid.removeAttribute('aria-busy');
            // The pill stays hidden for the whole load; it returns with the grid.
            setCount(all);
            var from = perPage * (st.page - 1) + 1;
            renderPagination(st, pages, from, Math.min(from + perPage - 1, all), all);
            root.setAttribute('aria-busy', 'false');
            if (paging) {
              paging = false;
              scrollToListing('auto');
            }
          });
        })
        .catch(function () {
          if (seq !== runSeq) return;
          fail(st);
        });
    }

    // The app is unreachable or answers with an error: try once more, then
    // hand the query to the store's native search, as the legacy page's
    // search app did — never leave the loading grid up.
    var retried = false;
    function fail(st) {
      if (!retried) {
        retried = true;
        run({ initial: true });
        return;
      }
      root.setAttribute('aria-busy', 'false');
      window.location.replace(rootPath() + 'search?q=' + encodeURIComponent(st.q));
    }

    function fillNomatchRail(st, seq) {
      var wrap = q('[data-ds-search-nomatch-rail]');
      if (!wrap) return;
      wrap.hidden = true;
      var title = wrap.querySelector('h2, h3');
      if (title) title.textContent = fill(t.popularIn, { __Q__: st.q });
      request(st, { max: 8, sel: { q: st.q, sort: st.sort, sel: {}, custom: null } })
        .then(function (data) { return loadCards(data.items); })
        .then(function (list) {
          if (seq !== runSeq || !list.length) return;
          var track = wrap.querySelector('[data-ds-product-rail-track]');
          if (!track) return;
          track.replaceChildren.apply(track, list);
          wrap.hidden = false;
        })
        .catch(function () {});
    }

    function apply(next) {
      state = next;
      state.page = 1;
      run();
    }

    // ── Filter sheet (below lg) ──────────────────────────────────────────

    var opener = null;

    function sheetOpen() {
      return sheet && sheet.getAttribute('aria-hidden') === 'false';
    }

    function renderSheet(data, draftTotal, focusTo) {
      renderPanel(q('[data-ds-filter-host="sheet"]'), 'sheet', draft, data, focusTo);
      var dirty = !sameSel(draft.sel, state.sel) || JSON.stringify(draft.custom) !== JSON.stringify(state.custom);
      var label = t.apply;
      var disabled = false;
      if (dirty && draftTotal != null) {
        label = draftTotal ? fill(draftTotal === 1 ? t.showOne : t.showOther, { __N__: number(draftTotal) }) : t.noProducts;
        disabled = !draftTotal;
      }
      if (sheetApply) {
        var text = sheetApply.querySelector('span') || sheetApply;
        text.textContent = label;
        sheetApply.disabled = disabled;
      }
      if (sheetClear) sheetClear.disabled = appliedCount(draft) === 0;
    }

    function refreshDraft(focusTo) {
      var seq = ++draftSeq;
      var st = draft;
      renderSheet(last && last.data, null, focusTo);
      // Counted as the results are fetched (suggestions on), so "Show N
      // products" matches what Apply then shows (SF0342).
      request(st, { facets: true, suggestions: true }).then(function (data) {
        if (seq !== draftSeq || !sheetOpen()) return;
        renderSheet(data, total(data));
      }).catch(function () {});
    }

    // iOS: the on-screen keyboard shrinks only the visual viewport, and with
    // the page pinned Safari no longer scrolls a focused Min / Max into view
    // (BY-115). The sheet carries [data-ds-page-lock-fit], so page-lock.js
    // keeps it to the visible height; a new height (the keyboard in or out)
    // brings the focused price field back into view from the sheet's own list.
    var PRICE_FIELD = '[data-ds-filter-price-min], [data-ds-filter-price-max]';
    if (sheet) {
      sheet.addEventListener('ds:page-lock:fit', function (event) {
        if (!event.detail.resized) return;
        var field = document.activeElement;
        if (field && field.matches(PRICE_FIELD) && sheet.contains(field)) {
          window.requestAnimationFrame(function () {
            // A phone on its side leaves about one field of height above the
            // keyboard, all of it taken by the header and footer, so the list
            // has no room to show the field in. The whole panel scrolls then.
            var room = sheetPanel.clientHeight;
            Array.prototype.forEach.call(sheetPanel.children, function (part) {
              if (!part.matches('[data-ds-filter-host="sheet"]')) room -= part.offsetHeight;
            });
            sheet.toggleAttribute('data-ds-search-sheet-short', room < field.offsetHeight);
            field.scrollIntoView({ block: 'center' });
          });
        } else {
          sheet.removeAttribute('data-ds-search-sheet-short');
        }
      });
    }

    function openSheet(trigger) {
      if (!sheet || !last) return;
      opener = trigger || null;
      draft = { q: state.q, sort: state.sort, page: 1, sel: copySel(state.sel), custom: state.custom ? { min: state.custom.min, max: state.custom.max } : null };
      ui.sheet = {};
      // A phone on its side is 744+ wide but too short for the drawer: it gets
      // the sheet, centred (search.css). tokens.css owns that test.
      var landscape = getComputedStyle(document.documentElement).getPropertyValue('--sheet-short-screen').trim() === '1';
      sheet.setAttribute('data-mode', landscape || window.matchMedia(SHEET).matches ? 'sheet' : 'drawer');
      sheet.toggleAttribute('data-ds-search-sheet-landscape', landscape);
      renderSheet(last.data, null);
      // page-lock.js pins the page (iOS-safe) and fits the sheet to the
      // visible height while this attribute is on.
      sheet.setAttribute('data-ds-page-lock', '');
      void sheet.offsetWidth;
      sheet.setAttribute('aria-hidden', 'false');
      if (filterOpen) filterOpen.setAttribute('aria-expanded', 'true');
      if (sheetPanel) sheetPanel.focus({ preventScroll: true });
    }

    function closeSheet() {
      if (!sheetOpen()) return;
      draftSeq++;
      sheet.setAttribute('aria-hidden', 'true');
      sheet.removeAttribute('data-ds-search-sheet-short');
      // Every way out leaves the page where it was (Esc used to land at 0).
      sheet.removeAttribute('data-ds-page-lock');
      if (filterOpen) filterOpen.setAttribute('aria-expanded', 'false');
      if (opener) opener.focus({ preventScroll: true });
      draft = null;
    }

    // ── Events ───────────────────────────────────────────────────────────

    function hostOf(el) {
      var host = el.closest('[data-ds-filter-host]');
      return host ? host.getAttribute('data-ds-filter-host') : null;
    }

    function stateFor(hostName) {
      return hostName === 'sheet' ? draft : state;
    }

    function copyState(st) {
      return { q: st.q, sort: st.sort, page: st.page, sel: copySel(st.sel), custom: st.custom ? { min: st.custom.min, max: st.custom.max } : null };
    }

    function changed(hostName, next, focusTo) {
      if (hostName === 'sheet') {
        draft = next;
        refreshDraft(focusTo);
      } else {
        apply(next);
      }
    }

    root.addEventListener('change', function (event) {
      var input = event.target;
      var key = input.getAttribute && input.getAttribute('data-ds-filter-input');
      if (!key) return;
      var hostName = hostOf(input);
      var st = stateFor(hostName);
      if (!st) return;
      var next = copyState(st);
      var values = next.sel[key] || [];
      if (input.checked) {
        if (values.indexOf(input.value) === -1) values.push(input.value);
      } else {
        values = values.filter(function (v) { return v !== input.value; });
      }
      next.sel[key] = values;
      changed(hostName, next);
    });

    function commitPrice(field, focusTo) {
      var box = field.closest('[data-ds-filter-price-root]');
      var hostName = hostOf(field);
      var st = stateFor(hostName);
      if (!box || !st) return;
      var read = function (el) {
        var v = el && el.value !== '' ? Math.max(0, parseFloat(el.value)) : null;
        return v == null || isNaN(v) ? null : v;
      };
      var minField = box.querySelector('[data-ds-filter-price-min]');
      var maxField = box.querySelector('[data-ds-filter-price-max]');
      var lo = read(minField);
      var hi = read(maxField);
      if (lo != null && hi != null && lo > hi) {
        var swap = lo;
        lo = hi;
        hi = swap;
      }
      // The fields show what is committed (swapped, clamped) at once: a field
      // that keeps focus through the re-render is not rewritten then.
      if (minField) showPrice(minField, lo);
      if (maxField) showPrice(maxField, hi);
      var custom = lo == null && hi == null ? null : { min: lo, max: hi };
      if (JSON.stringify(custom) === JSON.stringify(st.custom)) return;
      var next = copyState(st);
      next.custom = custom;
      changed(hostName, next, focusTo);
    }

    root.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' && event.target.closest && event.target.closest('[data-ds-filter-price-root]')) {
        event.preventDefault();
        commitPrice(event.target);
      }
    });
    root.addEventListener('focusout', function (event) {
      if (event.target.closest && event.target.closest('[data-ds-filter-price-root]') && event.target.matches('input')) {
        commitPrice(event.target, event.relatedTarget);
      }
    });

    root.addEventListener('click', function (event) {
      var target = event.target;
      if (!target.closest) return;

      var toggle = target.closest('[data-ds-filter-group-toggle]');
      if (toggle) {
        var hostName = hostOf(toggle);
        var view = ui[hostName][toggle.getAttribute('data-ds-filter-group')];
        if (!view) return;
        view.open = !view.open;
        toggle.setAttribute('aria-expanded', view.open ? 'true' : 'false');
        var body = document.getElementById(toggle.getAttribute('aria-controls'));
        if (body) body.hidden = !view.open;
        return;
      }

      var more = target.closest('[data-ds-filter-more]');
      if (more) {
        var moreHost = hostOf(more);
        var moreView = ui[moreHost][more.getAttribute('data-ds-filter-group')];
        if (!moreView) return;
        moreView.all = !moreView.all;
        if (moreHost === 'sheet') {
          refreshDraft();
        } else {
          renderPanel(q('[data-ds-filter-host="sidebar"]'), 'sidebar', state, last && last.data);
        }
        return;
      }

      var remove = target.closest('[data-ds-search-remove]');
      if (remove) {
        event.preventDefault();
        var key = remove.getAttribute('data-ds-search-remove');
        var value = remove.getAttribute('data-ds-search-remove-value');
        var next = copyState(state);
        if (value === '__custom') next.custom = null;
        else next.sel[key] = (next.sel[key] || []).filter(function (v) { return v !== value; });
        apply(next);
        return;
      }

      if (target.closest('[data-ds-search-clear], [data-ds-search-clear-all]')) {
        event.preventDefault();
        var cleared = copyState(state);
        cleared.sel = {};
        cleared.custom = null;
        apply(cleared);
        return;
      }

      var option = target.closest('[data-ds-search-sort] [data-ds-sort-picker-option]');
      if (option) {
        event.preventDefault();
        var sort = new URL(option.href, window.location.origin).searchParams.get('sort_by');
        if (sortValues.indexOf(sort) === -1 || sort === state.sort) return;
        var sorted = copyState(state);
        sorted.sort = sort;
        // Let the picker run its close before its markup is swapped.
        window.setTimeout(function () { apply(sorted); }, 0);
        return;
      }

      var pageLink = target.closest('[data-ds-search-pages] a[data-page]');
      if (pageLink) {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        state = copyState(state);
        state.page = parseInt(pageLink.getAttribute('data-page'), 10) || 1;
        paging = true;
        run();
        return;
      }

      var filterButton = target.closest('[data-ds-search-filter-open]');
      if (filterButton) {
        openSheet(filterButton);
        return;
      }

      if (target.closest('[data-ds-search-sheet-close]') || target === sheet) {
        closeSheet();
        return;
      }

      if (target.closest('[data-ds-search-sheet-clear]')) {
        if (!draft) return;
        var none = copyState(draft);
        none.sel = {};
        none.custom = null;
        draft = none;
        refreshDraft();
        return;
      }

      if (target.closest('[data-ds-search-sheet-apply]')) {
        if (!draft) return;
        var picked = draft;
        closeSheet();
        // page-lock.js unlocks the page once this handler returns; the run
        // that follows scrolls to the results, so it waits for that.
        window.setTimeout(function () { apply(picked); }, 0);
      }
    });

    // Capture phase: while the sheet is open, Esc is the sheet's alone — other
    // listeners (the search app's autocomplete) must not act on it too.
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape' || !sheetOpen()) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      closeSheet();
    }, true);

    // The sheet belongs below lg; crossing into lg closes it (the sidebar takes over).
    window.matchMedia(DESKTOP).addEventListener('change', function (event) {
      if (event.matches) closeSheet();
    });

    document.querySelectorAll('[data-ds-header-search] input').forEach(function (input) {
      if (!input.value && state.q) input.value = state.q;
    });

    run({ initial: true });
  }

  function init() {
    document.querySelectorAll('[data-ds-search]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();

} catch (sfError) {
if (typeof console !== 'undefined') console.error('[sf-core] behavior "search-results" failed to initialise:', sfError);
}
})();

/* seasonal-feature.js */
(function () {
try {
/* seasonal-feature — squares the seasonal feature tile to the product card
 * beside it, on both tablets.
 *
 * Between tablet-mini (744) and lg the inline_feature band puts the campaign
 * tile beside a track of three product cards, and the tile is a square as
 * tall as one card — image, title, rating and price (prototype EventRow.jsx
 * reads the first cell's offsetHeight in a layout effect). A card's height
 * depends on its width, which depends on how much room the tile leaves, so no
 * single width in CSS lands it at every size. This measures the first card
 * and sets the tile's width to that height; the tile's own square image then
 * makes its height match. Setting the width moves the cards (a narrower tile
 * leaves them more room), so it re-measures and re-assigns until the two
 * agree within a pixel, and checks once more on the next frame in case the
 * last reflow moved the card again.
 *
 * Below 744 the tile is a banner over the scroller and from lg a fixed 300
 * tile; both are pure CSS, so the inline width is removed there. Without this
 * file the tablet tile falls back to --seasonal-feature-tile.
 *
 * The range is read from --breakpoint-tablet-mini / --breakpoint-lg rather
 * than typed here, so a token change moves the JS with the CSS.
 *
 * Authoring rules: src/behaviors/README.md. No import/export.
 */

var SEASONAL_ROOT = '[data-ds-seasonal-showcase]';

function seasonalRange() {
  var style = window.getComputedStyle(document.documentElement);
  var from = style.getPropertyValue('--breakpoint-tablet-mini').trim() || '744px';
  var until = parseFloat(style.getPropertyValue('--breakpoint-lg').trim() || '1024') - 0.02;
  return '(min-width: ' + from + ') and (max-width: ' + until + 'px)';
}

function bindSeasonalFeature(root) {
  if (root.dataset.dsSeasonalFeatureBound) return;
  var tile = root.querySelector('[data-ds-seasonal-tile]');
  var track = root.querySelector('[data-ds-product-rail-track]');
  if (!tile || !track || !track.firstElementChild) return;
  root.dataset.dsSeasonalFeatureBound = '1';

  var query = window.matchMedia(seasonalRange());
  var queued = false;
  var retries = 0;

  // One pending frame at a time. Nothing is dropped: every trigger that
  // arrives while a frame is queued is covered by that frame's measurement.
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      fit();
    });
  }

  function fit() {
    if (!query.matches) {
      tile.style.removeProperty('width');
      retries = 0;
      return;
    }
    var card = track.firstElementChild;
    if (!card) return;
    // Each read forces a fresh layout, so every pass sees the card as the
    // previous assignment left it.
    for (var pass = 0; pass < 8; pass += 1) {
      var side = card.offsetHeight;
      if (!side || Math.abs(tile.offsetWidth - side) < 1) break;
      tile.style.width = side + 'px';
    }
    if (Math.abs(tile.offsetWidth - card.offsetHeight) >= 1 && retries < 4) {
      retries += 1;
      schedule();
    } else {
      retries = 0;
    }
  }

  fit();
  if (query.addEventListener) query.addEventListener('change', schedule);
  else if (query.addListener) query.addListener(schedule);
  if (typeof ResizeObserver !== 'undefined') {
    // The band's width (viewport) and the card's height (fonts, images) move
    // the answer. A settled fit writes nothing, so its own echo ends here.
    var observer = new ResizeObserver(schedule);
    observer.observe(root);
    observer.observe(track.firstElementChild);
  } else {
    window.addEventListener('resize', schedule);
  }
}

function initSeasonalFeatures(scope) {
  (scope || document).querySelectorAll(SEASONAL_ROOT).forEach(bindSeasonalFeature);
}

if (!document.__dsSeasonalFeatureBound) {
  document.__dsSeasonalFeatureBound = true;
  var startSeasonalFeatures = function () { initSeasonalFeatures(document); };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startSeasonalFeatures, { once: true });
  } else {
    startSeasonalFeatures();
  }
  document.addEventListener('shopify:section:load', startSeasonalFeatures);
}

} catch (sfError) {
if (typeof console !== 'undefined') console.error('[sf-core] behavior "seasonal-feature" failed to initialise:', sfError);
}
})();

/* size-chart.js */
(function () {
try {
/* size-chart — the Inches · Cm switch and the "Size chart / How to measure"
 * tabs of ds-size-chart.
 *
 * Liquid already renders the default unit and the first tab, so without this
 * script the chart reads correctly; it only switches.
 *
 * Unit: one attribute on the chart root, [data-ds-size-chart-unit]. Every
 * length cell carries both values and src/size-chart.css hides the other unit,
 * so every table of the chart switches at once. The options are a radiogroup:
 * click or ←/→ picks one.
 *
 * Tabs: [aria-selected] + roving tabindex on the tabs, [aria-hidden] + inert on
 * the panels (src/size-chart.css hides the other one). ←/→ moves
 * to the other tab and focuses it.
 *
 * On this page (size chart page, from 1024): the sidebar link of the chart in
 * view gets aria-current="location" — the last chart whose top has passed 120
 * from the top of the screen, else the first (prototype SizeChartToc). The
 * inline <details> below 1024 needs no script.
 *
 * Delegated on document, so charts added later (Theme Editor, a dialog body)
 * need no re-binding. Authoring rules: src/behaviors/README.md. No import/export.
 */

(function () {
  if (document.__dsSizeChartBound) return;
  document.__dsSizeChartBound = true;

  function setUnit(option) {
    var root = option.closest('[data-ds-size-chart]');
    if (!root) return;
    var unit = option.getAttribute('data-ds-size-chart-unit-option');
    root.setAttribute('data-ds-size-chart-unit', unit);
    root.querySelectorAll('[data-ds-size-chart-unit-option]').forEach(function (el) {
      var on = el === option;
      el.setAttribute('aria-checked', on ? 'true' : 'false');
      el.setAttribute('tabindex', on ? '0' : '-1');
    });
  }

  function selectTab(tab) {
    var list = tab.closest('[data-ds-size-chart-tabs]');
    var root = tab.closest('[data-ds-size-chart]');
    if (!list || !root) return;
    list.querySelectorAll('[data-ds-size-chart-tab]').forEach(function (el) {
      var on = el === tab;
      el.setAttribute('aria-selected', on ? 'true' : 'false');
      el.setAttribute('tabindex', on ? '0' : '-1');
    });
    var name = tab.getAttribute('data-ds-size-chart-tab');
    root.querySelectorAll('[data-ds-size-chart-panel]').forEach(function (panel) {
      // Only this chart's panels: a page stacks many charts.
      if (panel.closest('[data-ds-size-chart]') !== root) return;
      var on = panel.getAttribute('data-ds-size-chart-panel') === name;
      panel.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (on) panel.removeAttribute('inert');
      else panel.setAttribute('inert', '');
    });
  }

  // ←/→ inside a group of siblings: the next one, wrapping.
  function sibling(el, selector, step) {
    var group = Array.prototype.slice.call(el.parentNode.querySelectorAll(selector));
    var i = group.indexOf(el);
    return group[(i + step + group.length) % group.length];
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var option = e.target.closest('[data-ds-size-chart-unit-option]');
    if (option) {
      setUnit(option);
      return;
    }
    var tab = e.target.closest('[data-ds-size-chart-tab]');
    if (tab) selectTab(tab);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
    if (!e.target.closest) return;
    var step = e.key === 'ArrowRight' ? 1 : -1;

    var option = e.target.closest('[data-ds-size-chart-unit-option]');
    if (option) {
      e.preventDefault();
      var nextOption = sibling(option, '[data-ds-size-chart-unit-option]', step);
      setUnit(nextOption);
      nextOption.focus();
      return;
    }

    var tab = e.target.closest('[data-ds-size-chart-tab]');
    if (tab) {
      e.preventDefault();
      var nextTab = sibling(tab, '[data-ds-size-chart-tab]', step);
      selectTab(nextTab);
      nextTab.focus();
    }
  });

  // On this page: mark the chart in view. Read on scroll, at most once a frame.
  var TOC_LINE = 120;
  var tocQueued = false;
  function markToc() {
    tocQueued = false;
    var nav = document.querySelector('[data-ds-size-chart-toc="sidebar"]');
    if (!nav || !nav.offsetParent) return;
    var links = nav.querySelectorAll('[data-ds-size-chart-toc-link]');
    var current = links[0];
    links.forEach(function (link) {
      var target = document.getElementById(decodeURIComponent(link.hash.slice(1)));
      if (target && target.getBoundingClientRect().top <= TOC_LINE) current = link;
    });
    links.forEach(function (link) {
      if (link === current) link.setAttribute('aria-current', 'location');
      else link.removeAttribute('aria-current');
    });
  }
  function queueToc() {
    if (tocQueued) return;
    tocQueued = true;
    window.requestAnimationFrame(markToc);
  }
  window.addEventListener('scroll', queueToc, { passive: true });
  window.addEventListener('resize', queueToc);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', markToc);
  else markToc();
})();

} catch (sfError) {
if (typeof console !== 'undefined') console.error('[sf-core] behavior "size-chart" failed to initialise:', sfError);
}
})();

/* size-guide.js */
(function () {
try {
/* size-guide — opens the size-guide dialog (ds-size-guide) from its
 * [data-ds-size-guide-open] link on the size option's label row, closes it on X,
 * overlay click and Esc, and keeps Tab inside the dialog while it is open.
 *
 * Not a singleton: the picker renders one guide per product, but a page may hold
 * more than one product block (quick view, bundles), so every handler resolves
 * the dialog from the trigger's own subtree and falls back to the only one in the
 * document. Nothing is deduped or removed.
 *
 * Progressive enhancement: without this script the link is inert and the dialog
 * stays hidden — the variant picker itself is untouched.
 *
 * Open/closed is one attribute, [aria-hidden]. src/size-guide.css carries the
 * fade + slide off it, so the sheet stays painted while it animates out;
 * toggling a display utility here would cut that off.
 *
 * Authoring rules: src/behaviors/README.md. No import/export.
 */

(function () {
  if (document.__dsSizeGuideBound) return;
  document.__dsSizeGuideBound = true;

  var lastTrigger = null;

  // The trigger sits next to its own dialog, so walk up to the nearest shared
  // ancestor that holds one before falling back to the page's only guide.
  function modalFor(el) {
    var node = el;
    while (node && node !== document) {
      var found = node.querySelector && node.querySelector('[data-ds-size-guide]');
      if (found) return found;
      node = node.parentNode;
    }
    return document.querySelector('[data-ds-size-guide]');
  }

  function isOpen(modal) {
    return !!modal && modal.getAttribute('aria-hidden') === 'false';
  }

  function openModal(trigger) {
    var modal = modalFor(trigger);
    if (!modal) return;
    lastTrigger = trigger || null;
    modal.setAttribute('aria-hidden', 'false');
    // page-lock.js pins the page: iOS Safari ignores overflow on <html> and
    // <body>, and the page behind the sheet kept scrolling (BY-099).
    modal.setAttribute('data-ds-page-lock', '');

    var close = modal.querySelector('[data-ds-size-guide-close]');
    if (close) {
      // Focus after paint so the dialog is visible first.
      window.requestAnimationFrame(function () {
        close.focus({ focusVisible: false });
      });
    }
  }

  function closeModal(modal) {
    if (!modal) return;
    modal.setAttribute('aria-hidden', 'true');
    modal.removeAttribute('data-ds-page-lock');
    if (lastTrigger && typeof lastTrigger.focus === 'function') {
      lastTrigger.focus();
    }
    lastTrigger = null;
  }

  function openModalEl() {
    var modals = document.querySelectorAll('[data-ds-size-guide]');
    for (var i = 0; i < modals.length; i++) {
      if (isOpen(modals[i])) return modals[i];
    }
    return null;
  }

  // Tab must cycle inside the dialog while it is open, otherwise focus walks the
  // page behind the sheet — which is still rendered ([aria-hidden] only).
  function trapTab(e) {
    var modal = openModalEl();
    if (!modal) return;
    var dialog = modal.querySelector('[data-ds-size-guide-dialog]') || modal;
    var focusable = Array.prototype.filter.call(
      dialog.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])',
      ),
      // Tab-reachable only: roving-tabindex controls (the chart's unit radios
      // and tabs) sit at -1 when unselected, and the hidden tab panel is inert.
      function (el) {
        if (el.getAttribute('tabindex') === '-1' || el.closest('[inert]')) return false;
        return el.offsetParent !== null || el === document.activeElement;
      },
    );
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    } else if (!dialog.contains(document.activeElement)) {
      e.preventDefault();
      first.focus();
    }
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;

    var trigger = e.target.closest('[data-ds-size-guide-open]');
    if (trigger) {
      e.preventDefault();
      openModal(trigger);
      return;
    }

    var close = e.target.closest('[data-ds-size-guide-close]');
    if (close) {
      e.preventDefault();
      closeModal(close.closest('[data-ds-size-guide]') || openModalEl());
      return;
    }

    // Overlay: the click landed on the backdrop itself, not inside the card.
    if (e.target.matches && e.target.matches('[data-ds-size-guide]') && isOpen(e.target)) {
      closeModal(e.target);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var modal = openModalEl();
      if (modal) closeModal(modal);
      return;
    }
    if (e.key === 'Tab') trapTab(e);
  });
})();

} catch (sfError) {
if (typeof console !== 'undefined') console.error('[sf-core] behavior "size-guide" failed to initialise:', sfError);
}
})();

/* sort-picker.js */
(function () {
try {
/* sort-picker — opens and closes the ds-sort-picker list: a bottom sheet below
 * 744 and on a phone on its side, a dropdown under the trigger from 744.
 *
 * The picker is a <details> so it opens without JS; this script cancels the
 * native toggle and drives it instead. State is one attribute, [aria-hidden]
 * on the overlay (sort-picker.css
 * animates off it), mirrored on the trigger's aria-expanded. Closes on Esc, the
 * sheet's close button, a tap on the scrim, a click outside the picker, and
 * once an option is chosen. The sheet locks the page (page-lock.js) and
 * returns focus to the trigger; the dropdown does neither, since the page
 * stays usable.
 *
 * The options are plain `?sort_by=` links: this script never navigates. A page
 * behaviour may intercept the link (collection-listing.js) — without one the
 * browser follows it.
 *
 * Authoring rules: src/behaviors/README.md. No import/export.
 */

(function () {
  if (document.__dsSortPickerBound) return;
  document.__dsSortPickerBound = true;

  var SHEET = '(max-width: 743px)';
  var openRoot = null;

  function parts(root) {
    return {
      trigger: root.querySelector('[data-ds-sort-picker-trigger]'),
      overlay: root.querySelector('[data-ds-sort-picker-overlay]'),
    };
  }

  // A phone on its side is 744+ wide but too short for the dropdown; it keeps
  // the sheet. tokens.css owns the test (--sheet-short-screen), and open()
  // stamps [data-ds-sort-picker-landscape] for sort-picker.css to key off.
  function shortScreen() {
    return getComputedStyle(document.documentElement).getPropertyValue('--sheet-short-screen').trim() === '1';
  }

  function isSheet() {
    return window.matchMedia(SHEET).matches || shortScreen();
  }

  // How long the close transition runs (sort-picker.css: --duration-base).
  function closeDelay() {
    var value = getComputedStyle(document.documentElement).getPropertyValue('--duration-base');
    return parseFloat(value) || 200;
  }

  function open(root) {
    if (openRoot && openRoot !== root) close(openRoot, false);
    var p = parts(root);
    if (!p.trigger || !p.overlay) return;
    // A closed <details> does not render its content, so it has to be open for
    // the list to show; the marker keeps sort-picker.css's no-JS rule out.
    root.setAttribute('data-ds-sort-picker-js', '');
    window.clearTimeout(root.__dsSortPickerTimer);
    root.open = true;
    p.trigger.setAttribute('aria-expanded', 'true');
    openRoot = root;
    root.toggleAttribute('data-ds-sort-picker-landscape', shortScreen());
    // Only the sheet holds the page still; the dropdown leaves it usable.
    if (isSheet()) p.overlay.setAttribute('data-ds-page-lock', '');
    // Read layout once so the just-rendered content has a computed "closed"
    // style to transition from, then flip the state.
    void p.overlay.offsetWidth;
    p.overlay.setAttribute('aria-hidden', 'false');
    var target =
      p.overlay.querySelector('[data-ds-sort-picker-option][aria-current="true"]') ||
      p.overlay.querySelector('[data-ds-sort-picker-option]');
    if (target) target.focus({ preventScroll: true });
  }

  function close(root, refocus) {
    var p = parts(root);
    if (!p.overlay) return;
    p.overlay.setAttribute('aria-hidden', 'true');
    if (p.trigger) p.trigger.setAttribute('aria-expanded', 'false');
    p.overlay.removeAttribute('data-ds-page-lock');
    if (openRoot === root) openRoot = null;
    // Close the <details> once the slide-out has finished.
    window.clearTimeout(root.__dsSortPickerTimer);
    root.__dsSortPickerTimer = window.setTimeout(function () {
      if (openRoot !== root) root.open = false;
    }, closeDelay());
    if (refocus && p.trigger) p.trigger.focus({ preventScroll: true });
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    var root = target.closest('[data-ds-sort-picker]');

    if (openRoot && root !== openRoot) {
      close(openRoot, false);
    }
    if (!root) return;

    if (target.closest('[data-ds-sort-picker-trigger]')) {
      // The trigger is a <summary>: stop the native toggle, this script owns it.
      event.preventDefault();
      if (openRoot === root) close(root, true);
      else open(root);
      return;
    }
    if (target.closest('[data-ds-sort-picker-close]')) {
      close(root, true);
      return;
    }
    if (target.closest('[data-ds-sort-picker-option]')) {
      close(root, false);
      return;
    }
    // A tap on the scrim itself (the overlay, outside the panel).
    if (target.matches('[data-ds-sort-picker-overlay]')) {
      close(root, true);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && openRoot) close(openRoot, true);
  });
})();

} catch (sfError) {
if (typeof console !== 'undefined') console.error('[sf-core] behavior "sort-picker" failed to initialise:', sfError);
}
})();

/* sticky-bar.js */
(function () {
try {
/* sticky-bar — mobile fixed add-to-cart bar for the PDP.
 * Binds [data-ds-product-sticky-bar] (see snippets/ds-product-sticky-bar.liquid).
 * Reveals the bar once the main buy box ([data-ds-product-buy-buttons]) scrolls
 * out of view upward, and hides it again when the buy box returns. The bar's
 * "Add to Cart" ([data-ds-sticky-atc]) DELEGATES to the real submit, so native
 * and BuildYou (personalized) add-to-cart both run unchanged — the bar never
 * posts to the cart itself.
 *
 * Generic activator only: no pricing/variant logic (that lives in the theme).
 * The bar starts hidden (sf-hidden); this reveals it, so with no JS it never
 * shows and the in-flow buy button still works.
 *
 * Authoring rules: src/behaviors/README.md. No import/export.
 */

if (!document.__dsStickyBarBound) {
  document.__dsStickyBarBound = true;

  var stickyBar = document.querySelector('[data-ds-product-sticky-bar]');
  var stickyBuyBox = document.querySelector('[data-ds-product-buy-buttons]');

  if (stickyBar) {
    if (stickyBuyBox && 'IntersectionObserver' in window) {
      var stickyObserver = new IntersectionObserver(
        function (entries) {
          var entry = entries[0];
          if (!entry) return;
          // Reveal only when the buy box has scrolled ABOVE the viewport. While
          // it is on screen (or still below, before the shopper reaches it),
          // the in-flow button is enough and the bar stays hidden.
          if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
            stickyBar.classList.remove('sf-hidden');
          } else {
            stickyBar.classList.add('sf-hidden');
          }
        },
        { threshold: 0 }
      );
      stickyObserver.observe(stickyBuyBox);
    }

    stickyBar.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-ds-sticky-atc]');
      if (!trigger) return;
      event.preventDefault();
      // Forward to the real control: the SDK's aliased button when personalized,
      // else the native form submit. Clicking a disabled one is a no-op (the SDK
      // disables it until the customization form is ready).
      var main =
        (stickyBuyBox && stickyBuyBox.querySelector('.cus-add_to_cart')) ||
        (stickyBuyBox && stickyBuyBox.querySelector('button[type="submit"]'));
      if (main) {
        if (main.disabled) return;
        main.click();
      } else if (stickyBuyBox) {
        stickyBuyBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
  }
}

} catch (sfError) {
if (typeof console !== 'undefined') console.error('[sf-core] behavior "sticky-bar" failed to initialise:', sfError);
}
})();

/* tags-input.js */
(function () {
try {
/* tags-input — add a tag on Enter (as a removable chip + hidden input) and
 * remove it on chip click. Binds [data-ds-tags-input] and its children (see
 * snippets/ds-tags-input.liquid). New chips are cloned from the snippet's
 * [data-ds-tags-input-template] (a ds-chip with a __DS_TAG__ placeholder) so no
 * client-side Liquid render is needed — this is why it ships. Progressive
 * enhancement: server-rendered tags submit and remove-markup exists without JS;
 * only adding via the keyboard is enhanced.
 *
 * Authoring rules: src/behaviors/README.md. No import/export.
 */

var TAGS = '[data-ds-tags-input]';
var TAGS_LIST = '[data-ds-tags-input-list]';
var TAGS_FIELD = '[data-ds-tags-input-field]';
var TAGS_TEMPLATE = '[data-ds-tags-input-template]';
var TAG_MARKER = '__DS_TAG__';

function addTag(root, value) {
  var list = root.querySelector(TAGS_LIST);
  var template = root.querySelector(TAGS_TEMPLATE);
  var field = root.querySelector(TAGS_FIELD);
  if (!list || !template || !field) return;

  var chip = template.content.querySelector('[data-ds-chip]');
  if (!chip) return;
  chip = chip.cloneNode(true);

  // Swap the placeholder in the visible label text node.
  var walker = document.createTreeWalker(chip, NodeFilter.SHOW_TEXT, null);
  var node;
  while ((node = walker.nextNode())) {
    if (node.nodeValue.indexOf(TAG_MARKER) !== -1) {
      node.nodeValue = node.nodeValue.replace(TAG_MARKER, value);
    }
  }
  // Accessible name: "<remove-copy>: <value>", falling back to the value alone.
  var removeCopy = root.getAttribute('data-ds-tags-input-remove');
  chip.setAttribute('aria-label', removeCopy ? removeCopy + ': ' + value : value);

  // Each tag is a hidden <input> immediately before its chip so the set submits.
  var hidden = document.createElement('input');
  hidden.type = 'hidden';
  hidden.name = field.name || 'tags';
  hidden.value = value;

  list.insertBefore(hidden, field);
  list.insertBefore(chip, field);
}

if (!document.__dsTagsInputBound) {
  document.__dsTagsInputBound = true;

  document.addEventListener('keydown', function (e) {
    // Ignore the Enter that only commits an IME composition. Vietnamese/CJK IMEs
    // fire a keydown (isComposing, keyCode 229) to end composition then a real
    // Enter; compositionend re-inserts the text between them, so handling the
    // first would add the tag twice.
    if (e.key !== 'Enter' || e.isComposing || e.keyCode === 229) return;
    var field = e.target;
    if (!(field instanceof HTMLInputElement) || !field.matches(TAGS_FIELD)) return;
    e.preventDefault();
    var value = field.value.trim();
    if (!value) return;
    var root = field.closest(TAGS);
    if (root) addTag(root, value);
    field.value = '';
  });

  document.addEventListener('click', function (e) {
    var remove = e.target.closest && e.target.closest('[data-ds-chip-remove]');
    if (!remove || !remove.closest(TAGS)) return;
    var chip = remove.closest('[data-ds-chip]');
    // Drop the chip and the hidden input right before it, else the removed tag
    // lingers in the submitted form set.
    var hidden = chip && chip.previousElementSibling;
    if (hidden instanceof HTMLInputElement && hidden.type === 'hidden') hidden.remove();
    if (chip) chip.remove();
  });
}

} catch (sfError) {
if (typeof console !== 'undefined') console.error('[sf-core] behavior "tags-input" failed to initialise:', sfError);
}
})();

/* toast.js */
(function () {
try {
/* toast — the queue behind ds-toast: one strip at a time, auto-dismissed,
 * announced politely.
 *
 * Any behaviour can raise one by dispatching ds:toast with
 * { message, highlight, image, action, detail }. Taking the action dispatches it
 * with that detail; letting the toast go instead dispatches ds:toast:dismissed
 * with the same detail, which is how cart-lines.js knows an undo window closed.
 *
 * The copy is cloned into the live region rather than swapped into one node:
 * aria-live announces insertions, so a reused node would go unread. Up to three
 * stand at once; anything past that queues.
 *
 * Authoring rules: src/behaviors/README.md. No import/export.
 */

var TOAST_REGION = '[data-ds-toast-region]';
var TOAST_TEMPLATE = '[data-ds-toast-template]';
var TOAST_LIFETIME = 8000;

var toastQueue = [];
var toastVisible = [];
// Stacked, not serialised: a queued toast would leave its own removal without an
// Undo affordance while the one before it counted down.
var TOAST_MAX_VISIBLE = 3;

function toastRegion() {
  return document.querySelector(TOAST_REGION);
}

// `taken` says the action was used. Otherwise the toast simply ran out, which
// is what closes an undo window — cart-lines.js commits the removal on it.
function toastClose(node, taken) {
  if (!node) return;
  if (node.__dsToastTimer) window.clearTimeout(node.__dsToastTimer);
  var at = toastVisible.indexOf(node);
  if (at > -1) toastVisible.splice(at, 1);
  if (node.parentNode) node.parentNode.removeChild(node);
  if (!taken && node.__dsToastDetail) {
    document.dispatchEvent(new CustomEvent('ds:toast:dismissed', { detail: node.__dsToastDetail }));
  }
  toastPump();
}

function toastRender(next) {
  var region = toastRegion();
  var template = document.querySelector(TOAST_TEMPLATE);
  if (!region || !template) return;

  var node = template.content.firstElementChild.cloneNode(true);
  var message = node.querySelector('[data-ds-toast-message]');
  if (message) {
    message.textContent = '';
    if (next.highlight) {
      var strong = document.createElement('strong');
      strong.className = 'sf-font-semibold';
      // SoT UndoToast: the name is quoted, then the status ("was removed")
      // follows in the same sentence. Do not clamp the whole sentence — a long
      // title fills both lines and the status disappears.
      strong.textContent = '\u201c' + next.highlight + '\u201d';
      message.appendChild(strong);
      if (next.message) message.appendChild(document.createTextNode(' '));
    }
    if (next.message) message.appendChild(document.createTextNode(next.message));
  }

  var image = node.querySelector('[data-ds-toast-image]');
  if (image && next.image) {
    image.src = next.image;
    image.alt = '';
    image.removeAttribute('hidden');
  } else if (image) {
    // Drop the whole frame: removing only the <img> leaves ds-image's tinted box.
    var frame = image.closest('[data-ds-image]') || image;
    var slot = frame.parentNode && frame.parentNode.hasAttribute('data-ds-toast-image-slot')
      ? frame.parentNode
      : frame;
    if (slot.parentNode) slot.parentNode.removeChild(slot);
  }

  var undo = node.querySelector('[data-ds-toast-undo]');
  if (undo) {
    if (next.action) {
      undo.addEventListener('click', function () {
        document.dispatchEvent(new CustomEvent(next.action, { detail: next.detail || null }));
        toastClose(node, true);
      });
    } else if (undo.parentNode) {
      undo.parentNode.removeChild(undo);
    }
  }

  var close = node.querySelector('[data-ds-toast-close]');
  if (close) close.addEventListener('click', function () { toastClose(node, false); });

  // Dismissing without the action tells the raiser its window has closed.
  if (next.action) node.__dsToastDetail = next.detail || null;
  node.__dsToastTimer = window.setTimeout(function () { toastClose(node, false); }, next.lifetime || TOAST_LIFETIME);
  region.appendChild(node);
  toastVisible.push(node);
}

function toastPump() {
  while (toastVisible.length < TOAST_MAX_VISIBLE && toastQueue.length) {
    toastRender(toastQueue.shift());
  }
}

function toastPush(detail) {
  if (!detail || (!detail.message && !detail.highlight)) return;
  toastQueue.push(detail);
  toastPump();
}

if (!document.__dsToastBound) {
  document.__dsToastBound = true;

  document.addEventListener('ds:toast', function (event) {
    toastPush(event.detail);
  });

  document.addEventListener('ds:cart:removed', function (event) {
    var detail = event.detail || {};
    var region = toastRegion();
    if (!region) return;
    toastPush({
      highlight: detail.title || '',
      message: region.getAttribute('data-ds-toast-removed') || 'was removed',
      image: detail.image || '',
      action: detail.pending ? 'ds:cart:undo' : '',
      detail: detail.undo || null,
    });
  });
}

} catch (sfError) {
if (typeof console !== 'undefined') console.error('[sf-core] behavior "toast" failed to initialise:', sfError);
}
})();

/* trending-searches.js */
(function () {
try {
/* trending-searches — fills an empty ds-trending-searches block from the search
 * app's preloaded suggestions (Searchanise: window.Searchanise.preloadedSuggestions),
 * the same source and limits as the tenant's trending-search section: poll
 * every 200ms for up to 10s, take the first `data-limit` terms, link each to
 * `data-search-url?q=<term>`. The block ships hidden and is revealed only once
 * it has chips; a block that already has merchant chips is left alone, and so
 * is one marked data-autofill="false".
 *
 * Authoring rules: src/behaviors/README.md. No import/export.
 */

(function () {
  var POLL_MS = 200;
  var GIVE_UP_MS = 10000;

  function suggestions() {
    var app = window.Searchanise;
    return app && Array.isArray(app.preloadedSuggestions) ? app.preloadedSuggestions : null;
  }

  function fill(root, terms) {
    var list = root.querySelector('[data-ds-trending-searches-list]');
    var template = root.querySelector('template[data-ds-trending-searches-chip]');
    if (!list || !template) return;
    var limit = parseInt(root.dataset.limit, 10) || 9;
    var base = root.dataset.searchUrl || '/search';
    terms.slice(0, limit).forEach(function (term) {
      if (!term) return;
      var item = template.content.firstElementChild.cloneNode(true);
      var link = item.querySelector('a');
      link.href = base + '?q=' + encodeURIComponent(term);
      link.textContent = term;
      list.appendChild(item);
    });
    if (list.children.length) root.hidden = false;
  }

  function setup(root) {
    if (root.dataset.dsBound) return;
    root.dataset.dsBound = '1';
    // Another behaviour owns this list (Search Results' Related Searches).
    if (root.dataset.autofill === 'false') return;
    var list = root.querySelector('[data-ds-trending-searches-list]');
    if (!list || list.children.length) return;

    var started = Date.now();
    (function poll() {
      var terms = suggestions();
      if (terms) {
        fill(root, terms);
        return;
      }
      if (Date.now() - started < GIVE_UP_MS) window.setTimeout(poll, POLL_MS);
    })();
  }

  function init() {
    document.querySelectorAll('[data-ds-trending-searches]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();

} catch (sfError) {
if (typeof console !== 'undefined') console.error('[sf-core] behavior "trending-searches" failed to initialise:', sfError);
}
})();

/* upload.js */
(function () {
try {
/* upload — show the chosen file name(s) next to a file input.
 * Binds [data-ds-upload-input] with a [data-ds-upload-input-filename] label
 * (see snippets/ds-upload-input.liquid). The label's data-ds-upload-input-empty
 * holds the placeholder shown when nothing is selected. Progressive enhancement:
 * the native file input works without JS; only the label echo is enhanced.
 *
 * Authoring rules: src/behaviors/README.md. No import/export.
 */

if (!document.__dsUploadBound) {
  document.__dsUploadBound = true;
  document.addEventListener('change', function (e) {
    var field = e.target;
    if (!(field instanceof HTMLInputElement) || field.type !== 'file') return;
    var root = field.closest('[data-ds-upload-input]');
    var label = root && root.querySelector('[data-ds-upload-input-filename]');
    if (!label) return;
    var names = field.files ? Array.from(field.files).map(function (f) { return f.name; }) : [];
    label.textContent = names.length ? names.join(', ') : (label.dataset.dsUploadInputEmpty || '');
  });
}

} catch (sfError) {
if (typeof console !== 'undefined') console.error('[sf-core] behavior "upload" failed to initialise:', sfError);
}
})();

/* variant-droplist.js */
(function () {
try {
/* variant-droplist — open/close for droplist-style option pickers.
 * The trigger (ds-variants layout:trigger) toggles a listbox of row values.
 * Selection itself is handled by product-variants.js (rows are variant links);
 * this module only manages open/close, the chevron, and keyboard/outside-click
 * dismissal. Progressive enhancement: without JS the rows are normal variant
 * links inside a list that is only visually collapsed.
 * Authoring rules: src/behaviors/README.md. No import/export.
 */

function dsDroplistTrigger(dl) {
  return dl.querySelector('[data-ds-variants-layout="trigger"]');
}

function dsDroplistList(dl) {
  return dl.querySelector('[data-ds-variant-droplist-list]');
}

function dsDroplistSetOpen(dl, open) {
  dl.setAttribute('data-open', open ? 'true' : 'false');

  var trigger = dsDroplistTrigger(dl);
  if (trigger) {
    trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    var icon = trigger.querySelector('svg');
    var chevron = icon ? icon.parentElement : null;
    if (chevron) chevron.classList.toggle('sf-rotate-180', open);
  }

  var list = dsDroplistList(dl);
  if (list) list.hidden = !open;
}

function dsDroplistCloseAll(except) {
  document.querySelectorAll('[data-ds-variant-droplist][data-open="true"]').forEach(function (dl) {
    if (dl !== except) dsDroplistSetOpen(dl, false);
  });
}

if (!document.__dsVariantDroplistBound) {
  document.__dsVariantDroplistBound = true;

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var trigger = target.closest('[data-ds-variant-droplist] [data-ds-variants-layout="trigger"]');
    if (trigger) {
      event.preventDefault();
      var dl = trigger.closest('[data-ds-variant-droplist]');
      var isOpen = dl.getAttribute('data-open') === 'true';
      dsDroplistCloseAll(dl);
      dsDroplistSetOpen(dl, !isOpen);
      return;
    }

    // Selecting a row closes the list; product-variants.js applies the variant.
    var row = target.closest('[data-ds-variant-droplist-list] a[data-ds-variants]');
    if (row) {
      var owner = row.closest('[data-ds-variant-droplist]');
      if (owner) dsDroplistSetOpen(owner, false);
      return;
    }

    // Click outside any droplist closes them all.
    if (!target.closest('[data-ds-variant-droplist]')) dsDroplistCloseAll(null);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var open = document.querySelector('[data-ds-variant-droplist][data-open="true"]');
    if (!open) return;
    dsDroplistSetOpen(open, false);
    var trigger = dsDroplistTrigger(open);
    if (trigger) trigger.focus();
  });
}

} catch (sfError) {
if (typeof console !== 'undefined') console.error('[sf-core] behavior "variant-droplist" failed to initialise:', sfError);
}
})();
